(function () {
  'use strict';

  angular
    .module('app.todo', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msApiProvider) {
    $stateProvider
      // Main
      .state('app.todo', {
        url: '/todo',
        views: {
          'content@app': {
            templateUrl: 'app/main/todo/todo2.html',
            controller: 'Todo2Controller as vm'
          }
        },
        params: {
          searchTerm: null,
          showAdvancedSearch: false,
          isAdvancedSearch: false,
          fromDatetime: null,
          toDatetime: null,
          page: 0,
          pageLength: 25,
          selectedReadStatusDefault: 0,
          selectedTypeAndBoxDefault: 2
        },
        bodyClass: 'todo',
        moduleName: 'To Do'
      })
      // Edit
      .state('app.todo.edit', {
        url: '/edit',
        views: {
          'content@app': {
            templateUrl: 'app/main/todo/edit/memo-edit2.html',
            controller: 'MemoEdit2Controller as vm'
          }
        },
        params: {
          selectedDatetime: null,
          selectedDatetimePrecision: null,
          apptInfo: null
        },
        bodyClass: 'memo-edit',
        moduleName: 'To Do'
      })
      // Thread (Memo)
      .state('app.todo.thread', {
        url: '/thread/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/todo/thread/thread2.html',
            controller: 'Thread2Controller as vm'
          }
        },
        params: {
          searchTerm: null,
          showAdvancedSearch: false,
          isAdvancedSearch: false,
          fromDatetime: null,
          toDatetime: null,
          page: 0,
          pageLength: 25,
          selectedReadStatusDefault: 0,
          selectedTypeAndBoxDefault: 2
        },
        bodyClass: 'thread',
        moduleName: 'To Do'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.todo')
    .controller('ThreadReadStatusDialogController', ThreadReadStatusDialogController);

  /** @ngInject */
  function ThreadReadStatusDialogController(memo, $mdDialog) {
    var vm = this;

    vm.memo = memo;
    vm.read = [];
    vm.unread = [];

    vm.displayName = _displayName;
    vm.close = _close;

    function _init() {
      console.log(memo);

      var r = [];
      var ur = [];

      for (var i = 0; i < memo.recipients.length; ++i) {
        var recipient = memo.recipients[i];
        if (recipient.role.name === 'Root' || recipient.role.name === 'Admin') {
          continue;
        }

        if (recipient.read_status === 'READ') {
          r.push(recipient);
        } else if (recipient.read_status === 'UNREAD') {
          ur.push(recipient);
        }
      }

      vm.read = r;
      vm.unread = ur;
    }

    function _displayName(recipient) {
      if (recipient.doctorName) {
        return recipient.doctorName + ' (' + recipient.role.name + ')';
      }

      if (recipient.user && recipient.user.profile_name) {
        return recipient.user.profile_name + ' (' + recipient.role.name + ')';
      }

      return recipient.role.name;
    }

    function _close() {
      $mdDialog.hide();
    }

    _init();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.eDischargeConsultant', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      // Main
      .state('app.eDischargeConsultant', {
        url: '/e-discharge-consultant',
        views: {
          'content@app': {
            templateUrl:
              'app/main/e-discharge-consultant/e-discharge-consultant.html',
            controller: 'EdischargeConsultantController',
            controllerAs: 'vm'
          }
        },
        params: {
          searchTerm: null,
          page: 0,
          pageLength: 25,
          // Default to first one
          statusFilterIndex: 0
        },
        bodyClass: 'e-discharge-consultant',
        moduleName: 'E-Discharge List (Consultant View)'
      })
      // Edit
      .state('app.eDischargeConsultant.edit', {
        url: '/edit/:id',
        views: {
          'content@app': {
            templateUrl:
              'app/main/e-discharge-consultant/edit/e-discharge-consultant-edit.html',
            controller: 'EdischargeConsultantEditController',
            controllerAs: 'vm'
          }
        },
        bodyClass: 'e-discharge-consultant-edit',
        moduleName: 'E-Discharge List (Consultant View)'
      })
      // View
      .state('app.eDischargeConsultant.view', {
        url: '/view/:id',
        views: {
          'content@app': {
            templateUrl:
              'app/main/e-discharge-consultant/view/e-discharge-consultant-view.html',
            controller: 'EdischargeConsultantViewController',
            controllerAs: 'vm'
          }
        },
        bodyClass: 'e-discharge-consultant-view',
        moduleName: 'E-Discharge List (Consultant View)'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.eDischargeConsultant')
    .controller('EdischargeConsultantVisitDialogController', Controller);

  /** @ngInject */
  function Controller(
    dataSource,
    $scope,
    $rootScope,
    $http,
    $q,
    sharedService,
    $mdDialog
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data

    // Exposed Data
    vm.loading = false;

    vm.dataSource = {
      amount: 100 // Default fee
    };

    // Exposed methods
    vm.close = _close;

    vm.save = _save;
    vm.setVisitType = _setVisitType;

    function _init() {
      vm.dataSource.e_discharge_doctor_id = dataSource.e_discharge_doctor_id;

      if (dataSource.id) {
        vm.loading = true;

        $http
          .get($rootScope.routePath + '/eDischarge/getEdischargeVisitById', {
            params: {
              eDischargeVisitId: dataSource.id
            }
          })
          .then(function (res) {
            res = res.data;

            if (!res.success) {
              return $q.reject(new Error(res.message));
            }

            res.data.result.visit_datetime = res.data.result.visit_datetime
              ? moment(res.data.result.visit_datetime)
              : null;

            vm.dataSource = res.data.result;
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }

            $mdDialog.hide();
          })
          .finally(function () {
            vm.loading = false;
          });
      } else {
        var defaultVisitDatetime = moment();
        var remainder = defaultVisitDatetime.minute() % 5;

        vm.dataSource.visit_datetime = defaultVisitDatetime
          .subtract(remainder, 'minutes')
          .startOf('minute');
      }
    }

    function _close() {
      $mdDialog.hide();
    }

    function _save() {
      var payload = {
        e_discharge_doctor_id: vm.dataSource.e_discharge_doctor_id,
        visit_datetime: vm.dataSource.visit_datetime.toISOString(),
        visit_type: vm.dataSource.visit_type,
        amount: vm.dataSource.amount,
        remark: vm.dataSource.remark
      };

      if (vm.dataSource.id) {
        payload.id = vm.dataSource.id;
      }

      $http
        .post($rootScope.routePath + '/eDischarge/saveEdischargeVisit', payload)
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          $mdDialog.hide({
            reload: true
          });
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _setVisitType(data) {
      vm.dataSource.visit_type = data;
      $rootScope.dialogForm.$setDirty(true);
    }

    function _destroy() {}
  }
})();

(function () {
	'use strict';

	angular
		.module('app.sms', ['datatables', 'datatables.scroller'])
		.config(config);

	/** @ngInject */
	function config($stateProvider) {
		$stateProvider
			// Main
			.state('app.sms', {
				url: '/sms',
				views: {
					'content@app': {
						templateUrl: 'app/main/sms/sms2.html',
						controller: 'Sms2Controller as vm'
					}
				},
				bodyClass: 'sms',
				moduleName: 'SMS'
			});
	}
})();
(function () {
  'use strict';

  angular
    .module('app.sms')
    .controller('SmsExportExcelDialogController', SmsExportExcelDialogController);

  /** @ngInject */
  function SmsExportExcelDialogController(fromDate, toDate, $http, $q, $rootScope, sharedService, accountService, $mdMedia, $mdDialog, $state) {
    var vm = this;

    // Hooks

    // Local data

    // Exposed data
    vm.mediaXsActionButtons = $mdMedia('gt-xs') ? '' : 'md-mini';

    // Exposed methods
    vm.limitDateRange = _limitDateRange;

    vm.exportExcel = _exportExcel;
    vm.close = _close;

    // Method definitions
    function _init() {
      vm.fromDate = fromDate;
      vm.toDate = toDate;
    }

    function _limitDateRange() {
      var duration = moment.duration(vm.toDate.diff(vm.fromDate));
      var days = duration.asDays();
      if (days > 30) {
        sharedService.showToast('WARNING: Date range larger than 30 days might be slow to process.');
      }
    }

    function _exportExcel() {
      $mdDialog.hide({
        export: true,
        fromDate: vm.fromDate,
        toDate: vm.toDate,
      });
    }

    function _close() {
      $mdDialog.hide();
    }

    // Initializations
    _init();
  }
})();
(function () {
  'use strict';

  angular
    .module('app.roster', ['ui.calendar'])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      // Main
      .state('app.roster', {
        url: '/roster',
        views: {
          'content@app': {
            templateUrl: 'app/main/roster/roster.html',
            controller: 'RosterController',
            controllerAs: 'vm'
          }
        },
        bodyClass: 'roster',
        moduleName: 'Roster'
      })
      // Edit
      .state('app.roster.edit', {
        url: '/edit',
        views: {
          'content@app': {
            templateUrl: 'app/main/roster/edit/roster-edit.html',
            controller: 'RosterEditController',
            controllerAs: 'vm'
          }
        },
        bodyClass: 'roster-edit',
        moduleName: 'Roster'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.roster')
    .controller('RosterDetailDialogController', RosterDetailDialogController);

  /** @ngInject */
  function RosterDetailDialogController($rootScope, $http, $mdDialog, sharedService, roster, canModify, canDelete) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;

    // Exposed data
    vm.canModify = canModify;
    vm.canDelete = canDelete;

    vm.roster = roster;
    vm.isEditing = false;
    vm.startDatetime = undefined; // For some reason it cannot be assigned null
    vm.endDatetime = undefined; // For some reason it cannot be assigned null

    // Exposed methods
    vm.edit = _edit;
    vm.delete = _delete;
    vm.close = _close;

    // Method definitions
    function _init() {
      vm.roster.start_datetime_display = moment(vm.roster.start_datetime).format('DD/MM/YYYY hh:mm a');
      vm.roster.end_datetime_display = moment(vm.roster.end_datetime).format('DD/MM/YYYY hh:mm a');
    }

    function _edit() {
      $http.post($rootScope.routePath + '/roster/save', {
          rosterId: roster.id,
          rosterStartDatetime: vm.startDatetime.toISOString(),
          rosterEndDatetime: vm.endDatetime.toISOString()
        })
        .then(function (res) {
          res = res.data;

          sharedService.showToast(res.message);

          if (res.success) {
            $mdDialog.hide({
              reloadData: true,
              action: 'UPDATE',
              rosterStartDatetime: vm.startDatetime
            });
          }
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _delete() {
      var confirm = $mdDialog.confirm()
        .multiple(true)
        .title('Delete Confirmation')
        .textContent('Are you sure you want to delete this roster "' + roster.profile_name + '" at "' + roster.start_datetime_display + '"? This action is irreversible!')
        .ok('DELETE')
        .cancel('CANCEL');

      $mdDialog.show(confirm)
        .then(function () {
          return $http.post($rootScope.routePath + '/roster/deleteById', {
              rosterId: roster.id
            })
            .then(function (res) {
              res = res.data;

              sharedService.showToast(res.message);

              if (res.success) {
                $mdDialog.hide({
                  reloadData: true,
                  action: 'DELETE'
                });
              }
            })
            .catch(function (err) {
              if (err.message) {
                sharedService.showToast(err.message);
              } else {
                sharedService.showToast('Request timed out.');
              }
            });
        });
    }

    function _close() {
      $mdDialog.hide();
    }
  }
})();

(function() {
	'use strict';

	angular
		.module('app.operationTheater', ['datatables', 'datatables.scroller'])
		.config(config);
	
	/** @ngInject */
	function config($stateProvider, msApiProvider) {
		$stateProvider
		// Main
		.state('app.operationTheater', {
			url: '/operation-theater',
			views: {
				'content@app': {
					templateUrl: 'app/main/operation-theater/operation-theater.html',
					controller: 'OperationTheaterController as vm'
				}
			},
			bodyClass: 'operation-theater',
			moduleName: 'Operation Theater'
		})
		// Edit
		.state('app.operationTheater.edit', {
			url: '/edit/:id',
			views: {
				'content@app': {
					templateUrl: 'app/main/operation-theater/edit/operation-theater-edit.html',
					controller: 'OperationTheaterEditController as vm'
				}
			},
			params: {
				id: {
					value: null,
					squash: true
				}
			},
			bodyClass: 'operation-theater-edit',
			moduleName: 'Operation Theater'
		});
	}
})();
(function () {
  'use strict';

  angular
    .module('app.operationTheater')
    .controller('OperationTheaterDetailDialogController', OperationTheaterDetailDialogController);

  /** @ngInject */
  function OperationTheaterDetailDialogController(bookingId, $http, $q, $rootScope, sharedService, accountService, $mdMedia, $mdDialog, $state, Role, OperationTheater, Todo) {
    var vm = this;

    // Data
    vm.todo = null;
    vm.memo = new Todo({
      type: Todo.TYPE.OT_BOOKING,
      created_by: accountService.user.username,
      created_by_role: accountService.user.getFirstRole(),
      status: Todo.STATUS.COMPLETED
    });
    vm.booking = null;

    vm.loading = true;
    vm.showRequestButton = false;
    vm.showCompleteButton = false;

    vm.mediaXsActionButtons = $mdMedia('gt-xs') ? '' : 'md-mini';

    // Methods
    vm.edit = edit;
    vm.complete = complete;
    vm.close = close;

    init();

    //////////

    function init() {
      $http.get($rootScope.routePath + '/todo/get-booking', {
          params: {
            id: bookingId
          }
        })
        .then(function (res) {
          res = res.data;
          if (!res.success) return $q.reject(res.message);

          vm.booking = res.data.booking;
          vm.todo = new Todo(res.data.todo);

          vm.showRequestButton = false;
          vm.showCompleteButton = vm.todo.status !== Todo.STATUS.COMPLETED && accountService.user.hasRole(Role.NAME.PRE_ADMISSION_STAFF);
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
          $mdDialog.hide();
        })
        .finally(function () {
          vm.loading = false;
        });
    }

    function edit() {
      $state.go('app.operationTheater.edit', {
        id: bookingId
      });
      $mdDialog.hide();
    }

    function complete() {
      if (!vm.memo.remarks) return;

      vm.todo.status = Todo.STATUS.COMPLETED;
      vm.memo.created_for = vm.todo.created_by;
      vm.memo.created_for_role = vm.todo.created_by_role;

      $http.post($rootScope.routePath + '/todo/complete-request', {
          todo: vm.todo,
          memo: vm.memo
        })
        .then(function (res) {
          res = res.data;
          if (!res.success) return $q.reject(res.message);
          $mdDialog.hide({
            reload: true
          });
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function close() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.eDischargeStaff', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      // Main
      .state('app.eDischargeStaff', {
        url: '/e-discharge-staff',
        views: {
          'content@app': {
            templateUrl: 'app/main/e-discharge-staff/e-discharge-staff.html',
            controller: 'EdischargeStaffController',
            controllerAs: 'vm'
          }
        },
        params: {
          searchTerm: null,
          page: 0,
          pageLength: 25,
          // Default to first one
          statusFilterIndex: 0
        },
        bodyClass: 'e-discharge-staff',
        moduleName: 'E-Discharge List (Staff View)'
      })
      // Edit
      .state('app.eDischargeStaff.edit', {
        url: '/edit/:id',
        views: {
          'content@app': {
            templateUrl:
              'app/main/e-discharge-staff/edit/e-discharge-staff-edit.html',
            controller: 'EdischargeStaffEditController',
            controllerAs: 'vm'
          }
        },
        bodyClass: 'e-discharge-staff-edit',
        moduleName: 'E-Discharge List (Staff View)'
      })
      // View
      .state('app.eDischargeStaff.view', {
        url: '/view/:id',
        views: {
          'content@app': {
            templateUrl:
              'app/main/e-discharge-staff/view/e-discharge-staff-view.html',
            controller: 'EdischargeStaffViewController',
            controllerAs: 'vm'
          }
        },
        bodyClass: 'e-discharge-staff-view',
        moduleName: 'E-Discharge List (Staff View)'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.eDischargeStaff')
    .controller('EdischargeStaffProcedureDialogController', Controller);

  /** @ngInject */
  function Controller(
    dataSource,
    $scope,
    $rootScope,
    $http,
    $q,
    sharedService,
    $mdDialog
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data

    // Exposed Data
    vm.loading = false;

    vm.dataSource = {
      is_anaesthetic: false
    };

    vm.procedure = null;
    vm.searchProcedure = '';
    vm.consultant = null;
    vm.searchConsultant = '';

    // Exposed methods
    vm.close = _close;

    vm.save = _save;
    vm.setConsultant = _setConsultant;
    vm.acProcedure = _acProcedure;
    vm.acConsultant = _acConsultant;

    function _init() {
      vm.dataSource.e_discharge_doctor_id = dataSource.e_discharge_doctor_id;

      if (dataSource.id) {
        vm.loading = true;

        $http
          .get(
            $rootScope.routePath + '/eDischarge/getEdischargeProcedureById',
            {
              params: {
                eDischargeProcedureId: dataSource.id
              }
            }
          )
          .then(function (res) {
            res = res.data;

            if (!res.success) {
              return $q.reject(new Error(res.message));
            }

            vm.dataSource = res.data.result;

            vm.searchProcedure = res.data.result.procedure_name;
            vm.procedure = {
              ext_id: res.data.result.procedure_external_id,
              transaction_code: res.data.result.procedure_code,
              transaction_code_description: res.data.result.procedure_name,
              procedure_detail: {
                mma_code: res.data.result.procedure_mma_code
              }
            };

            vm.searchConsultant = res.data.result.doctor_username;
            vm.consultant = {
              ext_id: res.data.result.doctor_external_id,
              code: res.data.result.doctor_username,
              name: res.data.result.doctor_name
            };
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }

            $mdDialog.hide();
          })
          .finally(function () {
            vm.loading = false;
          });
      }
    }

    function _close() {
      $mdDialog.hide();
    }

    function _save() {
      var payload = {
        e_discharge_doctor_id: vm.dataSource.e_discharge_doctor_id,
        amount: vm.dataSource.amount,
        is_anaesthetic: vm.dataSource.is_anaesthetic
      };

      if (vm.dataSource.id) {
        payload.id = vm.dataSource.id;
      }
      if (vm.procedure) {
        payload.procedure_external_id = vm.procedure.ext_id;
      }
      if (vm.consultant) {
        payload.doctor_external_id = vm.consultant.ext_id;
      }

      $http
        .post(
          $rootScope.routePath + '/eDischarge/saveEdischargeProcedure',
          payload
        )
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          $mdDialog.hide({
            reload: true
          });
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _setConsultant(data) {
      vm.consultant = data;
      vm.searchConsultant = '';
    }

    function _acProcedure() {
      return $http
        .get($rootScope.routePath + '/eDischarge/searchProcedures', {
          params: {
            q: vm.searchProcedure,
            datetime: moment().toISOString()
          }
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            return res.data.result;
          }

          return [];
        })
        .catch(function (err) {
          return [];
        });
    }

    function _acConsultant() {
      return $http
        .get($rootScope.routePath + '/eDischarge/searchConsultants', {
          params: {
            q: vm.searchConsultant
          }
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            return res.data.result;
          }

          return [];
        })
        .catch(function (err) {
          return [];
        });
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('app.eDischargeStaff')
    .controller('EdischargeStaffVisitDialogController', Controller);

  /** @ngInject */
  function Controller(
    dataSource,
    $scope,
    $rootScope,
    $http,
    $q,
    sharedService,
    $mdDialog
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data

    // Exposed Data
    vm.loading = false;

    vm.dataSource = {
      amount: 100 // Default fee
    };

    // Exposed methods
    vm.close = _close;

    vm.save = _save;
    vm.setVisitType = _setVisitType;

    function _init() {
      vm.dataSource.e_discharge_doctor_id = dataSource.e_discharge_doctor_id;

      if (dataSource.id) {
        vm.loading = true;

        $http
          .get($rootScope.routePath + '/eDischarge/getEdischargeVisitById', {
            params: {
              eDischargeVisitId: dataSource.id
            }
          })
          .then(function (res) {
            res = res.data;

            if (!res.success) {
              return $q.reject(new Error(res.message));
            }

            res.data.result.visit_datetime = res.data.result.visit_datetime
              ? moment(res.data.result.visit_datetime)
              : null;

            vm.dataSource = res.data.result;
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }

            $mdDialog.hide();
          })
          .finally(function () {
            vm.loading = false;
          });
      } else {
        var defaultVisitDatetime = moment();
        var remainder = defaultVisitDatetime.minute() % 5;

        vm.dataSource.visit_datetime = defaultVisitDatetime
          .subtract(remainder, 'minutes')
          .startOf('minute');
      }
    }

    function _close() {
      $mdDialog.hide();
    }

    function _save() {
      var payload = {
        e_discharge_doctor_id: vm.dataSource.e_discharge_doctor_id,
        visit_datetime: vm.dataSource.visit_datetime.toISOString(),
        visit_type: vm.dataSource.visit_type,
        amount: vm.dataSource.amount,
        remark: vm.dataSource.remark
      };

      if (vm.dataSource.id) {
        payload.id = vm.dataSource.id;
      }

      $http
        .post($rootScope.routePath + '/eDischarge/saveEdischargeVisit', payload)
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          $mdDialog.hide({
            reload: true
          });
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _setVisitType(data) {
      vm.dataSource.visit_type = data;
      $rootScope.dialogForm.$setDirty(true);
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('app.eDischargeStaff')
    .controller('EdischargeStaffAmendVisitDialogController', Controller);

  /** @ngInject */
  function Controller(
    dataSource,
    $scope,
    $rootScope,
    $http,
    $q,
    sharedService,
    $mdDialog
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data

    // Exposed Data
    vm.loading = false;

    vm.dataSource = {
      amount: 100 // Default fee
    };

    // Exposed methods
    vm.close = _close;

    vm.save = _save;
    vm.setVisitType = _setVisitType;

    function _init() {
      vm.dataSource.e_discharge_doctor_id = dataSource.e_discharge_doctor_id;

      if (dataSource.id) {
        vm.loading = true;

        $http
          .get($rootScope.routePath + '/eDischarge/getEdischargeVisitById', {
            params: {
              eDischargeVisitId: dataSource.id
            }
          })
          .then(function (res) {
            res = res.data;

            if (!res.success) {
              return $q.reject(new Error(res.message));
            }

            res.data.result.visit_datetime = res.data.result.visit_datetime
              ? moment(res.data.result.visit_datetime)
              : null;

            vm.dataSource = res.data.result;
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }

            $mdDialog.hide();
          })
          .finally(function () {
            vm.loading = false;
          });
      } else {
        var defaultVisitDatetime = moment();
        var remainder = defaultVisitDatetime.minute() % 5;

        vm.dataSource.visit_datetime = defaultVisitDatetime
          .subtract(remainder, 'minutes')
          .startOf('minute');
      }
    }

    function _close() {
      $mdDialog.hide();
    }

    function _save() {
      var payload = {
        eDischargeFormId: dataSource.eDischargeFormId,
        e_discharge_doctor_id: vm.dataSource.e_discharge_doctor_id,
        visit_datetime: vm.dataSource.visit_datetime.toISOString(),
        visit_type: vm.dataSource.visit_type,
        amount: vm.dataSource.amount,
        remark: vm.dataSource.remark
      };

      if (vm.dataSource.id) {
        payload.amend_for_id = vm.dataSource.id;
      }

      $http
        .post(
          $rootScope.routePath + '/eDischarge/amendEdischargeVisit',
          payload
        )
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          $mdDialog.hide({
            reload: true
          });
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _setVisitType(data) {
      vm.dataSource.visit_type = data;
      $rootScope.dialogForm.$setDirty(true);
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('app.eDischargeStaff')
    .controller('EdischargeStaffAmendProcedureDialogController', Controller);

  /** @ngInject */
  function Controller(
    dataSource,
    $scope,
    $rootScope,
    $http,
    $q,
    sharedService,
    $mdDialog
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data

    // Exposed Data
    vm.loading = false;

    vm.dataSource = {
      is_anaesthetic: false
    };

    vm.procedure = null;
    vm.searchProcedure = '';
    vm.consultant = null;
    vm.searchConsultant = '';

    // Exposed methods
    vm.close = _close;

    vm.save = _save;
    vm.setConsultant = _setConsultant;
    vm.acProcedure = _acProcedure;
    vm.acConsultant = _acConsultant;

    function _init() {
      vm.dataSource.e_discharge_doctor_id = dataSource.e_discharge_doctor_id;

      if (dataSource.id) {
        vm.loading = true;

        $http
          .get(
            $rootScope.routePath + '/eDischarge/getEdischargeProcedureById',
            {
              params: {
                eDischargeProcedureId: dataSource.id
              }
            }
          )
          .then(function (res) {
            res = res.data;

            if (!res.success) {
              return $q.reject(new Error(res.message));
            }

            vm.dataSource = res.data.result;

            vm.searchProcedure = res.data.result.procedure_name;
            vm.procedure = {
              ext_id: res.data.result.procedure_external_id,
              transaction_code: res.data.result.procedure_code,
              transaction_code_description: res.data.result.procedure_name,
              procedure_detail: {
                mma_code: res.data.result.procedure_mma_code
              }
            };

            vm.searchConsultant = res.data.result.doctor_username;
            vm.consultant = {
              ext_id: res.data.result.doctor_external_id,
              code: res.data.result.doctor_username,
              name: res.data.result.doctor_name
            };
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }

            $mdDialog.hide();
          })
          .finally(function () {
            vm.loading = false;
          });
      }
    }

    function _close() {
      $mdDialog.hide();
    }

    function _save() {
      var payload = {
        eDischargeFormId: dataSource.eDischargeFormId,
        e_discharge_doctor_id: vm.dataSource.e_discharge_doctor_id,
        amount: vm.dataSource.amount,
        is_anaesthetic: vm.dataSource.is_anaesthetic
      };

      if (vm.dataSource.id) {
        payload.amend_for_id = vm.dataSource.id;
      }
      if (vm.procedure) {
        payload.procedure_external_id = vm.procedure.ext_id;
      }
      if (vm.consultant) {
        payload.doctor_external_id = vm.consultant.ext_id;
      }

      $http
        .post(
          $rootScope.routePath + '/eDischarge/amendEdischargeProcedure',
          payload
        )
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          $mdDialog.hide({
            reload: true
          });
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _setConsultant(data) {
      vm.consultant = data;
      vm.searchConsultant = '';
    }

    function _acProcedure() {
      return $http
        .get($rootScope.routePath + '/eDischarge/searchProcedures', {
          params: {
            q: vm.searchProcedure,
            datetime: moment().toISOString()
          }
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            return res.data.result;
          }

          return [];
        })
        .catch(function (err) {
          return [];
        });
    }

    function _acConsultant() {
      return $http
        .get($rootScope.routePath + '/eDischarge/searchConsultants', {
          params: {
            q: vm.searchConsultant
          }
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            return res.data.result;
          }

          return [];
        })
        .catch(function (err) {
          return [];
        });
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('app.eDischargeStaff')
    .controller('EdischargeStaffAddDoctorDialogController', Controller);

  /** @ngInject */
  function Controller(
    dataSource,
    $scope,
    $rootScope,
    $http,
    $q,
    sharedService,
    $mdDialog
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data

    // Exposed Data
    vm.loading = false;

    vm.dataSource = {};

    vm.doctor = null;
    vm.searchDoctor = '';

    // Exposed methods
    vm.close = _close;

    vm.save = _save;
    vm.acDoctor = _acDoctor;

    function _init() {}

    function _close() {
      $mdDialog.hide();
    }

    function _save() {
      var confirm = $mdDialog
        .confirm()
        .title('Add Doctor Confirmation')
        .textContent(
          'Are you sure you want to add the doctor "' +
            vm.doctor.name +
            '" for this patient "' +
            dataSource.patientName +
            ' (' +
            dataSource.episodeNumber +
            ')"? This action is irreversible!'
        )
        .ok('OK')
        .cancel('CANCEL')
        .multiple(true);

      $mdDialog
        .show(confirm)
        .then(function () {
          var payload = {
            eDischargeEpisodeExternalId: dataSource.eDischargeEpisodeExternalId,
            acDoctorExtId: vm.doctor.ext_id
          };

          $http
            .post(
              $rootScope.routePath + '/eDischarge/staff/addEdischargeDoctor',
              payload
            )
            .then(function (res) {
              res = res.data;

              if (!res.success) {
                return $q.reject(new Error(res.message));
              }

              sharedService.showToast(res.message);

              $mdDialog.hide({
                reload: true
              });
            })
            .catch(function (err) {
              if (err.message) {
                sharedService.showToast(err.message);
              } else {
                sharedService.showToast('Request timed out.');
              }
            });
        })
        .catch(function () {
          $mdDialog.hide();
        });
    }

    function _acDoctor() {
      return $http
        .get($rootScope.routePath + '/eDischarge/searchDoctors', {
          params: {
            q: vm.searchDoctor
          }
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            return res.data.result;
          }

          return [];
        })
        .catch(function (err) {
          return [];
        });
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('app.eDischargeConsultant')
    .controller(
      'EdischargeConsultantAmendProcedureDialogController',
      Controller
    );

  /** @ngInject */
  function Controller(
    dataSource,
    $scope,
    $rootScope,
    $http,
    $q,
    sharedService,
    $mdDialog
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data

    // Exposed Data
    vm.loading = false;

    vm.dataSource = {
      is_anaesthetic: false
    };

    vm.procedure = null;
    vm.searchProcedure = '';
    vm.consultant = null;
    vm.searchConsultant = '';

    // Exposed methods
    vm.close = _close;

    vm.save = _save;
    vm.setConsultant = _setConsultant;
    vm.acProcedure = _acProcedure;
    vm.acConsultant = _acConsultant;

    function _init() {
      vm.dataSource.e_discharge_doctor_id = dataSource.e_discharge_doctor_id;

      if (dataSource.id) {
        vm.loading = true;

        $http
          .get(
            $rootScope.routePath + '/eDischarge/getEdischargeProcedureById',
            {
              params: {
                eDischargeProcedureId: dataSource.id
              }
            }
          )
          .then(function (res) {
            res = res.data;

            if (!res.success) {
              return $q.reject(new Error(res.message));
            }

            vm.dataSource = res.data.result;

            vm.searchProcedure = res.data.result.procedure_name;
            vm.procedure = {
              ext_id: res.data.result.procedure_external_id,
              transaction_code: res.data.result.procedure_code,
              transaction_code_description: res.data.result.procedure_name,
              procedure_detail: {
                mma_code: res.data.result.procedure_mma_code
              }
            };

            vm.searchConsultant = res.data.result.doctor_username;
            vm.consultant = {
              ext_id: res.data.result.doctor_external_id,
              code: res.data.result.doctor_username,
              name: res.data.result.doctor_name
            };
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }

            $mdDialog.hide();
          })
          .finally(function () {
            vm.loading = false;
          });
      }
    }

    function _close() {
      $mdDialog.hide();
    }

    function _save() {
      var payload = {
        eDischargeFormId: dataSource.eDischargeFormId,
        e_discharge_doctor_id: vm.dataSource.e_discharge_doctor_id,
        amount: vm.dataSource.amount,
        is_anaesthetic: vm.dataSource.is_anaesthetic
      };

      if (vm.dataSource.id) {
        payload.amend_for_id = vm.dataSource.id;
      }
      if (vm.procedure) {
        payload.procedure_external_id = vm.procedure.ext_id;
      }
      if (vm.consultant) {
        payload.doctor_external_id = vm.consultant.ext_id;
      }

      $http
        .post(
          $rootScope.routePath + '/eDischarge/amendEdischargeProcedure',
          payload
        )
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          $mdDialog.hide({
            reload: true
          });
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _setConsultant(data) {
      vm.consultant = data;
      vm.searchConsultant = '';
    }

    function _acProcedure() {
      return $http
        .get($rootScope.routePath + '/eDischarge/searchProcedures', {
          params: {
            q: vm.searchProcedure,
            datetime: moment().toISOString()
          }
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            return res.data.result;
          }

          return [];
        })
        .catch(function (err) {
          return [];
        });
    }

    function _acConsultant() {
      return $http
        .get($rootScope.routePath + '/eDischarge/searchConsultants', {
          params: {
            q: vm.searchConsultant
          }
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            return res.data.result;
          }

          return [];
        })
        .catch(function (err) {
          return [];
        });
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('app.eDischargeConsultant')
    .controller('EdischargeConsultantProcedureDialogController', Controller);

  /** @ngInject */
  function Controller(
    dataSource,
    $scope,
    $rootScope,
    $http,
    $q,
    sharedService,
    $mdDialog
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data

    // Exposed Data
    vm.loading = false;

    vm.dataSource = {
      is_anaesthetic: false
    };

    vm.procedure = null;
    vm.searchProcedure = '';
    vm.consultant = null;
    vm.searchConsultant = '';

    // Exposed methods
    vm.close = _close;

    vm.save = _save;
    vm.setConsultant = _setConsultant;
    vm.acProcedure = _acProcedure;
    vm.acConsultant = _acConsultant;

    function _init() {
      vm.dataSource.e_discharge_doctor_id = dataSource.e_discharge_doctor_id;

      if (dataSource.id) {
        vm.loading = true;

        $http
          .get(
            $rootScope.routePath + '/eDischarge/getEdischargeProcedureById',
            {
              params: {
                eDischargeProcedureId: dataSource.id
              }
            }
          )
          .then(function (res) {
            res = res.data;

            if (!res.success) {
              return $q.reject(new Error(res.message));
            }

            vm.dataSource = res.data.result;

            vm.searchProcedure = res.data.result.procedure_name;
            vm.procedure = {
              ext_id: res.data.result.procedure_external_id,
              transaction_code: res.data.result.procedure_code,
              transaction_code_description: res.data.result.procedure_name,
              procedure_detail: {
                mma_code: res.data.result.procedure_mma_code
              }
            };

            vm.searchConsultant = res.data.result.doctor_username;
            vm.consultant = {
              ext_id: res.data.result.doctor_external_id,
              code: res.data.result.doctor_username,
              name: res.data.result.doctor_name
            };
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }

            $mdDialog.hide();
          })
          .finally(function () {
            vm.loading = false;
          });
      }
    }

    function _close() {
      $mdDialog.hide();
    }

    function _save() {
      var payload = {
        e_discharge_doctor_id: vm.dataSource.e_discharge_doctor_id,
        amount: vm.dataSource.amount,
        is_anaesthetic: vm.dataSource.is_anaesthetic
      };

      if (vm.dataSource.id) {
        payload.id = vm.dataSource.id;
      }
      if (vm.procedure) {
        payload.procedure_external_id = vm.procedure.ext_id;
      }
      if (vm.consultant) {
        payload.doctor_external_id = vm.consultant.ext_id;
      }

      $http
        .post(
          $rootScope.routePath + '/eDischarge/saveEdischargeProcedure',
          payload
        )
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          $mdDialog.hide({
            reload: true
          });
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _setConsultant(data) {
      vm.consultant = data;
      vm.searchConsultant = '';
    }

    function _acProcedure() {
      return $http
        .get($rootScope.routePath + '/eDischarge/searchProcedures', {
          params: {
            q: vm.searchProcedure,
            datetime: moment().toISOString()
          }
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            return res.data.result;
          }

          return [];
        })
        .catch(function (err) {
          return [];
        });
    }

    function _acConsultant() {
      return $http
        .get($rootScope.routePath + '/eDischarge/searchConsultants', {
          params: {
            q: vm.searchConsultant
          }
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            return res.data.result;
          }

          return [];
        })
        .catch(function (err) {
          return [];
        });
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('app.eDischargeConsultant')
    .controller('EdischargeConsultantAmendVisitDialogController', Controller);

  /** @ngInject */
  function Controller(
    dataSource,
    $scope,
    $rootScope,
    $http,
    $q,
    sharedService,
    $mdDialog
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data

    // Exposed Data
    vm.loading = false;

    vm.dataSource = {
      amount: 100 // Default fee
    };

    // Exposed methods
    vm.close = _close;

    vm.save = _save;
    vm.setVisitType = _setVisitType;

    function _init() {
      vm.dataSource.e_discharge_doctor_id = dataSource.e_discharge_doctor_id;

      if (dataSource.id) {
        vm.loading = true;

        $http
          .get($rootScope.routePath + '/eDischarge/getEdischargeVisitById', {
            params: {
              eDischargeVisitId: dataSource.id
            }
          })
          .then(function (res) {
            res = res.data;

            if (!res.success) {
              return $q.reject(new Error(res.message));
            }

            res.data.result.visit_datetime = res.data.result.visit_datetime
              ? moment(res.data.result.visit_datetime)
              : null;

            vm.dataSource = res.data.result;
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }

            $mdDialog.hide();
          })
          .finally(function () {
            vm.loading = false;
          });
      } else {
        var defaultVisitDatetime = moment();
        var remainder = defaultVisitDatetime.minute() % 5;

        vm.dataSource.visit_datetime = defaultVisitDatetime
          .subtract(remainder, 'minutes')
          .startOf('minute');
      }
    }

    function _close() {
      $mdDialog.hide();
    }

    function _save() {
      var payload = {
        eDischargeFormId: dataSource.eDischargeFormId,
        e_discharge_doctor_id: vm.dataSource.e_discharge_doctor_id,
        visit_datetime: vm.dataSource.visit_datetime.toISOString(),
        visit_type: vm.dataSource.visit_type,
        amount: vm.dataSource.amount,
        remark: vm.dataSource.remark
      };

      if (vm.dataSource.id) {
        payload.amend_for_id = vm.dataSource.id;
      }

      $http
        .post(
          $rootScope.routePath + '/eDischarge/amendEdischargeVisit',
          payload
        )
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          $mdDialog.hide({
            reload: true
          });
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _setVisitType(data) {
      vm.dataSource.visit_type = data;
      $rootScope.dialogForm.$setDirty(true);
    }

    function _destroy() {}
  }
})();

(function() {
	'use strict';

	angular
		.module('app.bill', [])
		.config(config);
	
	/** @ngInject */
	function config($stateProvider, msApiProvider) {
		$stateProvider
		// Main
		.state('app.bill', {
			url: '/bill/:id',
			views: {
				'content@app': {
					templateUrl: 'app/main/bill/bill.html',
					controller: 'BillController as vm'
				}
			},
			params: {
				id: {
					value: null,
					squash: true
				}
			},
			bodyClass: 'bill',
			moduleName: 'Bill'
		});
	}
})();
(function() {
	'use strict';

	angular
		.module('app.bill')
		.controller('BillDetailDialogController', BillDetailDialogController);
	
	/** @ngInject */
	function BillDetailDialogController(billId, $rootScope, $http, $q, $window, sharedService, accountService, $mdMedia, $mdDialog, $state, Role, Todo) {
		var vm = this;

		// Data
		vm.todo = null;
		vm.memo = new Todo({
			type: Todo.TYPE.BILLING,
			created_by: accountService.user.username,
			created_by_role: accountService.user.getFirstRole(),
			status: Todo.STATUS.COMPLETED
		});
		vm.bill = null;
		vm.attachmentLink = null;
		
		vm.loading = true;
		vm.showRequestButton = false;
		vm.showCompleteButton = false;

		vm.mediaXsActionButtons = $mdMedia('gt-xs') ? '' : 'md-mini';

		// Methods
		vm.edit = edit;
		vm.complete = complete;
		vm.close = close;
		vm.downloadAttachment = downloadAttachment;

		init();

		//////////

		function init() {
			$http.get($rootScope.routePath + '/todo/getBill', {
				params: {
					id: billId
				}
			})
			.then(function(res) {
				res = res.data;
				if (!res.success) return $q.reject(res.message);

				vm.bill = res.data.bill;
				vm.todo = new Todo(res.data.todo);
				vm.todos = res.data.todos;
				vm.todoAttachments = res.data.todoAttachments;
				vm.attachmentLink = vm.todo.attachment ? $rootScope.routePath + '/uploads/billingAttachments/' + vm.todo.attachment : null;

				vm.showRequestButton = false;
				vm.showCompleteButton = vm.todo.status !== Todo.STATUS.COMPLETED && (accountService.user.hasRole(Role.NAME.DOCTOR) || accountService.user.hasRole(Role.NAME.PERSONAL_ASSISTANT));
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
				$mdDialog.hide();
			})
			.finally(function() {
				vm.loading = false;
			});
		}

		function edit() {
			$state.go('app.bill', {
				id: billId
			});
			$mdDialog.hide();
		}

		function complete() {
			if (!vm.memo.remarks) return;

			vm.todo.status = Todo.STATUS.COMPLETED;
			vm.memo.created_for = vm.todo.created_by;
			vm.memo.created_for_role = vm.todo.created_by_role;

			$http.post($rootScope.routePath + '/todo/completeBillingRequest', {
				todo: vm.todo,
				memo: vm.memo
			})
			.then(function(res) {
				res = res.data;
				if (!res.success) return $q.reject(res.message);
				$mdDialog.hide({
					reload: true
				});
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			});
		}

		function close() {
			$mdDialog.hide();
		}

		function downloadAttachment(attachment) {
			$http.get($rootScope.routePath + '/todo/downloadBillingAttachment', {
				params: {
					attachment: attachment.path,
					attachmentName: attachment.original_file_name,
				},
				responseType: 'arraybuffer'
			})
				.then(function (res) {
					var header = res.headers('Content-Disposition');
					var fileName = header.split('=')[1].replace(/\"/gi, '');

					var blob = new Blob([res.data], {
						type: res.headers('Content-Type')
					});
					var objectUrl = ($window.URL || $window.webkitURL).createObjectURL(blob);
					var link = angular.element('<a/>');
					link.attr({
						href: objectUrl,
						download: fileName
					})[0].click();
				})
				.catch(function (err) {
					if (err.message) sharedService.showToast(err.message);
					else sharedService.showToast('Request timed out.');
				});
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('app.appointment', ['ui.calendar'])
		.config(config);
	
	/** @ngInject */
	function config($stateProvider, msApiProvider) {
		$stateProvider
		// Main
		.state('app.appointment', {
			url: '/appointment',
			views: {
				'content@app': {
					templateUrl: 'app/main/appointment/appointment.html',
					controller: 'AppointmentController as vm'
				}
			},
			bodyClass: 'appointment',
			moduleName: 'Appointment'
		})
		// Edit
		.state('app.appointment.edit', {
			url: '/edit/:id',
			views: {
				'content@app': {
					templateUrl: 'app/main/appointment/edit/appointment-edit.html',
					controller: 'AppointmentEditController as vm'
				}
			},
			params: {
				id: {
					value: null,
					squash: true,
				}
			},
			bodyClass: 'appointment-edit',
			moduleName: 'Appointment'
		});
	}
})();
(function () {
  'use strict';

  angular
    .module('app.appointment')
    .controller('AppointmentDetailDialogController', AppointmentDetailDialogController);

  /** @ngInject */
  function AppointmentDetailDialogController(appointmentId, $rootScope, $http, $q, sharedService, accountService, $mdMedia, $mdDialog, $state, Role, Appointment, Todo) {
    var vm = this;

    // Data
    vm.todo = null;
    vm.memo = new Todo({
      type: Todo.TYPE.APPOINTMENT,
      created_by: accountService.user.username,
      created_by_role: accountService.user.getFirstRole(),
      status: Todo.STATUS.COMPLETED
    });
    vm.appointment = null;

    vm.loading = true;
    vm.showRequestButton = false;
    vm.showCompleteButton = false;

    vm.mediaXsActionButtons = $mdMedia('gt-xs') ? '' : 'md-mini';

    // Methods
    vm.edit = edit;
    vm.complete = complete;
    vm.close = close;

    init();

    //////////

    function init() {
      $http.get($rootScope.routePath + '/todo/get-appointment', {
          params: {
            id: appointmentId
          }
        })
        .then(function (res) {
          res = res.data;
          if (!res.success) return $q.reject(res.message);

          vm.appointment = new Appointment(res.data.appointment);

          // Only show if not yet
          vm.showRequestButton = accountService.user.hasRole(Role.NAME.DOCTOR) && !res.data.todo;

          if (res.data.todo) {
            vm.todo = new Todo(res.data.todo);

            vm.showCompleteButton = vm.todo.status !== Todo.STATUS.COMPLETED && accountService.user.hasRole(Role.NAME.CALL_CENTER_STAFF);
          }
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
          $mdDialog.hide();
        })
        .finally(function () {
          vm.loading = false;
        });
    }

    function edit() {
      $state.go('app.todo.edit', {
        // id: appointmentId
        apptInfo: {
          patientName: vm.appointment.patient_name,
          patientNo: vm.appointment.patient_no,
          statusDesc: vm.appointment.status_desc,
          typeDesc: vm.appointment.type_desc,
          urgentInd: vm.appointment.urgent_ind,
          datetime: vm.appointment.datetime
        }
      });
      $mdDialog.hide();
    }

    function complete() {
      if (!vm.memo.remarks) return;

      vm.todo.status = Todo.STATUS.COMPLETED;
      vm.memo.created_for = vm.todo.created_by;
      vm.memo.created_for_role = vm.todo.created_by_role;

      $http.post($rootScope.routePath + '/todo/complete-request', {
          todo: vm.todo,
          memo: vm.memo
        })
        .then(function (res) {
          res = res.data;
          if (!res.success) return $q.reject(res.message);
          $mdDialog.hide({
            reload: true
          });
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function close() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.todo')
    .controller('Thread2Controller', Thread2Controller);

  /** @ngInject */
  function Thread2Controller($stateParams, Todo, $mdMedia, $mdDialog, $document, accountService, sharedService, Role, $http, $q, $rootScope, $timeout, $scope, $window) {
    var vm = this;

    // Hooks

    // Local data
    var _$threadChat;
    var _$prevChatEl;
    var _chatNoMoreData = false;
    var _chatNotAtBottom = false;
    // Use reference
    var _chatMoveScroll = _chatMoveScrollInit;

    var _stateParamsCopy;

    // Exposed data
    vm.loading = false;
    vm.memo = {};
    vm.memos = [];

    // Exposed methods
    vm.saveMemoToThread = _saveMemoToThread;
    vm.closeThread = _closeThread;
    vm.alterThreadState = _alterThreadState;

    vm.showReadStatuses = _showReadStatuses;

    vm.downloadAttachment = _downloadAttachment;
    vm.back = _back;

    vm.sharedService = sharedService;
    vm.displaySenders = _displaySenders;
    vm.displayThreadStatus = _displayThreadStatus;

    vm.hasRole = _hasRole;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-view-list';
      sharedService.pageName = 'Thread';

      // Copy params for return back to to-do
      _stateParamsCopy = $stateParams;

      _resetModel();

      _chatInit();

      // Load first batch of data
      _chatLoadData();
    }

    function _resetModel() {
      vm.memo = {
        type: 'MEMO',
        status: 'PENDING',
        created_by: accountService.user.username,
        created_by_role: accountService.user.roles[0].name,
        ref_id: 0,
        thread_group_id: $stateParams.id,
      };
    }

    function _chatInit() {
      _$threadChat = $('#thread-scroll-anchor');

      // Register scroll listener
      _$threadChat.on('scroll', function () {
        var st = _$threadChat.scrollTop();
        var h = _$threadChat.prop('scrollHeight') - _$threadChat.height();

        if (st === 0) {
          // Load more memos
          $timeout(function () {
            if (_chatNoMoreData) return;
            _chatLoadData();
          });
        } else {
          if (h - st > 1000) {
            $timeout(function () {
              _chatNotAtBottom = true;
            });
          } else {
            $timeout(function () {
              _chatNotAtBottom = false;
            });
          }
        }
      });
    }

    function _chatLoadData() {
      vm.loading = true;

      return $http.get($rootScope.routePath + '/todo/getThread', {
          params: {
            id: $stateParams.id,
            offset: vm.memos.length,
          },
        })
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(res.message);
          }

          if (res.data.length === 0) {
            _chatNoMoreData = true;
            return sharedService.showToast('No more older messages.');
          }

          var list = [];

          // Loop backwards and reverse the list
          for (var i = res.data.length - 1; i >= 0; --i) {
            var m = res.data[i];

            // Do patch if remarks within have newline then we change to line break
            m.remarks = m.remarks.replace(/\n/g, '<br>');

            // Check if is self and apply styles
            m.isSelf = false;
            for (var j = 0; j < m.senders.length; ++j) {
              if (m.senders[j].user_id === accountService.user.id) {
                m.isSelf = true;
                break;
              }
            }

            // Format display date
            var cd = moment(m.created_datetime).local();
            m.displayDate = _formatDisplayDate(cd);

            if (m.requested_datetime) {
              // Format requested datetime (for now only concerns date, if need time we can change later)
              var rd = moment(m.requested_datetime).local();
              if (m.requested_end_datetime) {
                var red = moment(m.requested_end_datetime).local();
                if (rd.isSame(red, 'date')) {
                  m.requested_datetime = rd.format('DD/MM/YYYY hh:mm a') + ' — ' + red.format('hh:mm a');
                } else {
                  m.requested_datetime = rd.format('DD/MM/YYYY hh:mm a') + ' — ' + red.format('DD/MM/YYYY hh:mm a');
                }
              } else {
                m.requested_datetime = rd.format('DD/MM/YYYY hh:mm a');
              }
            }

            list.push(m);
          }

          vm.memos.unshift.apply(vm.memos, list);

          $timeout(function () {
            _chatMoveScroll(list.length);
          });

          return res.data.length;
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }

          sharedService.back('app.todo', _stateParamsCopy);
        })
        .then(function () {
          vm.loading = false;
        });
    }

    function _formatDisplayDate(cd) {
      // If want like WhatsApp
      // return cd.isSame(now, 'day') ? 'Today ' + cd.format('hh:mm a') :
      // 				cd.isSame(now.subtract(1, 'day'), 'day') ? 'Yesterday ' + cd.format('hh:mm a') :
      // 				cd.isAfter(now.subtract(6, 'days'), 'day') ? 'Past ' + cd.format('dddd hh:mm a') :
      // 				cd.format('DD/MM/YYYY hh:mm a');

      // If want like normal
      return cd.format('DD/MM/YYYY hh:mm a');
    }

    function _chatMoveScrollInit() {
      _$prevChatEl = _$threadChat.find('.chat-bubble-container').last();

      _$threadChat.scrollTop(_$prevChatEl.position().top);

      // Reassign reference
      _chatMoveScroll = _chatMoveScrollOnLoad;
    }

    function _chatMoveScrollOnLoad(loadedCount) {
      _$prevChatEl = _$threadChat.find('.chat-bubble-container').eq(loadedCount);

      _$threadChat.scrollTop(_$prevChatEl.position().top);
    }

    function _downloadAttachment(memoIndex, attachmentIndex) {
      var attachment = vm.memos[memoIndex].attachments[attachmentIndex];

      $http.get($rootScope.routePath + '/todo/downloadAttachment', {
          params: {
            path: attachment.path,
            originalFileName: attachment.original_file_name,
          },
          responseType: 'arraybuffer'
        })
        .then(function (res) {
          var header = res.headers('Content-Disposition');
          var fileName = header.split('=')[1].replace(/\"/gi, '');

          var blob = new Blob([res.data], {
            type: res.headers('Content-Type')
          });
          var objectUrl = ($window.URL || $window.webkitURL).createObjectURL(blob);
          var link = angular.element('<a/>');
          link.attr({
            href: objectUrl,
            download: fileName
          })[0].click();
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function _saveMemoToThread() {
      vm.memo.created_datetime = moment();
      vm.memo.status = vm.memos[0].status;

      var threads = [{
        user_id: accountService.user.id,
        role_id: accountService.user.roles[0].id,
        is_recipient: false,
        read_status: 'READ',
      }, ];

      var formData = new FormData();
      if (vm.files.length) {
        for (var i = 0; i < vm.files.length; ++i) {
          formData.append('files', vm.files[i].lfFile);
        }
      }
      formData.append('todo', JSON.stringify(vm.memo));
      formData.append('threads', JSON.stringify(threads));

      return $http.post($rootScope.routePath + '/todo/saveMemoToThread', formData, {
          transformRequest: angular.identity,
          headers: {
            'Content-Type': undefined,
          },
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            vm.memo.id = res.data.id;
            vm.memo.isSelf = true;
            vm.memo.displayDate = _formatDisplayDate(vm.memo.created_datetime);
            vm.memo.senders = res.data.senders;
            vm.memo.recipients = res.data.recipients;
            vm.memo.attachments = res.data.attachments || [];
            vm.memos.push(vm.memo);

            vm.lfApi.removeAll();
            _resetModel();

            // Scroll to bottom on next tick
            _chatAnimateScrollToBottom();
          } else {
            sharedService.showToast(res.message);
          }
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _closeThread() {
      vm.memo.created_datetime = moment();

      var threads = [{
        user_id: accountService.user.id,
        role_id: accountService.user.roles[0].id,
        is_recipient: false,
        read_status: 'READ',
      }, ];

      var formData = new FormData();
      if (vm.files.length) {
        for (var i = 0; i < vm.files.length; ++i) {
          formData.append('files', vm.files[i].lfFile);
        }
      }
      formData.append('todo', JSON.stringify(vm.memo));
      formData.append('threads', JSON.stringify(threads));

      return $http.post($rootScope.routePath + '/todo/closeThread', formData, {
          transformRequest: angular.identity,
          headers: {
            'Content-Type': undefined,
          },
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            vm.memo.id = res.data.id;
            vm.memo.isSelf = true;
            vm.memo.displayDate = _formatDisplayDate(vm.memo.created_datetime);
            vm.memo.senders = res.data.senders;
            vm.memo.recipients = res.data.recipients;
            vm.memo.attachments = res.data.attachments || [];
            vm.memos.push(vm.memo);

            vm.lfApi.removeAll();
            _resetModel();

            // Set the status to close the thread
            for (var i = 0; i < vm.memos.length; ++i) {
              vm.memos[i].status = res.data.status;
            }

            // Scroll to bottom on next tick
            _chatAnimateScrollToBottom();
          }

          sharedService.showToast(res.message);
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _alterThreadState(status) {
      vm.memo.created_datetime = moment();
      vm.memo.status = status;
      if (status === 'APPROVED' && !vm.memo.remarks) {
        vm.memo.remarks = 'Approved';
      }

      var threads = [{
        user_id: accountService.user.id,
        role_id: accountService.user.roles[0].id,
        is_recipient: false,
        read_status: 'READ',
      }, ];

      var formData = new FormData();
      if (vm.files.length) {
        for (var i = 0; i < vm.files.length; ++i) {
          formData.append('files', vm.files[i].lfFile);
        }
      }
      formData.append('todo', JSON.stringify(vm.memo));
      formData.append('threads', JSON.stringify(threads));

      return $http.post($rootScope.routePath + '/todo/alterThreadState', formData, {
          transformRequest: angular.identity,
          headers: {
            'Content-Type': undefined,
          },
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            vm.memo.id = res.data.id;
            vm.memo.isSelf = true;
            vm.memo.displayDate = _formatDisplayDate(vm.memo.created_datetime);
            vm.memo.senders = res.data.senders;
            vm.memo.recipients = res.data.recipients;
            vm.memos.push(vm.memo);

            _resetModel();

            // Set the status to approve/reject the thread
            for (var i = 0; i < vm.memos.length; ++i) {
              vm.memos[i].status = res.data.status;
            }

            // Scroll to bottom on next tick
            _chatAnimateScrollToBottom();
          } else {
            sharedService.showToast(res.message);
          }
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _showReadStatuses(jsEvent, memo) {
      $mdDialog.show({
        controller: 'ThreadReadStatusDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/todo/dialogs/thread-read-status/thread-read-status-dialog.html',
        parent: angular.element($document.body),
        targetEvent: jsEvent,
        clickOutsideToClose: true,
        locals: {
          memo: memo,
        }
      });
    }

    function _chatAnimateScrollToBottom() {
      $timeout(function () {
        _$threadChat.animate({
          scrollTop: _$threadChat.prop('scrollHeight') - _$threadChat.height(),
        }, 250);
      });
    }

    function _displaySenders(memo) {
      if (memo.senders.length == 2) {
        if (memo.senders[0].role.name === 'Doctor') {
          return (memo.senders[0].doctorName || memo.senders[0].user.username) + ' (' + memo.senders[1].user.username + ') - ' + memo.displayDate + '<br>' + memo.senders[0].role.name + ' (' + memo.senders[1].role.name + ')';
        } else {
          return (memo.senders[1].doctorName || memo.senders[1].user.username) + ' (' + memo.senders[0].user.username + ') - ' + memo.displayDate + '<br>' + memo.senders[1].role.name + ' (' + memo.senders[0].role.name + ')';
        }
      } else {
        return (memo.senders[0].doctorName || memo.senders[0].user.username) + ' - ' + memo.displayDate + '<br>' + memo.senders[0].role.name;
      }
    }

    function _displayThreadStatus() {
      if (vm.memos.length) {
        if (vm.memos[0].status === 'COMPLETED') {
          var last = vm.memos[vm.memos.length - 1];
          var cd = moment(last.created_datetime).local();
          return '<div class="small-text h4">closed by ' + last.senders[0].user.username + '<br>on ' + _formatDisplayDate(cd) + '</div>';
        } else {
          return '<div class="small-text">(' + vm.memos[0].status + ')</div>';
        }
      }
    }

    function _hasRole(roleName) {
      for (var i = 0; i < accountService.user.roles.length; ++i) {
        if (accountService.user.roles[i].name === roleName) {
          return true;
        }
      }
      return false;
    }

    function _back() {
      sharedService.back('app.todo', _stateParamsCopy);
    }

    // Initializations
    _init();
  }
})();

(function() {
	'use strict';

	angular
		.module('app.user', ['datatables', 'datatables.scroller'])
		.config(config);

	/** @ngInject */
	function config($stateProvider) {
		$stateProvider
		.state('app.user', {
			url: '/user',
			views: {
				'content@app': {
					templateUrl: 'app/main/user/user.html',
					controller: 'UserController as vm'
				}
			},
			bodyClass: 'user',
			moduleName: 'User'
		})
		.state('app.user.edit', {
			url: '/edit/:id',
			views: {
				'content@app': {
					templateUrl: 'app/main/user/edit/user-edit.html',
					controller: 'UserEditController as vm'
				}
			},
			params: {
				id: {
					value: null,
					squash: true
				}
			},
			bodyClass: 'user-edit',
			moduleName: 'User'
		});
	}
})();
(function() {
	'use strict';

	angular
		.module('app.user')
		.controller('UserEditController', UserEditController);
	
	/** @ngInject */
	function UserEditController(User, $mdMedia, $stateParams, accountService, sharedService, Role, $http, $q, $rootScope) {
		var vm = this;

		// Data
		vm.sharedService = sharedService;
		vm.Role = Role;

		vm.user;
		vm.role;
		vm.roles = [];
		vm.doctor;
		vm.phoneNumber = null;
		vm.rosterEmails = null;
		vm.specialty = null;
		vm.specialties = [];

		vm.mediaXsActionButtons = $mdMedia('gt-xs') ? '' : 'md-mini';

		sharedService.pageIcon = 'icon-pencil';
		sharedService.pageName = 'Edit User';

		// Methods
		vm.$onInit = init;
		vm.request = request;
		vm.back = back;
		vm.acDoctor = acDoctor;

		//////////

		function init() {
			if (!$stateParams.id) sharedService.back('app.user');

			$http.get($rootScope.routePath + '/user/getWithRoles', {
				params: {
					id: $stateParams.id
				}
			})
			.then(function(res) {
				res = res.data;
				if (!res.success) return $q.reject(res.message);

				vm.user = new User(res.data.user);
				
				res.data.roles.forEach(function(role) {
					vm.roles.push(new Role(role));
				});

				vm.role = vm.user.roles.length === 1 ? vm.user.roles[0] : vm.roles[0];

				vm.doctor = res.data.doctor;

				vm.phoneNumber = res.data.user.phone_number;
				vm.rosterEmails = res.data.user.roster_emails;
				vm.specialty = res.data.specialty;
				vm.specialties = res.data.specialties;
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
				sharedService.back('app.user');
			});
		}
		
		function request() {
			$http.post($rootScope.routePath + '/user-role/saveUserRole', {
				user: vm.user,
				phoneNumber: vm.phoneNumber,
				userRosterEmails: vm.rosterEmails,
				roleId: vm.role.id,
				isPersonalAssistant: vm.role.name === Role.NAME.PERSONAL_ASSISTANT,
				doctor: vm.doctor,
				specialtyId: vm.specialty ? vm.specialty.id : null
			})
			.then(function(res) {
				res = res.data;
				if (res.success) sharedService.back('app.user');
				sharedService.showToast(res.message);
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			});
		}

		function back() {
			sharedService.back('app.user');
		}

		function acDoctor() {
			return $http.get($rootScope.routePath + '/autocomplete/doctor2', {
				params: {
					q: vm.searchDoctor
				}
			})
			.then(function(res) {
				res = res.data;
				if (res.success) return res.data;
				return [];
			})
			.catch(function(err) {
			});
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('app.todo')
    .controller('MemoEdit2Controller', MemoEdit2Controller);

  /** @ngInject */
  function MemoEdit2Controller($stateParams, Todo, $mdMedia, accountService, sharedService, Role, $http, $q, $rootScope) {
    var vm = this;

    // Hooks

    // Local Data
    var rolesClone = [];

    // Exposed Data
    // Loaded role list
    vm.roles = [];
    vm.files = [];
    // Selected role
    vm.role = {};
    // Selected doctor
    vm.doctor;
    // Search doctor text
    vm.searchDoctor;
    vm.todo = {};
    vm.startDate;
    vm.startTime;
    vm.endDate;
    vm.endTime;
    vm.isDoctor = false;
    vm.mediaXsActionButtons = $mdMedia('gt-xs') ? '' : 'md-mini';
    vm.minDate = moment();
    vm.sharedService = sharedService;
    vm.apptInfo;

    vm.isDoctor = accountService.user.hasRole(Role.NAME.DOCTOR);
    vm.isPersonalAssistant = accountService.user.hasRole(Role.NAME.PERSONAL_ASSISTANT);

    // Exposed Methods
    vm.acDoctor = _acDoctor;
    // Create new thread
    vm.request = _request;

    vm.isDoctorOrPa = _isDoctorOrPa;
    vm.needStartDate = _needSelectedDatetime;
    vm.needStartTime = _needSelectedDatetime;
    vm.needEndDate = _needSelectedDatetime;
    vm.needEndTime = _needSelectedDatetime;
    vm.back = _back;
    vm.subtypeChanged = _subtypeChanged;
    vm.startDateChanged = _startDateChanged;
    vm.startTimeChanged = _startTimeChanged;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-pencil';
      sharedService.pageName = 'Edit To Do';

      vm.mediaXsActionButtons = $mdMedia('gt-xs') ? '' : 'md-mini';

      vm.todo.type = 'MEMO';
      vm.todo.status = 'PENDING';
      vm.todo.created_by = accountService.user.username;
      vm.todo.created_by_role = accountService.user.roles[0].name;
      vm.todo.ref_id = 0;

      vm.apptInfo = $stateParams.apptInfo;
      if (vm.apptInfo) {
        vm.apptInfo.datetime = moment(vm.apptInfo.datetime);
      }

      _getRoles();

      if ($stateParams.selectedDatetime !== null && $stateParams.selectedDatetime.isSameOrAfter(vm.minDate, 'date')) {
        // Currently we only concern about date, if needed concern about time we can add that later
        // vm.todo.requested_datetime = $stateParams.selectedDatetime;
        vm.startDate = $stateParams.selectedDatetime;
        vm.endDate = $stateParams.selectedDatetime;
      }
    }

    function _getRoles() {
      $http.get($rootScope.routePath + '/role/getForMemo')
        .then(function (res) {
          res = res.data;
          if (!res.success) return $q.reject(res.message);

          vm.roles = res.data;

          rolesClone = vm.roles.slice();

          if (_isDoctorOrPa()) {
            if (vm.apptInfo) { // If coming from appointment then default is to cancel patient slot
              vm.todo.subtype = 'CANCEL/BLOCK CLINIC';
            } else {
              vm.todo.subtype = 'NEW/RESCHEDULE SLOT';
            }

            // Trigger subtype changed event to select appropriate default role, don't manually select
            _subtypeChanged();
          } else {
            _selectDefaultRole('Doctor');
          }
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
          sharedService.back('app.todo');
        });
    }

    function _isDoctorOrPa() {
      for (var i = 0; i < accountService.user.roles.length; ++i) {
        if (accountService.user.roles[i].name === 'Doctor' ||
          accountService.user.roles[i].name === 'PersonalAssistant') {
          return true;
        }
      }
      return false;
    }

    function _needSelectedDatetime() {
      return _isDoctorOrPa() && (vm.todo.subtype === 'NEW/RESCHEDULE SLOT' || vm.todo.subtype === 'CANCEL/BLOCK CLINIC');
    }

    function _selectDefaultRole(roleName) {
      for (var i = 0; i < vm.roles.length; ++i) {
        if (vm.roles[i].name === roleName) {
          vm.role = vm.roles[i];
          break;
        }
      }
    }

    function _request() {
      vm.todo.created_datetime = moment();

      var threads = [{
        user_id: accountService.user.id,
        role_id: accountService.user.roles[0].id,
        is_recipient: false,
        read_status: 'READ'
      }, ];

      if (vm.role.name === 'Doctor') {
        threads.push({
          user_id: vm.doctor.userId,
          role_id: vm.role.id,
          is_recipient: true,
          read_status: 'UNREAD'
        });
      } else {
        threads.push({
          user_id: null,
          role_id: vm.role.id,
          is_recipient: true,
          read_status: 'UNREAD'
        });
      }

      // if (moment.isMoment(vm.todo.requested_datetime)) {
      //   vm.todo.requested_datetime = vm.todo.requested_datetime.toISOString();
      // }
      if (moment.isMoment(vm.startDate) && moment.isMoment(vm.startTime)) {
        vm.todo.requested_datetime = moment(vm.startDate.format('YYYY-MM-DD') + ' ' + vm.startTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss').toISOString();
      }
      if (moment.isMoment(vm.endDate) && moment.isMoment(vm.endTime)) {
        vm.todo.requested_end_datetime = moment(vm.endDate.format('YYYY-MM-DD') + ' ' + vm.endTime.format('HH:mm:ss'), 'YYYY-MM-DD HH:mm:ss').toISOString();
      }

      // Keep a copy of remarks to revert in case failed to open thread
      var remarksCopy = vm.todo.remarks;

      // Append appointment information to remarks (if any)
      if (vm.apptInfo) {
        vm.todo.remarks = 'Patient Name: ' + vm.apptInfo.patientName +
          '\nPatient Number: ' + vm.apptInfo.patientNo +
          '\nAppt Status: ' + vm.apptInfo.statusDesc +
          '\nAppt Type: ' + vm.apptInfo.typeDesc +
          '\nIs Urgent: ' + vm.apptInfo.urgentInd +
          '\nDatetime: ' + vm.apptInfo.datetime.format('DD/MM/YYYY hh:mm a') +
          '\nRemarks: ' + vm.todo.remarks;
      }

      var formData = new FormData();
      if (vm.files.length) {
        for (var i = 0; i < vm.files.length; ++i) {
          formData.append('files', vm.files[i].lfFile);
        }
      }
      formData.append('todo', JSON.stringify(vm.todo));
      formData.append('threads', JSON.stringify(threads));

      $http.post($rootScope.routePath + '/todo/openThread', formData, {
          transformRequest: angular.identity,
          headers: {
            'Content-Type': undefined,
          },
        })
        .then(function (res) {
          res = res.data;
          if (res.success) {
            // vm.todo.id = res.data.id;
            sharedService.back('app.todo');
          } else {
            // We revert back the remarks
            vm.todo.remarks = remarksCopy;
          }
          sharedService.showToast(res.message);
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function _acDoctor() {
      return $http.get($rootScope.routePath + '/autocomplete/doctor2', {
          params: {
            q: vm.searchDoctor
          }
        })
        .then(function (res) {
          res = res.data;
          if (res.success) return res.data;
          return [];
        })
        .catch(function (err) {
          return [];
        });
    }

    function _back() {
      sharedService.back('app.todo');
    }

    function _subtypeChanged() {
      switch (vm.todo.subtype) {
        case 'NEW/RESCHEDULE SLOT': {
          vm.roles = rolesClone.slice();
          _selectDefaultRole('NurseManager');
          break;
        }
        case 'CANCEL/BLOCK CLINIC': {
          vm.roles = rolesClone.slice();
          _selectDefaultRole('CallCenterStaff');
          break;
        }
        case 'OTHERS': {
          vm.roles = rolesClone.slice();
          var i = vm.roles.length;
          while (i--) {
            if (vm.roles[i].name === 'NurseManager') {
              vm.roles.splice(i, 1);
            }
          }
          _selectDefaultRole('CallCenterStaff');
          break;
        }
      }
    }

    function _startDateChanged() {
      if (vm.endDate) {
        return;
      }
      vm.endDate = vm.startDate.clone();
    }

    function _startTimeChanged() {
      if (vm.endTime) {
        return;
      }
      vm.endTime = vm.startTime.clone();
      vm.endTime.add(1, 'hour');
    }

    // Initializations
    _init();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.timeslot', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      // Main
      .state('app.timeslot', {
        url: '/timeslot',
        views: {
          'content@app': {
            templateUrl: 'app/main/timeslot/timeslot.html',
            controller: 'TimeslotController',
            controllerAs: 'vm'
          }
        },
        params: {
          searchTerm: null,
          page: 0,
          pageLength: 25
        },
        bodyClass: 'timeslot',
        moduleName: 'Timeslot'
      })
      // Edit
      .state('app.timeslot.edit', {
        url: '/edit/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/timeslot/edit/timeslot-edit.html',
            controller: 'TimeslotEditController',
            controllerAs: 'vm'
          }
        },
        bodyClass: 'timeslot-edit',
        moduleName: 'Timeslot'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.timeslot')
    .controller('TimeslotEditController', TimeslotEditController);

  /** @ngInject */
  function TimeslotEditController(
    $scope,
    $rootScope,
    $q,
    $http,
    $stateParams,
    sharedService
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var _stateParamsCopy;

    // Exposed data
    vm.timeslot = {
      id: null,
      name: null,
      start_time: moment().startOf('day'),
      end_time: moment().add(1, 'day').startOf('day').subtract(5, 'minutes')
    };

    vm.sharedService = sharedService;

    // Exposed methods
    vm.save = _save;
    vm.back = _back;
    vm.startTimeChanged = _startTimeChanged;

    function _init() {
      sharedService.pageIcon = 'icon-pencil';
      sharedService.pageName = 'Edit Timeslot';

      _stateParamsCopy = $stateParams;

      if ($stateParams.id) {
        $http
          .get($rootScope.routePath + '/timeslot/getById', {
            params: {
              id: $stateParams.id
            }
          })
          .then(function (res) {
            res = res.data;

            if (!res.success) {
              return $q.reject(res.message);
            }

            res.data.timeslot.start_time = moment
              .utc(res.data.timeslot.start_time, 'HH:mm:ss')
              .local();
            res.data.timeslot.end_time = moment
              .utc(res.data.timeslot.end_time, 'HH:mm:ss')
              .local();

            vm.timeslot = res.data.timeslot;
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }

            sharedService.back('app.timeslot');
          });
      }
    }

    function _save() {
      $http
        .post($rootScope.routePath + '/timeslot/save', {
          timeslotId: vm.timeslot.id,
          timeslotName: vm.timeslot.name,
          timeslotStartTime: vm.timeslot.start_time
            .clone()
            .utc()
            .format('HH:mm:ss'),
          timeslotEndTime: vm.timeslot.end_time.clone().utc().format('HH:mm:ss')
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            sharedService.back('app.timeslot', _stateParamsCopy);
          }

          sharedService.showToast(res.message);
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _back() {
      sharedService.back('app.timeslot', _stateParamsCopy);
    }

    function _startTimeChanged() {
      if (vm.timeslot.end_time) {
        return;
      }
      vm.timeslot.end_time = vm.timeslot.start_time.clone();
      vm.timeslot.end_time.add(8, 'hour');
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('app.surgicalProcedure', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      // Main
      .state('app.surgicalProcedure', {
        url: '/surgical-procedure',
        views: {
          'content@app': {
            templateUrl: 'app/main/surgical-procedure/surgical-procedure.html',
            controller: 'SurgicalProcedureController',
            controllerAs: 'vm'
          }
        },
        params: {
          searchTerm: null,
          page: 0,
          pageLength: 25
        },
        bodyClass: 'surgical-procedure',
        moduleName: 'Surgical Procedure'
      })
      // Edit
      .state('app.surgicalProcedure.edit', {
        url: '/edit/:id',
        views: {
          'content@app': {
            templateUrl:
              'app/main/surgical-procedure/edit/surgical-procedure-edit.html',
            controller: 'SurgicalProcedureEditController',
            controllerAs: 'vm'
          }
        },
        bodyClass: 'surgical-procedure-edit',
        moduleName: 'Surgical Procedure'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.surgicalProcedure')
    .controller('SurgicalProcedureEditController', Controller);

  /** @ngInject */
  function Controller(
    $scope,
    $rootScope,
    $q,
    $http,
    $stateParams,
    sharedService
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var _stateParamsCopy;

    // Exposed data
    vm.dataSource = {
      procedure_detail: {}
    };

    vm.sharedService = sharedService;

    // Exposed methods
    vm.save = _save;
    vm.back = _back;

    function _init() {
      sharedService.pageIcon = 'icon-pencil';
      sharedService.pageName = 'Edit Surgical Procedure';

      _stateParamsCopy = $stateParams;

      if ($stateParams.id) {
        $http
          .get($rootScope.routePath + '/eDischarge/getProcedureByExternalId', {
            params: {
              procedureExternalId: $stateParams.id
            }
          })
          .then(function (res) {
            res = res.data;

            if (!res.success) {
              return $q.reject(res.message);
            }

            vm.dataSource = res.data.result;
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }

            sharedService.back('app.surgicalProcedure');
          });
      }
    }

    function _save() {
      $http
        .post(
          $rootScope.routePath + '/eDischarge/updateProcedureDetailMmaCode',
          {
            procedureExternalId: vm.dataSource.gntxncode_ext_id,
            mmaCode: vm.dataSource.procedure_detail.mma_code || null
          }
        )
        .then(function (res) {
          res = res.data;

          if (res.success) {
            sharedService.back('app.surgicalProcedure', _stateParamsCopy);
          }

          sharedService.showToast(res.message);
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _back() {
      sharedService.back('app.surgicalProcedure', _stateParamsCopy);
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('app.specialty', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      // Main
      .state('app.specialty', {
        url: '/specialty',
        views: {
          'content@app': {
            templateUrl: 'app/main/specialty/specialty.html',
            controller: 'SpecialtyController',
            controllerAs: 'vm'
          }
        },
        params: {
          searchTerm: null,
          page: 0,
          pageLength: 25
        },
        bodyClass: 'specialty',
        moduleName: 'Specialty'
      })
      // Edit
      .state('app.specialty.edit', {
        url: '/edit/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/specialty/edit/specialty-edit.html',
            controller: 'SpecialtyEditController',
            controllerAs: 'vm'
          }
        },
        bodyClass: 'specialty-edit',
        moduleName: 'Specialty'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.specialty')
    .controller('SpecialtyEditController', SpecialtyEditController);

  /** @ngInject */
  function SpecialtyEditController(
    $scope,
    $rootScope,
    $q,
    $http,
    $stateParams,
    sharedService
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var _stateParamsCopy;

    // Exposed data
    vm.specialty = {
      id: null,
      name: null,
      color: '#61a4c1'
    };

    vm.colorSettings = {
      control: 'hue',
      position: 'bottom left'
    };

    vm.sharedService = sharedService;

    // Exposed methods
    vm.save = _save;
    vm.back = _back;

    function _init() {
      sharedService.pageIcon = 'icon-pencil';
      sharedService.pageName = 'Edit Specialty';

      _stateParamsCopy = $stateParams;

      if ($stateParams.id) {
        $http
          .get($rootScope.routePath + '/specialty/getById', {
            params: {
              id: $stateParams.id
            }
          })
          .then(function (res) {
            res = res.data;

            if (!res.success) {
              return $q.reject(res.message);
            }

            vm.specialty = res.data.specialty;
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }

            sharedService.back('app.specialty');
          });
      }
    }

    function _save() {
      $http
        .post($rootScope.routePath + '/specialty/save', {
          specialtyId: vm.specialty.id,
          specialtyName: vm.specialty.name,
          specialtyColor: vm.specialty.color
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            sharedService.back('app.specialty', _stateParamsCopy);
          }

          sharedService.showToast(res.message);
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _back() {
      sharedService.back('app.specialty', _stateParamsCopy);
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('app.operationTheater')
    .controller('OperationTheaterEditController', OperationTheaterEditController);

  /** @ngInject */
  function OperationTheaterEditController($stateParams, Todo, $mdMedia, accountService, sharedService, Role, $http, $q, $rootScope) {
    var vm = this;

    // Data
    vm.sharedService = sharedService;

    vm.todo = new Todo({
      type: Todo.TYPE.OT_BOOKING,
      requested_datetime: moment(),
      created_by: accountService.user.username,
      created_by_role: accountService.user.getFirstRole(),
      created_for_role: Role.NAME.PRE_ADMISSION_STAFF
    });
    vm.patient;
    vm.room;
    vm.procedure;
    vm.procedures = [];

    vm.mediaXsActionButtons = $mdMedia('gt-xs') ? '' : 'md-mini';
    vm.minDate = moment();

    sharedService.pageIcon = 'icon-pencil';
    sharedService.pageName = 'Edit Booking';

    // Methods
    vm.$onInit = init;
    vm.request = request2;
    vm.back = back;

    vm.acPatient = acPatient;
    vm.acRoom = acRoom;
    vm.acProcedure = acProcedure;

    vm.transformChip = transformChip;

    //////////

    function init() {
      if (!$stateParams.id) return;

      $http.get($rootScope.routePath + '/todo/get-booking', {
          params: {
            id: $stateParams.id
          }
        })
        .then(function (res) {
          res = res.data;
          if (!res.success) return $q.reject(res.message);

          vm.todo = new Todo(res.data.todo);
          vm.todo.requested_datetime = vm.todo.requested_datetime ? moment(vm.todo.requested_datetime).local() : moment();

          vm.patient = res.data.autocompletes.patient;
          vm.room = res.data.autocompletes.room;
          vm.procedures = res.data.autocompletes.procedures;
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function request() {
      var procedureString = '';
      for (var i = 0; i < vm.procedures.length; ++i) {
        if (i > 0) {
          procedureString += ',';
        }
        procedureString += vm.procedures[i].code;
      }

      var booking = {
        patient_no: vm.patient.patient_no,
        procedures: procedureString,
        dr_desc: accountService.user.username
      };

      if (vm.room) booking.location = vm.room.code;

      if (vm.todo.id === 0) {
        $http.post($rootScope.routePath + '/todo/save-booking', {
            todo: vm.todo,
            booking: booking
          })
          .then(function (res) {
            res = res.data;
            if (res.success) {
              vm.todo.id = res.data.id;
              sharedService.back('app.operationTheater');
            }
            sharedService.showToast(res.message);
          })
          .catch(function (err) {
            if (err.message) sharedService.showToast(err.message);
            else sharedService.showToast('Request timed out.');
          });
      } else {
        $http.post($rootScope.routePath + '/todo/update-booking', {
            id: vm.todo.id,
            todo: vm.todo,
            booking: {
              patient_no: vm.patient.patient_no,
              location: vm.room.code,
              procedures: procedureString,
              dr_desc: accountService.user.username
            }
          })
          .then(function (res) {
            res = res.data;
            if (res.success) sharedService.back('app.operationTheater');
            sharedService.showToast(res.message);
          })
          .catch(function (err) {
            if (err.message) sharedService.showToast(err.message);
            else sharedService.showToast('Request timed out.');
          });
      }
    }

    function request2() {
      var todo = {
        type: 'MEMO',
        subtype: 'OTHERS',
        requested_datetime: vm.todo.requested_datetime,
        remarks: 'Patient Number: ' + vm.patient.patient_no,
        status: 'PENDING',
        created_by: accountService.user.username,
        created_by_role: accountService.user.roles[0].name,
				created_for_role: 'PreAdmissionStaff',
				ref_id: 0
      };
      todo.remarks = 'Patient Number: ' + vm.patient.patient_no;
      if (vm.room) {
        todo.remarks += '\nLocation: ' + vm.room.code;
      }
      if (vm.procedures.length > 0) {
        var procedureString = '';
        for (var i = 0; i < vm.procedures.length; ++i) {
          if (i > 0) {
            procedureString += ', ';
          }
          procedureString += vm.procedures[i].code;
        }
        todo.remarks += '\nProcedures: ' + procedureString;
      }
      todo.remarks += '\nRemarks: ' + vm.todo.remarks;

      var threads = [{
        user_id: accountService.user.id,
        role_id: accountService.user.roles[0].id,
        is_recipient: false,
        read_status: 'READ'
      }, {
        user_id: null,
        role_id: 4, // WARNING! Hardcoded! Need to get actual ID from database!
        is_recipient: true,
        read_status: 'UNREAD'
      }];

      var formData = new FormData();
      formData.append('todo', JSON.stringify(todo));
      formData.append('threads', JSON.stringify(threads));

      $http.post($rootScope.routePath + '/todo/openThread', formData, {
          transformRequest: angular.identity,
          headers: {
            'Content-Type': undefined
          },
        })
        .then(function (res) {
          res = res.data;
          if (res.success) {
            sharedService.back('app.operationTheater');
          }
          sharedService.showToast(res.message);
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function back() {
      sharedService.back('app.operationTheater');
    }

    function acPatient() {
      return $http.get($rootScope.routePath + '/autocomplete/patient', {
          params: {
            q: vm.searchPatient
          }
        })
        .then(function (res) {
          res = res.data;
          if (res.success) return res.data;
          return [];
        })
        .catch(function (err) {});
    }

    function acRoom() {
      return $http.get($rootScope.routePath + '/autocomplete/room', {
          params: {
            q: vm.searchRoom
          }
        })
        .then(function (res) {
          res = res.data;
          if (res.success) return res.data;
          return [];
        })
        .catch(function (err) {});
    }

    function acProcedure() {
      return $http.get($rootScope.routePath + '/autocomplete/procedure', {
          params: {
            q: vm.searchProcedure
          }
        })
        .then(function (res) {
          res = res.data;
          if (res.success) return res.data;
          return [];
        })
        .catch(function (err) {});
    }

    function transformChip(chip) {
      if (angular.isObject(chip)) return chip;
    }
  }
})();

(function() {
	'use strict';

	angular
		.module('app.sevenDaysDischarge', ['datatables', 'datatables.scroller'])
		.config(config);
	
	/** @ngInject */
	function config($stateProvider, msApiProvider) {
		$stateProvider
		// Main
		.state('app.sevenDaysDischarge', {
			url: '/seven-days-discharge',
			views: {
				'content@app': {
					templateUrl: 'app/main/seven-days-discharge/seven-days-discharge2.html',
					controller: 'SevenDaysDischarge2Controller as vm'
				}
			},
			params: {
				searchTerm: null,
				page: 0,
				pageLength: 25
			},
			bodyClass: 'seven-days-discharge',
			moduleName: 'Seven Days Discharge'
		})
		// Edit
		.state('app.sevenDaysDischarge.edit', {
			url: '/edit/:id',
			views: {
				'content@app': {
					templateUrl: 'app/main/seven-days-discharge/edit/discharge-edit.html',
					controller: 'DischargeEditController',
					controllerAs: 'vm'
				}
			},
			params: {
				dischargeEpisodeNo: null,
				dischargeAdmissionDatetime: null,
				dischargeDischargeDatetime: null,
				dischargeDrCode: null
			},
			bodyClass: 'discharge-edit',
			moduleName: 'Seven Days Discharge'
		});
	}
})();

(function () {
  'use strict';

  angular
    .module('app.sevenDaysDischarge')
    .controller('DischargeEditController', DischargeEditController);

  /** @ngInject */
  function DischargeEditController(
    $scope,
    $rootScope,
    $window,
    $q,
    $http,
    $stateParams,
    sharedService
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var _stateParamsCopy;

    // Exposed data
    vm.dischargeForm = {
      id: null,
      admission_date: null,
      discharge_date: null,
      primary_physician: null,
      diag_and_reason: null,
      med_history: null,
      investigation: null,
      procedure: null,
      progress: null,
      discharge_diag: null,
      allergies: null,
      discharge_meds: null,
      follow_up_orders: null,
      med_leave_start_date: undefined,
      med_leave_end_date: undefined,
      form_status: null
    };

    vm.sharedService = sharedService;

    // Exposed methods
    vm.submitDisabled = _submitDisabled;
    vm.save = _save;
    vm.back = _back;
    vm.submit = _submit;

    function _init() {
      sharedService.pageIcon = 'icon-pencil';
      sharedService.pageName = 'Edit Discharge Summary Form';

      _stateParamsCopy = $stateParams;

      if (
        !$stateParams.id ||
        !$stateParams.dischargeEpisodeNo ||
        !$stateParams.dischargeAdmissionDatetime ||
        !$stateParams.dischargeDischargeDatetime ||
        !$stateParams.dischargeDrCode
      ) {
        sharedService.showToast('No discharge found.');

        return sharedService.back('app.sevenDaysDischarge');
      }

      $http
        .get($rootScope.routePath + '/seven-days-discharge/getFormBySddId', {
          params: {
            id: $stateParams.id,
            dischargeFormEpisodeNo: $stateParams.dischargeEpisodeNo,
            dischargeFormAdmissionDate: $stateParams.dischargeAdmissionDatetime,
            dischargeFormDischargeDate: $stateParams.dischargeDischargeDatetime,
            dischargeFormPrimaryPhysician: $stateParams.dischargeDrCode
          }
        })
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(res.message);
          }

          vm.dischargeForm = res.data.dischargeForm;

          vm.dischargeForm.admission_date = moment
            .utc(vm.dischargeForm.admission_date)
            .local();
          vm.dischargeForm.discharge_date = moment
            .utc(vm.dischargeForm.discharge_date)
            .local();
          vm.dischargeForm.med_leave_start_date = moment
            .utc(vm.dischargeForm.med_leave_start_date)
            .local();
          vm.dischargeForm.med_leave_end_date = moment
            .utc(vm.dischargeForm.med_leave_end_date)
            .local();
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }

          sharedService.back('app.sevenDaysDischarge');
        });
    }

    function _submitDisabled() {
      return (
        vm.dischargeForm.form_status !== 'DRAFT' &&
        vm.dischargeForm.form_status !== 'SUBMITTED'
      );
    }

    function _submit() {
      $http
        .get(
          $rootScope.routePath + '/seven-days-discharge/submitAndDownloadForm',
          {
            params: {
              dischargeFormId: vm.dischargeForm.id,
              utcOffset: moment().utcOffset()
            },
            responseType: 'arraybuffer'
          }
        )
        .then(function (res) {
          var header = res.headers('Content-Disposition');
          var fileName = header.split('=')[1].replace(/\"/gi, '');

          var blob = new Blob([res.data], {
            type: res.headers('Content-Type')
          });
          var objectUrl = ($window.URL || $window.webkitURL).createObjectURL(
            blob
          );
          var link = angular.element('<a/>');
          link
            .attr({
              href: objectUrl,
              download: fileName
            })[0]
            .click();

          sharedService.showToast('Discharge summary form submitted.');
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function _save() {
      $http
        .post($rootScope.routePath + '/seven-days-discharge/saveForm', {
          dischargeFormId: vm.dischargeForm.id,
          dischargeFormAdmissionDate:
            vm.dischargeForm.admission_date.toISOString(),
          dischargeFormDischargeDate:
            vm.dischargeForm.discharge_date.toISOString(),
          dischargeFormPrimaryPhysician: vm.dischargeForm.primary_physician,
          dischargeFormDiagAndReason: vm.dischargeForm.diag_and_reason,
          dischargeFormMedHistory: vm.dischargeForm.med_history,
          dischargeFormInvestigation: vm.dischargeForm.investigation,
          dischargeFormProcedure: vm.dischargeForm.procedure,
          dischargeFormProgress: vm.dischargeForm.progress,
          dischargeFormDischargeDiag: vm.dischargeForm.discharge_diag,
          dischargeFormAllergies: vm.dischargeForm.allergies,
          dischargeFormDischargeMeds: vm.dischargeForm.discharge_meds,
          dischargeFormFollowUpOrders: vm.dischargeForm.follow_up_orders,
          dischargeFormMedLeaveStartDate: vm.dischargeForm.med_leave_start_date,
          dischargeFormMedLeaveEndDate: vm.dischargeForm.med_leave_end_date
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            vm.dischargeForm = res.data.dischargeForm;

            vm.dischargeForm.admission_date = moment
              .utc(vm.dischargeForm.admission_date)
              .local();
            vm.dischargeForm.discharge_date = moment
              .utc(vm.dischargeForm.discharge_date)
              .local();
            vm.dischargeForm.med_leave_start_date = moment
              .utc(vm.dischargeForm.med_leave_start_date)
              .local();
            vm.dischargeForm.med_leave_end_date = moment
              .utc(vm.dischargeForm.med_leave_end_date)
              .local();
          }

          sharedService.showToast(res.message);
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _back() {
      sharedService.back('app.sevenDaysDischarge', _stateParamsCopy);
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('app.shift', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      // Main
      .state('app.shift', {
        url: '/shift',
        views: {
          'content@app': {
            templateUrl: 'app/main/shift/shift.html',
            controller: 'ShiftController',
            controllerAs: 'vm'
          }
        },
        params: {
          searchTerm: null,
          page: 0,
          pageLength: 25
        },
        bodyClass: 'shift',
        moduleName: 'Shift'
      })
      // Edit
      .state('app.shift.edit', {
        url: '/edit/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/shift/edit/shift-edit.html',
            controller: 'ShiftEditController',
            controllerAs: 'vm'
          }
        },
        bodyClass: 'shift-edit',
        moduleName: 'Shift'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.shift')
    .controller('ShiftEditController', ShiftEditController);

  /** @ngInject */
  function ShiftEditController(
    $scope,
    $rootScope,
    $q,
    $http,
    $stateParams,
    sharedService
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var _stateParamsCopy;

    // Exposed data
    vm.shift = {
      id: null,
      name: null,
      mondaySlot: null,
      tuesdaySlot: null,
      wednesdaySlot: null,
      thursdaySlot: null,
      fridaySlot: null,
      saturdaySlot: null,
      sundaySlot: null
    };
    vm.defaultNoSelectionText = 'No shift';

    vm.timeslots = [];

    vm.sharedService = sharedService;

    // Exposed methods
    vm.save = _save;
    vm.back = _back;

    function _init() {
      sharedService.pageIcon = 'icon-pencil';
      sharedService.pageName = 'Edit Shift';

      _stateParamsCopy = $stateParams;

      if ($stateParams.id) {
        $http
          .get($rootScope.routePath + '/shift/getById', {
            params: {
              id: $stateParams.id
            }
          })
          .then(function (res) {
            res = res.data;

            if (!res.success) {
              return $q.reject(res.message);
            }

            vm.shift = res.data.shift;

            return _getAllTimeslots();
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }

            sharedService.back('app.shift');
          });
      } else {
        _getAllTimeslots().catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }

          sharedService.back('app.shift');
        });
      }
    }

    function _getAllTimeslots() {
      return $http
        .get($rootScope.routePath + '/timeslot/getAll')
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(res.message);
          }

          vm.timeslots = res.data.timeslots;
        });
    }

    function _save() {
      var body = {
        shiftId: vm.shift.id,
        shiftName: vm.shift.name
      };

      var slotAssigned = false;

      if (vm.shift.mondaySlot) {
        body.shiftMondaySlot = vm.shift.mondaySlot;
        slotAssigned = true;
      }
      if (vm.shift.tuesdaySlot) {
        body.shiftTuesdaySlot = vm.shift.tuesdaySlot;
        slotAssigned = true;
      }
      if (vm.shift.wednesdaySlot) {
        body.shiftWednesdaySlot = vm.shift.wednesdaySlot;
        slotAssigned = true;
      }
      if (vm.shift.thursdaySlot) {
        body.shiftThursdaySlot = vm.shift.thursdaySlot;
        slotAssigned = true;
      }
      if (vm.shift.fridaySlot) {
        body.shiftFridaySlot = vm.shift.fridaySlot;
        slotAssigned = true;
      }
      if (vm.shift.saturdaySlot) {
        body.shiftSaturdaySlot = vm.shift.saturdaySlot;
        slotAssigned = true;
      }
      if (vm.shift.sundaySlot) {
        body.shiftSundaySlot = vm.shift.sundaySlot;
        slotAssigned = true;
      }

      if (!slotAssigned) {
        return sharedService.showToast(
          'No timeslots assigned to shift. Please assign at least one timeslot.'
        );
      }

      $http
        .post($rootScope.routePath + '/shift/save', body)
        .then(function (res) {
          res = res.data;

          if (res.success) {
            sharedService.back('app.shift', _stateParamsCopy);
          }

          sharedService.showToast(res.message);
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _back() {
      sharedService.back('app.shift', _stateParamsCopy);
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('app.roster')
    .controller('RosterEditController', RosterEditController);

  /** @ngInject */
  function RosterEditController(
    $scope,
    $rootScope,
    $q,
    $http,
    $stateParams,
    sharedService
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data

    // Exposed data
    vm.roster = {
      id: null,
      tag: null
    };
    vm.user = null;
    vm.applyFromDate = undefined; // For some reason we cannot set date to null
    vm.applyToDate = undefined; // For some reason we cannot set date to null
    vm.shift = null;
    vm.defaultNoSelectionText = 'No Tag';
    vm.tags = [
      'SMO (Senior Medical Officer)',
      'MO (Medical Officer)',
      'Consultant'
    ];

    vm.shifts = [];
    vm.searchUser = null;
    vm.minDate = moment();
    vm.sharedService = sharedService;

    // Exposed methods
    vm.save = _save;
    vm.back = _back;
    vm.autocompleteUser = _autocompleteUser;

    function _init() {
      sharedService.pageIcon = 'icon-pencil';
      sharedService.pageName = 'Assign Roster';

      $http
        .get($rootScope.routePath + '/shift/getAll')
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(res.message);
          }

          vm.shifts = res.data.shifts;
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }

          sharedService.back('app.shift');
        });
    }

    function _save() {
      $http
        .post($rootScope.routePath + '/roster/assignShift', {
          userId: vm.user.id,
          applyFromDate: vm.applyFromDate.startOf('day').toISOString(),
          applyToDate: vm.applyToDate.startOf('day').toISOString(),
          shiftId: vm.shift.id,
          utcOffset: moment().utcOffset(),
          rosterTag: vm.roster.tag
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            sharedService.back('app.roster');
          }

          sharedService.showToast(res.message);
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _autocompleteUser() {
      return $http
        .get($rootScope.routePath + '/roster/autocompleteUser', {
          params: {
            q: vm.searchUser
          }
        })
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return [];
          }

          return res.data.users;
        })
        .catch(function (err) {
          return [];
        });
    }

    function _back() {
      sharedService.back('app.roster');
    }

    function _destroy() {}
  }
})();

(function() {
	'use strict';

	angular
		.module('app.login', [])
		.config(config);
	
	/** @ngInject */
	function config($stateProvider) {
		$stateProvider
		.state('app.login', {
			url: '/login',
			views: {
				'main@': {
					templateUrl: 'app/core/layouts/content-only.html',
					controller: 'MainController as vm'
				},
				'content@app.login': {
					templateUrl: 'app/main/login/login.html',
					controller: 'LoginController as vm'
				}
			},
			bodyClass: 'login',
			moduleName: 'Login'
		})
		.state('app.login.otp', {
			url: '/otp',
			views: {
				'main@': {
					templateUrl: 'app/core/layouts/content-only.html',
					controller: 'MainController as vm'
				},
				'content@app.login.otp': {
					templateUrl: 'app/main/login/otp/login-otp.html',
					controller: 'LoginOtpController as vm'
				}
			},
			bodyClass: 'login-otp',
			moduleName: 'Login'
		});
	}
})();

(function() {
	'use strict';

	angular
		.module('app.login')
		.controller('LoginOtpController', LoginOtpController);
	
	/** @ngInject */
	function LoginOtpController(accountService, $state) {
		var vm = this;

		// Data
		vm.accountService = accountService;

		// Methods
		vm.login = login;

		function login() {
			accountService.loginOtp()
			.then(function(res) {
				if (res.success) {
					accountService.checkFeaturePopup();
					$state.go('app.dashboard');
				} else {
					$state.go('app.login');
				}
			});
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('app.role', ['datatables', 'datatables.scroller'])
		.config(config);

	/** @ngInject */
	function config($stateProvider) {
		$stateProvider
		.state('app.role', {
			url: '/role',
			views: {
				'content@app': {
					templateUrl: 'app/main/role/role.html',
					controller: 'RoleController as vm'
				}
			},
			bodyClass: 'role',
			moduleName: 'Role'
		})
		.state('app.role.edit', {
			url: '/edit/:id',
			views: {
				'content@app': {
					templateUrl: 'app/main/role/edit/role-edit.html',
					controller: 'RoleEditController as vm'
				}
			},
			params: {
				id: {
					value: null,
					squash: true
				}
			},
			bodyClass: 'role-edit',
			moduleName: 'Role'
		});
	}
})();
(function() {
	'use strict';

	angular
		.module('app.role')
		.controller('RoleEditController', RoleEditController);
	
	/** @ngInject */
	function RoleEditController($mdMedia, $stateParams, accountService, sharedService, Role, $http, $q, $rootScope) {
		var vm = this;

		// Data
		vm.sharedService = sharedService;

		vm.role = new Role();

		vm.mediaXsActionButtons = $mdMedia('gt-xs') ? '' : 'md-mini';

		sharedService.pageIcon = 'icon-pencil';
		sharedService.pageName = 'Edit Role';

		// Methods
		vm.$onInit = init;
		vm.request = request;
		vm.back = back;

		//////////

		function init() {
			if (!$stateParams.id) return;

			$http.get($rootScope.routePath + '/role/get-role', {
				params: {
					id: $stateParams.id
				}
			})
			.then(function(res) {
				res = res.data;
				if (!res.success) return $q.reject(res.message);
				vm.role = new Role(res.data);
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			});
		}
		
		function request() {
			if (vm.role.id === 0) {
				$http.post($rootScope.routePath + '/role/save-role', vm.role)
				.then(function(res) {
					res = res.data;
					if (res.success) {
						vm.role = new Role(res.data);
						sharedService.back('app.role');
					}
					sharedService.showToast(res.message);
				})
				.catch(function(err) {
					if (err.message) sharedService.showToast(err.message);
					else sharedService.showToast('Request timed out.');
				});
			} else {
				$http.post($rootScope.routePath + '/role/update-role', vm.role)
				.then(function(res) {
					res = res.data;
					if (res.success) sharedService.back('app.role');
					sharedService.showToast(res.message);
				})
				.catch(function(err) {
					if (err.message) sharedService.showToast(err.message);
					else sharedService.showToast('Request timed out.');
				});
			}
		}

		function back() {
			sharedService.back('app.role');
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('app.forgotPassword', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
		$stateProvider
		.state('app.forgotPassword', {
			url: '/forgot-password',
			views: {
				'main@': {
					templateUrl: 'app/core/layouts/content-only.html',
					controller : 'MainController as vm'
				},
				'content@app.forgotPassword': {
					templateUrl: 'app/main/forgot-password/forgot-password.html',
					controller : 'ForgotPasswordController as vm'
				}
			},
			bodyClass: 'forgot-password',
			moduleName: 'Forgot Password'
		})
		.state('app.forgotPassword.edit', {
			url: '/reset?p',
			views: {
				'main@': {
					templateUrl: 'app/core/layouts/content-only.html',
					controller : 'MainController as vm'
				},
				'content@app.forgotPassword.edit': {
					templateUrl: 'app/main/forgot-password/edit/forgot-password-edit.html',
					controller : 'ForgotPasswordEditController as vm'
				}
			},
			bodyClass: 'forgot-password-edit',
			moduleName: 'Forgot Password'
		});
	}
})();
(function() {
	'use strict';

	angular
		.module('app.forgotPassword')
		.controller('ForgotPasswordEditController', ForgotPasswordEditController);
	
	/** @ngInject */
	function ForgotPasswordEditController($scope, $state, $stateParams, accountService) {
		var vm = this;

		// Data
		vm.accountService = accountService;
		vm.confirmPassword;

		// Methods
		vm.$onInit = init;
		vm.reset = reset;
		vm.resetErrors = resetErrors;

		//////////

		function init() {
			if (!$stateParams.p) return;

			accountService.resetPhrase = $stateParams.p;
		}
		
		function reset() {
			if (accountService.user.password !== vm.confirmPassword) {
				$scope.forgotPasswordEditForm.password.$setValidity('passwords-not-match', false);
				$scope.forgotPasswordEditForm.confirmPassword.$setValidity('passwords-not-match', false);
				return;
			}

			accountService.updatePassword()
			.then(function(res) {
				if (res.success) $state.go('app.login');
			});
		}
		
		function resetErrors() {
			$scope.forgotPasswordEditForm.password.$setValidity('passwords-not-match', true);
			$scope.forgotPasswordEditForm.confirmPassword.$setValidity('passwords-not-match', true);
		}
	}
})();
(function () {
  'use strict';

  angular
    .module('app.eDischargeStaff')
    .controller('EdischargeStaffViewController', Controller);

  /** @ngInject */
  function Controller(
    $scope,
    $rootScope,
    $q,
    $http,
    $stateParams,
    sharedService,
    $mdDialog,
    $document
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var _stateParamsCopy;

    // Exposed data
    vm.dataSource = {};

    vm.sharedService = sharedService;

    // Exposed methods
    vm.back = _back;

    vm.complete = _complete;

    vm.hasQuestionHistory = _hasQuestionHistory;
    vm.showQuestionHistory = _showQuestionHistory;

    function _init() {
      sharedService.pageIcon = 'icon-eye';
      sharedService.pageName = 'View E-Discharge';

      _stateParamsCopy = $stateParams;

      if ($stateParams.id) {
        _getDataSource();
      }
    }

    function _getDataSource() {
      $http
        .get(
          $rootScope.routePath +
            '/eDischarge/staff/getEdischargeFormByEdischargeEpisodeExternalId',
          {
            params: {
              eDischargeEpisodeExternalId: $stateParams.id
            }
          }
        )
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          vm.dataSource = res.data.result;

          // Default select the doctor directly if only 1 doctor
          if (res.data.result.e_discharge_doctor.length === 1) {
            vm.selectedDoctor = res.data.result.e_discharge_doctor[0];
          }
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }

          sharedService.back('app.eDischargeStaff');
        });
    }

    function _back() {
      sharedService.back('app.eDischargeStaff', _stateParamsCopy);
    }

    function _complete() {
      var confirm = $mdDialog
        .confirm()
        .title('Mark As Complete Confirmation')
        .textContent(
          'Are you sure you want to mark this e-discharge form as complete for this patient "' +
            vm.dataSource.patient_name +
            ' (' +
            vm.dataSource.episode_number +
            ')"?'
        )
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        $http
          .post($rootScope.routePath + '/eDischarge/staff/completeEdischarge', {
            eDischargeFormId: vm.dataSource.id
          })
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            if (res.success) {
              _getDataSource();
            }
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    function _hasQuestionHistory(doctor) {
      return (
        doctor &&
        doctor.e_discharge_question &&
        doctor.e_discharge_question.length &&
        Object.keys(doctor.e_discharge_question[0]).filter(function (v) {
          return !v.startsWith('$$');
        }).length > 0
      );
    }

    function _showQuestionHistory(doctor) {
      doctor.showQuestionHistory = !doctor.showQuestionHistory;
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('app.eDischargeStaff')
    .controller('EdischargeStaffEditController', Controller);

  /** @ngInject */
  function Controller(
    $scope,
    $rootScope,
    $q,
    $http,
    $stateParams,
    sharedService,
    $mdDialog,
    $document,
    $window,
    unsavedChangesService
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var _stateParamsCopy;

    // Exposed data
    vm.dataSource = {};
    vm.defaultNoSelectionText = 'Select one';

    vm.selectedDoctor = null;

    vm.sharedService = sharedService;

    vm.hasUnsavedChanges = unsavedChangesService.hasUnsavedChanges;

    // Exposed methods
    vm.back = _back;

    vm.selectedDoctorChanged = _selectedDoctorChanged;
    vm.editVisit = _editVisit;
    vm.deleteVisit = _deleteVisit;
    vm.amendVisit = _amendVisit;
    vm.cancelVisit = _cancelVisit;
    vm.editProcedure = _editProcedure;
    vm.deleteProcedure = _deleteProcedure;
    vm.amendProcedure = _amendProcedure;
    vm.cancelProcedure = _cancelProcedure;
    vm.isPendingApproval = _isPendingApproval;
    vm.addDoctor = _addDoctor;
    vm.requestDischarge = _requestDischarge;
    vm.complete = _complete;

    vm.catchAttention = _catchAttention;
    vm.hasQuestionHistory = _hasQuestionHistory;
    vm.hasPastQuestionHistory = _hasPastQuestionHistory;
    vm.showQuestionHistory = _showQuestionHistory;
    vm.saveQuestionDisabled = _saveQuestionDisabled;
    vm.editQuestion = _editQuestion;
    vm.amendQuestion = _amendQuestion;

    function _init() {
      sharedService.pageIcon = 'icon-pencil';
      sharedService.pageName = 'Edit E-Discharge';

      _stateParamsCopy = $stateParams;

      unsavedChangesService.setMessage(
        'You have unsaved changes in the questions section. Are you sure you want to leave without saving?'
      );

      if ($stateParams.id) {
        _getDataSource();
      }
    }

    function _getDataSource() {
      $http
        .get(
          $rootScope.routePath +
            '/eDischarge/staff/getEdischargeFormByEdischargeEpisodeExternalId',
          {
            params: {
              eDischargeEpisodeExternalId: $stateParams.id
            }
          }
        )
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          vm.dataSource = res.data.result;

          for (var i = 0; i < res.data.result.e_discharge_doctor.length; ++i) {
            var doctor = res.data.result.e_discharge_doctor[i];

            if (
              !doctor.e_discharge_question ||
              !doctor.e_discharge_question.length
            ) {
              doctor.e_discharge_question = [{}];
            }
          }

          // Default select the doctor directly if only 1 doctor
          if (res.data.result.e_discharge_doctor.length === 1) {
            vm.selectedDoctor = res.data.result.e_discharge_doctor[0];

            sharedService.pageName = vm.selectedDoctor.requires_reapproval
              ? 'Amend E-Discharge'
              : 'Edit E-Discharge';
          }
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }

          sharedService.back('app.eDischargeStaff');
        });
    }

    function _back() {
      sharedService.back('app.eDischargeStaff', _stateParamsCopy);
    }

    function _selectedDoctorChanged() {
      sharedService.pageName = vm.selectedDoctor.requires_reapproval
        ? 'Amend E-Discharge'
        : 'Edit E-Discharge';
    }

    function _editVisit(item) {
      item = item || {};
      item.e_discharge_doctor_id = vm.selectedDoctor.id;

      $mdDialog
        .show({
          controller: 'EdischargeStaffVisitDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/e-discharge-staff/dialogs/e-discharge-staff-visit/e-discharge-staff-visit-dialog.html',
          parent: angular.element($document.body),
          clickOutsideToClose: false,
          locals: {
            dataSource: item
          }
        })
        .then(function (res) {
          if (res && res.reload) {
            _getDataSource();
          }
        });
    }

    function _deleteVisit(item) {
      var confirm = $mdDialog
        .confirm()
        .title('Delete Confirmation')
        .textContent(
          'Are you sure you want to delete this visit "' +
            item.remark +
            '"? This action is irreversible!'
        )
        .ok('DELETE')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        return $http
          .post(
            $rootScope.routePath + '/eDischarge/deleteEdischargeVisitById',
            {
              eDischargeVisitId: item.id
            }
          )
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            if (res.success) {
              _getDataSource();
            }
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    function _amendVisit(item) {
      item = item || {};
      item.e_discharge_doctor_id = vm.selectedDoctor.id;

      $mdDialog
        .show({
          controller: 'EdischargeStaffAmendVisitDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/e-discharge-staff/dialogs/e-discharge-staff-amend-visit/e-discharge-staff-amend-visit-dialog.html',
          parent: angular.element($document.body),
          clickOutsideToClose: false,
          locals: {
            dataSource: item
          }
        })
        .then(function (res) {
          if (res && res.reload) {
            _getDataSource();
          }
        });
    }

    function _cancelVisit(item) {
      var confirm = $mdDialog
        .confirm()
        .title('Cancel Confirmation')
        .textContent(
          'Are you sure you want to cancel this visit "' +
            item.remark +
            '"? This action is irreversible!'
        )
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        return $http
          .post(
            $rootScope.routePath + '/eDischarge/cancelEdischargeVisitById',
            {
              eDischargeVisitId: item.id
            }
          )
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            if (res.success) {
              _getDataSource();
            }
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    function _editProcedure(item) {
      item = item || {};
      item.e_discharge_doctor_id = vm.selectedDoctor.id;

      $mdDialog
        .show({
          controller: 'EdischargeStaffProcedureDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/e-discharge-staff/dialogs/e-discharge-staff-procedure/e-discharge-staff-procedure-dialog.html',
          parent: angular.element($document.body),
          clickOutsideToClose: false,
          locals: {
            dataSource: item
          }
        })
        .then(function (res) {
          if (res && res.reload) {
            _getDataSource();
          }
        });
    }

    function _deleteProcedure(item) {
      var confirm = $mdDialog
        .confirm()
        .title('Delete Confirmation')
        .textContent(
          'Are you sure you want to delete this procedure "' +
            item.procedure_name +
            '"? This action is irreversible!'
        )
        .ok('DELETE')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        return $http
          .post(
            $rootScope.routePath + '/eDischarge/deleteEdischargeProcedureById',
            {
              eDischargeProcedureId: item.id
            }
          )
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            if (res.success) {
              _getDataSource();
            }
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    function _amendProcedure(item) {
      item = item || {};
      item.e_discharge_doctor_id = vm.selectedDoctor.id;

      $mdDialog
        .show({
          controller: 'EdischargeStaffAmendProcedureDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/e-discharge-staff/dialogs/e-discharge-staff-amend-procedure/e-discharge-staff-amend-procedure-dialog.html',
          parent: angular.element($document.body),
          clickOutsideToClose: false,
          locals: {
            dataSource: item
          }
        })
        .then(function (res) {
          if (res && res.reload) {
            _getDataSource();
          }
        });
    }

    function _cancelProcedure(item) {
      var confirm = $mdDialog
        .confirm()
        .title('Cancel Confirmation')
        .textContent(
          'Are you sure you want to cancel this procedure "' +
            item.procedure_name +
            '"? This action is irreversible!'
        )
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        return $http
          .post(
            $rootScope.routePath + '/eDischarge/cancelEdischargeProcedureById',
            {
              eDischargeProcedureId: item.id
            }
          )
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            if (res.success) {
              _getDataSource();
            }
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    function _isPendingApproval() {
      if (!vm.dataSource) {
        return false;
      }

      return [null, 'New'].includes(vm.dataSource.status);
    }

    function _addDoctor() {
      $mdDialog
        .show({
          controller: 'EdischargeStaffAddDoctorDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/e-discharge-staff/dialogs/e-discharge-staff-add-doctor/e-discharge-staff-add-doctor-dialog.html',
          parent: angular.element($document.body),
          clickOutsideToClose: false,
          locals: {
            dataSource: {
              eDischargeEpisodeExternalId: vm.dataSource.episode_external_id,
              patientName: vm.dataSource.patient_name,
              episodeNumber: vm.dataSource.episode_number
            }
          }
        })
        .then(function (res) {
          if (res && res.reload) {
            _getDataSource();
          }
        });
    }

    function _requestDischarge() {
      var confirm = $mdDialog
        .confirm()
        .title('Request Discharge Confirmation')
        .textContent(
          'Are you sure you want to request discharge for this patient "' +
            vm.dataSource.patient_name +
            ' (' +
            vm.dataSource.episode_number +
            ')"?'
        )
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        $http
          .post($rootScope.routePath + '/eDischarge/staff/requestDischarge', {
            eDischargeEpisodeExternalId:
              vm.dataSource.e_discharge_episode_external_id
          })
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            if (res.success) {
              _getDataSource();
            }
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    function _complete() {
      var confirm = $mdDialog
        .confirm()
        .title('Mark As Complete Confirmation')
        .textContent(
          'Are you sure you want to mark this e-discharge form as complete for this patient "' +
            vm.dataSource.patient_name +
            ' (' +
            vm.dataSource.episode_number +
            ')"?'
        )
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        $http
          .post($rootScope.routePath + '/eDischarge/staff/completeEdischarge', {
            eDischargeFormId: vm.dataSource.id
          })
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            if (res.success) {
              _getDataSource();
            }
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    function _catchAttention() {
      unsavedChangesService.setUnsavedChanges(true);

      var buttonSaveQuestion = vm.selectedDoctor.requires_reapproval
        ? angular.element('.button-save-questions.orange-500-bg-override')
        : angular.element('.button-save-questions');
      var textUnsaved = angular.element('.vnp-unsaved');

      if (vm.selectedDoctor.requires_reapproval) {
        buttonSaveQuestion.addClass('orange-900-bg-override');

        $window.setTimeout(function () {
          buttonSaveQuestion.removeClass('orange-900-bg-override');
        }, 300);
      } else {
        buttonSaveQuestion.addClass('blue-900-bg-override');

        $window.setTimeout(function () {
          buttonSaveQuestion.removeClass('blue-900-bg-override');
        }, 300);
      }

      textUnsaved.addClass('red-500-fg');

      $window.setTimeout(function () {
        textUnsaved.removeClass('red-500-fg');
      }, 300);
    }

    function _hasQuestionHistory(doctor) {
      return (
        doctor &&
        doctor.e_discharge_question &&
        doctor.e_discharge_question.length &&
        Object.keys(doctor.e_discharge_question[0]).filter(function (v) {
          return !v.startsWith('$$');
        }).length > 0
      );
    }

    function _hasPastQuestionHistory(doctor) {
      return (
        doctor &&
        doctor.e_discharge_question &&
        doctor.e_discharge_question.length > 1
      );
    }

    function _showQuestionHistory(doctor) {
      doctor.showQuestionHistory = !doctor.showQuestionHistory;
    }

    function _saveQuestionDisabled() {
      var dataSource =
        vm.selectedDoctor.e_discharge_question[
          vm.selectedDoctor.e_discharge_question.length - 1
        ];

      return dataSource.uses_implants === undefined;
    }

    function _editQuestion() {
      var dataSource =
        vm.selectedDoctor.e_discharge_question[
          vm.selectedDoctor.e_discharge_question.length - 1
        ];
      dataSource.e_discharge_doctor_id = vm.selectedDoctor.id;

      var payload = {
        id: dataSource.id,
        e_discharge_doctor_id: dataSource.e_discharge_doctor_id,
        uses_implants: dataSource.uses_implants
      };

      $http
        .post(
          $rootScope.routePath + '/eDischarge/saveEdischargeQuestion',
          payload
        )
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          sharedService.showToast(res.message);
          unsavedChangesService.setUnsavedChanges(false);

          _getDataSource();
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _amendQuestion() {
      var dataSource =
        vm.selectedDoctor.e_discharge_question[
          vm.selectedDoctor.e_discharge_question.length - 1
        ];
      dataSource.e_discharge_doctor_id = vm.selectedDoctor.id;

      var payload = {
        e_discharge_doctor_id: dataSource.e_discharge_doctor_id,
        uses_implants: dataSource.uses_implants,
        amend_for_id: dataSource.id
      };

      $http
        .post(
          $rootScope.routePath + '/eDischarge/amendEdischargeQuestion',
          payload
        )
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          sharedService.showToast(res.message);
          unsavedChangesService.setUnsavedChanges(false);

          _getDataSource();
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('app.eDischargeConsultant')
    .controller('EdischargeConsultantEditController', Controller);

  /** @ngInject */
  function Controller(
    $scope,
    $rootScope,
    $q,
    $http,
    $stateParams,
    sharedService,
    $mdDialog,
    $document,
    $window,
    unsavedChangesService
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var _stateParamsCopy;

    // Exposed data
    vm.dataSource = {};
    vm.defaultNoSelectionText = 'Select one';

    vm.selectedDoctor = null;
    vm.isDataAccurate = false;

    vm.sharedService = sharedService;

    vm.hasUnsavedChanges = unsavedChangesService.hasUnsavedChanges;

    // Exposed methods
    vm.back = _back;

    vm.editVisit = _editVisit;
    vm.deleteVisit = _deleteVisit;
    vm.amendVisit = _amendVisit;
    vm.cancelVisit = _cancelVisit;
    vm.editProcedure = _editProcedure;
    vm.deleteProcedure = _deleteProcedure;
    vm.amendProcedure = _amendProcedure;
    vm.cancelProcedure = _cancelProcedure;
    vm.approve = _approve;

    vm.catchAttention = _catchAttention;
    vm.hasQuestionHistory = _hasQuestionHistory;
    vm.hasPastQuestionHistory = _hasPastQuestionHistory;
    vm.showQuestionHistory = _showQuestionHistory;
    vm.saveQuestionDisabled = _saveQuestionDisabled;
    vm.editQuestion = _editQuestion;
    vm.amendQuestion = _amendQuestion;

    function _init() {
      sharedService.pageIcon = 'icon-pencil';
      sharedService.pageName = 'Edit E-Discharge';

      _stateParamsCopy = $stateParams;

      unsavedChangesService.setMessage(
        'You have unsaved changes in the questions section. Are you sure you want to leave without saving?'
      );

      if ($stateParams.id) {
        _getDataSource();
      }
    }

    function _getDataSource() {
      $http
        .get(
          $rootScope.routePath +
            '/eDischarge/consultant/getEdischargeFormByEdischargeEpisodeExternalId',
          {
            params: {
              eDischargeEpisodeExternalId: $stateParams.id
            }
          }
        )
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          vm.dataSource = res.data.result;

          for (var i = 0; i < res.data.result.e_discharge_doctor.length; ++i) {
            var doctor = res.data.result.e_discharge_doctor[i];

            if (
              !doctor.e_discharge_question ||
              !doctor.e_discharge_question.length
            ) {
              doctor.e_discharge_question = [{}];
            }
          }

          // Default select the doctor directly if only 1 doctor
          if (res.data.result.e_discharge_doctor.length === 1) {
            vm.selectedDoctor = res.data.result.e_discharge_doctor[0];

            sharedService.pageName = vm.selectedDoctor.requires_reapproval
              ? 'Amend E-Discharge'
              : 'Edit E-Discharge';
          }
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }

          sharedService.back('app.eDischargeConsultant');
        });
    }

    function _back() {
      sharedService.back('app.eDischargeConsultant', _stateParamsCopy);
    }

    function _editVisit(item) {
      item = item || {};
      item.e_discharge_doctor_id = vm.selectedDoctor.id;

      $mdDialog
        .show({
          controller: 'EdischargeConsultantVisitDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/e-discharge-consultant/dialogs/e-discharge-consultant-visit/e-discharge-consultant-visit-dialog.html',
          parent: angular.element($document.body),
          clickOutsideToClose: false,
          locals: {
            dataSource: item
          }
        })
        .then(function (res) {
          if (res && res.reload) {
            _getDataSource();
          }
        });
    }

    function _deleteVisit(item) {
      var confirm = $mdDialog
        .confirm()
        .title('Delete Confirmation')
        .textContent(
          'Are you sure you want to delete this visit "' +
            item.remark +
            '"? This action is irreversible!'
        )
        .ok('DELETE')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        return $http
          .post(
            $rootScope.routePath + '/eDischarge/deleteEdischargeVisitById',
            {
              eDischargeVisitId: item.id
            }
          )
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            if (res.success) {
              _getDataSource();
            }
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    function _amendVisit(item) {
      item = item || {};
      item.e_discharge_doctor_id = vm.selectedDoctor.id;

      $mdDialog
        .show({
          controller: 'EdischargeConsultantAmendVisitDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/e-discharge-consultant/dialogs/e-discharge-consultant-amend-visit/e-discharge-consultant-amend-visit-dialog.html',
          parent: angular.element($document.body),
          clickOutsideToClose: false,
          locals: {
            dataSource: item
          }
        })
        .then(function (res) {
          if (res && res.reload) {
            _getDataSource();
          }
        });
    }

    function _cancelVisit(item) {
      var confirm = $mdDialog
        .confirm()
        .title('Cancel Confirmation')
        .textContent(
          'Are you sure you want to cancel this visit "' +
            item.remark +
            '"? This action is irreversible!'
        )
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        return $http
          .post(
            $rootScope.routePath + '/eDischarge/cancelEdischargeVisitById',
            {
              eDischargeVisitId: item.id
            }
          )
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            if (res.success) {
              _getDataSource();
            }
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    function _editProcedure(item) {
      item = item || {};
      item.e_discharge_doctor_id = vm.selectedDoctor.id;

      $mdDialog
        .show({
          controller: 'EdischargeConsultantProcedureDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/e-discharge-consultant/dialogs/e-discharge-consultant-procedure/e-discharge-consultant-procedure-dialog.html',
          parent: angular.element($document.body),
          clickOutsideToClose: false,
          locals: {
            dataSource: item
          }
        })
        .then(function (res) {
          if (res && res.reload) {
            _getDataSource();
          }
        });
    }

    function _deleteProcedure(item) {
      var confirm = $mdDialog
        .confirm()
        .title('Delete Confirmation')
        .textContent(
          'Are you sure you want to delete this procedure "' +
            item.procedure_name +
            '"? This action is irreversible!'
        )
        .ok('DELETE')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        return $http
          .post(
            $rootScope.routePath + '/eDischarge/deleteEdischargeProcedureById',
            {
              eDischargeProcedureId: item.id
            }
          )
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            if (res.success) {
              _getDataSource();
            }
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    function _amendProcedure(item) {
      item = item || {};
      item.e_discharge_doctor_id = vm.selectedDoctor.id;

      $mdDialog
        .show({
          controller: 'EdischargeConsultantAmendProcedureDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/e-discharge-consultant/dialogs/e-discharge-consultant-amend-procedure/e-discharge-consultant-amend-procedure-dialog.html',
          parent: angular.element($document.body),
          clickOutsideToClose: false,
          locals: {
            dataSource: item
          }
        })
        .then(function (res) {
          if (res && res.reload) {
            _getDataSource();
          }
        });
    }

    function _cancelProcedure(item) {
      var confirm = $mdDialog
        .confirm()
        .title('Cancel Confirmation')
        .textContent(
          'Are you sure you want to cancel this procedure "' +
            item.procedure_name +
            '"? This action is irreversible!'
        )
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        return $http
          .post(
            $rootScope.routePath + '/eDischarge/cancelEdischargeProcedureById',
            {
              eDischargeProcedureId: item.id
            }
          )
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            if (res.success) {
              _getDataSource();
            }
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    function _approve() {
      var textContents = [];

      if (
        !vm.selectedDoctor.e_discharge_question ||
        !vm.selectedDoctor.e_discharge_question.length ||
        // After save definitely has id, but still has hash key
        vm.selectedDoctor.e_discharge_question[0].uses_implants === null ||
        vm.selectedDoctor.e_discharge_question[0].uses_implants === undefined ||
        !vm.selectedDoctor.e_discharge_question[0].id
      ) {
        textContents.push('Please state whether implants were used.');
      }

      if (textContents.length) {
        var invalid = $mdDialog
          .alert()
          .title('Invalid submission data')
          .htmlContent(textContents.join('<br>'))
          .ok('OK');

        return $mdDialog.show(invalid);
      }

      var approvalConfirm = $mdDialog
        .confirm()
        .title('Approval Confirmation')
        .htmlContent(
          'Are you sure you want to approve <span style="font-weight: bold;">ALL</span> the data entered in this e-discharge form for this patient "' +
            vm.dataSource.patient_name +
            ' (' +
            vm.dataSource.episode_number +
            ')"? This action is irreversible!'
        )
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(approvalConfirm).then(function () {
        var promise = $q.resolve();

        if (
          !vm.selectedDoctor.e_discharge_visit ||
          !vm.selectedDoctor.e_discharge_visit.length
        ) {
          var confirm = $mdDialog
            .confirm()
            .title('No data confirmation')
            .textContent(
              'Are you sure you that there are no visit data for this patient?'
            )
            .ok('YES')
            .cancel('NO');

          promise = promise.then(function () {
            return $mdDialog.show(confirm);
          });
        }

        promise.then(function () {
          return $http
            .post(
              $rootScope.routePath + '/eDischarge/consultant/approveEdischarge',
              {
                eDischargeDoctorId: vm.selectedDoctor.id
              }
            )
            .then(function (res) {
              res = res.data;

              sharedService.showToast(res.message);

              if (res.success) {
                _back();
              }
            })
            .catch(function (err) {
              if (err.message) {
                sharedService.showToast(err.message);
              } else {
                sharedService.showToast('Request timed out.');
              }
            });
        });
      });
    }

    function _catchAttention() {
      unsavedChangesService.setUnsavedChanges(true);

      var buttonSaveQuestion = vm.selectedDoctor.requires_reapproval
        ? angular.element('.button-save-questions.orange-500-bg-override')
        : angular.element('.button-save-questions');
      var textUnsaved = angular.element('.vnp-unsaved');

      if (vm.selectedDoctor.requires_reapproval) {
        buttonSaveQuestion.addClass('orange-900-bg-override');

        $window.setTimeout(function () {
          buttonSaveQuestion.removeClass('orange-900-bg-override');
        }, 300);
      } else {
        buttonSaveQuestion.addClass('blue-900-bg-override');

        $window.setTimeout(function () {
          buttonSaveQuestion.removeClass('blue-900-bg-override');
        }, 300);
      }

      textUnsaved.addClass('red-500-fg');

      $window.setTimeout(function () {
        textUnsaved.removeClass('red-500-fg');
      }, 300);
    }

    function _hasQuestionHistory(doctor) {
      return (
        doctor &&
        doctor.e_discharge_question &&
        doctor.e_discharge_question.length &&
        Object.keys(doctor.e_discharge_question[0]).filter(function (v) {
          return !v.startsWith('$$');
        }).length > 0
      );
    }

    function _hasPastQuestionHistory(doctor) {
      return (
        doctor &&
        doctor.e_discharge_question &&
        doctor.e_discharge_question.length > 1
      );
    }

    function _showQuestionHistory(doctor) {
      doctor.showQuestionHistory = !doctor.showQuestionHistory;
    }

    function _saveQuestionDisabled() {
      var dataSource =
        vm.selectedDoctor.e_discharge_question[
          vm.selectedDoctor.e_discharge_question.length - 1
        ];

      return dataSource.uses_implants === undefined;
    }

    function _editQuestion() {
      var dataSource =
        vm.selectedDoctor.e_discharge_question[
          vm.selectedDoctor.e_discharge_question.length - 1
        ];
      dataSource.e_discharge_doctor_id = vm.selectedDoctor.id;

      var payload = {
        id: dataSource.id,
        e_discharge_doctor_id: dataSource.e_discharge_doctor_id,
        uses_implants: dataSource.uses_implants
      };

      $http
        .post(
          $rootScope.routePath + '/eDischarge/saveEdischargeQuestion',
          payload
        )
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          sharedService.showToast(res.message);
          unsavedChangesService.setUnsavedChanges(false);

          _getDataSource();
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _amendQuestion() {
      var dataSource =
        vm.selectedDoctor.e_discharge_question[
          vm.selectedDoctor.e_discharge_question.length - 1
        ];
      dataSource.e_discharge_doctor_id = vm.selectedDoctor.id;

      var payload = {
        e_discharge_doctor_id: dataSource.e_discharge_doctor_id,
        uses_implants: dataSource.uses_implants,
        amend_for_id: dataSource.id
      };

      $http
        .post(
          $rootScope.routePath + '/eDischarge/amendEdischargeQuestion',
          payload
        )
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          sharedService.showToast(res.message);
          unsavedChangesService.setUnsavedChanges(false);

          _getDataSource();
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('app.eDischargeConsultant')
    .controller('EdischargeConsultantViewController', Controller);

  /** @ngInject */
  function Controller(
    $scope,
    $rootScope,
    $q,
    $http,
    $stateParams,
    sharedService,
    $mdDialog,
    $document
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var _stateParamsCopy;

    // Exposed data
    vm.dataSource = {};

    vm.sharedService = sharedService;

    // Exposed methods
    vm.back = _back;

    vm.hasQuestionHistory = _hasQuestionHistory;
    vm.showQuestionHistory = _showQuestionHistory;

    function _init() {
      sharedService.pageIcon = 'icon-eye';
      sharedService.pageName = 'View E-Discharge';

      _stateParamsCopy = $stateParams;

      if ($stateParams.id) {
        _getDataSource();
      }
    }

    function _getDataSource() {
      $http
        .get(
          $rootScope.routePath +
            '/eDischarge/consultant/getEdischargeFormByEdischargeEpisodeExternalId',
          {
            params: {
              eDischargeEpisodeExternalId: $stateParams.id
            }
          }
        )
        .then(function (res) {
          res = res.data;

          if (!res.success) {
            return $q.reject(new Error(res.message));
          }

          vm.dataSource = res.data.result;

          // Default select the doctor directly if only 1 doctor
          if (res.data.result.e_discharge_doctor.length === 1) {
            vm.selectedDoctor = res.data.result.e_discharge_doctor[0];
          }
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }

          sharedService.back('app.eDischargeConsultant');
        });
    }

    function _back() {
      sharedService.back('app.eDischargeConsultant', _stateParamsCopy);
    }

    function _hasQuestionHistory(doctor) {
      return (
        doctor &&
        doctor.e_discharge_question &&
        doctor.e_discharge_question.length &&
        Object.keys(doctor.e_discharge_question[0]).filter(function (v) {
          return !v.startsWith('$$');
        }).length > 0
      );
    }

    function _showQuestionHistory(doctor) {
      doctor.showQuestionHistory = !doctor.showQuestionHistory;
    }

    function _destroy() {}
  }
})();

(function () {
  'use strict';

  // Admin configuration for feature popups now lives in dr-portal-admin.
  // This module only hosts the post-login popup dialog shown to doctors
  // (see dialogs/feature-popup-dialog.controller.js).
  angular.module('app.featurePopup', []);
})();

(function () {
  'use strict';

  angular
    .module('app.featurePopup')
    .controller('FeaturePopupDialogController', FeaturePopupDialogController);

  /** @ngInject */
  function FeaturePopupDialogController(
    $scope,
    $interval,
    $sce,
    $mdDialog,
    bridgeService,
    featurePopup,
    images
  ) {
    var vm = this;

    var _rotationInterval;
    var _v2Host = bridgeService.getV2Host();

    // Data
    // The API response uses camelCase property names (featurePopup.videoUrl,
    // image.fileName, etc.) — this dialog previously read display_type /
    // video_url / file_name (snake_case), which never matched and silently
    // rendered nothing.
    vm.featurePopup = featurePopup;
    vm.popupWidth = featurePopup.popupWidth || 640;
    vm.popupHeight = featurePopup.popupHeight || 360;
    vm.currentSlideIndex = 0;

    // Video and rotating images are mutually exclusive display modes (see
    // dr-portal-nestjs-api's hooks.ts) — a fixed rotation interval has no way
    // to know when a video actually ends, so the two are never mixed.
    vm.slides = _buildSlides();

    // Methods
    vm.prev = _prev;
    vm.next = _next;
    vm.close = _close;

    _init();

    //////////

    // Browsers only allow autoplay when the media is muted, so autoplay=1
    // alone silently does nothing — mute=1 (YouTube's param name) is what
    // actually makes it play without a click.
    function _withAutoplay(embedUrl) {
      var url;
      try {
        url = new URL(embedUrl);
      } catch (e) {
        return embedUrl;
      }

      url.searchParams.set('autoplay', '1');

      var host = url.hostname.replace(/^www\.|^m\./, '');
      if (host === 'youtube.com') {
        url.searchParams.set('mute', '1');
      }

      return url.toString();
    }

    function _buildSlides() {
      if (vm.featurePopup.displayType === 'video' && vm.featurePopup.videoUrl) {
        return [
          {
            type: 'video',
            trustedUrl: $sce.trustAsResourceUrl(
              _withAutoplay(vm.featurePopup.videoUrl)
            ),
          },
        ];
      }

      return (images || []).map(function (image) {
        return {
          type: 'image',
          url: _v2Host + '/featurePopup/image/' + image.fileName,
        };
      });
    }

    function _init() {
      if (vm.slides.length > 1) {
        var intervalMs = (vm.featurePopup.rotationIntervalSeconds || 5) * 1000;

        _rotationInterval = $interval(_next, intervalMs);
      }

      $scope.$on('$destroy', function () {
        if (_rotationInterval) $interval.cancel(_rotationInterval);
      });
    }

    function _prev() {
      vm.currentSlideIndex =
        (vm.currentSlideIndex - 1 + vm.slides.length) % vm.slides.length;
    }

    function _next() {
      vm.currentSlideIndex = (vm.currentSlideIndex + 1) % vm.slides.length;
    }

    function _close() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.announcement', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      // Main
      .state('app.announcement', {
        url: '/announcement',
        views: {
          'content@app': {
            templateUrl: 'app/main/announcement/announcement.html',
            controller: 'AnnouncementController',
            controllerAs: 'vm'
          }
        },
        params: {
          searchTerm: null,
          page: 0,
          pageLength: 25
        },
        bodyClass: 'announcement',
        moduleName: 'Announcement'
      })
      // Edit
      .state('app.announcement.edit', {
        url: '/edit/:id',
        views: {
          'content@app': {
            templateUrl: 'app/main/announcement/edit/announcement-edit.html',
            controller: 'AnnouncementEditController',
            controllerAs: 'vm'
          }
        },
        params: {
          restorePartial: false
        },
        bodyClass: 'announcement-edit',
        moduleName: 'Announcement'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.announcement')
    .controller('AnnouncementEditController', AnnouncementEditController);

  /** @ngInject */
  function AnnouncementEditController(
    $scope,
    $rootScope,
    $q,
    $http,
    $stateParams,
    sharedService,
    $mdDialog,
    $window,
    $state,
    $timeout
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var _stateParamsCopy;

    // Exposed data
    vm.announcement = {
      id: null,
      name: null,
      message: null,
      start_datetime: moment().startOf('day'),
      end_datetime: null,
      is_active: true
    };

    vm.sharedService = sharedService;

    // Exposed methods
    vm.save = _save;
    vm.back = _back;

    function _init() {
      sharedService.pageIcon = 'icon-pencil';
      sharedService.pageName = 'Edit Announcement';

      _stateParamsCopy = $stateParams;

      if ($stateParams.id) {
        $http
          .get($rootScope.routePath + '/announcement/getById', {
            params: {
              id: $stateParams.id
            }
          })
          .then(function (res) {
            res = res.data;

            if (!res.success) {
              return $q.reject(res.message);
            }

            res.data.announcement.start_datetime = moment
              .utc(res.data.announcement.start_datetime)
              .local();
            res.data.announcement.end_datetime = moment
              .utc(res.data.announcement.end_datetime)
              .local();

            vm.announcement = res.data.announcement;
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }

            sharedService.back('app.announcement');
          });
      }

      if ($stateParams.restorePartial) {
        var announcementPartial = $window.localStorage.getItem(
          'announcementPartial'
        );

        if (announcementPartial) {
          try {
            var a = JSON.parse(announcementPartial);

            if (a.start_datetime) {
              a.start_datetime = moment(a.start_datetime);
            }
            if (a.end_datetime) {
              a.end_datetime = moment(a.end_datetime);
            }

            vm.announcement = a;

            $window.localStorage.removeItem('announcementPartial');
          } catch (err) {}

          $timeout(function () {
            $scope.announcementEditForm.$setDirty();
          });
        }
      }
    }

    function _save() {
      $http
        .post($rootScope.routePath + '/announcement/save', {
          announcementId: vm.announcement.id,
          announcementName: vm.announcement.name,
          announcementMessage: vm.announcement.message,
          announcementIsActive: vm.announcement.is_active,
          announcementStartDatetime: vm.announcement.start_datetime
            .clone()
            .utc(),
          announcementEndDatetime: vm.announcement.end_datetime
            ? vm.announcement.end_datetime.clone().utc()
            : null
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            _back();
          }

          if (!res.data || !res.data.result) {
            return sharedService.showToast(res.message);
          }

          if (res.data && res.data.result) {
            var confirm = $mdDialog
              .confirm()
              .title('Adjustment Confirmation')
              .textContent(
                'Date range overlaps with another announcement "' +
                  res.data.result.name +
                  '", do you want to adjust that "' +
                  res.data.result.name +
                  '" announcement?'
              )
              .ok('YES')
              .cancel('NO');

            $mdDialog
              .show(confirm)
              .then(function () {
                $window.localStorage.setItem(
                  'announcementPartial',
                  JSON.stringify(vm.announcement)
                );

                $state.go('app.announcement.edit', {
                  id: res.data.result.id,
                  searchTerm: $stateParams.searchTerm,
                  page: $stateParams.page,
                  pageLength: $stateParams.pageLength
                });
              })
              .catch(function () {
                sharedService.showToast(
                  'User cancelled adjustments. Please make sure the date range does not overlap with the "' +
                    res.data.result.name +
                    '" announcement.'
                );
              });
          }
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _back() {
      var announcementPartial = $window.localStorage.getItem(
        'announcementPartial'
      );

      if (announcementPartial) {
        try {
          var a = JSON.parse(announcementPartial);

          _stateParamsCopy.id = a.id;
          _stateParamsCopy.restorePartial = true;
        } catch (err) {}

        sharedService.back('app.announcement.edit', _stateParamsCopy);
        return;
      }

      // Special case
      $state.go('app.announcement', _stateParamsCopy);
    }

    function _destroy() {}
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function() {
	'use strict';

	angular
		.module('app.appointment')
		.controller('AppointmentEditController', AppointmentEditController);
	
	/** @ngInject */
	function AppointmentEditController($stateParams, Appointment, $mdMedia, sharedService, Todo, $rootScope, $http, $q, accountService, Role, $timeout) {
		var vm = this;

		// Data
		vm.sharedService = sharedService;

		vm.appointment;
		vm.Todo = Todo;
		vm.todo = null;
		vm.mediaXsActionButtons = $mdMedia('gt-xs') ? '' : 'md-mini';
		vm.minDate = moment();

		sharedService.pageIcon = 'icon-pencil';
		sharedService.pageName = 'Edit Appointment';

		// Methods
		vm.$onInit = init;
		vm.request = request;
		vm.back = back;

		//////////

		function init() {
			$http.get($rootScope.routePath + '/todo/get-appointment', {
				params: {
					id: $stateParams.id
				}
			})
			.then(function(res) {
				res = res.data;
				if (!res.success) return $q.reject(res.message);

				vm.appointment = new Appointment(res.data.appointment);

				if (res.data.todo) {
					vm.todo = new Todo(res.data.todo);
					vm.todo.requested_datetime = vm.todo.requested_datetime ? moment(vm.todo.requested_datetime).local() : moment();
				} else {
					vm.todo = new Todo({
						type: Todo.TYPE.APPOINTMENT,
						subtype: Todo.SUBTYPE.CANCEL,
						requested_datetime: moment(),
						created_by: accountService.user.username,
						created_by_role: accountService.user.getFirstRole(),
						created_for_role: Role.NAME.CALL_CENTER_STAFF,
						ref_id: $stateParams.id
					});
				}
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			});
		}
		
		function request() {
			if (vm.todo.subtype === Todo.SUBTYPE.CANCEL) vm.todo.requested_datetime = null;

			if (vm.todo.id === 0) {
				$http.post($rootScope.routePath + '/todo/save-appointment', vm.todo)
				.then(function(res) {
					res = res.data;
					if (res.success) {
						vm.todo.id = res.data.id;
						sharedService.back('app.appointment');
					}
					sharedService.showToast(res.message);
				})
				.catch(function(err) {
					if (err.message) sharedService.showToast(err.message);
					else sharedService.showToast('Request timed out.');
				});
			} else {
				$http.post($rootScope.routePath + '/todo/update-appointment', vm.todo)
				.then(function(res) {
					res = res.data;
					if (res.success) sharedService.back('app.appointment');
					sharedService.showToast(res.message);
				})
				.catch(function(err) {
					if (err.message) sharedService.showToast(err.message);
					else sharedService.showToast('Request timed out.');
				});
			}
		}

		function back() {
			sharedService.back('app.appointment');
		}
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Chat',
                        'icon'       : 'icon-hangouts',
                        'state'      : 'app.chat',
                        'badge'      : {
                            'content': 13,
                            'color'  : '#09d261'
                        },
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'chat',
                        '_path'      : 'apps.chat',
                        'uisref'     : 'app.chat',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Contacts',
                        'icon'       : 'icon-account-box',
                        'state'      : 'app.contacts',
                        'weight'     : 10,
                        'children'   : [],
                        '_id'        : 'contacts',
                        '_path'      : 'apps.contacts',
                        'uisref'     : 'app.contacts',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Notes',
                        'icon'       : 'icon-lightbulb',
                        'state'      : 'app.notes',
                        'weight'     : 11,
                        'children'   : [],
                        '_id'        : 'notes',
                        '_path'      : 'apps.notes',
                        'uisref'     : 'app.notes',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .provider('msNavigationService', msNavigationServiceProvider)
    .controller('MsNavigationController', MsNavigationController)
    // Vertical
    .directive('msNavigation', msNavigationDirective)
    .controller('MsNavigationNodeController', MsNavigationNodeController)
    .directive('msNavigationNode', msNavigationNodeDirective)
    .directive('msNavigationItem', msNavigationItemDirective)
    //Horizontal
    .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
    .controller(
      'MsNavigationHorizontalNodeController',
      MsNavigationHorizontalNodeController
    )
    .directive(
      'msNavigationHorizontalNode',
      msNavigationHorizontalNodeDirective
    )
    .directive(
      'msNavigationHorizontalItem',
      msNavigationHorizontalItemDirective
    );

  /** @ngInject */
  function msNavigationServiceProvider() {
    // Inject $log service
    var $log = angular.injector(['ng']).get('$log');

    // Navigation array
    var navigation = [];

    var service = this;

    // Methods
    service.saveItem = saveItem;
    service.deleteItem = deleteItem;
    service.sortByWeight = sortByWeight;

    //////////

    /**
     * Create or update the navigation item
     *
     * @param path
     * @param item
     */
    function saveItem(path, item) {
      if (!angular.isString(path)) {
        $log.error('path must be a string (eg. `dashboard.project`)');
        return;
      }

      var parts = path.split('.');

      // Generate the object id from the parts
      var id = parts[parts.length - 1];

      // MODIFIED: Get the parent item from the parts
      var parent = _findOrCreateParent(parts, item.order);

      // Decide if we are going to update or create
      var updateItem = false;

      for (var i = 0; i < parent.length; i++) {
        if (parent[i]._id === id) {
          updateItem = parent[i];

          break;
        }
      }

      // Update
      if (updateItem) {
        angular.extend(updateItem, item);

        // Add proper ui-sref
        updateItem.uisref = _getUiSref(updateItem);
      }
      // Create
      else {
        // Create an empty children array in the item
        item.children = [];

        // Add the default weight if not provided or if it's not a number
        if (
          angular.isUndefined(item.weight) ||
          !angular.isNumber(item.weight)
        ) {
          item.weight = 1;
        }

        // Add the item id
        item._id = id;

        // Add the item path
        item._path = path;

        // Add proper ui-sref
        item.uisref = _getUiSref(item);

        // CUSTOM: Add weight
        item.weight = item.order;

        // Push the item into the array
        parent.push(item);

        // CUSTOM: Sort parent
        parent.sort(function (a, b) {
          return parseFloat(a.weight) - parseFloat(b.weight);
        });
      }
    }

    /**
     * Delete navigation item
     *
     * @param path
     */
    function deleteItem(path) {
      if (!angular.isString(path)) {
        $log.error('path must be a string (eg. `dashboard.project`)');
        return;
      }

      // Locate the item by using given path
      var item = navigation,
        parts = path.split('.');

      for (var p = 0; p < parts.length; p++) {
        var id = parts[p];

        for (var i = 0; i < item.length; i++) {
          if (item[i]._id === id) {
            // If we have a matching path,
            // we have found our object:
            // remove it.
            if (item[i]._path === path) {
              item.splice(i, 1);
              return true;
            }

            // Otherwise grab the children of
            // the current item and continue
            item = item[i].children;
            break;
          }
        }
      }

      return false;
    }

    /**
     * Sort the navigation items by their weights
     *
     * @param parent
     */
    function sortByWeight(parent) {
      // If parent not provided, sort the root items
      if (!parent) {
        parent = navigation;
        parent.sort(_byWeight);
      }

      // Sort the children
      for (var i = 0; i < parent.length; i++) {
        var children = parent[i].children;

        if (children.length > 1) {
          children.sort(_byWeight);
        }

        if (children.length > 0) {
          sortByWeight(children);
        }
      }
    }

    /* ----------------- */
    /* Private Functions */
    /* ----------------- */

    /**
     * MODIFIED: Find or create parent
     *
     * @param parts
     * @returns {Array|Boolean}
     * @private
     */
    function _findOrCreateParent(parts, weight) {
      // CUSTOM: Sort navigation
      navigation.sort(function (a, b) {
        return parseFloat(a.weight) - parseFloat(b.weight);
      });

      // Store the main navigation
      var parent = navigation;

      // If it's going to be a root item
      // return the navigation itself
      if (parts.length === 1) {
        return parent;
      }

      // Remove the last element from the parts as
      // we don't need that to figure out the parent
      parts.pop();

      // Find and return the parent
      for (var i = 0; i < parts.length; i++) {
        var _id = parts[i],
          createParent = true;

        for (var p = 0; p < parent.length; p++) {
          if (parent[p]._id === _id) {
            parent = parent[p].children;
            createParent = false;

            break;
          }
        }

        // If there is no parent found, create one, push
        // it into the current parent and assign it as a
        // new parent
        if (createParent) {
          var item = {
            _id: _id,
            _path: parts.join('.'),
            title: _id,
            weight: weight,
            children: []
          };

          parent.push(item);
          parent = item.children;
        }
      }

      return parent;
    }

    /**
     * Sort by weight
     *
     * @param x
     * @param y
     * @returns {number}
     * @private
     */
    function _byWeight(x, y) {
      return parseInt(x.weight) - parseInt(y.weight);
    }

    /**
     * Setup the ui-sref using state & state parameters
     *
     * @param item
     * @returns {string}
     * @private
     */
    function _getUiSref(item) {
      var uisref = '';

      if (angular.isDefined(item.state)) {
        uisref = item.state;

        if (
          angular.isDefined(item.stateParams) &&
          angular.isObject(item.stateParams)
        ) {
          uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
        }
      }

      return uisref;
    }

    /* ----------------- */
    /* Service           */
    /* ----------------- */

    this.$get = function () {
      var activeItem = null,
        navigationScope = null,
        folded = null,
        foldedOpen = null;

      var service = {
        saveItem: saveItem,
        deleteItem: deleteItem,
        sort: sortByWeight,
        clearNavigation: clearNavigation,
        setActiveItem: setActiveItem,
        getActiveItem: getActiveItem,
        getNavigation: getNavigation,
        getFlatNavigation: getFlatNavigation,
        setNavigationScope: setNavigationScope,
        setFolded: setFolded,
        getFolded: getFolded,
        setFoldedOpen: setFoldedOpen,
        getFoldedOpen: getFoldedOpen,
        toggleFolded: toggleFolded
      };

      return service;

      //////////

      /**
       * Clear the entire navigation
       */
      function clearNavigation() {
        // Clear the navigation array
        navigation = [];

        // Clear the vm.navigation from main controller
        if (navigationScope) {
          navigationScope.vm.navigation = navigation;
        }
      }

      /**
       * Set active item
       *
       * @param node
       * @param scope
       */
      function setActiveItem(node, scope) {
        activeItem = {
          node: node,
          scope: scope
        };
      }

      /**
       * Return active item
       */
      function getActiveItem() {
        return activeItem;
      }

      /**
       * Return navigation array
       *
       * @param root
       * @returns Array
       */
      function getNavigation(root) {
        if (root) {
          for (var i = 0; i < navigation.length; i++) {
            if (navigation[i]._id === root) {
              return [navigation[i]];
            }
          }

          return null;
        }

        return navigation;
      }

      /**
       * Return flat navigation array
       *
       * @param root
       * @returns Array
       */
      function getFlatNavigation(root) {
        // Get the correct navigation array
        var navigation = getNavigation(root);

        // Flatten the navigation object
        return _flattenNavigation(navigation);
      }

      /**
       * Store navigation's scope for later use
       *
       * @param scope
       */
      function setNavigationScope(scope) {
        navigationScope = scope;
      }

      /**
       * Set folded status
       *
       * @param status
       */
      function setFolded(status) {
        folded = status;
      }

      /**
       * Return folded status
       *
       * @returns {*}
       */
      function getFolded() {
        return folded;
      }

      /**
       * Set folded open status
       *
       * @param status
       */
      function setFoldedOpen(status) {
        foldedOpen = status;
      }

      /**
       * Return folded open status
       *
       * @returns {*}
       */
      function getFoldedOpen() {
        return foldedOpen;
      }

      /**
       * Toggle fold on stored navigation's scope
       */
      function toggleFolded() {
        navigationScope.toggleFolded();
      }

      /**
       * Flatten the given navigation
       *
       * @param navigation
       * @private
       */
      function _flattenNavigation(navigation) {
        var flatNav = [];

        for (var x = 0; x < navigation.length; x++) {
          // Copy and clear the children of the
          // navigation that we want to push
          var navToPush = angular.copy(navigation[x]);
          navToPush.children = [];

          // Push the item
          flatNav.push(navToPush);

          // If there are child items in this navigation,
          // do some nested function magic
          if (navigation[x].children.length > 0) {
            flatNav = flatNav.concat(
              _flattenNavigation(navigation[x].children)
            );
          }
        }

        return flatNav;
      }
    };
  }

  /** @ngInject */
  function MsNavigationController($scope, msNavigationService) {
    var vm = this;

    // Data
    if ($scope.root) {
      vm.navigation = msNavigationService.getNavigation($scope.root);
    } else {
      vm.navigation = msNavigationService.getNavigation();
    }

    // Methods
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Sort the navigation before doing anything else
      msNavigationService.sort();
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      angular
        .element('body')
        .toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }
  }

  /** @ngInject */
  function msNavigationDirective(
    $rootScope,
    $timeout,
    $mdSidenav,
    msNavigationService
  ) {
    return {
      restrict: 'E',
      scope: {
        folded: '=',
        root: '@'
      },
      controller: 'MsNavigationController as vm',
      templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
      transclude: true,
      compile: function (tElement) {
        tElement.addClass('ms-navigation');

        return function postLink(scope, iElement) {
          var bodyEl = angular.element('body'),
            foldExpanderEl = angular.element(
              '<div id="ms-navigation-fold-expander"></div>'
            ),
            foldCollapserEl = angular.element(
              '<div id="ms-navigation-fold-collapser"></div>'
            ),
            sidenav = $mdSidenav('navigation');

          // Store the navigation in the service for public access
          msNavigationService.setNavigationScope(scope);

          // Initialize
          init();

          /**
           * Initialize
           */
          function init() {
            // Set the folded status for the first time.
            // First, we have to check if we have a folded
            // status available in the service already. This
            // will prevent navigation to act weird if we already
            // set the fold status, remove the navigation and
            // then re-initialize it, which happens if we
            // change to a view without a navigation and then
            // come back with history.back() function.

            // If the service didn't initialize before, set
            // the folded status from scope, otherwise we
            // won't touch anything because the folded status
            // already set in the service...
            if (msNavigationService.getFolded() === null) {
              msNavigationService.setFolded(scope.folded);
            }

            if (msNavigationService.getFolded()) {
              // Collapse everything.
              // This must be inside a $timeout because by the
              // time we call this, the 'msNavigation::collapse'
              // event listener is not registered yet. $timeout
              // will ensure that it will be called after it is
              // registered.
              $timeout(function () {
                $rootScope.$broadcast('msNavigation::collapse');
              });

              // Add class to the body
              bodyEl.addClass('ms-navigation-folded');

              // Set fold expander
              setFoldExpander();
            }
          }

          // Sidenav locked open status watcher
          scope.$watch(
            function () {
              return sidenav.isLockedOpen();
            },
            function (current, old) {
              if (
                angular.isUndefined(current) ||
                angular.equals(current, old)
              ) {
                return;
              }

              var folded = msNavigationService.getFolded();

              if (folded) {
                if (current) {
                  // Collapse everything
                  $rootScope.$broadcast('msNavigation::collapse');
                } else {
                  // Expand the active one and its parents
                  var activeItem = msNavigationService.getActiveItem();
                  if (activeItem) {
                    activeItem.scope.$emit('msNavigation::stateMatched');
                  }
                }
              }
            }
          );

          // Folded status watcher
          scope.$watch('folded', function (current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }

            setFolded(current);
          });

          /**
           * Set folded status
           *
           * @param folded
           */
          function setFolded(folded) {
            // Store folded status on the service for global access
            msNavigationService.setFolded(folded);

            if (folded) {
              // Collapse everything
              $rootScope.$broadcast('msNavigation::collapse');

              // Add class to the body
              bodyEl.addClass('ms-navigation-folded');

              // Set fold expander
              setFoldExpander();
            } else {
              // Expand the active one and its parents
              var activeItem = msNavigationService.getActiveItem();
              if (activeItem) {
                activeItem.scope.$emit('msNavigation::stateMatched');
              }

              // Remove body class
              bodyEl.removeClass(
                'ms-navigation-folded ms-navigation-folded-open'
              );

              // Remove fold collapser
              removeFoldCollapser();
            }
          }

          /**
           * Set fold expander
           */
          function setFoldExpander() {
            iElement.parent().append(foldExpanderEl);

            // Let everything settle for a moment
            // before registering the event listener
            $timeout(function () {
              foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
            });
          }

          /**
           * Set fold collapser
           */
          function setFoldCollapser() {
            bodyEl.find('#main').append(foldCollapserEl);
            foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
          }

          /**
           * Remove fold collapser
           */
          function removeFoldCollapser() {
            foldCollapserEl.remove();
          }

          /**
           * onHover event of foldExpander
           */
          function onFoldExpanderHover(event) {
            if (event) {
              event.preventDefault();
            }

            // Set folded open status
            msNavigationService.setFoldedOpen(true);

            // Expand the active one and its parents
            var activeItem = msNavigationService.getActiveItem();
            if (activeItem) {
              activeItem.scope.$emit('msNavigation::stateMatched');
            }

            // Add class to the body
            bodyEl.addClass('ms-navigation-folded-open');

            // Remove the fold opener
            foldExpanderEl.remove();

            // Set fold collapser
            setFoldCollapser();
          }

          /**
           * onHover event of foldCollapser
           */
          function onFoldCollapserHover(event) {
            if (event) {
              event.preventDefault();
            }

            // Set folded open status
            msNavigationService.setFoldedOpen(false);

            // Collapse everything
            $rootScope.$broadcast('msNavigation::collapse');

            // Remove body class
            bodyEl.removeClass('ms-navigation-folded-open');

            // Remove the fold collapser
            foldCollapserEl.remove();

            // Set fold expander
            setFoldExpander();
          }

          /**
           * Public access for toggling folded status externally
           */
          scope.toggleFolded = function () {
            var folded = msNavigationService.getFolded();

            setFolded(!folded);
          };

          /**
           * On $stateChangeStart
           */
          scope.$on('$stateChangeStart', function () {
            // Close the sidenav
            sidenav.close();
          });

          // Cleanup
          scope.$on('$destroy', function () {
            foldCollapserEl.off('mouseenter touchstart');
            foldExpanderEl.off('mouseenter touchstart');
          });
        };
      }
    };
  }

  /** @ngInject */
  function MsNavigationNodeController(
    $scope,
    $element,
    $rootScope,
    $animate,
    $state,
    msNavigationService
  ) {
    var vm = this;

    // Data
    vm.element = $element;
    vm.node = $scope.node;
    vm.hasChildren = undefined;
    vm.collapsed = undefined;
    vm.collapsable = undefined;
    vm.group = undefined;
    vm.animateHeightClass = 'animate-height';

    // Methods
    vm.toggleCollapsed = toggleCollapsed;
    vm.collapse = collapse;
    vm.expand = expand;
    vm.getClass = getClass;
    vm.isHidden = isHidden;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Setup the initial values

      // Has children?
      vm.hasChildren = vm.node.children.length > 0;

      // Is group?
      vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

      // Is collapsable?
      if (!vm.hasChildren || vm.group) {
        vm.collapsable = false;
      } else {
        vm.collapsable = !!(
          angular.isUndefined(vm.node.collapsable) ||
          typeof vm.node.collapsable !== 'boolean' ||
          vm.node.collapsable === true
        );
      }

      // Is collapsed?
      if (!vm.collapsable) {
        vm.collapsed = false;
      } else {
        vm.collapsed = !!(
          angular.isUndefined(vm.node.collapsed) ||
          typeof vm.node.collapsed !== 'boolean' ||
          vm.node.collapsed === true
        );
      }

      // Expand all parents if we have a matching state or
      // the current state is a child of the node's state
      if (
        vm.node.state === $state.current.name ||
        $state.includes(vm.node.state)
      ) {
        // If state params are defined, make sure they are
        // equal, otherwise do not set the active item
        if (
          angular.isDefined(vm.node.stateParams) &&
          angular.isDefined($state.params) &&
          !angular.equals(vm.node.stateParams, $state.params)
        ) {
          return;
        }

        $scope.$emit('msNavigation::stateMatched');

        // Also store the current active menu item
        msNavigationService.setActiveItem(vm.node, $scope);
      }

      $scope.$on('msNavigation::stateMatched', function () {
        // Expand if the current scope is collapsable and is collapsed
        if (vm.collapsable && vm.collapsed) {
          $scope.$evalAsync(function () {
            vm.collapsed = false;
          });
        }
      });

      // Listen for collapse event
      $scope.$on('msNavigation::collapse', function (event, path) {
        if (vm.collapsed || !vm.collapsable) {
          return;
        }

        // If there is no path defined, collapse
        if (angular.isUndefined(path)) {
          vm.collapse();
        }
        // If there is a path defined, do not collapse
        // the items that are inside that path. This will
        // prevent parent items from collapsing
        else {
          var givenPathParts = path.split('.'),
            activePathParts = [];

          var activeItem = msNavigationService.getActiveItem();
          if (activeItem) {
            activePathParts = activeItem.node._path.split('.');
          }

          // Test for given path
          if (givenPathParts.indexOf(vm.node._id) > -1) {
            return;
          }

          // Test for active path
          if (activePathParts.indexOf(vm.node._id) > -1) {
            return;
          }

          vm.collapse();
        }
      });

      // Listen for $stateChangeSuccess event
      $scope.$on('$stateChangeSuccess', function () {
        if (vm.node.state === $state.current.name) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (
            angular.isDefined(vm.node.stateParams) &&
            angular.isDefined($state.params) &&
            !angular.equals(vm.node.stateParams, $state.params)
          ) {
            return;
          }

          // Update active item on state change
          msNavigationService.setActiveItem(vm.node, $scope);

          // Collapse everything except the one we're using
          $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
        }

        // Expand the parents if we the current
        // state is a child of the node's state
        if ($state.includes(vm.node.state)) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (
            angular.isDefined(vm.node.stateParams) &&
            angular.isDefined($state.params) &&
            !angular.equals(vm.node.stateParams, $state.params)
          ) {
            return;
          }

          // Emit the stateMatched
          $scope.$emit('msNavigation::stateMatched');
        }
      });
    }

    /**
     * Toggle collapsed
     */
    function toggleCollapsed() {
      if (vm.collapsed) {
        vm.expand();
      } else {
        vm.collapse();
      }
    }

    /**
     * Collapse
     */
    function collapse() {
      // Grab the element that we are going to collapse
      var collapseEl = vm.element.children('ul');

      // Grab the height
      var height = collapseEl[0].offsetHeight;

      $scope.$evalAsync(function () {
        // Set collapsed status
        vm.collapsed = true;

        // Add collapsing class to the node
        vm.element.addClass('collapsing');

        // Animate the height
        $animate
          .animate(
            collapseEl,
            {
              display: 'block',
              height: height + 'px'
            },
            {
              height: '0px'
            },
            vm.animateHeightClass
          )
          .then(function () {
            // Clear the inline styles after animation done
            collapseEl.css({
              display: '',
              height: ''
            });

            // Clear collapsing class from the node
            vm.element.removeClass('collapsing');
          });

        // Broadcast the collapse event so child items can also be collapsed
        $scope.$broadcast('msNavigation::collapse');
      });
    }

    /**
     * Expand
     */
    function expand() {
      // Grab the element that we are going to expand
      var expandEl = vm.element.children('ul');

      // Move the element out of the dom flow and
      // make it block so we can get its height
      expandEl.css({
        position: 'absolute',
        visibility: 'hidden',
        display: 'block',
        height: 'auto'
      });

      // Grab the height
      var height = expandEl[0].offsetHeight;

      // Reset the style modifications
      expandEl.css({
        position: '',
        visibility: '',
        display: '',
        height: ''
      });

      $scope.$evalAsync(function () {
        // Set collapsed status
        vm.collapsed = false;

        // Add expanding class to the node
        vm.element.addClass('expanding');

        // Animate the height
        $animate
          .animate(
            expandEl,
            {
              // [2022-10-14 @ Dino] Found solution to menu not showing due to this position need to be relative and visibility need to be visible
              //                     These two lines below are added
              position: 'relative',
              visibility: 'visible',
              display: 'block',
              height: '0px'
            },
            {
              height: height + 'px'
            },
            vm.animateHeightClass
          )
          .then(function () {
            // Clear the inline styles after animation done
            expandEl.css({
              height: ''
            });

            // Clear expanding class from the node
            vm.element.removeClass('expanding');
          });

        // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
        // can be collapsed. This is necessary for keeping only one parent expanded at any time
        $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
      });
    }

    /**
     * Return the class
     *
     * @returns {*}
     */
    function getClass() {
      return vm.node.class;
    }

    /**
     * Check if node should be hidden
     *
     * @returns {boolean}
     */
    function isHidden() {
      if (
        angular.isDefined(vm.node.hidden) &&
        angular.isFunction(vm.node.hidden)
      ) {
        return vm.node.hidden();
      }

      return false;
    }
  }

  /** @ngInject */
  function msNavigationNodeDirective() {
    return {
      restrict: 'A',
      bindToController: {
        node: '=msNavigationNode'
      },
      controller: 'MsNavigationNodeController as vm',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-node');

        return function postLink(
          scope,
          iElement,
          iAttrs,
          MsNavigationNodeCtrl
        ) {
          // Add custom classes
          iElement.addClass(MsNavigationNodeCtrl.getClass());

          // Add group class if it's a group
          if (MsNavigationNodeCtrl.group) {
            iElement.addClass('group');
          }
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationItemDirective() {
    return {
      restrict: 'A',
      require: '^msNavigationNode',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-item');

        return function postLink(
          scope,
          iElement,
          iAttrs,
          MsNavigationNodeCtrl
        ) {
          // If the item is collapsable...
          if (MsNavigationNodeCtrl.collapsable) {
            iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
          }

          // Cleanup
          scope.$on('$destroy', function () {
            iElement.off('click');
          });
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationHorizontalDirective(msNavigationService) {
    return {
      restrict: 'E',
      scope: {
        root: '@'
      },
      controller: 'MsNavigationController as vm',
      templateUrl:
        'app/core/directives/ms-navigation/templates/horizontal.html',
      transclude: true,
      compile: function (tElement) {
        tElement.addClass('ms-navigation-horizontal');

        return function postLink(scope) {
          // Store the navigation in the service for public access
          msNavigationService.setNavigationScope(scope);
        };
      }
    };
  }

  /** @ngInject */
  function MsNavigationHorizontalNodeController(
    $scope,
    $element,
    $rootScope,
    $state,
    msNavigationService
  ) {
    var vm = this;

    // Data
    vm.element = $element;
    vm.node = $scope.node;
    vm.hasChildren = undefined;
    vm.group = undefined;

    // Methods
    vm.getClass = getClass;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Setup the initial values

      // Is active
      vm.isActive = false;

      // Has children?
      vm.hasChildren = vm.node.children.length > 0;

      // Is group?
      vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

      // Mark all parents as active if we have a matching state
      // or the current state is a child of the node's state
      if (
        vm.node.state === $state.current.name ||
        $state.includes(vm.node.state)
      ) {
        // If state params are defined, make sure they are
        // equal, otherwise do not set the active item
        if (
          angular.isDefined(vm.node.stateParams) &&
          angular.isDefined($state.params) &&
          !angular.equals(vm.node.stateParams, $state.params)
        ) {
          return;
        }

        $scope.$emit('msNavigation::stateMatched');

        // Also store the current active menu item
        msNavigationService.setActiveItem(vm.node, $scope);
      }

      $scope.$on('msNavigation::stateMatched', function () {
        // Mark as active if has children
        if (vm.hasChildren) {
          $scope.$evalAsync(function () {
            vm.isActive = true;
          });
        }
      });

      // Listen for clearActive event
      $scope.$on('msNavigation::clearActive', function () {
        if (!vm.hasChildren) {
          return;
        }

        var activePathParts = [];

        var activeItem = msNavigationService.getActiveItem();
        if (activeItem) {
          activePathParts = activeItem.node._path.split('.');
        }

        // Test for active path
        if (activePathParts.indexOf(vm.node._id) > -1) {
          $scope.$evalAsync(function () {
            vm.isActive = true;
          });
        } else {
          $scope.$evalAsync(function () {
            vm.isActive = false;
          });
        }
      });

      // Listen for $stateChangeSuccess event
      $scope.$on('$stateChangeSuccess', function () {
        if (
          vm.node.state === $state.current.name ||
          $state.includes(vm.node.state)
        ) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (
            angular.isDefined(vm.node.stateParams) &&
            angular.isDefined($state.params) &&
            !angular.equals(vm.node.stateParams, $state.params)
          ) {
            return;
          }

          // Update active item on state change
          msNavigationService.setActiveItem(vm.node, $scope);

          // Clear all active states except the one we're using
          $rootScope.$broadcast('msNavigation::clearActive');
        }
      });
    }

    /**
     * Return the class
     *
     * @returns {*}
     */
    function getClass() {
      return vm.node.class;
    }
  }

  /** @ngInject */
  function msNavigationHorizontalNodeDirective() {
    return {
      restrict: 'A',
      bindToController: {
        node: '=msNavigationHorizontalNode'
      },
      controller: 'MsNavigationHorizontalNodeController as vm',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-horizontal-node');

        return function postLink(
          scope,
          iElement,
          iAttrs,
          MsNavigationHorizontalNodeCtrl
        ) {
          // Add custom classes
          iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

          // Add group class if it's a group
          if (MsNavigationHorizontalNodeCtrl.group) {
            iElement.addClass('group');
          }
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationHorizontalItemDirective($mdMedia) {
    return {
      restrict: 'A',
      require: '^msNavigationHorizontalNode',
      compile: function (tElement) {
        tElement.addClass('ms-navigation-horizontal-item');

        return function postLink(
          scope,
          iElement,
          iAttrs,
          MsNavigationHorizontalNodeCtrl
        ) {
          iElement.on('click', onClick);

          function onClick() {
            if (
              !MsNavigationHorizontalNodeCtrl.hasChildren ||
              $mdMedia('gt-md')
            ) {
              return;
            }

            iElement.toggleClass('expanded');
          }

          // Cleanup
          scope.$on('$destroy', function () {
            iElement.off('click');
          });
        };
      }
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
  'use strict';

  angular.module('app.user').controller('UserController', UserController);

  /** @ngInject */
  function UserController(
    $scope,
    $mdMedia,
    $mdDialog,
    $rootScope,
    DTOptionsBuilder,
    DTColumnBuilder,
    $document,
    $timeout,
    $http,
    $q,
    sharedService,
    $compile,
    User,
    $state,
    $cookies,
    accountService
  ) {
    var vm = this;

    // Local data
    var canceller = $q.defer();
    var sortBy = {
      colIndex: 0,
      col: null,
      dir: 'asc'
    };
    var sortEl;

    // Data
    vm.sharedService = sharedService;

    vm.users = []; // Initialize empty in case something happens

    vm.dt = dt;

    vm.lengthMenu = [10, 25, 50, 100];
    vm.dtOptions = DTOptionsBuilder.newOptions()
      .withDOM('t')
      .withOption('autoWidth', false)
      .withOption('responsive', true)
      .withScroller()
      .withOption('scrollY', 'auto')
      .withOption('createdRow', sharedService.dtCreatedRow($scope))
      .withOption('drawCallback', function () {
        $timeout(function () {
          vm.loading = false;
          $rootScope.loadingProgress = false;
        });
      });
    vm.dtColumns = [
      DTColumnBuilder.newColumn(null)
        .withTitle('No')
        .renderWith(function (data, type, rows, meta) {
          return meta.row + 1;
        }),
      DTColumnBuilder.newColumn('profile_name').withTitle('Profile Name'),
      DTColumnBuilder.newColumn('roles')
        .withTitle('Role(s)')
        .renderWith(function (data, type, rows, meta) {
          return vm.users[meta.row].getFlatRoleNames() || 'N/A';
        }),
      DTColumnBuilder.newColumn(null)
        .withTitle('Actions')
        .renderWith(function (data, type, rows, meta) {
          var template =
            '<md-button class="md-icon-button" ng-click="vm.edit(' +
            meta.row +
            ')">' +
            '<md-icon md-font-icon="icon-pencil" class="s18 green-500-fg"></md-icon>' +
            '<md-tooltip>Edit</md-tooltip>' +
            '</md-button>' +
            '<md-button class="md-icon-button" ng-click="vm.toggleSuspend(' +
            meta.row +
            ')">' +
            '<md-icon md-font-icon="icon-lock-outline" class="s18 purple-500-fg" ng-class="{ \'icon-lock-unlocked-outline\': vm.users[' +
            meta.row +
            "].is_suspended, 'icon-lock-outline': !vm.users[" +
            meta.row +
            '].is_suspended }"></md-icon>' +
            '<md-tooltip ng-bind="vm.users[' +
            meta.row +
            "].is_suspended ? 'Unsuspend' : 'Suspend'\"></md-tooltip>" +
            '</md-button>';

          var impersonateTemplate =
            '<md-button class="md-icon-button" ng-click="vm.impersonate(' +
            meta.row +
            ')">' +
            '<md-icon md-font-icon="icon-key" class="s18 brown-500-fg"></md-icon>' +
            '<md-tooltip>Impersonate</md-tooltip>' +
            '</md-button>';

          if (
            accountService.user.hasRole('Root') ||
            accountService.user.hasRole('Admin')
          ) {
            var dataIsAdmin = false;
            for (var i = 0; i < rows.roles.length; ++i) {
              if (rows.roles[i].name === 'Admin') {
                dataIsAdmin = true;
                break;
              }
            }

            if (dataIsAdmin) {
              return template;
            }

            if (rows.roles.length === 0) {
              return template;
            }

            return template + impersonateTemplate;
          }

          return template;
        })
    ];

    vm.mediaXsAddButton = $mdMedia('gt-xs') ? '' : 'md-mini';
    vm.isMediaGtSm = $mdMedia('gt-sm');

    vm.offset = 0;
    vm.offsetFrom = 0;
    vm.recordsPerPage = 25;
    vm.pageRecords = 0;
    vm.recordsTotal = 0;

    sharedService.pageIcon = 'icon-account';
    sharedService.pageName = 'Users';

    // Methods
    $scope.$on('$destroy', destroy);
    vm.pagingChanged = pagingChanged;
    vm.search = load;
    vm.swipeLeft = swipeLeft;
    vm.swipeRight = swipeRight;
    vm.prev = prev;
    vm.next = next;
    vm.edit = edit;

    vm.toggleSuspend = toggleSuspend;
    vm.impersonate = impersonate;

    //////////

    function dt(i) {
      vm.dt = i;

      vm.dt.DataTable.page.len(vm.recordsPerPage).draw();
      vm.dt.DataTable.on(
        'responsive-display',
        sharedService.dtResponsiveDisplay($scope)
      );
      load();
    }

    function load() {
      if (vm.loading) return;

      vm.loading = true;
      $rootScope.loadingProgress = true;

      vm.dt.DataTable.off('order');

      $http
        .get($rootScope.routePath + '/user/get-by-page', {
          params: {
            offset: vm.offset,
            limit: vm.recordsPerPage,
            col: sortBy.col,
            dir: sortBy.dir,
            q: vm.searchTerm
          }
        })
        .then(function (res) {
          res = res.data;

          vm.users.length = 0;
          vm.dt.DataTable.clear();

          var thead = angular.element(vm.dt.DataTable.header());
          thead.find('.sorting_asc, .sorting_desc').attr('class', 'sorting');
          thead
            .children()
            .children()
            .eq(sortBy.colIndex)
            .attr('class', 'sorting_' + sortBy.dir);

          vm.recordsTotal = res.recordsTotal;

          if (res.success) {
            vm.offsetFrom = Math.min(vm.offset + 1, vm.recordsTotal);
            vm.pageRecords = Math.min(
              vm.offset + vm.recordsPerPage,
              vm.recordsTotal
            );

            res.data.forEach(function (user) {
              vm.users.push(new User(user));
            });

            vm.dt.DataTable.rows
              .add(vm.users)
              .order([sortBy.colIndex, sortBy.dir])
              .draw();
            vm.dt.DataTable.columns.adjust().draw();
          } else {
            vm.offsetFrom = 0;
            vm.pageRecords = 0;

            vm.dt.DataTable.draw();
            sharedService.showToast(res.message);
          }
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        })
        .finally(function () {
          vm.loading = false;
          $rootScope.loadingProgress = false;

          vm.dt.DataTable.on('order', order);
        });
    }

    function destroy() {
      canceller.resolve();
      vm.dt.DataTable.off('responsive-display');
      vm.dt.DataTable.off('order');
    }

    function order(jsEvent, settings) {
      sortBy.colIndex = settings.aaSorting[0][0];

      var column = settings.aoColumns[sortBy.colIndex].mData;
      var direction = settings.aaSorting[0][1];

      sortBy.col = column || '';
      sortBy.dir = direction;
      load();
    }

    function pagingChanged() {
      vm.dt.DataTable.page.len(vm.recordsPerPage);
      load();
    }

    //////////

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function swipeLeft() {
      if (vm.isMediaGtSm) return;
      prev();
    }

    function swipeRight() {
      if (vm.isMediaGtSm) return;
      next();
    }

    //////////

    function prev() {
      if (vm.offset === 0) return;
      vm.offset -= vm.recordsPerPage;
      load();
    }

    function next() {
      if (vm.offset + vm.recordsPerPage >= vm.recordsTotal) return;
      vm.offset += vm.recordsPerPage;
      load();
    }

    function edit(index) {
      var user = vm.users[index];
      $state.go('app.user.edit', {
        id: user ? user.id : null
      });
    }

    function toggleSuspend(index) {
      var user = vm.users[index];
      user.is_suspended = !user.is_suspended;
      $http
        .post($rootScope.routePath + '/user/update-user', {
          id: user.id,
          is_suspended: user.is_suspended
        })
        .then(function (res) {
          res = res.data;
          sharedService.showToast(res.message);
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function impersonate(index) {
      var user = vm.users[index];
      $http
        .post($rootScope.routePath + '/user/impersonate', {
          asId: user.id
        })
        .then(function (res) {
          return res.data;
        })
        .then(function (res) {
          sharedService.showToast(res.message);

          if (res.success) {
            var expires = moment().add(7, 'days').toDate();

            $cookies.putObject('user_bak', $cookies.getObject('user'), {
              expires: expires
            });

            $cookies.putObject('user', res.data.impersonatedUser, {
              expires: expires
            });

            window.location.href = '/#/login';
          }
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else
            sharedService.showToast('Unable to impersonate. Please try again.');
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.todo')
    .controller('Todo2Controller', Todo2Controller);

  /** @ngInject */
  function Todo2Controller($scope, $mdMedia, $mdDialog, $rootScope, $document, $timeout, accountService, $http, $q, sharedService, $compile, Todo, Role, $state, $stateParams, $window, DtRendererService) {
    var vm = this;

    // Hooks
    $scope.$on('$destroy', _destroy);

    // Local data
    var todos = [];
    var canceller = $q.defer();
    var isMediaGtSm = $mdMedia('gt-sm');

    var isAdvancedSearch = false;

    // Exposed data
    vm.loading = false;
    vm.sharedService = sharedService;
    vm.mediaXsAddButton = $mdMedia('gt-xs') ? '' : 'md-mini';

    vm.todoTable;

    vm.typeAndBoxes = [{
      type: 'BILLING',
      box: 'INBOX',
    }, {
      type: 'BILLING',
      box: 'OUTBOX',
    }, {
      type: 'OTHERS',
      box: 'INBOX',
    }, {
      type: 'OTHERS',
      box: 'OUTBOX',
    }, ];
    // Default to others inbox
    vm.selectedTypeAndBox = vm.typeAndBoxes[$stateParams.selectedTypeAndBoxDefault];

    vm.readStatuses = [
      { text: 'UNREAD', tooltip: 'Filter by UNREAD', value: 'UNREAD', selected: false, class: 's24 grey-600-fg md-default-theme md-font material-icons icon-minus' },
      { text: 'READ', tooltip: 'Filter by READ', value: 'READ', selected: false, class: 's24 blue-600-fg md-default-theme md-font material-icons icon-check-all' },
      { text: 'ALL', tooltip: 'NO filter', value: undefined, selected: false, class: 's24 purple-600-fg md-default-theme md-font material-icons icon-checkbox-multiple-blank-outline' },
    ];
    // Default to UNREAD
    vm.selectedReadStatus = vm.readStatuses[$stateParams.selectedReadStatusDefault];
    vm.selectedReadStatus.selected = true;

    // Exposed methods
    vm.selectReadStatus = _selectReadStatus;
    vm.showDialog = _showDialog;
    vm.showThread = _showThread;
    vm.markAsRead = _markAsRead;

    vm.search = _search;
    vm.advancedSearch = _advancedSearch;
    vm.resetAdvancedSearch = _resetAdvancedSearch;

    vm.edit = _edit;
    vm.exportExcel = _exportExcel;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-checkbox-marked';
      sharedService.pageName = 'To Do';

      // Copy search term for display only
      vm.searchTerm = $stateParams.searchTerm;
      vm.showAdvancedSearch = $stateParams.showAdvancedSearch;
      isAdvancedSearch = $stateParams.isAdvancedSearch;
      vm.fromDatetime = $stateParams.fromDatetime;
      vm.toDatetime = $stateParams.toDatetime;

      _initDatatable();
    }

    function _initDatatable() {
      vm.todoTable = $('#todo-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: $stateParams.pageLength,
        displayStart: $stateParams.page * $stateParams.pageLength,
        search: {
          search: $stateParams.searchTerm, // Initial search term actually here
        },
        order: [
          [3, 'desc',],
        ],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;

          if (isAdvancedSearch) {
            if (vm.fromDatetime) {
              data.fromDatetime = vm.fromDatetime.startOf('day').toISOString();
            }
            if (vm.toDatetime) {
              data.toDatetime = vm.toDatetime.endOf('day').toISOString();
            }
          }

          data.readStatus = vm.selectedReadStatus.value;

          // Do necessary remapping for query
          data.columns[0].data = 'todo.id';
          data.columns[5].data = 'username';
          data.columns[6].data = 'name';

          $http.post($rootScope.routePath + '/todo/getByPage', data, {
            timeout: canceller.promise
          })
            .then(function (res) {
              res = res.data;

              if (res.success) {
                todos = res.data;
                vm.badgesCount = res.badgesCount;
                // For now we hide for READ and ALL
                vm.badgesCount.READ = 0;
                vm.badgesCount.ALL = 0;
                callback({
                  recordsTotal: res.recordsTotal,
                  recordsFiltered: res.recordsTotal,
                  data: res.data,
                });
              } else {
                sharedService.showToast(res.message);
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: [],
                });
              }
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope),
          },
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: DtRendererService.rowRenderer($scope),
        scrollY: 'auto',
        columns: [{
          data: null,
          title: 'No',
          width: '40px',
          render: function (data, type, row, meta) {
            return meta.row + 1;
          },
        },
        {
          data: 'type',
          title: 'Type',
        },
        {
          data: 'remarks',
          title: 'Remarks',
        },
        {
          data: 'created_datetime',
          title: 'Created Datetime',
          render: function (data, type, row, meta) {
            return data ? moment.utc(data).local().format('DD/MM/YYYY hh:mm a') : 'N/A';
          },
        },
        {
          data: 'status',
          title: 'Status/Doctor',
          render: function (data, type, row, meta) {
            var drUsername = row.doctorName;
            // for (var i = 0; i < row.recipients.length; ++i) {
            //   if (row.recipients[i].role === 'Doctor') {
            //     drUsername = row.recipients[i].username;
            //     break;
            //   }
            // }
            if (drUsername) {
              return data + '<br>' + drUsername;
            }
            return data;
          },
        },
        {
          data: null,
          title: 'Created By',
          render: function (data, type, row, meta) {
            var t = todos[meta.row];
            if (t.senders.length === 2) {
              if (t.senders[0].role === 'PersonalAssistant') {
                return t.senders[1].username + '<br>(' + t.senders[0].username + ')';
              } else {
                return t.senders[0].username + ' (' + t.senders[1].username + ')';
              }
            } else {
              // Show doctor's full name (if any)
              if (t.senders[0].role === 'Doctor' && t.doctorName !== null) {
                return t.doctorName;
              } else {
                return t.senders[0].username;
              }
            }
          },
        },
        {
          data: null,
          title: 'Created By Role',
          render: function (data, type, row, meta) {
            var t = todos[meta.row];
            if (t.senders.length === 2) {
              if (t.senders[0].role === 'PersonalAssistant') {
                return t.senders[1].role + '<br>(' + t.senders[0].role + ')';
              } else {
                return t.senders[0].role + ' (' + t.senders[1].role + ')';
              }
            } else {
              return t.senders[0].role;
            }
          },
        },
        {
          data: 'subtype',
          title: 'Process',
          render: function (data, type, row, meta) {
            return data ? data : 'N/A';
          },
        },
        {
          data: 'requested_datetime',
          title: 'Datetime',
          render: function (data, type, row, meta) {
            // For now the selected datetime for Memo only concerns date, when needed we change
            if (row.type === 'MEMO') {
              return data ? moment.utc(data).local().format('DD/MM/YYYY') : 'N/A';
            }

            return data ? moment.utc(data).local().format('DD/MM/YYYY hh:mm a') : 'N/A';
          },
        },
        {
          data: null,
          title: 'Actions',
          render: function (data, type, row, meta) {
            var t = todos[meta.row];
            var detailsTemplate =
              '<md-button class="md-icon-button" ng-click="vm.showDialog($event, ' + meta.row + ')">' +
              '<md-icon md-font-icon="icon-more" class="s18 grey-500-fg"></md-icon>' +
              '<md-tooltip md-direction="top">More details</md-tooltip>' +
              '</md-button>';
            var threadTemplate =
              '<md-button class="md-icon-button" ng-click="vm.showThread(' + meta.row + ')">' +
              '<md-icon md-font-icon="icon-view-list" class="s18 ' + (t.status === 'COMPLETED' ? 'red' : 'blue') + '-500-fg"></md-icon>' +
              '<md-tooltip md-direction="top">Show Thread</md-tooltip>' +
              '</md-button>';
            // return t.type === 'MEMO' ? threadTemplate : t.ref_id === 0 ? 'N/A' : detailsTemplate;
            var markAsReadTemplate = 
              '<md-button class="md-icon-button" ng-click="vm.markAsRead(' + meta.row + ')">' +
              '<md-icon md-font-icon="icon-check-all" class="s18 green-500-fg"></md-icon>' +
              '<md-tooltip md-direction="top">Mark As Read</md-tooltip>' +
              '</md-button>';
            return (t.type === 'MEMO' ? threadTemplate : (t.ref_id === 0 ? 'N/A' : detailsTemplate)) + markAsReadTemplate;
          },
        },
        ],
      });
    }

    function _selectReadStatus(status) {
      vm.selectedReadStatus.selected = false;
      status.selected = true;
      vm.selectedReadStatus = status;

      vm.todoTable.ajax.reload(null, false);
    }

    function _showDialog(jsEvent, index) {
      var todo = todos[index];

      switch (todo.type) {
        case 'APPOINTMENT':
          {
            $mdDialog.show({
              controller: 'AppointmentDetailDialogController',
              controllerAs: 'vm',
              templateUrl: 'app/main/appointment/dialogs/appointment-detail/appointment-detail-dialog.html',
              parent: angular.element($document.body),
              targetEvent: jsEvent,
              clickOutsideToClose: true,
              locals: {
                appointmentId: todo.ref_id,
              },
            })
              .then(function (res) {
                if (res && res.reload) {
                  vm.todoTable.ajax.reload(null, false);
                }
              });
            break;
          }
        case 'OT BOOKING':
          {
            $mdDialog.show({
              controller: 'OperationTheaterDetailDialogController',
              controllerAs: 'vm',
              templateUrl: 'app/main/operation-theater/dialogs/operation-theater-detail/operation-theater-detail-dialog.html',
              parent: angular.element($document.body),
              targetEvent: jsEvent,
              clickOutsideToClose: true,
              locals: {
                bookingId: todo.ref_id,
              },
            })
              .then(function (res) {
                if (res && res.reload) {
                  vm.todoTable.ajax.reload(null, false);
                }
              });
            break;
          }
        case 'BILLING':
          {
            $mdDialog.show({
              controller: 'BillDetailDialogController',
              controllerAs: 'vm',
              templateUrl: 'app/main/bill/dialogs/bill-detail/bill-detail-dialog.html',
              parent: angular.element($document.body),
              targetEvent: jsEvent,
              clickOutsideToClose: true,
              locals: {
                billId: todo.ref_id,
              },
            })
              .then(function (res) {
                if (res && res.reload) {
                  vm.todoTable.ajax.reload(null, false);
                }
              });
            break;
          }
      }
    }

    function _showThread(index) {
      var todo = todos[index];

      $state.go('app.todo.thread', {
        id: todo.thread_group_id,
        searchTerm: vm.searchTerm,
        showAdvancedSearch: vm.showAdvancedSearch,
        isAdvancedSearch: isAdvancedSearch,
        fromDatetime: vm.fromDatetime,
        toDatetime: vm.toDatetime,
        page: vm.todoTable.page.info().page,
        pageLength: vm.todoTable.page.info().length,
        selectedReadStatusDefault: vm.readStatuses.indexOf(vm.selectedReadStatus),
        selectedTypeAndBoxDefault: vm.typeAndBoxes.indexOf(vm.selectedTypeAndBox)
      });
    }

    function _markAsRead(index) {
      var todo = todos[index];

      var data = {
        todoId: todo.id,
        userId: accountService.user.id
      };
      
      canceller = $q.defer();
      $http.post($rootScope.routePath + '/todo/markThreadAsRead', data, {
        timeout: canceller.promise
      })
        .then(function (res) {
          res = res.data;

          sharedService.showToast(res.message);

          if (res.success) {
            vm.todoTable.ajax.reload(null, false);
            --vm.badgesCount.UNREAD;
          }
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _search() {
      vm.todoTable.search(vm.searchTerm).draw();
    }

    function _advancedSearch() {
      isAdvancedSearch = true;
      vm.todoTable.ajax.reload(null, false);
    }

    function _resetAdvancedSearch() {
      vm.fromDatetime = null;
      vm.toDatetime = null;
      isAdvancedSearch = false;
      vm.todoTable.ajax.reload(null, false);
    }

    function _edit(index) {
      var todo = todos[index];
      $state.go('app.todo.edit', {
        id: todo ? todo.id : null,
      });
    }

    function _exportExcel() {
      var params = {};

      if (isAdvancedSearch) {
        if (vm.fromDatetime) {
          params.fromDatetime = vm.fromDatetime.startOf('day').toISOString();
        }
        if (vm.toDatetime) {
          params.toDatetime = vm.toDatetime.endOf('day').toISOString();
        }
      }

      $http.get($rootScope.routePath + '/todo/exportExcel', {
        responseType: 'arraybuffer',
        params: params,
      })
        .then(function (res) {
          var header = res.headers('Content-Disposition');
          var fileName = header.split('=')[1].replace(/\"/gi, '');

          var blob = new Blob([res.data], {
            type: res.headers('Content-Type')
          });
          var objectUrl = ($window.URL || $window.webkitURL).createObjectURL(blob);
          var link = angular.element('<a/>');
          link.attr({
            href: objectUrl,
            download: fileName
          })[0].click();
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;
      if (vm.todoTable.page.info().start === 0) return;
      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;
      if (vm.todoTable.page.info().end === vm.todoTable.page.info().recordsTotal) return;
      _next();
    }

    function _prev() {
      vm.todoTable.page('previous');
      vm.todoTable.ajax.reload(null, false);
    }

    function _next() {
      vm.todoTable.page('next');
      vm.todoTable.ajax.reload(null, false);
    }

    function _destroy() {
      canceller.resolve();
    }

    // Initializations
    _init();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.timeslot')
    .controller('TimeslotController', TimeslotController);

  /** @ngInject */
  function TimeslotController($scope, $rootScope, $http, $q, $state, $stateParams, $mdDialog, $mdMedia, sharedService, DtRendererService) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var timeslots = [];
    var canceller = $q.defer();
    var isMediaGtSm = $mdMedia('gt-sm');

    // Exposed data
    vm.loading = false;
    vm.sharedService = sharedService;

    vm.timeslotTable;

    // Exposed methods
    vm.search = _search;

    vm.edit = _edit;
    vm.delete = _delete;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-clock';
      sharedService.pageName = 'Timeslot';

      // Copy search term for display only
      vm.searchTerm = $stateParams.searchTerm;

      _initDatatable();
    }

    function _initDatatable() {
      vm.timeslotTable = $('#timeslot-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: $stateParams.pageLength,
        displayStart: $stateParams.page * $stateParams.pageLength,
        search: {
          search: $stateParams.searchTerm, // Initial search term actually here
        },
        order: [
          [0, 'asc', ],
        ],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;

          $http.post($rootScope.routePath + '/timeslot/getByPage', data, {
              timeout: canceller.promise
            })
            .then(function (res) {
              res = res.data;

              if (res.success) {
                timeslots = res.data.timeslots;
                callback({
                  recordsTotal: res.data.recordsTotal,
                  recordsFiltered: res.data.recordsTotal,
                  data: res.data.timeslots,
                });
              } else {
                sharedService.showToast(res.message);
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: [],
                });
              }
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope),
          },
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: DtRendererService.rowRenderer($scope),
        scrollY: 'auto',
        columns: [{
          data: 'id',
          title: 'No',
          width: '40px',
          render: function (data, type, row, meta) {
            return meta.row + 1;
          }
        }, {
          data: 'name',
          title: 'Name',
        }, {
          data: 'start_time',
          title: 'Start Time (24hr)',
          render: function (data, type, row, meta) {
            return moment.utc(data, 'HH:mm:ss').local().format('HH:mm');
          }
        }, {
          data: 'end_time',
          title: 'End Time (24hr)',
          render: function (data, type, row, meta) {
            return moment.utc(data, 'HH:mm:ss').local().format('HH:mm');
          }
        }, {
          data: null,
          title: 'Actions',
          sortable: false,
          render: function (data, type, row, meta) {
            var template =
              '<md-button class="md-icon-button" ng-click="vm.edit(' + meta.row + ')">' +
              '<md-icon md-font-icon="icon-pencil" class="s18 green-500-fg"></md-icon>' +
              '<md-tooltip>Edit</md-tooltip>' +
              '</md-button>' +
              '<md-button class="md-icon-button" ng-click="vm.delete(' + meta.row + ')">' +
              '<md-icon md-font-icon="icon-trash" class="s18 red-500-fg"></md-icon>' +
              '<md-tooltip>Delete</md-tooltip>' +
              '</md-button>';

            return template;
          }
        }],
      });
    }

    function _search() {
      vm.timeslotTable.search(vm.searchTerm).draw();
    }


    function _edit(index) {
      var timeslot = timeslots[index];
      $state.go('app.timeslot.edit', {
        id: timeslot ? timeslot.id : null,
        searchTerm: vm.searchTerm,
        page: vm.timeslotTable.page.info().page,
        pageLength: vm.timeslotTable.page.info().length
      });
    }

    function _delete(index) {
      var timeslot = timeslots[index];
      var confirm = $mdDialog.confirm()
        .title('Delete Confirmation')
        .textContent('Are you sure you want to delete this timeslot "' + timeslot.name + '"? This action is irreversible!')
        .ok('DELETE')
        .cancel('CANCEL');

      $mdDialog.show(confirm)
        .then(function () {
          return $http.post($rootScope.routePath + '/timeslot/deleteById', {
              timeslotId: timeslot.id
            })
            .then(function (res) {
              res = res.data;

              sharedService.showToast(res.message);

              vm.timeslotTable.ajax.reload(null, false);
            })
            .catch(function (err) {
              if (err.message) {
                sharedService.showToast(err.message);
              } else {
                sharedService.showToast('Request timed out.');
              }
            });
        });
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;
      if (vm.timeslotTable.page.info().start === 0) return;
      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;
      if (vm.timeslotTable.page.info().end === vm.timeslotTable.page.info().recordsTotal) return;
      _next();
    }

    function _prev() {
      vm.timeslotTable.page('previous');
      vm.timeslotTable.ajax.reload(null, false);
    }

    function _next() {
      vm.timeslotTable.page('next');
      vm.timeslotTable.ajax.reload(null, false);
    }

    function _destroy() {
      canceller.resolve();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.surgicalProcedure')
    .controller('SurgicalProcedureController', Controller);

  /** @ngInject */
  function Controller(
    $scope,
    $rootScope,
    $http,
    $q,
    $state,
    $stateParams,
    $mdDialog,
    $mdMedia,
    sharedService,
    DtRendererService
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var dataSource = [];
    var canceller = $q.defer();
    var isMediaGtSm = $mdMedia('gt-sm');

    // Exposed data
    vm.loading = false;
    vm.sharedService = sharedService;

    vm.dataSourceTable;

    // Exposed methods
    vm.search = _search;

    vm.edit = _edit;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-content-cut';
      sharedService.pageName = 'Surgical Procedure';

      // Copy search term for display only
      vm.searchTerm = $stateParams.searchTerm;

      _initDatatable();
    }

    function _initDatatable() {
      vm.dataSourceTable = $('#surgical-procedure-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: $stateParams.pageLength,
        displayStart: $stateParams.page * $stateParams.pageLength,
        search: {
          search: $stateParams.searchTerm // Initial search term actually here
        },
        order: [[0, 'asc']],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;

          $http
            .post($rootScope.routePath + '/eDischarge/getProcedureList', data, {
              timeout: canceller.promise
            })
            .then(function (res) {
              res = res.data;

              if (res.success) {
                dataSource = res.data.result;
                callback({
                  recordsTotal: res.data.resultCount,
                  recordsFiltered: res.data.resultCount,
                  data: res.data.result
                });
              } else {
                sharedService.showToast(res.message);
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: []
                });
              }
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope)
          }
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: DtRendererService.rowRenderer($scope),
        scrollY: 'auto',
        columns: [
          {
            data: 'ac_e_discharge_surgical_procedure.ext_id',
            title: '#',
            sortable: true,
            searchable: false,
            defaultContent: '-',
            width: '40px',
            render: function (data, type, row, meta) {
              return meta.row + 1;
            }
          },
          {
            data: 'ac_e_discharge_surgical_procedure.transaction_code',
            title: 'Code',
            sortable: true,
            searchable: true,
            defaultContent: '-'
          },
          {
            data: 'ac_e_discharge_surgical_procedure.transaction_code_description',
            title: 'Description',
            sortable: true,
            searchable: true,
            defaultContent: '-'
          },
          {
            data: 'procedure_detail.mma_code',
            title: 'MMA Code',
            sortable: true,
            searchable: true,
            defaultContent: '-'
          },
          {
            data: 'ac_e_discharge_surgical_procedure.active_indicator',
            title: 'Is Active',
            sortable: true,
            searchable: false,
            defaultContent: '-',
            render: function (data, type, row, meta) {
              return data
                ? '<md-icon md-font-icon="icon-check" class="s18 green-500-fg"></md-icon>'
                : '<md-icon md-font-icon="icon-close" class="s18 red-500-fg"></md-icon>';
            }
          },
          {
            data: null,
            title: 'Actions',
            sortable: false,
            searchable: false,
            defaultContent: '-',
            render: function (data, type, row, meta) {
              var template =
                '<md-button class="md-icon-button" ng-click="vm.edit(' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-pencil" class="s18 green-500-fg"></md-icon>' +
                '<md-tooltip>Edit</md-tooltip>' +
                '</md-button>';

              return template;
            }
          }
        ]
      });
    }

    function _search() {
      vm.dataSourceTable.search(vm.searchTerm).draw();
    }

    function _edit(index) {
      var item = dataSource[index];
      $state.go('app.surgicalProcedure.edit', {
        id: item
          ? item.ac_e_discharge_surgical_procedure.gntxncode_ext_id
          : null,
        searchTerm: vm.searchTerm,
        page: vm.dataSourceTable.page.info().page,
        pageLength: vm.dataSourceTable.page.info().length
      });
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;
      if (vm.dataSourceTable.page.info().start === 0) return;
      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;
      if (
        vm.dataSourceTable.page.info().end ===
        vm.dataSourceTable.page.info().recordsTotal
      )
        return;
      _next();
    }

    function _prev() {
      vm.dataSourceTable.page('previous');
      vm.dataSourceTable.ajax.reload(null, false);
    }

    function _next() {
      vm.dataSourceTable.page('next');
      vm.dataSourceTable.ajax.reload(null, false);
    }

    function _destroy() {
      canceller.resolve();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.specialty')
    .controller('SpecialtyController', SpecialtyController);

  /** @ngInject */
  function SpecialtyController($scope, $rootScope, $http, $q, $state, $stateParams, $mdDialog, $mdMedia, sharedService, DtRendererService) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var specialties = [];
    var canceller = $q.defer();
    var isMediaGtSm = $mdMedia('gt-sm');

    // Exposed data
    vm.loading = false;
    vm.sharedService = sharedService;

    vm.specialtyTable;

    // Exposed methods
    vm.search = _search;

    vm.edit = _edit;
    vm.delete = _delete;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-tie';
      sharedService.pageName = 'Specialty';

      // Copy search term for display only
      vm.searchTerm = $stateParams.searchTerm;

      _initDatatable();
    }

    function _initDatatable() {
      vm.specialtyTable = $('#specialty-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: $stateParams.pageLength,
        displayStart: $stateParams.page * $stateParams.pageLength,
        search: {
          search: $stateParams.searchTerm, // Initial search term actually here
        },
        order: [
          [0, 'asc', ],
        ],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;

          $http.post($rootScope.routePath + '/specialty/getByPage', data, {
              timeout: canceller.promise
            })
            .then(function (res) {
              res = res.data;

              if (res.success) {
                specialties = res.data.specialties;
                callback({
                  recordsTotal: res.data.recordsTotal,
                  recordsFiltered: res.data.recordsTotal,
                  data: res.data.specialties,
                });
              } else {
                sharedService.showToast(res.message);
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: [],
                });
              }
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope),
          },
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: DtRendererService.rowRenderer($scope),
        scrollY: 'auto',
        columns: [{
          data: 'id',
          title: 'No',
          width: '40px',
          render: function (data, type, row, meta) {
            return meta.row + 1;
          }
        }, {
          data: 'name',
          title: 'Name',
        }, {
          data: 'color',
          title: 'Color',
          render: function (data, type, row, meta) {
            return '<div layout="row" layout-align="start center"><div style="height:20px;width:20px;background-color:' + data + '"></div><span>&nbsp;&nbsp;' + data + '</span></div>';
          }
        }, {
          data: null,
          title: 'Actions',
          sortable: false,
          render: function (data, type, row, meta) {
            var template =
              '<md-button class="md-icon-button" ng-click="vm.edit(' + meta.row + ')">' +
              '<md-icon md-font-icon="icon-pencil" class="s18 green-500-fg"></md-icon>' +
              '<md-tooltip>Edit</md-tooltip>' +
              '</md-button>' +
              '<md-button class="md-icon-button" ng-click="vm.delete(' + meta.row + ')">' +
              '<md-icon md-font-icon="icon-trash" class="s18 red-500-fg"></md-icon>' +
              '<md-tooltip>Delete</md-tooltip>' +
              '</md-button>';

            return template;
          }
        }],
      });
    }

    function _search() {
      vm.specialtyTable.search(vm.searchTerm).draw();
    }


    function _edit(index) {
      var specialty = specialties[index];
      $state.go('app.specialty.edit', {
        id: specialty ? specialty.id : null,
        searchTerm: vm.searchTerm,
        page: vm.specialtyTable.page.info().page,
        pageLength: vm.specialtyTable.page.info().length
      });
    }

    function _delete(index) {
      var specialty = specialties[index];
      var confirm = $mdDialog.confirm()
        .title('Delete Confirmation')
        .textContent('Are you sure you want to delete this specialty "' + specialty.name + '"? This action is irreversible!')
        .ok('DELETE')
        .cancel('CANCEL');

      $mdDialog.show(confirm)
        .then(function () {
          return $http.post($rootScope.routePath + '/specialty/deleteById', {
            specialtyId: specialty.id
            })
            .then(function (res) {
              res = res.data;

              sharedService.showToast(res.message);

              vm.specialtyTable.ajax.reload(null, false);
            })
            .catch(function (err) {
              if (err.message) {
                sharedService.showToast(err.message);
              } else {
                sharedService.showToast('Request timed out.');
              }
            });
        });
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;
      if (vm.specialtyTable.page.info().start === 0) return;
      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;
      if (vm.specialtyTable.page.info().end === vm.specialtyTable.page.info().recordsTotal) return;
      _next();
    }

    function _prev() {
      vm.specialtyTable.page('previous');
      vm.specialtyTable.ajax.reload(null, false);
    }

    function _next() {
      vm.specialtyTable.page('next');
      vm.specialtyTable.ajax.reload(null, false);
    }

    function _destroy() {
      canceller.resolve();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.sms')
    .controller('Sms2Controller', Sms2Controller);

  /** @ngInject */
  function Sms2Controller($scope, $mdMedia, $mdDialog, $rootScope, DTOptionsBuilder, DTColumnBuilder, $document, $timeout, $http, $q, sharedService, $compile, OperationTheater, $state, DtRendererService, $window) {
    var vm = this;

    // Hooks
    $scope.$on('$destroy', _destroy);

    // Local data
    var apptBlasts = [];
    var canceller = $q.defer();
    var isMediaGtSm = $mdMedia('gt-sm');

    var isAdvancedSearch = true;

    // Exposed data
    vm.loading = false;
    vm.sharedService = sharedService;
    vm.mediaXsActionButtons = '';
    vm.showAdvancedSearch = true;

    vm.apptBlastTable;

    vm.daysPrior = 5;
    vm.smsSentSuccessCount = 0;
    vm.smsSentFailedCount = 0;

    // Exposed methods
    vm.send = _send;
    vm.showExportExcelDialog = _showExportExcelDialog;
    vm.exportExcel = _exportExcel;

    vm.search = _search;
    vm.advancedSearch = _advancedSearch;
    vm.resetAdvancedSearch = _resetAdvancedSearch;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-comment';
      sharedService.pageName = 'Daily Appointment Blast List';

      vm.mediaXsAddButton = $mdMedia('gt-xs') ? '' : 'md-mini';

      _initDatatable();
    }

    function _initDatatable() {
      vm.apptBlastTable = $('#appt-blast-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: 25,
        order: [
          [2, 'desc',],
        ],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;
          canceller = $q.defer();

          if (isAdvancedSearch) {
            if (vm.daysPrior !== 'Infinity') {
              data.fromDate = moment().add(+vm.daysPrior, 'days').startOf('day').toISOString();
              data.toDate = moment().add(+vm.daysPrior, 'days').endOf('day').toISOString();
            }
          }

          // Do necessary remapping for query
          data.columns[0].data = 'appt_blast.id';

          $http.post($rootScope.routePath + '/sms/getByPage2', data, {
            timeout: canceller.promise,
          })
            .then(function (res) {
              res = res.data;

              if (res.success) {
                apptBlasts = res.data.apptBlasts;

                callback({
                  recordsTotal: res.data.recordsTotal,
                  recordsFiltered: res.data.recordsTotal,
                  data: res.data.apptBlasts,
                });
              } else {
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: [],
                });
                sharedService.showToast(res.message);
              }
            })
            .catch(function (err) {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: [],
              });
              sharedService.showToast('Request timed out.');
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope),
          },
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: DtRendererService.rowRenderer($scope),
        scrollY: 'auto',
        columns: [
          {
            data: null,
            title: 'No',
            width: '40px',
            render: function (data, type, row, meta) {
              var info = vm.apptBlastTable.page.info();
              return (info.page * info.length) + (meta.row + 1);
            },
          },
          {
            data: 'dr_name',
            title: 'Doctor',
          },
          {
            data: 'appt_datetime',
            title: 'Appt Datetime',
            render: function (data, type, row, meta) {
              var datetime = moment(data);
              return datetime.format('DD/MM/YY') + '<br>' + datetime.format('hh:mm a');
            },
          },
          {
            data: 'requestor_name',
            title: 'Requestor',
          },
          {
            data: 'requestor_contactno',
            title: 'Requestor Contact',
          },
          {
            data: 'status',
            title: 'SMS Sent Status',
          },
        ],
      });
    }

    function _send() {
      canceller = $q.defer();

      var data = vm.apptBlastTable.ajax.params();

      if (isAdvancedSearch) {
        if (vm.daysPrior !== 'Infinity') {
          data.fromDate = moment().add(+vm.daysPrior, 'days').startOf('day').toISOString();
          data.toDate = moment().add(+vm.daysPrior, 'days').endOf('day').toISOString();
        }
      }

      $http.post($rootScope.routePath + '/sms/getApptBlastListConfirmation', data, {
        timeout: canceller.promise,
      })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            canceller = $q.defer();

            var confirm = $mdDialog.confirm()
              .title('Send out SMS?')
              .ok('OK, send it out!')
              .cancel('Cancel');

            if (res.data.recordsTotal === 1) {
              confirm.textContent('SMS will be sent out to 1 person who has not received the SMS.');
            } else {
              confirm.textContent('SMS will be sent out to ' + res.data.recordsTotal + ' people who have not received the SMS.');
            }

            $mdDialog.show(confirm)
              .then(function () {
                $http.post($rootScope.routePath + '/sms/sendSms2', data, {
                  timeout: canceller.promise,
                })
                  .then(function (res2) {
                    res2 = res2.data;

                    if (res2.success) {
                      vm.smsSentSuccessCount = res2.data.successCount;
                      vm.smsSentFailedCount = res2.data.failedCount;
                      vm.apptBlastTable.ajax.reload(null, false);
                    }
                    sharedService.showToast(res2.message);
                  })
                  .catch(function (err) {
                    sharedService.showToast('Request timed out.');
                  });
              }, angular.noop);
          } else {

          }
        })
        .catch(function (err) {
          sharedService.showToast('Request timed out.');
        });
    }

    function _showExportExcelDialog() {
      $mdDialog.show({
        controller: 'SmsExportExcelDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/sms/dialogs/sms-export-excel/sms-export-excel-dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        locals: {
          fromDate: moment().add(5, 'days'),
          toDate: moment().add(5, 'days'),
        },
      })
        .then(function (res) {
          if (res && res.export) {
            _exportExcel(res.fromDate, res.toDate);
          }
        });
    }

    function _exportExcel(fromDate, toDate) {
      $rootScope.loadingProgress = true;
      canceller = $q.defer();

      var params = {};
      if (fromDate) {
        params.fromDate = fromDate.startOf('day').toISOString();
      }
      if (toDate) {
        params.toDate = toDate.endOf('day').toISOString();
      }

      $http.get($rootScope.routePath + '/sms/getApptBlastList', {
        responseType: 'arraybuffer',
        params: params,
        timeout: canceller.promise,
      })
        .then(function (res) {
          var header = res.headers('Content-Disposition');
          var fileName = header.split('=')[1].replace(/\"/gi, '');

          var blob = new Blob([res.data], {
            type: res.headers('Content-Type'),
          });
          var objectUrl = ($window.URL || $window.webkitURL).createObjectURL(blob);
          var link = angular.element('<a/>');
          link.attr({
            href: objectUrl,
            download: fileName,
          })[0].click();
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function _search() {
      vm.apptBlastTable.search(vm.searchTerm).draw();
    }

    function _advancedSearch() {
      isAdvancedSearch = true;
      vm.apptBlastTable.ajax.reload(null, false);
    }

    function _resetAdvancedSearch() {
      vm.daysPrior = 5;
      vm.searchTerm = '';
      isAdvancedSearch = true;
      vm.apptBlastTable.ajax.reload(null, false);
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;
      if (vm.apptBlastTable.page.info().start === 0) return;
      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;
      if (vm.apptBlastTable.page.info().end === vm.apptBlastTable.page.info().recordsTotal) return;
      _next();
    }

    function _prev() {
      vm.apptBlastTable.page('previous');
      vm.apptBlastTable.ajax.reload(null, false);
    }

    function _next() {
      vm.apptBlastTable.page('next');
      vm.apptBlastTable.ajax.reload(null, false);
    }

    function _destroy() {
      canceller.resolve();
    }

    // Initializations
    _init();
  }
})();
(function () {
  'use strict';

  angular
    .module('app.statistics', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      .state('app.statistics', {
        url: '/statistics',
        views: {
          'content@app': {
            templateUrl: 'app/main/statistics/statistics.html',
            controller: 'StatisticsController as vm'
          }
        },
        bodyClass: 'statistics',
        moduleName: 'Statistics'
      });
  }
})();
(function () {
  'use strict';

  angular
    .module('app.statistics')
    .controller('StatisticsController', StatisticsController)
    .filter('startFrom', startFromFilter);

  /** @ngInject */
  function StatisticsController(sharedService, $http, $rootScope, $filter) {
    var vm = this;

    // Data
    vm.sharedService = sharedService;
    vm.sharedService.pageIcon = 'icon-poll';
    vm.sharedService.pageName = 'Statistics';

    vm.accessList = [];
    vm.pageOffset = 0;
    vm.pageSize = 25;
    vm.itemIndex = 1;
    vm.filteredLength = 0;
    vm.searchTerm = '';

    // Methods
    vm.accessList = accessList;
    vm.prevPage = prevPage;
    vm.nextPage = nextPage;
    vm.pageSizeChanged = pageSizeChanged;
    vm.accessListFilter = accessListFilter;
    vm.searchTermChanged = searchTermChanged;

    //////////

    init();

    function init() {
      getAccessStatistics();
    }

    function getAccessStatistics() {
      $http.get($rootScope.routePath + '/statistics/get-all-access-statistics')
        .then(function (res) {
          res = res.data;

          if (res.success) {
            vm.stats = res.data;

            vm.stats.dailyLogins = Object.keys(vm.stats.dailyLogins).map(function (prop) {
              return vm.stats.dailyLogins[prop];
            });

            vm.stats.dailyDoctorLogins = Object.keys(vm.stats.dailyDoctorLogins).map(function (prop) {
              return vm.stats.dailyDoctorLogins[prop];
            });

            vm.stats.accessList = Object.keys(vm.stats.accessList).map(function (prop) {
              return vm.stats.accessList[prop];
            });

            vm.itemToIndex = Math.min(vm.itemIndex + +vm.pageSize - 1, vm.stats.accessList.length);
            vm.filteredLength = vm.stats.accessList.length;

            drawLoginGraph();
          }
        })
        .catch(function (err) { });
    }

    function drawLoginGraph() {
      nv.addGraph(function () {
        var chart = nv.models.lineChart()
          .useInteractiveGuideline(true);

        chart.xAxis
          .axisLabel('Date')
          .tickFormat(function (d) {
            return d3.time.format('%b %d')(new Date(d));
          });

        chart.yAxis
          .axisLabel('Number of Logins')
          .tickFormat(d3.format('.02f'));

        d3.select('#statistics .login-graph')
          .datum(function () {
            var chartData = [];

            for (var i = 0; i < vm.stats.dailyLogins.length; ++i) {
              var c = vm.stats.dailyLogins[i];
              c.x = moment(c.x);
            }

            for (var i = 0; i < vm.stats.dailyDoctorLogins.length; ++i) {
              var c = vm.stats.dailyDoctorLogins[i];
              c.x = moment(c.x);
            }

            if (vm.stats.dailyLogins.length) {
              chartData.push({ values: vm.stats.dailyLogins, key: 'Total Logins', color: '#ff7f0e' });
            }
            
            if (vm.stats.dailyDoctorLogins.length) {
              chartData.push({ values: vm.stats.dailyDoctorLogins, key: 'Doctor Logins', color: '#2ca02c' });
            }

            return chartData;
          })
          .transition().duration(500)
          .call(chart);

        nv.utils.windowResize(chart.update);

        return chart;
      });
    }

    function accessList() {
      if (!vm.stats) return [];
      return $filter('filter')(vm.stats.accessList, vm.searchTerm);
    }

    function prevPage() {
      --vm.pageOffset;
      vm.itemIndex = vm.pageOffset * +vm.pageSize + 1;
      vm.itemToIndex = Math.min(vm.itemIndex + +vm.pageSize - 1, vm.stats.accessList.length);
    }

    function nextPage() {
      ++vm.pageOffset;
      vm.itemIndex = vm.pageOffset * +vm.pageSize + 1;
      vm.itemToIndex = Math.min(vm.itemIndex + +vm.pageSize - 1, vm.stats.accessList.length);
    }

    function pageSizeChanged() {
      vm.pageOffset = 0;
      vm.itemIndex = vm.pageOffset * +vm.pageSize + 1;
      vm.itemToIndex = Math.min(vm.itemIndex + +vm.pageSize - 1, vm.stats.accessList.length);
    }

    function searchTermChanged() {
      var f = $filter('filter')(vm.stats.accessList, vm.searchTerm);

      vm.pageOffset = 0;
      vm.itemIndex = vm.pageOffset * +vm.pageSize + 1;
      vm.itemToIndex = Math.min(vm.itemIndex + +vm.pageSize - 1, f.length);
      vm.filteredLength = f.length;
    }

    function accessListFilter(item) {
      return item.username === vm.searchTerm;
    }
  }

  function startFromFilter() {
    return function (input, start) {
      if (!input) return;
      return input.slice(+start);
    }
  }
})();
(function () {
  'use strict';

  angular
    .module('app.smsResponse', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      // Main
      .state('app.smsResponse', {
        url: '/smsResponse',
        views: {
          'content@app': {
            templateUrl: 'app/main/sms-response/sms-response.html',
            controller: 'SmsResponseController as vm',
          },
        },
        bodyClass: 'sms-response',
        moduleName: 'SMS Response',
      });
  }
})();
(function () {
  'use strict';

  angular
    .module('app.smsResponse')
    .controller('SmsResponseController', SmsResponseController);

  /** @ngInject */
  function SmsResponseController($scope, $mdMedia, $mdDialog, $rootScope, DTOptionsBuilder, DTColumnBuilder, $document, $timeout, $http, $q, sharedService, $compile, OperationTheater, $state, DtRendererService) {
    var vm = this;

    // Hooks
    $scope.$on('$destroy', _destroy);

    // Local data
    var smsResponses = [];
    var canceller = $q.defer();
    var isMediaGtSm = $mdMedia('gt-sm');

    var isAdvancedSearch = false;

    // Exposed data
    vm.loading = false;
    vm.sharedService = sharedService;
    vm.showAdvancedSearch = false;

    vm.smsResponseTable;

    vm.fromDatetime;
    vm.toDatetime;

    // Exposed methods
    vm.search = _search;
    vm.advancedSearch = _advancedSearch;
    vm.resetAdvancedSearch = _resetAdvancedSearch;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-comment';
      sharedService.pageName = 'SMS Response';

      vm.mediaXsAddButton = $mdMedia('gt-xs') ? '' : 'md-mini';

      _initDatatable();
    }

    function _initDatatable() {
      vm.smsResponseTable = $('#sms-response-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: 25,
        order: [
          [1, 'desc',],
        ],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;
          canceller = $q.defer();

          if (isAdvancedSearch) {
            if (vm.fromDatetime) {
              data.fromDate = vm.fromDatetime.startOf('day').toISOString();
            }
            if (vm.toDatetime) {
              data.toDate = vm.toDatetime.endOf('day').toISOString();
            }
          }

          // Do necessary remapping for query
          data.columns[0].data = 'unixtime';

          $http.post($rootScope.routePath + '/sms/getSmsResponses', data, {
            timeout: canceller.promise,
          })
            .then(function (res) {
              res = res.data;

              if (res.success) {
                smsResponses = res.data.smsResponses;

                callback({
                  recordsTotal: res.data.recordsTotal,
                  recordsFiltered: res.data.recordsTotal,
                  data: res.data.smsResponses,
                });
              } else {
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: [],
                });
                sharedService.showToast(res.message);
              }
            })
            .catch(function (err) {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: [],
              });
              sharedService.showToast('Request timed out.');
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope),
          },
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: DtRendererService.rowRenderer($scope),
        scrollY: 'auto',
        columns: [
          {
            data: null,
            title: 'No',
            width: '40px',
            render: function (data, type, row, meta) {
              var info = vm.smsResponseTable.page.info();
              return (info.page * info.length) + (meta.row + 1);
            },
          },
          {
            data: 'unixtime',
            title: 'Datetime',
            render: function (data, type, row, meta) {
              var datetime = moment(data, 'x');
              return datetime.format('DD/MM/YY') + '<br>' + datetime.format('hh:mm a');
            },
          },
          {
            data: 'message',
            title: 'Message',
          },
          {
            data: 'dr_name',
            title: 'Most Likely Response To',
          },
          {
            data: 'requestor_name',
            title: 'Most Likely Is Patient',
          },
          {
            data: 'phone_number',
            title: 'Requestor Contact',
          },
          {
            data: 'status',
            title: 'SMS Status',
          },
          {
            data: 'mtmo',
            title: 'MTMO',
          },
        ],
      });
    }

    function _search() {
      vm.smsResponseTable.search(vm.searchTerm).draw();
    }

    function _advancedSearch() {
      isAdvancedSearch = true;
      vm.smsResponseTable.ajax.reload(null, false);
    }

    function _resetAdvancedSearch() {
      vm.fromDatetime = undefined;
      vm.toDatetime = undefined;
      vm.searchTerm = '';
      isAdvancedSearch = false;
      vm.smsResponseTable.ajax.reload(null, false);
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;
      if (vm.smsResponseTable.page.info().start === 0) return;
      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;
      if (vm.smsResponseTable.page.info().end === vm.smsResponseTable.page.info().recordsTotal) return;
      _next();
    }

    function _prev() {
      vm.smsResponseTable.page('previous');
      vm.smsResponseTable.ajax.reload(null, false);
    }

    function _next() {
      vm.smsResponseTable.page('next');
      vm.smsResponseTable.ajax.reload(null, false);
    }

    function _destroy() {
      canceller.resolve();
    }

    // Initializations
    _init();
  }
})();
(function () {
  'use strict';

  angular
    .module('app.sevenDaysDischarge')
    .controller('SevenDaysDischarge2Controller', SevenDaysDischarge2Controller);

  /** @ngInject */
  function SevenDaysDischarge2Controller($scope, $window, $rootScope, $http, $q, $state, $stateParams, $mdDialog, $mdMedia, accountService, sharedService, DtRendererService) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var discharges = [];
    var canceller = $q.defer();
    var isMediaGtSm = $mdMedia('gt-sm');

    // Exposed data
    vm.loading = false;
    vm.sharedService = sharedService;

    vm.dischargesTable;

    // Exposed methods
    vm.search = _search;

    vm.edit = _edit;
    vm.close = _close;
    vm.download = _download;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-run';
      sharedService.pageName = 'Seven Days Discharge';

      // Copy search term for display only
      vm.searchTerm = $stateParams.searchTerm;

      _initDatatable();
    }

    function _initDatatable() {
      vm.dischargesTable = $('#discharge-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: $stateParams.pageLength,
        displayStart: $stateParams.page * $stateParams.pageLength,
        search: {
          search: $stateParams.searchTerm, // Initial search term actually here
        },
        order: [
          [3, 'desc', ],
        ],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;

          $http.post($rootScope.routePath + '/seven-days-discharge/getByPage', data, {
              timeout: canceller.promise
            })
            .then(function (res) {
              res = res.data;

              if (res.success) {
                discharges = res.data.discharges;
                callback({
                  recordsTotal: res.data.recordsTotal,
                  recordsFiltered: res.data.recordsTotal,
                  data: res.data.discharges,
                });
              } else {
                sharedService.showToast(res.message);
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: [],
                });
              }
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope),
          },
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: function (row, data, dataIndex) {
          DtRendererService.rowRenderer($scope)(row, data, dataIndex);

          // TODO: Re-enable color for next deployment, currently hide first
          // Do post processing for color
          if (data.discharge_form_id) {
            if (data.form_status === 'DRAFT') {
              angular.element(row).addClass('discharge-yellow');
            } else if (data.form_status === 'SUBMITTED') {
              angular.element(row).addClass('discharge-orange');
            } else if (data.form_status === 'COMPLETED') {
              angular.element(row).addClass('discharge-green');
            }
          } else {
            // If more than seven days show red
            var now = moment();
            var dischargeMoment = moment.utc(data.discharge_datetime);
            var duration = moment.duration(now.diff(dischargeMoment));
            if (duration.asDays() > 7) {
              angular.element(row).addClass('discharge-red');
            }
          }
        },
        scrollY: 'auto',
        columns: [{
          data: 'id',
          title: 'No',
          width: '40px',
          render: function (data, type, row, meta) {
            return meta.row + 1;
          }
        }, {
          data: 'episode_no',
          title: 'Episode No',
          defaultContent: 'N/A'
        }, {
          data: 'admission_datetime',
          title: 'Admission Datetime',
          render: function (data, type, row, meta) {
            var date = moment.utc(data);
            if (!date.isValid()) {
              return 'N/A';
            }
            return date.format('DD/MM/YYYY hh:mm a');
          }
        }, {
          data: 'discharge_datetime',
          title: 'Discharge Datetime',
          render: function (data, type, row, meta) {
            var date = moment.utc(data);
            if (!date.isValid()) {
              return 'N/A';
            }
            return date.format('DD/MM/YYYY hh:mm a');
          }
        }, {
          data: 'txn_desc',
          title: 'Description'
        }, {
          data: 'txn_amount',
          title: 'Transaction Amount',
          className: 'dt-head-right dt-body-right',
          render: function (data, type, row, meta) {
            return 'MYR ' + parseFloat(data).toFixed(2);
          }
        }, {
          data: 'dr_code',
          title: 'Doctor Code'
        }, {
          data: 'billinggrp_code',
          title: 'Billing Group Code'
        // TODO: Re-enable actions for next deployment, currently hide first
        }, {
          data: null,
          title: 'Actions',
          sortable: false,
          render: function (data, type, row, meta) {
            var template = '';

            if (['Doctor', 'PersonalAssistant'].indexOf(accountService.user.roles[0].name) !== -1) {
              if (['SUBMITTED', 'COMPLETED'].indexOf(row.form_status) === -1) {
                template +=
                  '<md-button class="md-icon-button" ng-click="vm.edit(' + meta.row + ')">' +
                  '<md-icon md-font-icon="icon-pencil" class="s18 green-500-fg"></md-icon>' +
                  '<md-tooltip>Edit</md-tooltip>' +
                  '</md-button>';
              }
            } else {
              if (row.form_status === 'SUBMITTED') {
                template +=
                  '<md-button class="md-icon-button" ng-click="vm.close(' + meta.row + ')">' +
                  '<md-icon md-font-icon="icon-check" class="s18 green-500-fg"></md-icon>' +
                  '<md-tooltip>Complete/Close</md-tooltip>' +
                  '</md-button>';
              }
            }

            if (row.discharge_form_id) {
              template +=
                '<md-button class="md-icon-button" ng-click="vm.download(' + meta.row + ')">' +
                '<md-icon md-font-icon="icon-download" class="s18 purple-500-fg"></md-icon>' +
                '<md-tooltip>Download</md-tooltip>' +
                '</md-button>';
            }

            return template;
          }
        }],
      });
    }

    function _search() {
      vm.dischargesTable.search(vm.searchTerm).draw();
    }

    function _edit(index) {
      var discharge = discharges[index];
      $state.go('app.sevenDaysDischarge.edit', {
        id: discharge ? discharge.id : null,
        dischargeEpisodeNo: discharge.episode_no,
        dischargeAdmissionDatetime: discharge.admission_datetime,
        dischargeDischargeDatetime: discharge.discharge_datetime,
        dischargeDrCode: discharge.dr_code,
        searchTerm: vm.searchTerm,
        page: vm.dischargesTable.page.info().page,
        pageLength: vm.dischargesTable.page.info().length
      });
    }

    function _download(index) {
      var discharge = discharges[index];

      $http.get($rootScope.routePath + '/seven-days-discharge/downloadFormByDischargeFormId', {
          params: {
            dischargeFormId: discharge.discharge_form_id,
            utcOffset: moment().utcOffset()
          },
          responseType: 'arraybuffer'
        })
        .then(function (res) {
          var header = res.headers('Content-Disposition');
          var fileName = header.split('=')[1].replace(/\"/gi, '');

          var blob = new Blob([res.data], {
            type: res.headers('Content-Type')
          });
          var objectUrl = ($window.URL || $window.webkitURL).createObjectURL(blob);
          var link = angular.element('<a/>');
          link.attr({
            href: objectUrl,
            download: fileName
          })[0].click();
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function _close(index) {
      var discharge = discharges[index];

      $http.post($rootScope.routePath + '/seven-days-discharge/completeDischargeForm', {
          dischargeFormId: discharge.discharge_form_id,
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            vm.dischargesTable.ajax.reload(null, false);
          }

          sharedService.showToast(res.message);
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;
      if (vm.dischargesTable.page.info().start === 0) return;
      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;
      if (vm.dischargesTable.page.info().end === vm.dischargesTable.page.info().recordsTotal) return;
      _next();
    }

    function _prev() {
      vm.dischargesTable.page('previous');
      vm.dischargesTable.ajax.reload(null, false);
    }

    function _next() {
      vm.dischargesTable.page('next');
      vm.dischargesTable.ajax.reload(null, false);
    }

    function _destroy() {
      canceller.resolve();
    }
  }
})();

(function() {
	'use strict';
	
	angular
		.module('app.sevenDaysDischarge')
		.controller('SevenDaysDischargeController', SevenDaysDischargeController);
	
	/** @ngInject */
	function SevenDaysDischargeController($scope, $mdMedia, $mdDialog, $rootScope, DTOptionsBuilder, DTColumnBuilder, $document, $timeout, $http, $q, sharedService, $compile, SevenDaysDischarge, $state) {
		var vm = this;
		
		// Local data
		var canceller = $q.defer();
		var sortBy = {
			colIndex: 3,
			col: 'discharge_datetime',
			dir: 'desc'
		};
		var sortEl;
		
		// Data
		vm.sharedService = sharedService;

		vm.sevenDaysDischarges = []; // Initialize empty in case something happens		

		vm.dt = dt;
		
		vm.lengthMenu = [10, 25, 50, 100];
		vm.dtOptions = DTOptionsBuilder.newOptions()
			.withDOM('t')
			.withOption('autoWidth', false)
			.withOption('responsive', true)
			.withScroller()
			.withOption('scrollY', 'auto')
			.withOption('createdRow', sharedService.dtCreatedRow($scope))
			.withOption('drawCallback', function() {
				$timeout(function() {
					vm.loading = false;
					$rootScope.loadingProgress = false;
				});
			});
		vm.dtColumns = [
			DTColumnBuilder.newColumn(null).withTitle('No').renderWith(function(data, type, rows, meta) {
				return meta.row + 1;
			}),
			DTColumnBuilder.newColumn('episode_no').withTitle('Episode No').renderWith(function(data, type, rows, meta) {
				return vm.sevenDaysDischarges[meta.row].episode_no || 'N/A';
			}),
			DTColumnBuilder.newColumn('admission_datetime').withTitle('Admission Datetime').renderWith(function(data, type, rows, meta) {
				return vm.sevenDaysDischarges[meta.row].getAdmissionDatetime().format('DD/MM/YYYY hh:mm a') || 'N/A';
			}),
			DTColumnBuilder.newColumn('discharge_datetime').withTitle('Discharge Datetime').renderWith(function(data, type, rows, meta) {
				return vm.sevenDaysDischarges[meta.row].getDischargeDatetime().format('DD/MM/YYYY hh:mm a') || 'N/A';
			}),
			DTColumnBuilder.newColumn('txn_desc').withTitle('Description'),
			DTColumnBuilder.newColumn('txn_amount').withTitle('Transaction Amount').withClass('dt-head-right dt-body-right').renderWith(function(data, type, rows, meta) {
				return 'MYR ' + parseFloat(data).toFixed(2);	
			}),
			DTColumnBuilder.newColumn('dr_code').withTitle('Doctor Code'),
			DTColumnBuilder.newColumn('billinggrp_code').withTitle('Billing Group Code')
		];

		vm.mediaXsAddButton = $mdMedia('gt-xs') ? '' : 'md-mini';
		vm.isMediaGtSm = $mdMedia('gt-sm');

		vm.offset = 0;
		vm.offsetFrom = 0;
		vm.recordsPerPage = 25;
		vm.pageRecords = 0;
		vm.recordsTotal = 0;
		
		sharedService.pageIcon = 'icon-run';
		sharedService.pageName = 'Seven Days Discharge';

		// Methods
		$scope.$on('$destroy', destroy);
		vm.pagingChanged = pagingChanged;
		vm.search = load;
		vm.swipeLeft = swipeLeft;
		vm.swipeRight = swipeRight;
		vm.prev = prev;
		vm.next = next;
		
		//////////

		function dt(i) {
			vm.dt = i;
			
			vm.dt.DataTable.page.len(vm.recordsPerPage).draw();
			vm.dt.DataTable.on('responsive-display', sharedService.dtResponsiveDisplay($scope));
			load();
		}
		
		function load() {
			if (vm.loading) return;

			vm.loading = true;
			$rootScope.loadingProgress = true;

			vm.dt.DataTable.off('order');
			
			$http.get($rootScope.routePath + '/seven-days-discharge/get-by-page', {
				params: {
					offset: vm.offset,
					limit: vm.recordsPerPage,
					col: sortBy.col,
					dir: sortBy.dir,
					q: vm.searchTerm
				},
				timeout: canceller.promise
			})
			.then(function(res) {
				res = res.data;

				vm.sevenDaysDischarges.length = 0;
				vm.dt.DataTable.clear();
				
				var thead = angular.element(vm.dt.DataTable.header());
				thead.find('.sorting_asc, .sorting_desc').attr('class', 'sorting');
				thead.children().children().eq(sortBy.colIndex).attr('class', 'sorting_' + sortBy.dir);
				
				vm.recordsTotal = res.recordsTotal;

				if (res.success) {
					vm.offsetFrom = Math.min(vm.offset + 1, vm.recordsTotal);
					vm.pageRecords = Math.min(vm.offset + vm.recordsPerPage, vm.recordsTotal);

					res.data.forEach(function(sevenDaysDischarge) {
						vm.sevenDaysDischarges.push(new SevenDaysDischarge(sevenDaysDischarge));
					});

					vm.dt.DataTable.rows.add(vm.sevenDaysDischarges).order([sortBy.colIndex, sortBy.dir]).draw();
					vm.dt.DataTable.columns.adjust().draw();
				} else {
					vm.offsetFrom = 0;
					vm.pageRecords = 0;

					vm.dt.DataTable.draw();
					sharedService.showToast(res.message);
				}
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			})
			.finally(function() {
				vm.loading = false;
				$rootScope.loadingProgress = false;

				vm.dt.DataTable.on('order', order);
			});
		}

		function destroy() {
			canceller.resolve();
			vm.dt.DataTable.off('responsive-display');
			vm.dt.DataTable.off('order');
		}

		function order(jsEvent, settings) {
			sortBy.colIndex = settings.aaSorting[0][0];

			var column = settings.aoColumns[sortBy.colIndex].mData;
			var direction = settings.aaSorting[0][1];

			sortBy.col = column || '';
			sortBy.dir = direction;
			load();
		}

		function pagingChanged() {
			vm.dt.DataTable.page.len(vm.recordsPerPage);
			load();
		}

		//////////
		
		// Only swipe on small to medium screens,
		// prevent click, drag and copy data conflict on bigger screens
		function swipeLeft() {
			if (vm.isMediaGtSm) return;
			prev();
		}

		function swipeRight() {
			if (vm.isMediaGtSm) return;
			next();
		}

		//////////

		function prev() {
			if (vm.offset === 0) return;
			vm.offset -= vm.recordsPerPage;
			load();
		}

		function next() {
			if (vm.offset + vm.recordsPerPage >= vm.recordsTotal) return;
			vm.offset += vm.recordsPerPage;
			load();
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('app.settings', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      // Main
      .state('app.settings', {
        url: '/settings',
        views: {
          'content@app': {
            templateUrl: 'app/main/settings/settings.html',
            controller: 'SettingsController as vm',
          },
        },
        bodyClass: 'settings',
        moduleName: 'Settings',
      });
  }
})();
(function () {
  'use strict';

  angular
    .module('app.settings')
    .controller('SettingsController', SettingsController);

  /** @ngInject */
  function SettingsController($scope, $mdMedia, $mdDialog, $rootScope, $document, $timeout, accountService, $http, $q, sharedService, $compile, Role, $state, $window, DtRendererService) {
    var vm = this;

    // Hooks
    $scope.$on('$destroy', _destroy);

    // Local data
    var canceller = $q.defer();
    var isMediaGtSm = $mdMedia('gt-sm');

    // Exposed data
    vm.settings = [];

    vm.loading = false;
    vm.sharedService = sharedService;

    vm.settingsTable;

    // Exposed methods
    vm.search = _search;

    vm.edit = _edit;
    vm.save = _save;
    vm.cancel = _cancel;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-cog';
      sharedService.pageName = 'Settings';

      _initDatatable();
    }

    function _initDatatable() {
      vm.settingsTable = $('#settings-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: 25,
        order: [
          // [3, 'desc',],
        ],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;
          canceller = $q.defer();

          // Do necessary remapping for query
          data.columns[0].data = 'id';

          $http.post($rootScope.routePath + '/settings/getSettings', data, {
            timeout: canceller.promise
          })
            .then(function (res) {
              res = res.data;

              if (res.success) {
                vm.settings = res.data.settings;

                callback({
                  recordsTotal: res.data.recordsTotal,
                  recordsFiltered: res.data.recordsTotal,
                  data: res.data.settings,
                });
              } else {
                sharedService.showToast(res.message);
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: [],
                });
              }
            })
            .catch(function (err) {
              sharedService.showToast('Request timed out.');
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: [],
              });
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope),
          },
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: DtRendererService.rowRenderer($scope),
        scrollY: 'auto',
        columns: [
          {
            data: null,
            title: 'No',
            width: '40px',
            render: function (data, type, row, meta) {
              var info = vm.settingsTable.page.info();
              return (info.page * info.length) + (meta.row + 1);
            },
          },
          {
            data: 'name',
            title: 'Name',
          },
          {
            data: 'value',
            title: 'Value',
            render: function (data, type, row, meta) {
              var template =
                '<md-input-container class="md-block" ng-if="vm.settings[' + meta.row + '].editing">' +
                '<label>Value</label>' +
                '<input type="text" ng-model="vm.settings[' + meta.row + '].value">' +
                '</md-input-container>' +
                '<span ng-if="!vm.settings[' + meta.row + '].editing" ng-bind="vm.settings[' + meta.row + '].value"></span>';

              return template;
            },
          },
          {
            data: 'is_active',
            title: 'Is Active?',
            render: function (data, type, row, meta) {
              var template =
                '<md-checkbox ng-model="vm.settings[' + meta.row + '].is_active" ng-change="vm.save(' + meta.row + ')">' +
                '</md-checkbox>';

              return template;
            },
          },
          {
            data: null,
            title: 'Actions',
            render: function (data, type, row, meta) {
              var template =
                '<md-button class="md-icon-button" ng-click="vm.edit(' + meta.row + ')" ng-if="!vm.settings[' + meta.row + '].editing">' +
                '<md-icon md-font-icon="icon-pencil" class="s18 green-500-fg"></md-icon>' +
                '<md-tooltip md-direction="top">Edit</md-tooltip>' +
                '</md-button>' +
                '<md-button class="md-icon-button" ng-click="vm.save(' + meta.row + ')" ng-if="vm.settings[' + meta.row + '].editing">' +
                '<md-icon md-font-icon="icon-content-save" class="s18 green-500-fg"></md-icon>' +
                '<md-tooltip md-direction="top">Save</md-tooltip>' +
                '</md-button>' +
                '<md-button class="md-icon-button" ng-click="vm.cancel(' + meta.row + ')" ng-if="vm.settings[' + meta.row + '].editing">' +
                '<md-icon md-font-icon="icon-close" class="s18 red-500-fg"></md-icon>' +
                '<md-tooltip md-direction="top">Cancel</md-tooltip>' +
                '</md-button>';
              return template;
            },
          },
        ],
      });
    }

    function _search() {
      vm.settingsTable.search(vm.searchTerm).draw();
    }

    function _edit(i) {
      vm.settings[i].editing = true;
    }

    function _save(i) {
      var s = vm.settings[i];
      canceller = $q.defer();

      var data = {
        id: s.id,
        name: s.name,
        setting: {
          value: s.value,
          is_active: s.is_active,
        },
      };

      $http.post($rootScope.routePath + '/settings/saveSettings', data, {
        timeout: canceller.promise,
      })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            s.editing = false;
          }

          sharedService.showToast(res.message);
        })
        .catch(function (err) {
          sharedService.showToast('Request timed out.');
        });
    }

    function _cancel(i) {
      vm.settings[i].editing = false;
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;
      if (vm.settingsTable.page.info().start === 0) return;
      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;
      if (vm.settingsTable.page.info().end === vm.settingsTable.page.info().recordsTotal) return;
      _next();
    }

    function _prev() {
      vm.settingsTable.page('previous');
      vm.settingsTable.ajax.reload(null, false);
    }

    function _next() {
      vm.settingsTable.page('next');
      vm.settingsTable.ajax.reload(null, false);
    }

    function _destroy() {
      canceller.resolve();
    }

    // Initializations
    _init();
  }
})();

(function () {
  'use strict';

  angular
    .module('app.shift')
    .controller('ShiftController', ShiftController);

  /** @ngInject */
  function ShiftController($scope, $rootScope, $http, $q, $state, $stateParams, $mdDialog, $mdMedia, sharedService, DtRendererService) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var shifts = [];
    var canceller = $q.defer();
    var isMediaGtSm = $mdMedia('gt-sm');

    // Exposed data
    vm.loading = false;
    vm.sharedService = sharedService;

    vm.shiftTable;

    // Exposed methods
    vm.search = _search;

    vm.edit = _edit;
    vm.delete = _delete;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-calendar-text';
      sharedService.pageName = 'Shift';

      // Copy search term for display only
      vm.searchTerm = $stateParams.searchTerm;

      _initDatatable();
    }

    function _initDatatable() {
      vm.shiftTable = $('#shift-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: $stateParams.pageLength,
        displayStart: $stateParams.page * $stateParams.pageLength,
        search: {
          search: $stateParams.searchTerm, // Initial search term actually here
        },
        order: [
          [0, 'asc', ],
        ],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;

          $http.post($rootScope.routePath + '/shift/getByPage', data, {
              timeout: canceller.promise
            })
            .then(function (res) {
              res = res.data;

              if (res.success) {
                shifts = res.data.shifts;
                callback({
                  recordsTotal: res.data.recordsTotal,
                  recordsFiltered: res.data.recordsTotal,
                  data: res.data.shifts,
                });
              } else {
                sharedService.showToast(res.message);
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: [],
                });
              }
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope),
          },
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: DtRendererService.rowRenderer($scope),
        scrollY: 'auto',
        columns: [{
            data: 'id',
            title: 'No',
            width: '40px',
            render: function (data, type, row, meta) {
              return meta.row + 1;
            },
          },
          {
            data: 'name',
            title: 'Name',
            render: function (data, type, row, meta) {
              var template = data;
              for (var i = 0; i < row.slots.length; ++i) {
                var slot = row.slots[i];
                template += '<br>' + slot.weekday + ' from ' + moment.utc(slot.start_time, 'HH:mm:ss').local().format('HH:mm') + ' to ' + moment.utc(slot.end_time, 'HH:mm:ss').local().format('HH:mm');
              }
              return template;
            }
          },
          {
            data: null,
            title: 'Actions',
            render: function (data, type, row, meta) {
              var template =
                '<md-button class="md-icon-button" ng-click="vm.edit(' + meta.row + ')">' +
                '<md-icon md-font-icon="icon-pencil" class="s18 green-500-fg"></md-icon>' +
                '<md-tooltip>Edit</md-tooltip>' +
                '</md-button>' +
                '<md-button class="md-icon-button" ng-click="vm.delete(' + meta.row + ')">' +
                '<md-icon md-font-icon="icon-trash" class="s18 red-500-fg"></md-icon>' +
                '<md-tooltip>Delete</md-tooltip>' +
                '</md-button>';

              return template;
            },
          },
        ],
      });
    }

    function _search() {
      vm.shiftTable.search(vm.searchTerm).draw();
    }


    function _edit(index) {
      var shift = shifts[index];
      $state.go('app.shift.edit', {
        id: shift ? shift.id : null,
        searchTerm: vm.searchTerm,
        page: vm.shiftTable.page.info().page,
        pageLength: vm.shiftTable.page.info().length
      });
    }

    function _delete(index) {
      var shift = shifts[index];
      var confirm = $mdDialog.confirm()
        .title('Delete Confirmation')
        .textContent('Are you sure you want to delete this shift "' + shift.name + '"? This action is irreversible!')
        .ok('DELETE')
        .cancel('CANCEL');

      $mdDialog.show(confirm)
        .then(function () {
          return $http.post($rootScope.routePath + '/shift/deleteById', {
              shiftId: shift.id
            })
            .then(function (res) {
              res = res.data;

              sharedService.showToast(res.message);

              vm.shiftTable.ajax.reload(null, false);
            })
            .catch(function (err) {
              if (err.message) {
                sharedService.showToast(err.message);
              } else {
                sharedService.showToast('Request timed out.');
              }
            });
        });
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;
      if (vm.shiftTable.page.info().start === 0) return;
      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;
      if (vm.shiftTable.page.info().end === vm.shiftTable.page.info().recordsTotal) return;
      _next();
    }

    function _prev() {
      vm.shiftTable.page('previous');
      vm.shiftTable.ajax.reload(null, false);
    }

    function _next() {
      vm.shiftTable.page('next');
      vm.shiftTable.ajax.reload(null, false);
    }

    function _destroy() {
      canceller.resolve();
    }
  }
})();

(function() {
	'use strict';
	
	angular
		.module('app.operationTheater')
		.controller('OperationTheaterController', OperationTheaterController);
	
	/** @ngInject */
	function OperationTheaterController($scope, $mdMedia, $mdDialog, $rootScope, DTOptionsBuilder, DTColumnBuilder, $document, $timeout, $http, $q, sharedService, $compile, OperationTheater, $state) {
		var vm = this;
		
		// Local data
		var canceller = $q.defer();
		var sortBy = {
			colIndex: 3,
			col: 'operation_datetime',
			dir: 'desc'
		};
		var sortEl;
		
		// Data
		vm.sharedService = sharedService;

		vm.operationTheaters = []; // Initialize empty in case something happens		

		vm.dt = dt;
		
		vm.lengthMenu = [10, 25, 50, 100];
		vm.dtOptions = DTOptionsBuilder.newOptions()
			.withDOM('t')
			.withOption('autoWidth', false)
			.withOption('responsive', true)
			.withScroller()
			.withOption('scrollY', 'auto')
			.withOption('createdRow', sharedService.dtCreatedRow($scope))
			.withOption('drawCallback', function() {
				$timeout(function() {
					vm.loading = false;
					$rootScope.loadingProgress = false;
				});
			});
		vm.dtColumns = [
			DTColumnBuilder.newColumn(null).withTitle('No').renderWith(function(data, type, rows, meta) {
				return meta.row + 1;
			}),
			DTColumnBuilder.newColumn('booking_datetime').withTitle('Booking Date').renderWith(function(data, type, rows, meta) {
				return vm.operationTheaters[meta.row].getBookingDatetime().format('DD/MM/YYYY hh:mm a');
			}),
			DTColumnBuilder.newColumn('patient_no').withTitle('MRN/Name').renderWith(function(data, type, rows, meta) {
				return vm.operationTheaters[meta.row].getMrnNameHtmlString();
			}),
			DTColumnBuilder.newColumn('operation_datetime').withTitle('Operation Datetime').renderWith(function(data, type, rows, meta) {
				return vm.operationTheaters[meta.row].getOperationDatetime().format('DD/MM/YYYY hh:mm a');
			}),
			DTColumnBuilder.newColumn('procedures').withTitle('Procedure').renderWith(function(data, type, rows, meta) {
				return vm.operationTheaters[meta.row].procedures || 'N/A';
			}),
			DTColumnBuilder.newColumn('diagnosis').withTitle('Diagnosis').renderWith(function(data, type, rows, meta) {
				return vm.operationTheaters[meta.row].diagnosis || 'N/A';
			}),
			DTColumnBuilder.newColumn('location').withTitle('OT Room'),
			DTColumnBuilder.newColumn('patient_gender').withTitle('Gender/Age').renderWith(function(data, type, rows, meta) {
				return vm.operationTheaters[meta.row].getGenderAgeString();
			}),
			DTColumnBuilder.newColumn('surgeon').withTitle('Surgeon')
		];

		vm.mediaXsAddButton = $mdMedia('gt-xs') ? '' : 'md-mini';
		vm.isMediaGtSm = $mdMedia('gt-sm');

		vm.offset = 0;
		vm.offsetFrom = 0;
		vm.recordsPerPage = 25;
		vm.pageRecords = 0;
		vm.recordsTotal = 0;
		
		sharedService.pageIcon = 'icon-bone';
		sharedService.pageName = 'OT Bookings';

		// Methods
		$scope.$on('$destroy', destroy);
		vm.pagingChanged = pagingChanged;
		vm.search = load;
		vm.swipeLeft = swipeLeft;
		vm.swipeRight = swipeRight;
		vm.prev = prev;
		vm.next = next;
		vm.edit = edit;
		vm.simple = simple;
		
		//////////

		function dt(i) {
			vm.dt = i;
			
			vm.dt.DataTable.page.len(vm.recordsPerPage).draw();
			vm.dt.DataTable.on('responsive-display', sharedService.dtResponsiveDisplay($scope));
			load();
		}
		
		function load() {
			if (vm.loading) return;

			vm.loading = true;
			$rootScope.loadingProgress = true;

			vm.dt.DataTable.off('order');
			
			$http.get($rootScope.routePath + '/operation-theater/get-by-page', {
				params: {
					offset: vm.offset,
					limit: vm.recordsPerPage,
					col: sortBy.col,
					dir: sortBy.dir,
					q: vm.searchTerm
				},
				timeout: canceller.promise
			})
			.then(function(res) {
				res = res.data;

				vm.operationTheaters.length = 0;
				vm.dt.DataTable.clear();
				
				var thead = angular.element(vm.dt.DataTable.header());
				thead.find('.sorting_asc, .sorting_desc').attr('class', 'sorting');
				thead.children().children().eq(sortBy.colIndex).attr('class', 'sorting_' + sortBy.dir);
				
				vm.recordsTotal = res.recordsTotal;

				if (res.success) {
					vm.offsetFrom = Math.min(vm.offset + 1, vm.recordsTotal);
					vm.pageRecords = Math.min(vm.offset + vm.recordsPerPage, vm.recordsTotal);

					res.data.forEach(function(operationTheater) {
						vm.operationTheaters.push(new OperationTheater(operationTheater));
					});

					vm.dt.DataTable.rows.add(vm.operationTheaters).order([sortBy.colIndex, sortBy.dir]).draw();
					vm.dt.DataTable.columns.adjust().draw();
				} else {
					vm.offsetFrom = 0;
					vm.pageRecords = 0;

					vm.dt.DataTable.draw();
					sharedService.showToast(res.message);
				}
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			})
			.finally(function() {
				vm.loading = false;
				$rootScope.loadingProgress = false;

				vm.dt.DataTable.on('order', order);
			});
		}

		function destroy() {
			canceller.resolve();
			vm.dt.DataTable.off('responsive-display');
			vm.dt.DataTable.off('order');
		}

		function order(jsEvent, settings) {
			sortBy.colIndex = settings.aaSorting[0][0];

			var column = settings.aoColumns[sortBy.colIndex].mData;
			var direction = settings.aaSorting[0][1];

			sortBy.col = column || '';
			sortBy.dir = direction;
			load();
		}

		function pagingChanged() {
			vm.dt.DataTable.page.len(vm.recordsPerPage);
			load();
		}

		//////////
		
		// Only swipe on small to medium screens,
		// prevent click, drag and copy data conflict on bigger screens
		function swipeLeft() {
			if (vm.isMediaGtSm) return;
			prev();
		}

		function swipeRight() {
			if (vm.isMediaGtSm) return;
			next();
		}

		//////////

		function prev() {
			if (vm.offset === 0) return;
			vm.offset -= vm.recordsPerPage;
			load();
		}

		function next() {
			if (vm.offset + vm.recordsPerPage >= vm.recordsTotal) return;
			vm.offset += vm.recordsPerPage;
			load();
		}

		function edit() {
			$state.go('app.operationTheater.edit');
		}

		function simple() {
			$state.go('app.todo.edit');
		}
	}
})();
(function () {
  'use strict';

  angular
    .module('app.rosterList', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      // Main
      .state('app.rosterList', {
        url: '/rosterList',
        views: {
          'content@app': {
            templateUrl: 'app/main/roster-list/roster-list.html',
            controller: 'RosterListController',
            controllerAs: 'vm'
          }
        },
        params: {
          searchTerm: null,
          page: 0,
          pageLength: 25
        },
        bodyClass: 'roster',
        moduleName: 'Roster'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.rosterList')
    .controller('RosterListController', RosterListController);

  /** @ngInject */
  function RosterListController($scope, $rootScope, $http, $q, $state, $stateParams, $mdDialog, $mdMedia, accountService, sharedService, DtRendererService) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var rosters = [];
    var canceller = $q.defer();
    var isMediaGtSm = $mdMedia('gt-sm');

    // Exposed data
    vm.canCreate = false;

    vm.loading = false;
    vm.sharedService = sharedService;
    vm.views = ['Month', 'Week'];
    vm.view = vm.views[0];

    vm.rosterTable;
    vm.fromDate = moment().startOf('month');
    vm.specialty;
    vm.specialties = [];

    // Exposed methods
    vm.reloadData = _reloadData;
    vm.getShow = _getShow;

    vm.print = _print;
    vm.edit = _edit;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-calendar-clock';
      sharedService.pageName = 'Roster List';

      // Copy search term for display only
      vm.searchTerm = $stateParams.searchTerm;

      $scope.$on('permissionGet', function (event, data) {
        vm.canCreate = data.canCreate;
      });

      _initDatatable();
    }

    function _initDatatable() {
      vm.rosterTable = $('#roster-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length">><"right"<"dt-info">>>',
        processing: true,
        serverSide: true,
        ordering: false,
        paging: false,
        pagingType: 'simple',
        pageLength: $stateParams.pageLength,
        displayStart: $stateParams.page * $stateParams.pageLength,
        search: {
          search: $stateParams.searchTerm, // Initial search term actually here
        },
        order: [
          [0, 'asc', ],
        ],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;

          if (vm.specialty) {
            data.specialtyId = vm.specialty.id;
          }
          if (vm.view === vm.views[1]) { // Week
            data.fromDate = vm.fromDate.clone().startOf('week').toISOString();
            data.toDate = vm.fromDate.clone().endOf('week').toISOString();
          } else { // Month and else
            data.fromDate = vm.fromDate.clone().startOf('month').toISOString();
            data.toDate = vm.fromDate.clone().endOf('month').toISOString();
          }
          data.view = vm.view;
          data.utcOffset = moment().utcOffset();

          $http.post($rootScope.routePath + '/roster/getByPage', data, {
              timeout: canceller.promise
            })
            .then(function (res) {
              res = res.data;

              if (res.success) {
                // Convert map to array
                rosters = Object.values(res.data.rosters);
                vm.specialties = res.data.specialties;

                callback({
                  recordsTotal: res.data.recordsTotal,
                  recordsFiltered: res.data.recordsTotal,
                  data: rosters,
                });
              } else {
                sharedService.showToast(res.message);
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: [],
                });
              }
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope),
          },
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: DtRendererService.rowRenderer($scope),
        scrollY: 'auto',
        columns: [{
          data: null,
          title: 'Date',
          width: '40px',
          sortable: false,
          render: function (data, type, row, meta) {
            return moment(data.date).date();
          }
        }, {
          data: null,
          title: 'Weekday',
          sortable: false,
          render: function (data, type, row, meta) {
            var date = moment(data.date);
            if (date.day() === 0 || date.day() === 6) {
              return '<span style="font-weight: bold">' + date.format('dddd') + '</span>';
            }
            return date.format('dddd');
          }
        }, {
          data: null,
          title: 'SMO',
          sortable: false,
          render: function (data, type, row, meta) {
            var smo = data['SMO (Senior Medical Officer)'];

            if (smo.length === 0) {
              return '-';
            }

            var result = '';
            for (var i = 0; i < smo.length; ++i) {
              if (i > 0) {
                result += '<br><br>';
              }
              result += '<span style="font-weight:bold">' + smo[i].profile_name + '</span><br><span style="font-style:italic">' + smo[i].specialty_name + '</span><br>' + smo[i].roster_emails + '<br>' + smo[i].phone_number;
            }
            return result;
          }
        }, {
          data: null,
          title: 'MO',
          sortable: false,
          render: function (data, type, row, meta) {
            var smo = data['MO (Medical Officer)'];

            if (smo.length === 0) {
              return '-';
            }

            var result = '';
            for (var i = 0; i < smo.length; ++i) {
              if (i > 0) {
                result += '<br><br>';
              }
              result += '<span style="font-weight:bold">' + smo[i].profile_name + '</span><br><span style="font-style:italic">' + smo[i].specialty_name + '</span><br>' + smo[i].roster_emails + '<br>' + smo[i].phone_number;
            }
            return result;
          }
        }, {
          data: null,
          title: 'Consultant',
          sortable: false,
          render: function (data, type, row, meta) {
            var smo = data['Consultant'];

            if (smo.length === 0) {
              return '-';
            }

            var result = '';
            for (var i = 0; i < smo.length; ++i) {
              if (i > 0) {
                result += '<br><br>';
              }
              result += '<span style="font-weight:bold">' + smo[i].profile_name + '</span><br><span style="font-style:italic">' + smo[i].specialty_name + '</span><br>' + smo[i].roster_emails + '<br>' + smo[i].phone_number;
            }
            return result;
          }
        }, {
          data: null,
          title: 'No Tag',
          sortable: false,
          render: function (data, type, row, meta) {
            var smo = data['No Tag'];

            if (smo.length === 0) {
              return '-';
            }

            var result = '';
            for (var i = 0; i < smo.length; ++i) {
              if (i > 0) {
                result += '<br><br>';
              }
              result += '<span style="font-weight:bold">' + smo[i].profile_name + '</span><br><span style="font-style:italic">' + smo[i].specialty_name + '</span><br>' + smo[i].roster_emails + '<br>' + smo[i].phone_number;
            }
            return result;
          }
        }],
      });
    }

    function _reloadData() {
      vm.rosterTable.ajax.reload(null, false);
    }

    function _getShow(viewName) {
      return viewName === vm.view;
    }

    function _print() {
      var prtContent = $("#roster-dt_wrapper").clone();
      prtContent.find('.dataTables_scrollHead').remove();
      prtContent.find('#roster-dt').css('border-collapse', 'collapse');
      prtContent.find('#roster-dt thead tr').css('height', 'auto');
      prtContent.find('#roster-dt thead tr th').css('height', 'auto').css('text-align', 'left').css('border', '1px solid black').css('padding', '5px');
      prtContent.find('#roster-dt thead tr th div').css('height', 'auto');
      prtContent.find('#roster-dt tbody tr td').css('border', '1px solid black').css('padding', '5px');
      var winPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      winPrint.document.write('<head><style>*{font-size:9px}html,body{height:99%;}</style></head>' + prtContent.html());
      winPrint.document.close();
      winPrint.focus();
      winPrint.print();
    }

    function _edit() {
      $state.go('app.roster.edit');
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;
      if (vm.rosterTable.page.info().start === 0) return;
      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;
      if (vm.rosterTable.page.info().end === vm.rosterTable.page.info().recordsTotal) return;
      _next();
    }

    function _prev() {
      vm.rosterTable.page('previous');
      vm.rosterTable.ajax.reload(null, false);
    }

    function _next() {
      vm.rosterTable.page('next');
      vm.rosterTable.ajax.reload(null, false);
    }

    function _destroy() {
      canceller.resolve();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.roster')
    .controller('RosterController', RosterController);

  /** @ngInject */
  function RosterController($scope, $rootScope, $document, $http, $q, $timeout, $state, $mdDialog, sharedService, uiCalendarConfig) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var _canceller = $q.defer();
    var _debouncing = false;
    var _latestDebounce = angular.identity;

    // Exposed data
    vm.canCreate = false;
    vm.canModify = false;
    vm.canDelete = false;

    vm.pageIcon = null;
    vm.pageName = null;
    vm.currentMonthShort = null;
    vm.calendarTitle = null;
    vm.events = [
      []
    ];
    vm.calendar = null;
    vm.uiCalendarConfig = {
      calendar: {
        eventLimit: true,
        header: false,
        handleWindowResize: true,
        aspectRatio: 1,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        defaultView: 'month',
        allDaySlot: false,
        viewRender: function (view) {
          if (vm.calendar) {
            vm.calendarTitle = vm.calendar.fullCalendar('getCalendar').view.title;
          }

          $rootScope.loadingProgress = true;

          // Clear previous events
          vm.events.length = 0;

          // Debounce it so when user change view quickly we do not hit API multiple times
          _debounceFetch(1000, function () {
            var params = {
              fromDatetime: view.intervalStart.local().toISOString(),
              toDatetime: view.intervalEnd.local().subtract(1, 'seconds').toISOString()
            };

            if (vm.specialty) {
              params.specialtyId = vm.specialty.id;
            }

            $http.get($rootScope.routePath + '/roster/getBetweenDates', {
                params: params,
                timeout: _canceller.promise
              })
              .then(function (res) {
                res = res.data;

                if (!res.success) {
                  return sharedService.showToast(res.message);
                }

                vm.specialties = res.data.specialties;

                switch (view.name) {
                  case 'month': {
                    // Get selected month's offset
                    var cellOffset = view.intervalStart.local().isoWeekday() % 7;

                    // Create empty object
                    var eventCountPerDay = {};

                    res.data.rosters.forEach(function (roster) {
                      var s = moment(roster.start_datetime);

                      // Add to count
                      var cellIndex = s.date() + cellOffset - 1;
                      eventCountPerDay[cellIndex] = eventCountPerDay[cellIndex] ? ++eventCountPerDay[cellIndex] : 1;
                    });

                    // Loop through all dates and modify render
                    for (var key in eventCountPerDay) {
                      var $dayEl = $(view.dayGrid.dayEls[key]);
                      var html = '<span class="count">' + eventCountPerDay[key] + '</span>';
                      $dayEl.html(html);
                    }
                    break;
                  }
                  case 'agendaWeek': {
                    var events = [];

                    res.data.rosters.forEach(function (roster) {
                      var s = moment(roster.start_datetime);
                      var e = moment(roster.end_datetime);

                      var obj = {
                        roster: roster,
                        title: roster.profile_name,
                        start: s,
                        end: e
                      };

                      var tagText = roster.tag ? roster.tag : 'No tag';

                      if (roster.specialty_name) {
                        obj.title += '\n\n' + tagText + '\n\n' + roster.specialty_name;
                        obj.color = roster.specialty_color;
                        obj.textColor = _invertColor(roster.specialty_color, true);
                      }

                      events.push(obj);
                    });

                    vm.events.push(events);

                    break;
                  }
                  case 'agendaDay': {
                    var events = [];

                    res.data.rosters.forEach(function (roster) {
                      var s = moment(roster.start_datetime);
                      var e = moment(roster.end_datetime);

                      var obj = {
                        roster: roster,
                        title: roster.profile_name,
                        start: s,
                        end: e
                      };

                      if (roster.specialty_name) {
                        obj.title += '\n\n' + roster.specialty_name;
                        obj.color = roster.specialty_color;
                        obj.textColor = _invertColor(roster.specialty_color, true);
                      }

                      events.push(obj);
                    });

                    vm.events.push(events);

                    break;
                  }
                }


              })
              .catch(function (err) {
                if (err.message) {
                  sharedService.showToast(err.message);
                } else {
                  sharedService.showToast('Request timed out.');
                }
              })
              .finally(function () {
                $rootScope.loadingProgress = false;
              });

          });
        },
        columnFormat: {
          month: 'ddd',
          week: 'ddd',
          day: 'ddd M'
        },
        eventClick: function (calEvent, jsEvent, view) {
          $mdDialog.show({
              controller: 'RosterDetailDialogController',
              controllerAs: 'vm',
              templateUrl: 'app/main/roster/dialogs/roster-detail/roster-detail-dialog.html',
              parent: angular.element($document.body),
              targetEvent: jsEvent,
              clickOutsideToClose: true,
              locals: {
                canModify: vm.canModify,
                canDelete: vm.canDelete,
                roster: calEvent.roster
              }
            })
            .then(function (res) {
              if (res && res.reloadData) {
                if (res.action === 'UPDATE') {
                  view.calendar.gotoDate(res.rosterStartDatetime);
                } else if (res.action === 'DELETE') {
                  vm.uiCalendarConfig.calendar.viewRender(view);
                }
              }
            });
        },
        dayClick: function (date, jsEvent, view) {
          switch (view.name) {
            case 'month':
            case 'agendaWeek': {
              view.calendar.gotoDate(date);
              view.calendar.changeView('agendaDay');
              break;
            }
          }
        },
        timezone: 'local',
        slotDuration: '03:00:00',
        displayEventTime: false
      }
    };
    vm.rosters = [];
    vm.specialty = null;
    vm.specialties = [];

    // Exposed methods
    vm.edit = _edit;
    vm.next = _next;
    vm.prev = _prev;
    vm.changeCalendarView = _changeCalendarView;
    vm.goToToday = _goToToday;
    vm.filterSpecialty = _filterSpecialty;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-calendar-clock';
      sharedService.pageName = 'Roster';

      vm.pageIcon = sharedService.pageIcon;
      vm.pageName = sharedService.pageName;

      $timeout(function () {
        vm.calendar = uiCalendarConfig.calendars.main;
        vm.currentMonthShort = vm.calendar.fullCalendar('getDate').format('MMM');
        vm.calendarTitle = vm.calendar.fullCalendar('getCalendar').view.title;
      });

      $scope.$on('permissionGet', function (event, data) {
        vm.canCreate = data.canCreate;
        vm.canModify = data.canModify;
        vm.canDelete = data.canDelete;
      });
    }

    function _next() {
      _canceller.resolve();
      _canceller = $q.defer();

      vm.calendar.fullCalendar('next');
    }

    function _prev() {
      _canceller.resolve();
      _canceller = $q.defer();

      vm.calendar.fullCalendar('prev');
    }

    function _changeCalendarView(viewName) {
      vm.calendar.fullCalendar('changeView', viewName);
    }

    function _goToToday() {
      vm.calendar.fullCalendar('today');
    }

    function _filterSpecialty() {
      var view = vm.calendar.fullCalendar('getView');
      vm.uiCalendarConfig.calendar.viewRender(view);
    }

    function _edit() {
      $state.go('app.roster.edit');
    }

    function _debounceFetch(milliseconds, next) {
      _latestDebounce = next;

      if (_debouncing) {
        return;
      }

      _debouncing = true;
      $timeout(function () {
        _debouncing = false;
        _latestDebounce();
      }, milliseconds);
    }

    function _destroy() {
      _canceller.resolve();
    }

    function _invertColor(hex, bw) {
      if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
      }
      // convert 3-digit hex to 6-digits.
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      if (hex.length !== 6) {
        throw new Error('Invalid HEX color.');
      }
      var r = parseInt(hex.slice(0, 2), 16),
        g = parseInt(hex.slice(2, 4), 16),
        b = parseInt(hex.slice(4, 6), 16);
      if (bw) {
        // http://stackoverflow.com/a/3943023/112731
        return (r * 0.299 + g * 0.587 + b * 0.114) > 186 ?
          '#000000' :
          '#FFFFFF';
      }
      // invert color components
      r = (255 - r).toString(16);
      g = (255 - g).toString(16);
      b = (255 - b).toString(16);
      // pad each with zeros and return
      return "#" + _padZero(r) + _padZero(g) + _padZero(b);
    }

    function _padZero(str, len) {
      len = len || 2;
      var zeros = new Array(len).join('0');
      return (zeros + str).slice(-len);
    }
  }
})();

(function() {
	'use strict';
	
	angular
		.module('app.role')
		.controller('RoleController', RoleController);
	
	/** @ngInject */
	function RoleController($scope, $mdMedia, $mdDialog, $rootScope, DTOptionsBuilder, DTColumnBuilder, $document, $timeout, $http, $q, sharedService, $compile, Role, $state) {
		var vm = this;
		
		// Local data
		var canceller = $q.defer();
		var sortBy = {
			colIndex: 0,
			col: null,
			dir: 'asc'
		};
		var sortEl;
		
		// Data
		vm.sharedService = sharedService;

		vm.roles = []; // Initialize empty in case something happens		

		vm.dt = dt;
		
		vm.lengthMenu = [10, 25, 50, 100];
		vm.dtOptions = DTOptionsBuilder.newOptions()
			.withDOM('t')
			.withOption('autoWidth', false)
			.withOption('responsive', true)
			.withScroller()
			.withOption('scrollY', 'auto')
			.withOption('createdRow', sharedService.dtCreatedRow($scope))
			.withOption('drawCallback', function() {
				$timeout(function() {
					vm.loading = false;
					$rootScope.loadingProgress = false;
				});
			});
		vm.dtColumns = [
			DTColumnBuilder.newColumn(null).withTitle('No').renderWith(function(data, type, rows, meta) {
				return meta.row + 1;
			}),
			DTColumnBuilder.newColumn('name').withTitle('Role Name'),
			DTColumnBuilder.newColumn('description').withTitle('Description').renderWith(function(data, type, rows, meta) {
				return data || 'N/A';
			}),
			DTColumnBuilder.newColumn(null).withTitle('Actions').renderWith(function(data, type, rows, meta) {
				var template =
					'<md-button class="md-icon-button" ng-click="vm.edit(' + meta.row + ')">' +
						'<md-icon md-font-icon="icon-pencil" class="s18 green-500-fg"></md-icon>' +
						'<md-tooltip>Edit</md-tooltip>' +
					'</md-button>' +
					'<md-button class="md-icon-button" ng-click="vm.delete(' + meta.row + ')">' +
						'<md-icon md-font-icon="icon-trash" class="s18 red-500-fg"></md-icon>' +
						'<md-tooltip>Delete</md-tooltip>' +
					'</md-button>';
				
				return template;
			})
		];

		vm.mediaXsAddButton = $mdMedia('gt-xs') ? '' : 'md-mini';
		vm.isMediaGtSm = $mdMedia('gt-sm');

		vm.offset = 0;
		vm.offsetFrom = 0;
		vm.recordsPerPage = 25;
		vm.pageRecords = 0;
		vm.recordsTotal = 0;
		
		sharedService.pageIcon = 'icon-account-check';
		sharedService.pageName = 'Roles';

		// Methods
		$scope.$on('$destroy', destroy);
		vm.pagingChanged = pagingChanged;
		vm.search = load;
		vm.swipeLeft = swipeLeft;
		vm.swipeRight = swipeRight;
		vm.prev = prev;
		vm.next = next;
		vm.edit = edit;
		vm.delete = trash;

		//////////

		function dt(i) {
			vm.dt = i;
			
			vm.dt.DataTable.page.len(vm.recordsPerPage).draw();
			vm.dt.DataTable.on('responsive-display', sharedService.dtResponsiveDisplay($scope));
			load();
		}
		
		function load() {
			if (vm.loading) return;

			vm.loading = true;
			$rootScope.loadingProgress = true;

			vm.dt.DataTable.off('order');
			
			$http.get($rootScope.routePath + '/role/get-by-page', {
				params: {
					offset: vm.offset,
					limit: vm.recordsPerPage,
					col: sortBy.col,
					dir: sortBy.dir,
					q: vm.searchTerm
				},
				timeout: canceller.promise
			})
			.then(function(res) {
				res = res.data;

				vm.roles.length = 0;
				vm.dt.DataTable.clear();
				
				var thead = angular.element(vm.dt.DataTable.header());
				thead.find('.sorting_asc, .sorting_desc').attr('class', 'sorting');
				thead.children().children().eq(sortBy.colIndex).attr('class', 'sorting_' + sortBy.dir);
				
				vm.recordsTotal = res.recordsTotal;

				if (res.success) {
					vm.offsetFrom = Math.min(vm.offset + 1, vm.recordsTotal);
					vm.pageRecords = Math.min(vm.offset + vm.recordsPerPage, vm.recordsTotal);

					res.data.forEach(function(role) {
						vm.roles.push(new Role(role));
					});

					vm.dt.DataTable.rows.add(vm.roles).order([sortBy.colIndex, sortBy.dir]).draw();
					vm.dt.DataTable.columns.adjust().draw();
				} else {
					vm.offsetFrom = 0;
					vm.pageRecords = 0;

					vm.dt.DataTable.draw();
					sharedService.showToast(res.message);
				}
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			})
			.finally(function() {
				vm.loading = false;
				$rootScope.loadingProgress = false;

				vm.dt.DataTable.on('order', order);
			});
		}

		function destroy() {
			canceller.resolve();
			vm.dt.DataTable.off('responsive-display');
			vm.dt.DataTable.off('order');
		}

		function order(jsEvent, settings) {
			sortBy.colIndex = settings.aaSorting[0][0];

			var column = settings.aoColumns[sortBy.colIndex].mData;
			var direction = settings.aaSorting[0][1];

			sortBy.col = column || '';
			sortBy.dir = direction;
			load();
		}

		function pagingChanged() {
			vm.dt.DataTable.page.len(vm.recordsPerPage);
			load();
		}

		//////////
		
		// Only swipe on small to medium screens,
		// prevent click, drag and copy data conflict on bigger screens
		function swipeLeft() {
			if (vm.isMediaGtSm) return;
			prev();
		}

		function swipeRight() {
			if (vm.isMediaGtSm) return;
			next();
		}

		//////////

		function prev() {
			if (vm.offset === 0) return;
			vm.offset -= vm.recordsPerPage;
			load();
		}

		function next() {
			if (vm.offset + vm.recordsPerPage >= vm.recordsTotal) return;
			vm.offset += vm.recordsPerPage;
			load();
		}

		function edit(index) {
			var role = vm.roles[index];
			$state.go('app.role.edit', { id: role ? role.id : null });
		}

		function trash(index) {
			var role = vm.roles[index];
			$http.post($rootScope.routePath + '/role/delete-role', role)
			.then(function(res) {
				res = res.data;
				sharedService.showToast(res.message);
				load();
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			});
		}
	}
})();
(function () {
  'use strict';

  angular
    .module('app.permission', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      // Main
      .state('app.permission', {
        url: '/permission',
        views: {
          'content@app': {
            templateUrl: 'app/main/permission/permission2.html',
            controller: 'Permission2Controller',
            controllerAs: 'vm'
          }
        },
        params: {
          page: 0,
          pageLength: 50
        },
        bodyClass: 'permission',
        moduleName: 'Permission'
      });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.permission')
    .controller('Permission2Controller', Permission2Controller);

  /** @ngInject */
  function Permission2Controller($scope, $rootScope, $http, $q, $state, $stateParams, $mdDialog, $mdMedia, sharedService, DtRendererService) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var canceller = $q.defer();
    var isMediaGtSm = $mdMedia('gt-sm');

    // Exposed data
    vm.allPermission = {
      can_view: false,
      can_create: false,
      can_modify: false,
      can_delete: false
    };
    vm.role = null;
    vm.roles = [];
    vm.permissions = [];
    vm.loading = false;
    vm.sharedService = sharedService;

    vm.permissionTable;

    // Exposed methods
    vm.roleChanged = _roleChanged;

    vm.edit = _edit;
    vm.allEdit = _allEdit;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-account-key';
      sharedService.pageName = 'Permissions';

      _initDatatable();
    }

    function _initDatatable() {
      vm.permissionTable = $('#permission-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: $stateParams.pageLength,
        displayStart: $stateParams.page * $stateParams.pageLength,
        order: [
          [0, 'asc', ],
        ],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;

          if (vm.role) {
            data.roleId = vm.role.id;
          }

          $http.post($rootScope.routePath + '/permission/getByPage', data, {
              timeout: canceller.promise
            })
            .then(function (res) {
              res = res.data;

              if (res.success) {
                vm.roles = res.data.roles;
                if (!vm.role) {
                  vm.role = vm.roles[0];
                }
                vm.permissions = res.data.permissions;
                vm.allPermission = res.data.allPermission;

                callback({
                  recordsTotal: res.data.recordsTotal,
                  recordsFiltered: res.data.recordsTotal,
                  data: res.data.permissions,
                });
              } else {
                sharedService.showToast(res.message);
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: [],
                });
              }
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope),
          },
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: DtRendererService.rowRenderer($scope),
        scrollY: 'auto',
        columns: [{
            data: 'acl_module.id',
            title: 'No',
            width: '40px',
            render: function (data, type, row, meta) {
              return meta.row + 1;
            },
          },
          {
            data: 'name',
            title: 'Module'
          },
          {
            data: 'can_view',
            sortable: false,
            title: 'View&nbsp;&nbsp;&nbsp;&nbsp;<md-checkbox ng-model="vm.allPermission.can_view" ng-change="vm.allEdit(\'can_view\')"></md-checkbox>',
            render: function (data, type, row, meta) {
              console.log(vm.permissions[meta.row]);
              return '<md-checkbox ng-model="vm.permissions[' + meta.row + '].can_view" ng-change="vm.edit(' + meta.row + ', \'can_view\')"></md-checkbox>';
            }
          },
          {
            data: 'can_create',
            sortable: false,
            title: 'Create&nbsp;&nbsp;&nbsp;&nbsp;<md-checkbox ng-model="vm.allPermission.can_create" ng-change="vm.allEdit(\'can_create\')"></md-checkbox>',
            render: function (data, type, row, meta) {
              return '<md-checkbox ng-model="vm.permissions[' + meta.row + '].can_create" ng-change="vm.edit(' + meta.row + ', \'can_create\')"></md-checkbox>';
            }
          },
          {
            data: 'can_modify',
            sortable: false,
            title: 'Modify&nbsp;&nbsp;&nbsp;&nbsp;<md-checkbox ng-model="vm.allPermission.can_modify" ng-change="vm.allEdit(\'can_modify\')"></md-checkbox>',
            render: function (data, type, row, meta) {
              return '<md-checkbox ng-model="vm.permissions[' + meta.row + '].can_modify" ng-change="vm.edit(' + meta.row + ', \'can_modify\')"></md-checkbox>';
            }
          },
          {
            data: 'can_delete',
            sortable: false,
            title: 'Delete&nbsp;&nbsp;&nbsp;&nbsp;<md-checkbox ng-model="vm.allPermission.can_delete" ng-change="vm.allEdit(\'can_delete\')"></md-checkbox>',
            render: function (data, type, row, meta) {
              return '<md-checkbox ng-model="vm.permissions[' + meta.row + '].can_delete" ng-change="vm.edit(' + meta.row + ', \'can_delete\')"></md-checkbox>';
            }
          }
        ]
      });
    }

    function _roleChanged() {
      vm.permissionTable.ajax.reload(null, false);
    }

    function _edit(index, actionType) {
      var permission = vm.permissions[index];

      $http.post($rootScope.routePath + '/permission/updatePermission', {
          permissionId: permission['acl_permission.id'],
          roleId: vm.role.id,
          moduleId: permission['acl_module.id'],
          permissionCanView: permission.can_view,
          permissionCanCreate: permission.can_create,
          permissionCanModify: permission.can_modify,
          permissionCanDelete: permission.can_delete
        })
        .then(function (res) {
          res = res.data;

          sharedService.showToast(res.message);

          if (res.success) {
            permission['acl_permission.id'] = res.data.permissionId;

            vm.allPermission = res.data.allPermission;
          } else {
            permission[actionType] = !permission[actionType];
          }
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _allEdit(actionType) {
      var data = {
        roleId: vm.role.id,
        permission: {}
      };

      data.permission[actionType] = vm.allPermission[actionType];

      $http.post($rootScope.routePath + '/permission/updateAll', data)
        .then(function (res) {
          res = res.data;

          sharedService.showToast(res.message);

          if (res.success) {
            vm.permissionTable.ajax.reload(null, false);
          } else {
            vm.allPermission[actionType] = !vm.allPermission[actionType];
          }
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;
      if (vm.permissionTable.page.info().start === 0) return;
      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;
      if (vm.permissionTable.page.info().end === vm.permissionTable.page.info().recordsTotal) return;
      _next();
    }

    function _prev() {
      vm.permissionTable.page('previous');
      vm.permissionTable.ajax.reload(null, false);
    }

    function _next() {
      vm.permissionTable.page('next');
      vm.permissionTable.ajax.reload(null, false);
    }

    function _destroy() {
      canceller.resolve();
    }
  }
})();

(function() {
	'use strict';
	
	angular
		.module('app.permission')
		.controller('PermissionController', PermissionController);
	
	/** @ngInject */
	function PermissionController($scope, $mdMedia, $mdDialog, $rootScope, DTOptionsBuilder, DTColumnBuilder, $document, $timeout, $http, $q, sharedService, $compile, Role, Permission, $state) {
		var vm = this;
		
		// Local data
		var canceller = $q.defer();
		var sortBy = {
			colIndex: 0,
			col: null,
			dir: 'asc'
		};
		var sortEl;
		
		// Data
		vm.sharedService = sharedService;

		vm.role;
		vm.roles = [];
		vm.permissions = []; // Initialize empty in case something happens

		vm.all_view = false;
		vm.all_create = false;
		vm.all_modify = false;
		vm.all_delete = false;

		vm.dt = dt;
		
		vm.lengthMenu = [10, 25, 50, 100];
		vm.dtOptions = DTOptionsBuilder.newOptions()
			.withDOM('t')
			.withOption('autoWidth', false)
			.withOption('responsive', true)
			.withScroller()
			.withOption('scrollY', 'auto')
			.withOption('createdRow', sharedService.dtCreatedRow($scope))
			.withOption('drawCallback', function() {
				$timeout(function() {
					vm.loading = false;
					$rootScope.loadingProgress = false;
				});
			});
		vm.dtColumns = [
			DTColumnBuilder.newColumn(null).withTitle('No').renderWith(function(data, type, rows, meta) {
				return meta.row + 1;
			}),
			DTColumnBuilder.newColumn('module_name').withTitle('Module'),
			DTColumnBuilder.newColumn('can_view').withTitle('View').renderWith(function(data, type, rows, meta) {
				var template =
					'<md-checkbox ng-model="vm.permissions[' + meta.row + '].can_view" ng-change="vm.edit(' + meta.row + ')"></md-checkbox>';
					
				return template;
			}),
			DTColumnBuilder.newColumn('can_create').withTitle('Create').renderWith(function(data, type, rows, meta) {
				var template =
					'<md-checkbox ng-model="vm.permissions[' + meta.row + '].can_create" ng-change="vm.edit(' + meta.row + ')"></md-checkbox>';

				return template;
			}),
			DTColumnBuilder.newColumn('can_modify').withTitle('Modify').renderWith(function(data, type, rows, meta) {
				var template =
					'<md-checkbox ng-model="vm.permissions[' + meta.row + '].can_modify" ng-change="vm.edit(' + meta.row + ')"></md-checkbox>';

				return template;
			}),
			DTColumnBuilder.newColumn('can_delete').withTitle('Delete').renderWith(function(data, type, rows, meta) {
				var template =
					'<md-checkbox ng-model="vm.permissions[' + meta.row + '].can_delete" ng-change="vm.edit(' + meta.row + ')"></md-checkbox>';

				return template;
			})
		];

		vm.mediaXsAddButton = $mdMedia('gt-xs') ? '' : 'md-mini';
		vm.isMediaGtSm = $mdMedia('gt-sm');

		vm.offset = 0;
		vm.offsetFrom = 0;
		vm.recordsPerPage = 25;
		vm.pageRecords = 0;
		vm.recordsTotal = 0;
		
		sharedService.pageIcon = 'icon-account-key';
		sharedService.pageName = 'Permissions';

		// Methods
		vm.$onInit = init;
		$scope.$on('$destroy', destroy);
		vm.pagingChanged = pagingChanged;
		vm.search = load;
		vm.swipeLeft = swipeLeft;
		vm.swipeRight = swipeRight;
		vm.prev = prev;
		vm.next = next;
		vm.edit = edit;
		vm.roleChanged = load;

		vm.allView = allView;
		vm.allCreate = allCreate;
		vm.allModify = allModify;
		vm.allDelete = allDelete;

		//////////

		function dt(i) {
			vm.dt = i;
			
			vm.dt.DataTable.page.len(vm.recordsPerPage).draw();
			vm.dt.DataTable.on('responsive-display', sharedService.dtResponsiveDisplay($scope));
			$scope.$on('role-ready', load);
		}

		function init() {
			$http.get($rootScope.routePath + '/role/get-all')
			.then(function(res) {
				res = res.data;
				if (!res.success) return $q.reject(res.message);
				
				res.data.forEach(function(role) {
					vm.roles.push(new Role(role));
				});

				vm.role = vm.roles[0];

				$scope.$emit('role-ready');
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			});
		}
		
		function load() {
			if (vm.loading) return;

			vm.loading = true;
			$rootScope.loadingProgress = true;

			vm.dt.DataTable.off('order');

			vm.all_view = true;
			vm.all_create = true;
			vm.all_modify = true;
			vm.all_delete = true;

			$http.get($rootScope.routePath + '/permission/get-by-page', {
				params: {
					roleId: vm.role.id,
					offset: vm.offset,
					limit: vm.recordsPerPage,
					col: sortBy.col,
					dir: sortBy.dir,
					q: vm.searchTerm
				},
				timeout: canceller.promise
			})
			.then(function(res) {
				res = res.data;

				vm.permissions.length = 0;
				vm.dt.DataTable.clear();
				
				var thead = angular.element(vm.dt.DataTable.header());
				thead.find('.sorting_asc, .sorting_desc').attr('class', 'sorting');
				thead.children().children().eq(sortBy.colIndex).attr('class', 'sorting_' + sortBy.dir);
				
				vm.recordsTotal = res.recordsTotal;

				if (res.success) {
					vm.offsetFrom = Math.min(vm.offset + 1, vm.recordsTotal);
					vm.pageRecords = Math.min(vm.offset + vm.recordsPerPage, vm.recordsTotal);

					res.data.forEach(function(permission) {
						var p = new Permission(permission);
						vm.all_view = vm.all_view && p.can_view;
						vm.all_create = vm.all_create && p.can_create;
						vm.all_modify = vm.all_modify && p.can_modify;
						vm.all_delete = vm.all_delete && p.can_delete;
						vm.permissions.push(p);
					});

					vm.dt.DataTable.rows.add(vm.permissions).order([sortBy.colIndex, sortBy.dir]).draw();
					vm.dt.DataTable.columns.adjust().draw();
				} else {
					vm.offsetFrom = 0;
					vm.pageRecords = 0;

					vm.dt.DataTable.draw();
					sharedService.showToast(res.message);
				}
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			})
			.finally(function() {
				vm.loading = false;
				$rootScope.loadingProgress = false;

				vm.dt.DataTable.on('order', order);
			});
		}

		function destroy() {
			canceller.resolve();
			vm.dt.DataTable.off('responsive-display');
			vm.dt.DataTable.off('order');
		}

		function order(jsEvent, settings) {
			sortBy.colIndex = settings.aaSorting[0][0];

			var column = settings.aoColumns[sortBy.colIndex].mData;
			var direction = settings.aaSorting[0][1];

			sortBy.col = column || '';
			sortBy.dir = direction;
			load();
		}

		function pagingChanged() {
			vm.dt.DataTable.page.len(vm.recordsPerPage);
			load();
		}

		//////////
		
		// Only swipe on small to medium screens,
		// prevent click, drag and copy data conflict on bigger screens
		function swipeLeft() {
			if (vm.isMediaGtSm) return;
			prev();
		}

		function swipeRight() {
			if (vm.isMediaGtSm) return;
			next();
		}

		//////////

		function prev() {
			if (vm.offset === 0) return;
			vm.offset -= vm.recordsPerPage;
			load();
		}

		function next() {
			if (vm.offset + vm.recordsPerPage >= vm.recordsTotal) return;
			vm.offset += vm.recordsPerPage;
			load();
		}

		function edit(index) {
			var permission = angular.copy(vm.permissions[index]);
			delete permission.module_name;
			$http.post($rootScope.routePath + '/permission/update-permission', permission)
			.then(function(res) {
				res = res.data;
				sharedService.showToast(res.message);
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			})
			.finally(reloadCheckbox);
		}

		function allView() {
			$http.post($rootScope.routePath + '/permission/update-all', {
				roleId: vm.role.id,
				prop: 'can_view',
				val: vm.all_view
			})
			.then(function(res) {
				res = res.data;
				sharedService.showToast(res.message);
				load();
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			});
		}

		function allCreate() {
			$http.post($rootScope.routePath + '/permission/update-all', {
				roleId: vm.role.id,
				prop: 'can_create',
				val: vm.all_create
			})
			.then(function(res) {
				res = res.data;
				sharedService.showToast(res.message);
				load();
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			});
		}

		function allModify() {
			$http.post($rootScope.routePath + '/permission/update-all', {
				roleId: vm.role.id,
				prop: 'can_modify',
				val: vm.all_modify
			})
			.then(function(res) {
				res = res.data;
				sharedService.showToast(res.message);
				load();
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			});
		}

		function allDelete() {
			$http.post($rootScope.routePath + '/permission/update-all', {
				roleId: vm.role.id,
				prop: 'can_delete',
				val: vm.all_delete
			})
			.then(function(res) {
				res = res.data;
				sharedService.showToast(res.message);
				load();
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			});
		}

		function reloadCheckbox() {
			vm.all_view = true;
			vm.all_create = true;
			vm.all_modify = true;
			vm.all_delete = true;
			
			vm.permissions.forEach(function(p) {
				vm.all_view = vm.all_view && p.can_view;
				vm.all_create = vm.all_create && p.can_create;
				vm.all_modify = vm.all_modify && p.can_modify;
				vm.all_delete = vm.all_delete && p.can_delete;
			});
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('app.module', ['datatables', 'datatables.scroller'])
		.config(config);

	/** @ngInject */
	function config($stateProvider) {
		$stateProvider
		.state('app.module', {
			url: '/module',
			views: {
				'content@app': {
					templateUrl: 'app/main/module/module.html',
					controller: 'ModuleController as vm'
				}
			},
			bodyClass: 'module',
			moduleName: 'Module'
		});
	}
})();
(function() {
	'use strict';
	
	angular
		.module('app.module')
		.controller('ModuleController', ModuleController);
	
	/** @ngInject */
	function ModuleController($scope, $mdMedia, $mdDialog, $rootScope, DTOptionsBuilder, DTColumnBuilder, $document, $timeout, $http, $q, sharedService, accountService, $compile, Role, Module, $state) {
		var vm = this;
		
		// Local data
		var canceller = $q.defer();
		var sortBy = {
			colIndex: 0,
			col: null,
			dir: 'asc'
		};
		var sortEl;
		
		var prevSel;
		
		// Data
		vm.sharedService = sharedService;

		vm.modules = []; // Initialize empty in case something happens

		vm.dt = dt;
		
		vm.lengthMenu = [10, 25, 50, 100];
		vm.dtOptions = DTOptionsBuilder.newOptions()
			.withDOM('t')
			.withOption('autoWidth', false)
			.withOption('responsive', true)
			.withScroller()
			.withOption('scrollY', 'auto')
			.withOption('createdRow', sharedService.dtCreatedRow($scope))
			.withOption('drawCallback', function() {
				$timeout(function() {
					vm.loading = false;
					$rootScope.loadingProgress = false;
				});
			});
		vm.dtColumns = [
			DTColumnBuilder.newColumn(null).withTitle('No').renderWith(function(data, type, rows, meta) {
				return meta.row + 1;
			}),
			DTColumnBuilder.newColumn('name').withTitle('Module'),
			DTColumnBuilder.newColumn('is_active').withTitle('Is Active').renderWith(function(data, type, rows, meta) {
				var template =
					'<md-checkbox ng-model="vm.modules[' + meta.row + '].is_active" ng-change="vm.toggleActive(' + meta.row + ')"></md-checkbox>';

				return vm.modules[meta.row].name === 'Module' ? 'N/A' : template;
			}),
			DTColumnBuilder.newColumn('display_order').withTitle('Display Order').renderWith(function(data, type, rows, meta) {
				var template =
					'<span ng-hide="vm.modules[' + meta.row + '].edit">' + data + '</span>' +
					'<md-input-container class="md-block" md-no-float ng-show="vm.modules[' + meta.row + '].edit">' +
						'<input type="number" ng-model="vm.modules[' + meta.row + '].display_order" placeholder="Order">'
					'</md-input-container>';
				
				return template;
			}),
			DTColumnBuilder.newColumn(null).withTitle('Actions').renderWith(function(data, type, rows, meta) {
				var template =
					'<md-button class="md-icon-button" ng-click="vm.edit(' + meta.row + ')" ng-hide="vm.modules[' + meta.row + '].edit">' +
						'<md-icon md-font-icon="icon-pencil" class="s18 green-500-fg"></md-icon>' +
						'<md-tooltip>Edit</md-tooltip>' +
					'</md-button>' +
					'<md-button class="md-icon-button" ng-click="vm.save(' + meta.row + ')" ng-show="vm.modules[' + meta.row + '].edit">' +
						'<md-icon md-font-icon="icon-content-save" class="s18 green-500-fg"></md-icon>' +
						'<md-tooltip>Save</md-tooltip>' +
					'</md-button>' +
					'<md-button class="md-icon-button" ng-click="vm.cancel(' + meta.row + ')" ng-show="vm.modules[' + meta.row + '].edit">' +
						'<md-icon md-font-icon="icon-close" class="s18 red-500-fg"></md-icon>' +
						'<md-tooltip>Cancel</md-tooltip>' +
					'</md-button>';
				
				return template;
			})
		];

		vm.mediaXsAddButton = $mdMedia('gt-xs') ? '' : 'md-mini';
		vm.isMediaGtSm = $mdMedia('gt-sm');

		vm.offset = 0;
		vm.offsetFrom = 0;
		vm.recordsPerPage = 25;
		vm.pageRecords = 0;
		vm.recordsTotal = 0;
		
		sharedService.pageIcon = 'icon-view-module';
		sharedService.pageName = 'Modules';

		// Methods
		$scope.$on('$destroy', destroy);
		vm.pagingChanged = pagingChanged;
		vm.search = load;
		vm.swipeLeft = swipeLeft;
		vm.swipeRight = swipeRight;
		vm.prev = prev;
		vm.next = next;
		vm.edit = edit;
		vm.save = save;
		vm.cancel = cancel;
		vm.toggleActive = toggleActive;

		//////////

		function dt(i) {
			vm.dt = i;
			
			vm.dt.DataTable.page.len(vm.recordsPerPage).draw();
			vm.dt.DataTable.on('responsive-display', sharedService.dtResponsiveDisplay($scope));
			load();
		}
		
		function load() {
			if (vm.loading) return;

			vm.loading = true;
			$rootScope.loadingProgress = true;

			vm.dt.DataTable.off('order');
			
			$http.get($rootScope.routePath + '/module/get-by-page', {
				params: {
					offset: vm.offset,
					limit: vm.recordsPerPage,
					col: sortBy.col,
					dir: sortBy.dir,
					q: vm.searchTerm
				},
				timeout: canceller.promise
			})
			.then(function(res) {
				res = res.data;

				vm.modules.length = 0;
				vm.dt.DataTable.clear();
				
				var thead = angular.element(vm.dt.DataTable.header());
				thead.find('.sorting_asc, .sorting_desc').attr('class', 'sorting');
				thead.children().children().eq(sortBy.colIndex).attr('class', 'sorting_' + sortBy.dir);
				
				vm.recordsTotal = res.recordsTotal;

				if (res.success) {
					vm.offsetFrom = Math.min(vm.offset + 1, vm.recordsTotal);
					vm.pageRecords = Math.min(vm.offset + vm.recordsPerPage, vm.recordsTotal);

					res.data.forEach(function(mod) {
						var m = new Module(mod);
						m.edit = false;
						vm.modules.push(m);
					});

					vm.dt.DataTable.rows.add(vm.modules).order([sortBy.colIndex, sortBy.dir]).draw();
					vm.dt.DataTable.columns.adjust().draw();
				} else {
					vm.offsetFrom = 0;
					vm.pageRecords = 0;

					vm.dt.DataTable.draw();
					sharedService.showToast(res.message);
				}
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			})
			.finally(function() {
				vm.loading = false;
				$rootScope.loadingProgress = false;

				vm.dt.DataTable.on('order', order);
			});
		}

		function destroy() {
			canceller.resolve();
			vm.dt.DataTable.off('responsive-display');
			vm.dt.DataTable.off('order');
		}

		function order(jsEvent, settings) {
			sortBy.colIndex = settings.aaSorting[0][0];

			var column = settings.aoColumns[sortBy.colIndex].mData;
			var direction = settings.aaSorting[0][1];

			sortBy.col = column || '';
			sortBy.dir = direction;
			load();
		}

		function pagingChanged() {
			vm.dt.DataTable.page.len(vm.recordsPerPage);
			load();
		}

		//////////
		
		// Only swipe on small to medium screens,
		// prevent click, drag and copy data conflict on bigger screens
		function swipeLeft() {
			if (vm.isMediaGtSm) return;
			prev();
		}

		function swipeRight() {
			if (vm.isMediaGtSm) return;
			next();
		}

		//////////

		function prev() {
			if (vm.offset === 0) return;
			vm.offset -= vm.recordsPerPage;
			load();
		}

		function next() {
			if (vm.offset + vm.recordsPerPage >= vm.recordsTotal) return;
			vm.offset += vm.recordsPerPage;
			load();
		}

		function toggleActive(index) {
			var mod = angular.copy(vm.modules[index]);
			delete mod.edit;

			$http.post($rootScope.routePath + '/module/update-module', mod)
			.then(function(res) {
				res = res.data;
				if (res.success) accountService.loadSidenav();
				sharedService.showToast(res.message);
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			});
		}

		function edit(index) {
			var mod = vm.modules[index];
			mod.edit = !mod.edit;
			if (prevSel && prevSel !== mod) prevSel.edit = false;
			prevSel = mod;
		}

		function save(index) {
			var mod = angular.copy(vm.modules[index]);
			delete mod.edit;
			
			$http.post($rootScope.routePath + '/module/update-module', mod)
			.then(function(res) {
				res = res.data;
				if (res.success) accountService.loadSidenav();
				sharedService.showToast(res.message);
				load();
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			});
		}

		function cancel(index) {
			vm.modules[index].edit = false;
		}
	}
})();
(function () {
  'use strict';

  angular
    .module('app.income', ['datatables', 'datatables.scroller'])
    .config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider
      // Main
      .state('app.income', {
        url: '/income',
        views: {
          'content@app': {
            templateUrl: 'app/main/income/income.html',
            controller: 'IncomeController as vm'
          }
        },
        bodyClass: 'income',
        moduleName: 'Income'
      });
  }
})();

(function () {
  'use strict';

  angular.module('app.income').controller('IncomeController', IncomeController);

  /** @ngInject */
  function IncomeController(
    $scope,
    $window,
    $rootScope,
    $http,
    $state,
    $stateParams,
    $timeout,
    $mdDialog,
    $mdMedia,
    $document,
    $cookies,
    accountService,
    sharedService,
    DtRendererService
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;

    // Local data
    var _incomes = [];
    var incomeYear = [];
    var incomeMonth = [];
    var incomeDetail = [];
    var isMediaGtSm = $mdMedia('gt-sm');
    // [2025-07-21 @ Dino] Provide a flag for toggling between new and old query,
    // no point get this flag on button click, because page is cached and a reload is required anyway
    var legacyIncome = $cookies.getObject('legacy_income') || false;

    // Exposed data
    vm.loading = false;
    vm.sharedService = sharedService;

    vm.incomeYearTable;
    vm.incomeMonthTable;
    vm.incomeDetailTable;
    vm.incomeCategoryTable;
    vm.incomeCnDnYearMonthTable;
    vm.incomeCnDnEpisodeTable;
    vm.viewName = 'year';
    vm.yearFilters = [];
    vm.yearFilter;
    vm.consultantName = accountService.user.username;
    vm.billerRemarks = [];

    // Exposed methods
    vm.search = _search;

    vm.view = _view;
    vm.back = _back;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    vm.exportGetIncomes = _exportGetIncomes;
    vm.exportGetIncomesByEpisodeNo = _exportGetIncomesByEpisodeNo;
    vm.exportGetIncomeDetails = _exportGetIncomeDetails;
    vm.exportGetIncomesByCategory = _exportGetIncomesByCategory;
    vm.showDialog = _showDialog;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-cash-usd';
      sharedService.pageName = 'Income';

      _getIncomeYears();

      _initIncomeYearDatatable();
      _initIncomeMonthDatatable();
      _initIncomeDetailDatatable();
      _initIncomeCategoryDatatable();
      _initIncomeCnDnYearMonthDatatable();
      _initIncomeCnDnEpisodeDatatable();
    }

    function _getIncomeYears() {
      $http
        .get($rootScope.routePath + '/income/getIncomeYears')
        .then(function (res) {
          return res.data;
        })
        .then(function (res) {
          if (!res.success) {
            return sharedService.showToast(res.message);
          }

          vm.yearFilters = res.data;
          vm.yearFilter = vm.yearFilters[0];
        })
        .catch(function (err) {
          sharedService.showToast(err.message);
        });
    }

    function _initIncomeYearDatatable() {
      vm.incomeYearTable = $('#income-year-dt').DataTable({
        // dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        dom: 'rt',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: 100,
        displayStart: 0,
        search: {
          search: '' // Initial search term actually here
        },
        order: [
          [0, 'asc'],
          [2, 'asc']
        ],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;

          data.dr_code = accountService.user.username;
          data.yearFilter = vm.yearFilter;

          data.columns[0].data = 'monthn';

          data.legacyIncome = legacyIncome;

          $http
            .post($rootScope.routePath + '/income/getIncomes', data)
            .then(function (res) {
              return res.data;
            })
            .then(function (res) {
              if (!res.success) {
                throw new Error(res.message);
              }

              incomeYear = res.data.incomes;

              callback({
                recordsTotal: res.data.recordsTotal,
                recordsFiltered: res.data.recordsTotal,
                data: res.data.incomes
              });
            })
            .catch(function (err) {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;

              _redraw();
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope)
          }
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: function (row, data, dataIndex) {
          DtRendererService.rowRenderer($scope)(row, data, dataIndex);
        },
        scrollY: 'auto',
        columns: [
          {
            data: 'month',
            title: 'Month',
            defaultContent: '-',
            render: _boldText
          },
          {
            data: null,
            title: 'Total No of Bill',
            defaultContent: '-',
            sortable: false,
            render: function (data, type, row, meta) {
              return row.total_bill_count;
            }
          },
          {
            data: 'patient_type_desc',
            title: 'Patient Type',
            defaultContent: '-',
            render: function (data, type, row, meta) {
              var template = '';
              for (var i = 0; i < row.data.length; ++i) {
                if (i > 0) {
                  template += '<br>';
                }
                template += row.data[i].patient_type_desc;
              }
              return template;
            }
          },
          {
            data: 'total_bill_size',
            title: 'Total Generated Bills',
            defaultContent: '-',
            className: 'dt-head-right dt-body-right',
            render: function (data, type, row, meta) {
              var template = '';
              for (var i = 0; i < row.data.length; ++i) {
                if (i > 0) {
                  template += '<br>';
                }
                // template += (+row.data[i].paid_amt + +row.data[i].contract_balance).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') + '&nbsp;(' + (+row.data[i].paid_count + +row.data[i].outstanding_count) + ')';
                // template += (+row.data[i].total_bill_size).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') + '&nbsp;(' + row.data[i].ep_count + ')';
                template +=
                  (+row.data[i].total_bill_size).toFixed(2) +
                  '&nbsp;(' +
                  row.data[i].ep_count +
                  ')';
              }
              return template;
            }
          },
          {
            data: 'outs_bill_size',
            title: 'Total Outstanding Bills',
            defaultContent: '-',
            className: 'dt-head-right dt-body-right',
            render: function (data, type, row, meta) {
              var template = '';
              for (var i = 0; i < row.data.length; ++i) {
                if (i > 0) {
                  template += '<br>';
                }
                // template += (+row.data[i].outs_bill_size).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') + '&nbsp;(' + row.data[i].outstanding_count + ')';
                template +=
                  (+row.data[i].outs_bill_size).toFixed(2) +
                  '&nbsp;(' +
                  row.data[i].outstanding_count +
                  ')';
              }
              return template;
            }
          },
          {
            data: 'outs_dr_amt',
            title: 'Outstanding Income',
            defaultContent: '-',
            className: 'dt-head-right dt-body-right',
            render: function (data, type, row, meta) {
              var template = '';
              for (var i = 0; i < row.data.length; ++i) {
                if (i > 0) {
                  template += '<br>';
                }
                // template += (+row.data[i].outs_dr_amt).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',') + '&nbsp;(' + row.data[i].outstanding_count + ')';
                template +=
                  (+row.data[i].outs_dr_amt).toFixed(2) +
                  '&nbsp;(' +
                  row.data[i].outstanding_count +
                  ')';
              }
              return template;
            }
          },
          {
            data: 'gross_income',
            title: 'Gross Income',
            defaultContent: '-',
            sortable: false,
            className: 'dt-head-right dt-body-right',
            render: function (data, type, row, meta) {
              // return (+data).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
              return (+data).toFixed(2);
            }
          },
          {
            data: 'has_dn_cn',
            title: 'CN/DN',
            defaultContent: '-',
            sortable: false,
            render: function (data, type, row, meta) {
              var template = '<div class="cn-dn-group"><div>';
              for (var i = 0; i < row.data.length; ++i) {
                template +=
                  '<div>' +
                  row.data[i].dn_cn_amt.toFixed(2) +
                  ' (' +
                  row.data[i].dn_cn_count +
                  ')</div>';
              }
              template += '</div>';

              template += data
                ? '<md-button class="md-icon-button" ng-click="vm.view(\'cn_dn_year_month\', ' +
                  meta.row +
                  ')">' +
                  '<md-icon md-font-icon="icon-receipt" class="s18 teal-500-fg"></md-icon>' +
                  '<md-tooltip>Show CN/DN</md-tooltip>' +
                  '</md-button>'
                : '';

              template += '</div>';

              return template;
            }
          },
          {
            data: null,
            title: 'Actions',
            sortable: false,
            render: function (data, type, row, meta) {
              var template = '';

              template +=
                '<md-button class="md-icon-button" ng-click="vm.view(\'month\', ' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-file-document" class="s18 blue-500-fg"></md-icon>' +
                '<md-tooltip>Billing Details</md-tooltip>' +
                '</md-button>';

              template +=
                '<md-button class="md-icon-button" ng-click="vm.view(\'category\', ' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-chart-line" class="s18 purple-500-fg"></md-icon>' +
                '<md-tooltip>Summary</md-tooltip>' +
                '</md-button>';

              return template;
            }
          }
        ]
      });
    }

    function _initIncomeMonthDatatable() {
      vm.incomeMonthTable = $('#income-month-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: 100,
        displayStart: 0,
        search: {
          search: '' // Initial search term actually here
        },
        order: [[5, 'desc']],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          if (vm.viewName !== 'month') {
            return callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
          }

          vm.loading = true;
          $rootScope.loadingProgress = true;

          data.dr_code = accountService.user.username;
          data.yearFilter = vm.yearFilter;
          data.monthFilter = vm.selectedRecord.month;

          data.legacyIncome = legacyIncome;

          $http
            .post($rootScope.routePath + '/income/getIncomesByEpisodeNo', data)
            .then(function (res) {
              return res.data;
            })
            .then(function (res) {
              if (!res.success) {
                throw new Error(res.message);
              }

              incomeMonth = res.data.incomes;

              // vm.totalBillSize = (+res.data.total_bill_size).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
              vm.totalBillSize = (+res.data.total_bill_size).toFixed(2);
              // vm.totalGrossIncome = (+res.data.total_gross_income).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
              vm.totalGrossIncome = (+res.data.total_gross_income).toFixed(2);

              callback({
                recordsTotal: res.data.recordsTotal,
                recordsFiltered: res.data.recordsTotal,
                data: res.data.incomes
              });
            })
            .catch(function (err) {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;

              _redraw();
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope)
          }
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: function (row, data, dataIndex) {
          DtRendererService.rowRenderer($scope)(row, data, dataIndex);

          if (
            data.payment_status === 'UNPAID' ||
            data.payment_status === 'PARTIALLY PAID'
          ) {
            angular.element(row).addClass('red-100-bg');
          }
          // else if (data.remarks) {
          //   angular.element(row).addClass('purple-100-bg');
          // }
        },
        scrollY: 'auto',
        columns: [
          {
            data: 'id',
            title: 'No',
            width: '40px',
            render: function (data, type, row, meta) {
              var info = vm.incomeMonthTable.page.info();
              return info.page * info.length + (meta.row + 1);
            }
          },
          {
            data: 'patient_name',
            title: 'Patient Name',
            defaultContent: '-',
            render: _boldText
          },
          {
            data: 'patient_no',
            title: 'Patient No',
            defaultContent: '-',
            render: _boldText
          },
          {
            data: 'episode_no',
            title: 'Episode No',
            defaultContent: '-',
            render: _boldText
          },
          {
            data: 'patient_type_desc',
            title: 'Patient Type',
            defaultContent: '-'
          },
          {
            data: 'admission_datetime',
            title: 'Admission Datetime',
            defaultContent: '-',
            render: function (data, type, row, meta) {
              return moment(data).format('YYYY-MM-DD<br>HH:mm:ss');
            }
          },
          {
            data: 'discharge_datetime',
            title: 'Discharge Datetime',
            defaultContent: '-',
            render: function (data, type, row, meta) {
              return moment(data).format('YYYY-MM-DD<br>HH:mm:ss');
            }
          },
          {
            data: 'latest_bill_size',
            title: 'Bill Size',
            defaultContent: '-',
            render: function (data, type, row, meta) {
              // return (+data).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
              return (+data).toFixed(2);
            }
          },
          {
            data: 'dr_amt',
            title: 'Gross Income',
            defaultContent: '-',
            className: 'dt-head-right dt-body-right',
            render: function (data, type, row, meta) {
              // return (+data).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
              return (+data).toFixed(2);
            }
          },
          {
            data: 'has_dn_cn',
            title: 'CN/DN',
            defaultContent: '-',
            sortable: false,
            render: function (data, type, row, meta) {
              return data
                ? '<div class="cn-dn-group">' +
                    '<div>' +
                    row.dn_cn_amt.toFixed(2) +
                    '</div>' +
                    '<md-button class="md-icon-button" ng-click="vm.view(\'cn_dn_episode\', ' +
                    meta.row +
                    ')">' +
                    '<md-icon md-font-icon="icon-receipt" class="s18 teal-500-fg"></md-icon>' +
                    '<md-tooltip>Show CN/DN</md-tooltip>' +
                    '</md-button>' +
                    '</div>'
                : '-';
            }
          },
          {
            data: 'payment_status',
            title: 'Payment Status',
            defaultContent: '-'
          },
          {
            data: 'organisation_type',
            title: 'Debtor Type',
            defaultContent: '-',
            render: function (data, type, row, meta) {
              if (!data) {
                return '-';
              }

              var arr = data.split(',');

              for (var i = 0; i < arr.length; ++i) {
                if (arr[i] === 'BNK') {
                  arr[i] = 'BANK';
                } else if (arr[i] === 'INS') {
                  arr[i] = 'INSURANCE';
                } else if (arr[i] === 'MCO') {
                  arr[i] = 'MANAGE CARE ORGANISATION';
                } else if (arr[i] === 'CC') {
                  arr[i] = 'CORPORATE COMPANY';
                } else if (arr[i] === 'CONS') {
                  arr[i] = 'CONSULTANT';
                } else if (arr[i] === 'GOV') {
                  arr[i] = 'GOVERNMENT AGENCY';
                } else if (arr[i] === 'IND') {
                  arr[i] = 'INDIVIDUAL';
                } else if (arr[i] === 'INTERCO') {
                  arr[i] = 'INTER-CO';
                } else if (arr[i] === 'UMSCSTF') {
                  arr[i] = 'UMSC STAFF';
                } else if (arr[i] === 'PLC') {
                  arr[i] = 'PUBLIC LISTED COMPANY';
                }
              }

              return arr.join(', ');
            }
            // }, {
            //   data: 'remarks',
            //   title: 'Remarks',
            //   defaultContent: '-'
          },
          {
            data: null,
            title: 'Actions',
            sortable: false,
            render: function (data, type, row, meta) {
              var template = '';

              template +=
                '<md-button class="md-icon-button" ng-click="vm.view(\'detail\', ' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-format-list-bulleted" class="s18 indigo-500-fg"></md-icon>' +
                '<md-tooltip>View Billing Group Codes</md-tooltip>' +
                '</md-button>';

              if (row.remarks) {
                template +=
                  '<md-button class="md-icon-button" ng-click="vm.view(\'todo\', ' +
                  meta.row +
                  ')">' +
                  '<md-icon md-font-icon="icon-checkbox-marked" class="s18 green-500-fg"></md-icon>' +
                  '<md-tooltip>View Biller Remarks</md-tooltip>' +
                  '</md-button>';
              }

              return template;
            }
          }
        ]
      });
    }

    function _initIncomeDetailDatatable() {
      vm.incomeDetailTable = $('#income-detail-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: 100,
        displayStart: 0,
        search: {
          search: '' // Initial search term actually here
        },
        order: [[0, 'asc']],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          if (vm.viewName !== 'detail') {
            return callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
          }

          vm.loading = true;
          $rootScope.loadingProgress = true;

          console.log(vm.selectedRecord);

          data.dr_code = accountService.user.username;
          data.episode_no = vm.selectedRecord.episode_no;

          data.legacyIncome = legacyIncome;

          $http
            .post($rootScope.routePath + '/income/getIncomeDetails', data)
            .then(function (res) {
              return res.data;
            })
            .then(function (res) {
              if (!res.success) {
                throw new Error(res.message);
              }

              vm.incomeDetail = res.data.incomes[0];
              vm.incomeDetail.admission_datetime_display = moment(
                vm.incomeDetail.admission_datetime
              ).format('YYYY-MM-DD HH:mm:ss');
              vm.incomeDetail.discharge_datetime_display = moment(
                vm.incomeDetail.discharge_datetime
              ).format('YYYY-MM-DD HH:mm:ss');
              vm.incomeDetail.eporg_dr_amt = 0;
              angular.forEach(res.data.incomes, function (inc) {
                vm.incomeDetail.eporg_dr_amt += +inc.dr_amt;
              });
              // vm.incomeDetail.eporg_dr_amt = vm.incomeDetail.eporg_dr_amt.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
              vm.incomeDetail.eporg_dr_amt =
                vm.incomeDetail.eporg_dr_amt.toFixed(2);
              // vm.incomeDetail.bill_size = (+vm.incomeDetail.bill_size).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
              vm.incomeDetail.bill_size = (+vm.incomeDetail.bill_size).toFixed(
                2
              );

              callback({
                recordsTotal: res.data.recordsTotal,
                recordsFiltered: res.data.recordsTotal,
                data: res.data.incomes
              });
            })
            .catch(function (err) {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;

              _redraw();
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope)
          }
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: function (row, data, dataIndex) {
          DtRendererService.rowRenderer($scope)(row, data, dataIndex);
        },
        scrollY: 'auto',
        columns: [
          {
            data: 'id',
            title: 'No',
            width: '40px',
            render: function (data, type, row, meta) {
              var info = vm.incomeDetailTable.page.info();
              return info.page * info.length + (meta.row + 1);
            }
          },
          {
            data: 'category_description',
            title: 'Billing Group Code',
            defaultContent: '-'
          },
          {
            data: 'txncode',
            title: 'Charge Code',
            defaultContent: '-'
          },
          {
            data: 'txncode_desc',
            title: 'Charge Code Description',
            defaultContent: '-'
          },
          {
            data: 'dr_amt',
            title: 'Gross Income',
            defaultContent: '-',
            className: 'dt-head-right dt-body-right',
            render: function (data, type, row, meta) {
              // return (+data).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
              return (+data).toFixed(2);
            }
          }
        ]
      });
    }

    function _initIncomeCategoryDatatable() {
      vm.incomeCategoryTable = $('#income-category-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: 100,
        displayStart: 0,
        search: {
          search: '' // Initial search term actually here
        },
        order: [
          [0, 'asc'],
          [1, 'asc']
        ],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          if (vm.viewName !== 'category') {
            return callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
          }

          vm.loading = true;
          $rootScope.loadingProgress = true;

          data.dr_code = accountService.user.username;
          data.yearFilter = vm.yearFilter;
          data.monthFilter = vm.selectedRecord.month;

          data.legacyIncome = legacyIncome;

          $http
            .post($rootScope.routePath + '/income/getIncomesByCategory', data)
            .then(function (res) {
              return res.data;
            })
            .then(function (res) {
              if (!res.success) {
                throw new Error(res.message);
              }

              // vm.totalBillSize = (+res.data.total_bill_size).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
              vm.totalBillSize = (+res.data.total_bill_size).toFixed(2);
              // vm.totalGrossIncome = (+res.data.total_gross_income).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
              vm.totalGrossIncome = (+res.data.total_gross_income).toFixed(2);

              callback({
                recordsTotal: res.data.recordsTotal,
                recordsFiltered: res.data.recordsTotal,
                data: res.data.incomes
              });
            })
            .catch(function (err) {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;

              _redraw();
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope)
          }
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: function (row, data, dataIndex) {
          DtRendererService.rowRenderer($scope)(row, data, dataIndex);
        },
        scrollY: 'auto',
        columns: [
          {
            data: 'patient_type_desc',
            title: 'Patient Type',
            defaultContent: '-'
          },
          {
            data: 'category_description',
            title: 'Billing Group Code',
            render: function (data, type, row, meta) {
              var template = '';
              for (var i = 0; i < row.data.length; ++i) {
                if (i > 0) {
                  template += '<br>';
                }
                template += row.data[i].category_description;
              }
              return template;
            }
          },
          {
            data: 'gross_income',
            title: 'Gross Income',
            defaultContent: '-',
            className: 'dt-head-right dt-body-right',
            render: function (data, type, row, meta) {
              var template = '';
              for (var i = 0; i < row.data.length; ++i) {
                if (i > 0) {
                  template += '<br>';
                }
                // template += (+row.data[i].dr_amt).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
                template += (+row.data[i].dr_amt).toFixed(2);
              }
              return template;
            }
          },
          {
            data: null,
            title: 'Subtotal',
            defaultContent: '-',
            sortable: false,
            className: 'dt-head-right dt-body-right',
            render: function (data, type, row, meta) {
              // return (+row.subtotal).toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
              return (+row.subtotal).toFixed(2);
            }
          }
        ]
      });
    }

    function _initIncomeCnDnYearMonthDatatable() {
      vm.incomeCnDnYearMonthTable = $('#income-cn-dn-year-month-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: 100,
        displayStart: 0,
        search: {
          search: '' // Initial search term actually here
        },
        order: [
          [1, 'asc'],
          [2, 'asc']
        ],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          if (vm.viewName !== 'cn_dn_year_month') {
            return callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
          }

          vm.loading = true;
          $rootScope.loadingProgress = true;

          data.dr_code = accountService.user.username;
          data.yearFilter = vm.yearFilter;
          data.monthFilter = vm.selectedRecord.monthNumber;

          $http
            .post($rootScope.routePath + '/income/getCnDnByYearMonth', data)
            .then(function (res) {
              return res.data;
            })
            .then(function (res) {
              if (!res.success) {
                throw new Error(res.message);
              }

              vm.totalBillSize = (+res.data.total_bill_size).toFixed(2);
              vm.totalGrossIncome = (+res.data.total_gross_income).toFixed(2);

              callback({
                recordsTotal: res.data.recordsTotal,
                recordsFiltered: res.data.recordsTotal,
                data: res.data.cnDns
              });
            })
            .catch(function (err) {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;

              _redraw();
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope)
          }
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: function (row, data, dataIndex) {
          DtRendererService.rowRenderer($scope)(row, data, dataIndex);

          if (
            data.payment_status === 'UNPAID' ||
            data.payment_status === 'PARTIALLY PAID'
          ) {
            angular.element(row).addClass('red-100-bg');
          }
        },
        scrollY: 'auto',
        columns: [
          {
            data: 'id',
            title: 'No',
            width: '40px',
            render: function (data, type, row, meta) {
              var info = vm.incomeCnDnYearMonthTable.page.info();
              return info.page * info.length + (meta.row + 1);
            }
          },
          {
            data: 'episode_no',
            title: 'Episode No',
            defaultContent: '-'
          },
          {
            data: 'admission_datetime',
            title: 'Admission Datetime',
            defaultContent: '-',
            render: function (data, type, row, meta) {
              return moment(data).format('YYYY-MM-DD<br>HH:mm:ss');
            }
          },
          {
            data: 'discharge_datetime',
            title: 'Discharge Datetime',
            defaultContent: '-',
            render: function (data, type, row, meta) {
              return moment(data).format('YYYY-MM-DD<br>HH:mm:ss');
            }
          },
          {
            data: 'bill_size',
            title: 'Bill Size',
            defaultContent: '-',
            className: 'dt-head-right dt-body-right',
            render: function (data, type, row, meta) {
              return (+data).toFixed(2);
            }
          },
          {
            data: 'patient_type_desc',
            title: 'Patient Type',
            defaultContent: '-'
          },
          {
            data: 'dn_cn_no',
            title: 'CN/DN No',
            defaultContent: '-'
          },
          {
            data: 'created_datetime',
            title: 'CN/DN Date',
            render: function (data, type, row, meta) {
              return data ? moment(data).format('YYYY-MM-DD<br>HH:mm:ss') : '-';
            }
          },
          {
            data: 'category_description',
            title: 'Billing Group Code',
            defaultContent: '-'
          },
          {
            data: 'dr_amt',
            title: 'Gross Income',
            defaultContent: '-',
            className: 'dt-head-right dt-body-right',
            render: function (data, type, row, meta) {
              return (+data).toFixed(2);
            }
          }
        ]
      });
    }

    function _initIncomeCnDnEpisodeDatatable() {
      vm.incomeCnDnEpisodeTable = $('#income-cn-dn-episode-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: 100,
        displayStart: 0,
        search: {
          search: '' // Initial search term actually here
        },
        order: [
          [1, 'asc'],
          [2, 'asc']
        ],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          if (vm.viewName !== 'cn_dn_episode') {
            return callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
          }

          vm.loading = true;
          $rootScope.loadingProgress = true;

          data.dr_code = accountService.user.username;
          data.episode_no = vm.selectedRecord.episode_no;

          $http
            .post($rootScope.routePath + '/income/getCnDnByEpisode', data)
            .then(function (res) {
              return res.data;
            })
            .then(function (res) {
              if (!res.success) {
                throw new Error(res.message);
              }

              vm.totalBillSize = (+res.data.total_bill_size).toFixed(2);
              vm.totalGrossIncome = (+res.data.total_gross_income).toFixed(2);

              callback({
                recordsTotal: res.data.recordsTotal,
                recordsFiltered: res.data.recordsTotal,
                data: res.data.cnDns
              });
            })
            .catch(function (err) {
              callback({
                recordsTotal: 0,
                recordsFiltered: 0,
                data: []
              });
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;

              _redraw();
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope)
          }
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: function (row, data, dataIndex) {
          DtRendererService.rowRenderer($scope)(row, data, dataIndex);

          if (
            data.payment_status === 'UNPAID' ||
            data.payment_status === 'PARTIALLY PAID'
          ) {
            angular.element(row).addClass('red-100-bg');
          }
        },
        scrollY: 'auto',
        columns: [
          {
            data: 'id',
            title: 'No',
            width: '40px',
            render: function (data, type, row, meta) {
              var info = vm.incomeCnDnEpisodeTable.page.info();
              return info.page * info.length + (meta.row + 1);
            }
          },
          {
            data: 'episode_no',
            title: 'Episode No',
            defaultContent: '-'
          },
          {
            data: 'admission_datetime',
            title: 'Admission Datetime',
            defaultContent: '-',
            render: function (data, type, row, meta) {
              return moment(data).format('YYYY-MM-DD<br>HH:mm:ss');
            }
          },
          {
            data: 'discharge_datetime',
            title: 'Discharge Datetime',
            defaultContent: '-',
            render: function (data, type, row, meta) {
              return moment(data).format('YYYY-MM-DD<br>HH:mm:ss');
            }
          },
          {
            data: 'bill_size',
            title: 'Bill Size',
            defaultContent: '-',
            className: 'dt-head-right dt-body-right',
            render: function (data, type, row, meta) {
              return (+data).toFixed(2);
            }
          },
          {
            data: 'patient_type_desc',
            title: 'Patient Type',
            defaultContent: '-'
          },
          {
            data: 'dn_cn_no',
            title: 'CN/DN No',
            defaultContent: '-'
          },
          {
            data: 'created_datetime',
            title: 'CN/DN Date',
            render: function (data, type, row, meta) {
              return data ? moment(data).format('YYYY-MM-DD<br>HH:mm:ss') : '-';
            }
          },
          {
            data: 'category_description',
            title: 'Billing Group Code',
            defaultContent: '-'
          },
          {
            data: 'dr_amt',
            title: 'Gross Income',
            defaultContent: '-',
            className: 'dt-head-right dt-body-right',
            render: function (data, type, row, meta) {
              return (+data).toFixed(2);
            }
          }
        ]
      });
    }

    function _boldText(data, type, row, meta) {
      return row.has_dn_cn ? '<div class="has-dn-cn">' + data + '</div>' : data;
    }

    function _search() {
      switch (vm.viewName) {
        case 'year': {
          vm.incomeYearTable.search(vm.searchTerm).draw();
          break;
        }
        case 'month': {
          vm.incomeMonthTable.search(vm.searchTerm).draw();
          break;
        }
        case 'detail': {
          vm.incomeDetailTable.search(vm.searchTerm).draw();
          break;
        }
        case 'category': {
          vm.incomeCategoryTable.search(vm.searchTerm).draw();
          break;
        }
        case 'cn_dn_year_month': {
          vm.incomeCnDnYearMonthTable.search(vm.searchTerm).draw();
          break;
        }
        case 'cn_dn_episode': {
          vm.incomeCnDnEpisodeTable.search(vm.searchTerm).draw();
          break;
        }
      }
    }

    function _view(viewName, index) {
      vm.viewName = viewName;

      switch (vm.viewName) {
        case 'year': {
          vm.selectedRecord = null;
          vm.incomeYearTable.ajax.reload(null, false);
          break;
        }
        case 'month': {
          vm.selectedRecord = incomeYear[index];
          vm.incomeMonthTable.ajax.reload(null, false);
          break;
        }
        case 'detail': {
          vm.selectedRecord = incomeMonth[index];
          vm.incomeDetailTable.ajax.reload(null, false);
          break;
        }
        case 'category': {
          vm.selectedRecord = incomeYear[index];
          vm.incomeCategoryTable.ajax.reload(null, false);
          break;
        }
        case 'todo': {
          vm.selectedRecord = incomeMonth[index];
          vm.selectedRecord.admission_datetime_display = moment(
            vm.selectedRecord.admission_datetime
          ).format('YYYY-MM-DD HH:mm:ss');
          vm.selectedRecord.discharge_datetime_display = moment(
            vm.selectedRecord.discharge_datetime
          ).format('YYYY-MM-DD HH:mm:ss');

          _getBillingTodoByEpisodeNo();
          break;
        }
        case 'cn_dn_year_month': {
          vm.selectedRecord = incomeYear[index];
          vm.incomeCnDnYearMonthTable.ajax.reload(null, false);
          break;
        }
        case 'cn_dn_episode': {
          vm.selectedRecord = incomeMonth[index];
          vm.incomeCnDnEpisodeTable.ajax.reload(null, false);
          break;
        }
      }
    }

    function _back(viewName) {
      vm.viewName = viewName;

      _redraw();
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;

      switch (vm.viewName) {
        case 'year': {
          if (vm.incomeYearTable.page.info().start === 0) return;
        }
        case 'month': {
          if (vm.incomeMonthTable.page.info().start === 0) return;
        }
        case 'detail': {
          if (vm.incomeDetailTable.page.info().start === 0) return;
        }
        case 'category': {
          if (vm.incomeCategoryTable.page.info().start === 0) return;
        }
        case 'cn_dn_year_month': {
          if (vm.incomeCnDnYearMonthTable.page.info().start === 0) return;
        }
        case 'cn_dn_episode': {
          if (vm.incomeCnDnEpisodeTable.page.info().start === 0) return;
        }
      }

      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;

      switch (vm.viewName) {
        case 'year': {
          if (
            vm.incomeYearTable.page.info().end ===
            vm.incomeYearTable.page.info().recordsTotal
          )
            return;
        }
        case 'month': {
          if (
            vm.incomeMonthTable.page.info().end ===
            vm.incomeMonthTable.page.info().recordsTotal
          )
            return;
        }
        case 'detail': {
          if (
            vm.incomeDetailTable.page.info().end ===
            vm.incomeDetailTable.page.info().recordsTotal
          )
            return;
        }
        case 'category': {
          if (
            vm.incomeCategoryTable.page.info().end ===
            vm.incomeCategoryTable.page.info().recordsTotal
          )
            return;
        }
        case 'cn_dn_year_month': {
          if (
            vm.incomeCnDnYearMonthTable.page.info().end ===
            vm.incomeCnDnYearMonthTable.page.info().recordsTotal
          )
            return;
        }
        case 'cn_dn_episode': {
          if (
            vm.incomeCnDnEpisodeTable.page.info().end ===
            vm.incomeCnDnEpisodeTable.page.info().recordsTotal
          )
            return;
        }
      }

      _next();
    }

    function _prev() {
      switch (vm.viewName) {
        case 'year': {
          vm.incomeYearTable.page('previous');
          vm.incomeYearTable.ajax.reload(null, false);
          break;
        }
        case 'month': {
          vm.incomeMonthTable.page('previous');
          vm.incomeMonthTable.ajax.reload(null, false);
          break;
        }
        case 'detail': {
          vm.incomeDetailTable.page('previous');
          vm.incomeDetailTable.ajax.reload(null, false);
          break;
        }
        case 'category': {
          vm.incomeCategoryTable.page('previous');
          vm.incomeCategoryTable.ajax.reload(null, false);
          break;
        }
        case 'cn_dn_year_month': {
          vm.incomeCnDnYearMonthTable.page('previous');
          vm.incomeCnDnYearMonthTable.ajax.reload(null, false);
          break;
        }
        case 'cn_dn_episode': {
          vm.incomeCnDnEpisodeTable.page('previous');
          vm.incomeCnDnEpisodeTable.ajax.reload(null, false);
          break;
        }
      }
    }

    function _next() {
      switch (vm.viewName) {
        case 'year': {
          vm.incomeYearTable.page('next');
          vm.incomeYearTable.ajax.reload(null, false);
          break;
        }
        case 'month': {
          vm.incomeMonthTable.page('next');
          vm.incomeMonthTable.ajax.reload(null, false);
          break;
        }
        case 'detail': {
          vm.incomeDetailTable.page('next');
          vm.incomeDetailTable.ajax.reload(null, false);
          break;
        }
        case 'category': {
          vm.incomeCategoryTable.page('next');
          vm.incomeCategoryTable.ajax.reload(null, false);
          break;
        }
        case 'cn_dn_year_month': {
          vm.incomeCnDnYearMonthTable.page('next');
          vm.incomeCnDnYearMonthTable.ajax.reload(null, false);
          break;
        }
        case 'cn_dn_episode': {
          vm.incomeCnDnEpisodeTable.page('next');
          vm.incomeCnDnEpisodeTable.ajax.reload(null, false);
          break;
        }
      }
    }

    function _redraw() {
      // Needs to be in timeout for back button
      $timeout(function () {
        // This is for Angular Datatables header
        window.dispatchEvent(new Event('resize'));
        // This is for Datatables
        window.dispatchEvent(new UIEvent('resize'));
      });
    }

    function _exportGetIncomes() {
      var params = {
        dr_code: accountService.user.username,
        yearFilter: vm.yearFilter
      };

      params.legacyIncome = legacyIncome;

      $http
        .get($rootScope.routePath + '/income/exportGetIncomes', {
          responseType: 'arraybuffer',
          params: params
        })
        .then(function (res) {
          var header = res.headers('Content-Disposition');
          var fileName = header.split('=')[1].replace(/\"/gi, '');

          var blob = new Blob([res.data], {
            type: res.headers('Content-Type')
          });
          var objectUrl = ($window.URL || $window.webkitURL).createObjectURL(
            blob
          );
          var link = angular.element('<a/>');
          link
            .attr({
              href: objectUrl,
              download: fileName
            })[0]
            .click();
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function _exportGetIncomesByEpisodeNo() {
      var params = {
        dr_code: accountService.user.username,
        yearFilter: vm.yearFilter,
        monthFilter: vm.selectedRecord.month
      };

      params.legacyIncome = legacyIncome;

      $http
        .get($rootScope.routePath + '/income/exportGetIncomesByEpisodeNo', {
          responseType: 'arraybuffer',
          params: params
        })
        .then(function (res) {
          var header = res.headers('Content-Disposition');
          var fileName = header.split('=')[1].replace(/\"/gi, '');

          var blob = new Blob([res.data], {
            type: res.headers('Content-Type')
          });
          var objectUrl = ($window.URL || $window.webkitURL).createObjectURL(
            blob
          );
          var link = angular.element('<a/>');
          link
            .attr({
              href: objectUrl,
              download: fileName
            })[0]
            .click();
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function _exportGetIncomeDetails() {
      var params = {
        dr_code: accountService.user.username,
        episode_no: vm.incomeDetail.episode_no
      };

      params.legacyIncome = legacyIncome;

      $http
        .get($rootScope.routePath + '/income/exportGetIncomeDetails', {
          responseType: 'arraybuffer',
          params: params
        })
        .then(function (res) {
          var header = res.headers('Content-Disposition');
          var fileName = header.split('=')[1].replace(/\"/gi, '');

          var blob = new Blob([res.data], {
            type: res.headers('Content-Type')
          });
          var objectUrl = ($window.URL || $window.webkitURL).createObjectURL(
            blob
          );
          var link = angular.element('<a/>');
          link
            .attr({
              href: objectUrl,
              download: fileName
            })[0]
            .click();
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function _exportGetIncomesByCategory() {
      var params = {
        dr_code: accountService.user.username,
        yearFilter: vm.yearFilter,
        monthFilter: vm.selectedRecord.month
      };

      params.legacyIncome = legacyIncome;

      $http
        .get($rootScope.routePath + '/income/exportGetIncomesByCategory', {
          responseType: 'arraybuffer',
          params: params
        })
        .then(function (res) {
          var header = res.headers('Content-Disposition');
          var fileName = header.split('=')[1].replace(/\"/gi, '');

          var blob = new Blob([res.data], {
            type: res.headers('Content-Type')
          });
          var objectUrl = ($window.URL || $window.webkitURL).createObjectURL(
            blob
          );
          var link = angular.element('<a/>');
          link
            .attr({
              href: objectUrl,
              download: fileName
            })[0]
            .click();
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function _showDialog(billId) {
      $mdDialog
        .show({
          controller: 'BillDetailDialogController',
          controllerAs: 'vm',
          templateUrl:
            'app/main/bill/dialogs/bill-detail/bill-detail-dialog.html',
          parent: angular.element($document.body),
          clickOutsideToClose: true,
          locals: {
            billId: billId
          }
        })
        .then(function (res) {
          if (res && res.reload) {
            _getBillingTodoByEpisodeNo();
          }
        });
    }

    function _getBillingTodoByEpisodeNo() {
      vm.loading = true;
      $rootScope.loadingProgress = true;

      $http
        .get($rootScope.routePath + '/income/getBillingTodoByEpisodeNo', {
          params: {
            episodeNo: vm.selectedRecord.episode_no
          }
        })
        .then(function (res) {
          return res.data;
        })
        .then(function (res) {
          if (!res.success) {
            throw new Error(res.message);
          }

          for (var i = 0; i < res.data.todos.length; ++i) {
            var todo = res.data.todos[i];
            if (todo.status !== 'COMPLETED') {
              todo.class = 'red-100-bg';
            }
          }

          vm.billerRemarks = res.data.todos;
        })
        .catch(function (err) {
          vm.billerRemarks = [];
        })
        .finally(function () {
          vm.loading = false;
          $rootScope.loadingProgress = false;
        });
    }
  }
})();

(function() {
	'use strict';

	angular
		.module('app.login')
		.controller('LoginController', LoginController);
	
	/** @ngInject */
	function LoginController(accountService, $state) {
		var vm = this;

		// Data
		vm.accountService = accountService;

		// Methods
		vm.$onInit = init;
		vm.login = login;

		function init() {
			if (accountService.isRemembered) {
				accountService.login()
				.then(function(res) {
					if (res.success) {
						accountService.checkFeaturePopup();
						return $state.go('app.dashboard');
					}

					// If failed using token then remove credentials and prompt user to manual login
					accountService.logout();
				});
			}
		}

		function login() {
			accountService.login()
			.then(function(res) {
				if (res.success) $state.go('app.login.otp');
				// if (res.success) $state.go('app.dashboard');
			});
		}
	}
})();

(function() {
	'use strict';

	angular
		.module('app.forgotPassword')
		.controller('ForgotPasswordController', ForgotPasswordController);
	
	/** @ngInject */
	function ForgotPasswordController($state, accountService) {
		var vm = this;

		// Data
		vm.accountService = accountService;

		// Methods
		vm.reset = reset;

		//////////
		
		function reset() {
			accountService.resetPassword()
			.then(function() {
				$state.go('app.login');
			});
		}
	}
})();
(function () {
  'use strict';

  angular
    .module('app.eDischargeStaff')
    .controller('EdischargeStaffController', Controller);

  /** @ngInject */
  function Controller(
    $scope,
    $rootScope,
    $http,
    $q,
    $state,
    $stateParams,
    $mdDialog,
    $mdMedia,
    sharedService,
    DtRendererService,
    $document
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var dataSource = [];
    var canceller = $q.defer();
    var isMediaGtSm = $mdMedia('gt-sm');

    // Exposed data
    vm.loading = false;
    vm.sharedService = sharedService;

    vm.dataSourceTable;

    vm.statusFilters = [
      {
        status: 'New',
        display: 'New',
        tooltip: 'New',
        icon: 'icon-apps',
        badge: {
          show: true,
          mapping: 'newCount',
          count: 0
        }
      },
      {
        status: 'Pending Approval',
        display: 'Pending',
        tooltip: 'Requested Discharge Pending Approval',
        icon: 'icon-minus',
        badge: {
          show: true,
          mapping: 'pendingApprovalCount',
          count: 0
        }
      },
      {
        status: 'Approved',
        display: 'Approved',
        tooltip: 'Approved',
        icon: 'icon-check-all',
        badge: {
          show: true,
          mapping: 'approvedCount',
          count: 0
        }
      },
      {
        status: 'Completed',
        display: 'Completed',
        tooltip: 'Completed',
        icon: 'icon-package-variant-closed',
        badge: {
          show: false,
          mapping: 'completedCount',
          count: 0
        }
      }
    ];
    vm.statusFilter = vm.statusFilters[$stateParams.statusFilterIndex];

    // Exposed methods
    vm.search = _search;
    vm.onStatusFilter = _onStatusFilter;

    vm.edit = _edit;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    vm.view = _view;
    vm.addDoctor = _addDoctor;
    vm.requestDischarge = _requestDischarge;
    vm.complete = _complete;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-logout';
      sharedService.pageName = 'E-Discharge';

      // Copy search term for display only
      vm.searchTerm = $stateParams.searchTerm;

      _initDatatable();
      _initBadges();
    }

    function _initDatatable() {
      vm.dataSourceTable = $('#e-discharge-staff-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: $stateParams.pageLength,
        displayStart: $stateParams.page * $stateParams.pageLength,
        search: {
          search: $stateParams.searchTerm // Initial search term actually here
        },
        order: [[4, 'desc']],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;

          data.status = vm.statusFilter.status;

          $http
            .post(
              $rootScope.routePath + '/eDischarge/staff/getEdischargeList',
              data,
              {
                timeout: canceller.promise
              }
            )
            .then(function (res) {
              res = res.data;

              if (res.success) {
                dataSource = res.data.result;
                callback({
                  recordsTotal: res.data.resultCount,
                  recordsFiltered: res.data.resultCount,
                  data: res.data.result
                });
              } else {
                sharedService.showToast(res.message);
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: []
                });
              }
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope)
          }
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: function (row, data, dataIndex) {
          DtRendererService.rowRenderer($scope)(row, data, dataIndex);

          if (['Pending Approval'].includes(data.e_discharge_form.status)) {
            angular.element(row).addClass('brown-50-bg');
          }
        },
        scrollY: 'auto',
        columns: [
          {
            data: 'e_discharge.ext_id',
            title: '#',
            sortable: true,
            searchable: false,
            defaultContent: '-',
            width: '40px',
            render: function (data, type, row, meta) {
              return meta.row + 1;
            }
          },
          {
            data: 'e_discharge.patient_mrn',
            title: 'MRN',
            sortable: true,
            searchable: true,
            defaultContent: '-'
          },
          {
            data: 'e_discharge.patient_name',
            title: 'Patient',
            sortable: true,
            searchable: true,
            defaultContent: '-'
          },
          {
            data: 'e_discharge.episode_number',
            title: 'Episode #',
            sortable: true,
            searchable: true,
            defaultContent: '-'
          },
          {
            data: 'e_discharge.admission_datetime',
            title: 'Admission Datetime',
            sortable: true,
            searchable: false,
            defaultContent: '-',
            render: function (data, type, row, meta) {
              return data
                ? moment.utc(data).local().format('DD/MM/YYYY hh:mm a')
                : undefined;
            }
          },
          {
            data: 'e_discharge.discharged_datetime',
            title: 'Discharge Datetime',
            sortable: true,
            searchable: false,
            defaultContent: '-',
            render: function (data, type, row, meta) {
              return data
                ? moment.utc(data).local().format('DD/MM/YYYY hh:mm a')
                : undefined;
            }
          },
          {
            data: null,
            title: 'Actions',
            sortable: false,
            searchable: false,
            defaultContent: '-',
            render: function (data, type, row, meta) {
              var viewTemplate =
                '<md-button class="md-icon-button" ng-click="vm.view(' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-eye" class="s18 brown-500-fg"></md-icon>' +
                '<md-tooltip>View</md-tooltip>' +
                '</md-button>';
              var editTemplate =
                '<md-button class="md-icon-button" ng-click="vm.edit(' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-pencil" class="s18 green-500-fg"></md-icon>' +
                '<md-tooltip>Edit/Amend</md-tooltip>' +
                '</md-button>';
              var addDoctorTemplate =
                '<md-button class="md-icon-button" ng-click="vm.addDoctor(' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-tie" class="s18 orange-500-fg"></md-icon>' +
                '<md-tooltip>Add Doctor</md-tooltip>' +
                '</md-button>';
              var requestDischargeTemplate =
                '<md-button class="md-icon-button" ng-click="vm.requestDischarge(' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-logout" class="s18 blue-500-fg"></md-icon>' +
                '<md-tooltip>Request Discharge</md-tooltip>' +
                '</md-button>';
              var completeTemplate =
                '<md-button class="md-icon-button" ng-click="vm.complete(' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-package-variant-closed" class="s18 purple-500-fg"></md-icon>' +
                '<md-tooltip>Mark As Complete</md-tooltip>' +
                '</md-button>';

              var template = viewTemplate;

              // As long as not yet completed then can edit
              if (
                [null, 'New', 'Pending Approval', 'Approved'].includes(
                  row.e_discharge_form.status
                )
              ) {
                template += editTemplate;
                template += addDoctorTemplate;
              }

              // As long as is new then can be requested for discharge
              if ([null, 'New'].includes(row.e_discharge_form.status)) {
                template += requestDischargeTemplate;
              }

              // If all doctors approved then can mark as complete
              if (['Approved'].includes(row.e_discharge_form.status)) {
                template += completeTemplate;
              }

              return template;
            }
          }
        ]
      });
    }

    function _initBadges() {
      $http
        .get(
          $rootScope.routePath + '/eDischarge/staff/getEdischargeListBadgeCount'
        )
        .then(function (res) {
          res = res.data;

          for (var i = 0; i < vm.statusFilters.length; ++i) {
            var filter = vm.statusFilters[i];

            filter.badge.count = res.data[filter.badge.mapping] || 0;
          }
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _search() {
      vm.dataSourceTable.search(vm.searchTerm).draw();
    }

    function _onStatusFilter(filter) {
      vm.statusFilter = filter;
      vm.dataSourceTable.ajax.reload(null, false);
    }

    function _edit(index) {
      var item = dataSource[index];
      $state.go('app.eDischargeStaff.edit', {
        id: item ? item.e_discharge.episode_external_id : null,
        searchTerm: vm.searchTerm,
        page: vm.dataSourceTable.page.info().page,
        pageLength: vm.dataSourceTable.page.info().length,
        statusFilterIndex: vm.statusFilters.indexOf(vm.statusFilter)
      });
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;
      if (vm.dataSourceTable.page.info().start === 0) return;
      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;
      if (
        vm.dataSourceTable.page.info().end ===
        vm.dataSourceTable.page.info().recordsTotal
      )
        return;
      _next();
    }

    function _prev() {
      vm.dataSourceTable.page('previous');
      vm.dataSourceTable.ajax.reload(null, false);
    }

    function _next() {
      vm.dataSourceTable.page('next');
      vm.dataSourceTable.ajax.reload(null, false);
    }

    function _view(index) {
      var item = dataSource[index];
      $state.go('app.eDischargeStaff.view', {
        id: item ? item.e_discharge.episode_external_id : null,
        searchTerm: vm.searchTerm,
        page: vm.dataSourceTable.page.info().page,
        pageLength: vm.dataSourceTable.page.info().length,
        statusFilterIndex: vm.statusFilters.indexOf(vm.statusFilter)
      });
    }

    function _addDoctor(index) {
      var item = dataSource[index];

      $mdDialog.show({
        controller: 'EdischargeStaffAddDoctorDialogController',
        controllerAs: 'vm',
        templateUrl:
          'app/main/e-discharge-staff/dialogs/e-discharge-staff-add-doctor/e-discharge-staff-add-doctor-dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: false,
        locals: {
          dataSource: {
            eDischargeEpisodeExternalId: item.e_discharge.episode_external_id,
            patientName: item.e_discharge.patient_name,
            episodeNumber: item.e_discharge.episode_number
          }
        }
      });
    }

    function _requestDischarge(index) {
      var item = dataSource[index];

      var confirm = $mdDialog
        .confirm()
        .title('Request Discharge Confirmation')
        .textContent(
          'Are you sure you want to request discharge for this patient "' +
            item.e_discharge.patient_name +
            ' (' +
            item.e_discharge.episode_number +
            ')"?'
        )
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        $http
          .post($rootScope.routePath + '/eDischarge/staff/requestDischarge', {
            eDischargeEpisodeExternalId: item.e_discharge.episode_external_id
          })
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            if (res.success) {
              vm.dataSourceTable.ajax.reload(null, false);

              _initBadges();
            }
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    function _complete(index) {
      var item = dataSource[index];

      var confirm = $mdDialog
        .confirm()
        .title('Mark As Complete Confirmation')
        .textContent(
          'Are you sure you want to mark this e-discharge form as complete for this patient "' +
            item.e_discharge.patient_name +
            ' (' +
            item.e_discharge.episode_number +
            ')"?'
        )
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        $http
          .post($rootScope.routePath + '/eDischarge/staff/completeEdischarge', {
            eDischargeFormId: item.e_discharge_form.id
          })
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            if (res.success) {
              vm.dataSourceTable.ajax.reload(null, false);

              _initBadges();
            }
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    function _destroy() {
      canceller.resolve();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.eDischargeConsultant')
    .controller('EdischargeConsultantController', Controller);

  /** @ngInject */
  function Controller(
    $scope,
    $rootScope,
    $http,
    $q,
    $state,
    $stateParams,
    $mdDialog,
    $mdMedia,
    sharedService,
    DtRendererService
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var dataSource = [];
    var canceller = $q.defer();
    var isMediaGtSm = $mdMedia('gt-sm');

    // Exposed data
    vm.loading = false;
    vm.sharedService = sharedService;

    vm.dataSourceTable;

    vm.statusFilters = [
      {
        status: 'New',
        display: 'New',
        tooltip: 'New',
        icon: 'icon-apps',
        badge: {
          show: true,
          mapping: 'newCount',
          count: 0
        }
      },
      {
        status: 'Pending Approval',
        display: 'Pending',
        tooltip: 'Requested Discharge Pending Approval',
        icon: 'icon-minus',
        badge: {
          show: true,
          mapping: 'pendingApprovalCount',
          count: 0
        }
      },
      {
        status: 'Done',
        display: 'Done',
        tooltip: 'Approved / Completed',
        icon: 'icon-check-all',
        badge: {
          show: false,
          mapping: 'doneCount',
          count: 0
        }
      }
    ];
    vm.statusFilter = vm.statusFilters[$stateParams.statusFilterIndex];

    // Exposed methods
    vm.search = _search;
    vm.onStatusFilter = _onStatusFilter;

    vm.edit = _edit;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    vm.view = _view;
    vm.requestDischarge = _requestDischarge;
    vm.complete = _complete;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-logout';
      sharedService.pageName = 'E-Discharge';

      // Copy search term for display only
      vm.searchTerm = $stateParams.searchTerm;

      _initDatatable();
      _initBadges();
    }

    function _initDatatable() {
      vm.dataSourceTable = $('#e-discharge-consultant-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: $stateParams.pageLength,
        displayStart: $stateParams.page * $stateParams.pageLength,
        search: {
          search: $stateParams.searchTerm // Initial search term actually here
        },
        order: [[4, 'desc']],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;

          data.status = vm.statusFilter.status;

          $http
            .post(
              $rootScope.routePath + '/eDischarge/consultant/getEdischargeList',
              data,
              {
                timeout: canceller.promise
              }
            )
            .then(function (res) {
              res = res.data;

              if (res.success) {
                dataSource = res.data.result;
                callback({
                  recordsTotal: res.data.resultCount,
                  recordsFiltered: res.data.resultCount,
                  data: res.data.result
                });
              } else {
                sharedService.showToast(res.message);
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: []
                });
              }
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope)
          }
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: DtRendererService.rowRenderer($scope),
        scrollY: 'auto',
        columns: [
          {
            data: 'e_discharge.ext_id',
            title: '#',
            sortable: true,
            searchable: false,
            defaultContent: '-',
            width: '40px',
            render: function (data, type, row, meta) {
              return meta.row + 1;
            }
          },
          {
            data: 'e_discharge.patient_mrn',
            title: 'MRN',
            sortable: true,
            searchable: true,
            defaultContent: '-'
          },
          {
            data: 'e_discharge.patient_name',
            title: 'Patient',
            sortable: true,
            searchable: true,
            defaultContent: '-'
          },
          {
            data: 'e_discharge.episode_number',
            title: 'Episode #',
            sortable: true,
            searchable: true,
            defaultContent: '-'
          },
          {
            data: 'e_discharge.admission_datetime',
            title: 'Admission Datetime',
            sortable: true,
            searchable: false,
            defaultContent: '-',
            render: function (data, type, row, meta) {
              return data
                ? moment.utc(data).local().format('DD/MM/YYYY hh:mm a')
                : undefined;
            }
          },
          {
            data: 'e_discharge.discharged_datetime',
            title: 'Discharge Datetime',
            sortable: true,
            searchable: false,
            defaultContent: '-',
            render: function (data, type, row, meta) {
              return data
                ? moment.utc(data).local().format('DD/MM/YYYY hh:mm a')
                : undefined;
            }
          },
          {
            data: null,
            title: 'Actions',
            sortable: false,
            searchable: false,
            defaultContent: '-',
            render: function (data, type, row, meta) {
              var viewTemplate =
                '<md-button class="md-icon-button" ng-click="vm.view(' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-eye" class="s18 brown-500-fg"></md-icon>' +
                '<md-tooltip>View</md-tooltip>' +
                '</md-button>';
              var editTemplate =
                '<md-button class="md-icon-button" ng-click="vm.edit(' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-pencil" class="s18 green-500-fg"></md-icon>' +
                '<md-tooltip>Edit/Amend</md-tooltip>' +
                '</md-button>';
              var requestDischargeTemplate =
                '<md-button class="md-icon-button" ng-click="vm.requestDischarge(' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-logout" class="s18 blue-500-fg"></md-icon>' +
                '<md-tooltip>Request Discharge</md-tooltip>' +
                '</md-button>';
              var completeTemplate =
                '<md-button class="md-icon-button" ng-click="vm.complete(' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-package-variant-closed" class="s18 purple-500-fg"></md-icon>' +
                '<md-tooltip>Mark As Complete</md-tooltip>' +
                '</md-button>';

              var template = viewTemplate;

              // As long as not yet completed then can edit
              if (
                [null, 'New', 'Pending Approval', 'Approved'].includes(
                  row.e_discharge_form.status
                )
              ) {
                template += editTemplate;
              }

              // As long as is new then can be requested for discharge
              if (
                false &&
                [null, 'New'].includes(row.e_discharge_form.status)
              ) {
                template += requestDischargeTemplate;
              }

              // If all doctors approved then can mark as complete
              if (false && ['Approved'].includes(row.e_discharge_form.status)) {
                template += completeTemplate;
              }

              return template;
            }
          }
        ]
      });
    }

    function _initBadges() {
      $http
        .get(
          $rootScope.routePath +
            '/eDischarge/consultant/getEdischargeListBadgeCount'
        )
        .then(function (res) {
          res = res.data;

          for (var i = 0; i < vm.statusFilters.length; ++i) {
            var filter = vm.statusFilters[i];

            filter.badge.count = res.data[filter.badge.mapping] || 0;
          }
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _search() {
      vm.dataSourceTable.search(vm.searchTerm).draw();
    }

    function _onStatusFilter(filter) {
      vm.statusFilter = filter;
      vm.dataSourceTable.ajax.reload(null, false);
    }

    function _edit(index) {
      var item = dataSource[index];
      $state.go('app.eDischargeConsultant.edit', {
        id: item ? item.e_discharge.episode_external_id : null,
        searchTerm: vm.searchTerm,
        page: vm.dataSourceTable.page.info().page,
        pageLength: vm.dataSourceTable.page.info().length,
        statusFilterIndex: vm.statusFilters.indexOf(vm.statusFilter)
      });
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;
      if (vm.dataSourceTable.page.info().start === 0) return;
      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;
      if (
        vm.dataSourceTable.page.info().end ===
        vm.dataSourceTable.page.info().recordsTotal
      )
        return;
      _next();
    }

    function _prev() {
      vm.dataSourceTable.page('previous');
      vm.dataSourceTable.ajax.reload(null, false);
    }

    function _next() {
      vm.dataSourceTable.page('next');
      vm.dataSourceTable.ajax.reload(null, false);
    }

    function _view(index) {
      var item = dataSource[index];
      $state.go('app.eDischargeConsultant.view', {
        id: item ? item.e_discharge.episode_external_id : null,
        searchTerm: vm.searchTerm,
        page: vm.dataSourceTable.page.info().page,
        pageLength: vm.dataSourceTable.page.info().length,
        statusFilterIndex: vm.statusFilters.indexOf(vm.statusFilter)
      });
    }

    function _requestDischarge(index) {
      var item = dataSource[index];

      var confirm = $mdDialog
        .confirm()
        .title('Request Discharge Confirmation')
        .textContent(
          'Are you sure you want to request discharge for this patient "' +
            item.e_discharge.patient_name +
            ' (' +
            item.e_discharge.episode_number +
            ')"?'
        )
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        $http
          .post(
            $rootScope.routePath + '/eDischarge/consultant/requestDischarge',
            {
              eDischargeEpisodeExternalId: item.e_discharge.episode_external_id
            }
          )
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            if (res.success) {
              vm.dataSourceTable.ajax.reload(null, false);
            }
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    function _complete(index) {
      var item = dataSource[index];

      var confirm = $mdDialog
        .confirm()
        .title('Mark As Complete Confirmation')
        .textContent(
          'Are you sure you want to mark this e-discharge form as complete for this patient "' +
            item.e_discharge.patient_name +
            ' (' +
            item.e_discharge.episode_number +
            ')"?'
        )
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        $http
          .post(
            $rootScope.routePath + '/eDischarge/consultant/completeEdischarge',
            {
              eDischargeFormId: item.e_discharge_form.id
            }
          )
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            if (res.success) {
              vm.dataSourceTable.ajax.reload(null, false);
            }
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    function _destroy() {
      canceller.resolve();
    }
  }
})();

(function() {
	'use strict';

	angular
		.module('app.dashboard', ['datatables', 'datatables.scroller'])
		.config(config);
	
	/** @ngInject */
	function config($stateProvider, msApiProvider) {
		$stateProvider
		// Main
		.state('app.dashboard', {
			url: '/dashboard',
			views: {
				'content@app': {
					templateUrl: 'app/main/dashboard/dashboard2.html',
					controller: 'Dashboard2Controller as vm'
				}
			},
			params: {
				searchTerm: null,
				showAdvancedSearch: false,
				isAdvancedSearch: false,
				fromDatetime: null,
				toDatetime: null,
				page: 0,
				pageLength: 25,
				selectedReadStatusDefault: 0,
				selectedTypeAndBoxDefault: null
			},
			bodyClass: 'dashboard',
			moduleName: 'Dashboard'
		});
	}
})();

(function () {
  'use strict';

  angular
    .module('app.dashboard')
    .controller('Dashboard2Controller', Dashboard2Controller);

  /** @ngInject */
  function Dashboard2Controller(
    $scope,
    $mdMedia,
    $mdDialog,
    $rootScope,
    DTOptionsBuilder,
    DTColumnBuilder,
    $document,
    $timeout,
    accountService,
    $http,
    $q,
    sharedService,
    $compile,
    Todo,
    Role,
    $state,
    $stateParams,
    DtRendererService,
    $window
  ) {
    var vm = this;

    // Hooks
    $scope.$on('$destroy', _destroy);

    // Local data
    var todos = [];
    var canceller = $q.defer();
    var isMediaGtSm = $mdMedia('gt-sm');

    var isAdvancedSearch = false;

    // Exposed data
    vm.loading = false;
    vm.sharedService = sharedService;

    vm.dashboardTable;

    vm.typeAndBoxes = [
      {
        type: 'BILLING',
        box: 'INBOX'
      },
      {
        type: 'BILLING',
        box: 'OUTBOX'
      },
      {
        type: 'OTHERS',
        box: 'INBOX'
      },
      {
        type: 'OTHERS',
        box: 'OUTBOX'
      }
    ];
    // Default to others inbox
    vm.selectedTypeAndBox =
      vm.typeAndBoxes[$stateParams.selectedTypeAndBoxDefault];

    vm.readStatuses = [
      {
        text: 'UNREAD',
        tooltip: 'Filter by UNREAD',
        value: 'UNREAD',
        selected: false,
        class:
          's24 grey-600-fg md-default-theme md-font material-icons icon-minus'
      },
      {
        text: 'READ',
        tooltip: 'Filter by READ',
        value: 'READ',
        selected: false,
        class:
          's24 blue-600-fg md-default-theme md-font material-icons icon-check-all'
      },
      {
        text: 'ALL',
        tooltip: 'NO filter',
        value: undefined,
        selected: false,
        class:
          's24 purple-600-fg md-default-theme md-font material-icons icon-checkbox-multiple-blank-outline'
      }
    ];
    // Default to UNREAD
    vm.selectedReadStatus =
      vm.readStatuses[$stateParams.selectedReadStatusDefault];
    vm.selectedReadStatus.selected = true;

    // Exposed methods
    vm.selectTypeAndBox = _selectTypeAndBox;
    vm.selectReadStatus = _selectReadStatus;
    vm.showDialog = _showDialog;
    vm.showThread = _showThread;
    vm.markAsRead = _markAsRead;
    vm.openScheduleDocument = _openScheduleDocument;
    vm.openFormularyDocument = _openFormularyDocument;
    vm.openGlobocareUserGuide = _openGlobocareUserGuide;
    vm.openScheduleOfProcedureBooklet = _openScheduleOfProcedureBooklet;

    vm.advancedSearch = _advancedSearch;
    vm.resetAdvancedSearch = _resetAdvancedSearch;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    // Method definitions
    function _init() {
      $rootScope.$broadcast('userLoggedIn');

      sharedService.pageIcon = 'icon-tile-four';
      sharedService.pageName = 'Dashboard';

      // Copy search term for display only
      vm.searchTerm = $stateParams.searchTerm;
      vm.showAdvancedSearch = $stateParams.showAdvancedSearch;
      isAdvancedSearch = $stateParams.isAdvancedSearch;
      vm.fromDatetime = $stateParams.fromDatetime;
      vm.toDatetime = $stateParams.toDatetime;

      // Select box before initialize datatable
      _selectDefaultTypeAndBox();

      _initDatatable();
    }

    function _initDatatable() {
      vm.dashboardTable = $('#dashboard-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: $stateParams.pageLength,
        displayStart: $stateParams.page * $stateParams.pageLength,
        search: {
          search: $stateParams.searchTerm // Initial search term actually here
        },
        order: [[3, 'desc']],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;

          // Add type and box
          data.type = vm.selectedTypeAndBox.type;
          data.box = vm.selectedTypeAndBox.box;

          if (isAdvancedSearch) {
            if (vm.fromDatetime) {
              data.fromDatetime = vm.fromDatetime.startOf('day').toISOString();
            }
            if (vm.toDatetime) {
              data.toDatetime = vm.toDatetime.endOf('day').toISOString();
            }
          }

          data.readStatus = vm.selectedReadStatus.value;

          // Do necessary remapping for query
          data.columns[0].data = 'todo.id';
          data.columns[5].data = 'username';
          data.columns[6].data = 'name';

          $http
            .post($rootScope.routePath + '/todo/getByPageInboxOutbox', data, {
              timeout: canceller.promise
            })
            .then(function (res) {
              res = res.data;

              // Show message if not success
              if (!res.success) {
                return sharedService.showToast(res.message);
              }

              todos = res.data;
              // vm.badgesCount = res.badgesCount;
              vm.badgesCount = {};
              // Change to use correct data, but that means other badge can't be shown without going to the filter itself
              // But we don't care for now since they don't want to know also
              if (vm.selectedReadStatus.value === 'UNREAD') {
                vm.badgesCount.UNREAD = res.recordsTotal;
              }
              // For now we hide for READ and ALL
              vm.badgesCount.READ = 0;
              vm.badgesCount.ALL = 0;

              callback({
                recordsTotal: res.recordsTotal,
                recordsFiltered: res.recordsTotal,
                data: res.data
              });
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope)
          }
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: DtRendererService.rowRenderer($scope),
        scrollY: 'auto',
        columns: [
          {
            data: null,
            title: 'No',
            width: '40px',
            render: function (data, type, row, meta) {
              return meta.row + 1;
            }
          },
          {
            data: 'type',
            title: 'Type'
          },
          {
            data: 'remarks',
            title: 'Remarks'
          },
          {
            data: 'created_datetime',
            title: 'Created Datetime',
            render: function (data, type, row, meta) {
              return data
                ? moment.utc(data).local().format('DD/MM/YYYY hh:mm a')
                : 'N/A';
            }
          },
          {
            data: 'status',
            title: 'Status/Doctor',
            render: function (data, type, row, meta) {
              var drUsername = row.doctorName;
              // for (var i = 0; i < row.recipients.length; ++i) {
              //   if (row.recipients[i].role === 'Doctor') {
              //     drUsername = row.recipients[i].username;
              //     break;
              //   }
              // }
              if (drUsername) {
                return data + '<br>' + drUsername;
              }
              return data;
            }
          },
          {
            data: null,
            title: 'Created By',
            render: function (data, type, row, meta) {
              var t = todos[meta.row];
              if (t.senders.length === 2) {
                if (t.senders[0].role === 'PersonalAssistant') {
                  return (
                    t.senders[1].username +
                    '<br>(' +
                    t.senders[0].username +
                    ')'
                  );
                } else {
                  return (
                    t.senders[0].username + ' (' + t.senders[1].username + ')'
                  );
                }
              } else {
                // Show doctor's full name (if any)
                if (t.senders[0].role === 'Doctor' && t.doctorName !== null) {
                  return t.doctorName;
                } else {
                  return t.senders[0].username;
                }
              }
            }
          },
          {
            data: null,
            title: 'Created By Role',
            render: function (data, type, row, meta) {
              var t = todos[meta.row];
              if (t.senders.length === 2) {
                if (t.senders[0].role === 'PersonalAssistant') {
                  return t.senders[1].role + '<br>(' + t.senders[0].role + ')';
                } else {
                  return t.senders[0].role + ' (' + t.senders[1].role + ')';
                }
              } else {
                return t.senders[0].role;
              }
            }
          },
          {
            data: 'subtype',
            title: 'Process',
            render: function (data, type, row, meta) {
              return data ? data : 'N/A';
            }
          },
          {
            data: 'requested_datetime',
            title: 'Datetime',
            render: function (data, type, row, meta) {
              return data
                ? moment.utc(data).local().format('DD/MM/YYYY hh:mm a')
                : 'N/A';
            }
          },
          {
            data: null,
            title: 'Actions',
            render: function (data, type, row, meta) {
              var t = todos[meta.row];
              var detailsTemplate =
                '<md-button class="md-icon-button" ng-click="vm.showDialog($event, ' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-more" class="s18 grey-500-fg"></md-icon>' +
                '<md-tooltip md-direction="top">More details</md-tooltip>' +
                '</md-button>';
              var threadTemplate =
                '<md-button class="md-icon-button" ng-click="vm.showThread(' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-view-list" class="s18 ' +
                (t.status === 'COMPLETED' ? 'red' : 'blue') +
                '-500-fg"></md-icon>' +
                '<md-tooltip md-direction="top">Show Thread</md-tooltip>' +
                '</md-button>';
              // return t.type === 'MEMO' ? threadTemplate : t.ref_id === 0 ? 'N/A' : detailsTemplate;
              var markAsReadTemplate =
                '<md-button class="md-icon-button" ng-click="vm.markAsRead(' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-check-all" class="s18 green-500-fg"></md-icon>' +
                '<md-tooltip md-direction="top">Mark As Read</md-tooltip>' +
                '</md-button>';
              return (
                (t.type === 'MEMO'
                  ? threadTemplate
                  : t.ref_id === 0
                  ? 'N/A'
                  : detailsTemplate) + markAsReadTemplate
              );
            }
          }
        ]
      });
    }

    function _selectDefaultTypeAndBox() {
      if ($stateParams.selectedTypeAndBoxDefault) {
        vm.selectedTypeAndBox =
          vm.typeAndBoxes[$stateParams.selectedTypeAndBoxDefault];
        return;
      }

      switch (accountService.user.roles[0].name) {
        case 'Doctor':
        case 'PersonalAssistant':
        case 'Biller': {
          vm.selectedTypeAndBox = vm.typeAndBoxes[0];
          break;
        }
        default: {
          vm.selectedTypeAndBox = vm.typeAndBoxes[2];
          break;
        }
      }
    }

    function _selectTypeAndBox(index) {
      vm.selectedTypeAndBox = vm.typeAndBoxes[index];
      vm.dashboardTable.ajax.reload(null, false);
    }

    function _selectReadStatus(status) {
      vm.selectedReadStatus.selected = false;
      status.selected = true;
      vm.selectedReadStatus = status;

      vm.dashboardTable.ajax.reload(null, false);
    }

    function _showDialog(jsEvent, index) {
      var todo = todos[index];

      switch (todo.type) {
        case Todo.TYPE.APPOINTMENT: {
          $mdDialog
            .show({
              controller: 'AppointmentDetailDialogController',
              controllerAs: 'vm',
              templateUrl:
                'app/main/appointment/dialogs/appointment-detail/appointment-detail-dialog.html',
              parent: angular.element($document.body),
              targetEvent: jsEvent,
              clickOutsideToClose: true,
              locals: {
                appointmentId: todo.ref_id
              }
            })
            .then(function (res) {
              if (res && res.reload) {
                vm.dashboardTable.ajax.reload(null, false);
              }
            });
          break;
        }
        case Todo.TYPE.OT_BOOKING: {
          $mdDialog
            .show({
              controller: 'OperationTheaterDetailDialogController',
              controllerAs: 'vm',
              templateUrl:
                'app/main/operation-theater/dialogs/operation-theater-detail/operation-theater-detail-dialog.html',
              parent: angular.element($document.body),
              targetEvent: jsEvent,
              locals: {
                bookingId: todo.ref_id
              }
            })
            .then(function (res) {
              if (res && res.reload) {
                vm.dashboardTable.ajax.reload(null, false);
              }
            });
          break;
        }
        case Todo.TYPE.BILLING: {
          $mdDialog
            .show({
              controller: 'BillDetailDialogController',
              controllerAs: 'vm',
              templateUrl:
                'app/main/bill/dialogs/bill-detail/bill-detail-dialog.html',
              parent: angular.element($document.body),
              targetEvent: jsEvent,
              locals: {
                billId: todo.ref_id
              }
            })
            .then(function (res) {
              if (res && res.reload) {
                vm.dashboardTable.ajax.reload(null, false);
              }
            });
          break;
        }
      }
    }

    function _showThread(index) {
      var todo = todos[index];

      $state.go('app.todo.thread', {
        id: todo.thread_group_id,
        searchTerm: vm.searchTerm,
        showAdvancedSearch: vm.showAdvancedSearch,
        isAdvancedSearch: isAdvancedSearch,
        fromDatetime: vm.fromDatetime,
        toDatetime: vm.toDatetime,
        page: vm.dashboardTable.page.info().page,
        pageLength: vm.dashboardTable.page.info().length,
        selectedReadStatusDefault: vm.readStatuses.indexOf(
          vm.selectedReadStatus
        ),
        selectedTypeAndBoxDefault: vm.typeAndBoxes.indexOf(
          vm.selectedTypeAndBox
        )
      });
    }

    function _markAsRead(index) {
      var todo = todos[index];

      var data = {
        todoId: todo.id,
        userId: accountService.user.id
      };

      canceller = $q.defer();
      $http
        .post($rootScope.routePath + '/todo/markThreadAsRead', data, {
          timeout: canceller.promise
        })
        .then(function (res) {
          res = res.data;

          sharedService.showToast(res.message);

          if (res.success) {
            vm.dashboardTable.ajax.reload(null, false);
            --vm.badgesCount.UNREAD;
          }
        })
        .catch(function (err) {
          if (err.message) {
            sharedService.showToast(err.message);
          } else {
            sharedService.showToast('Request timed out.');
          }
        });
    }

    function _openScheduleDocument() {
      $window.open(
        $rootScope.routePath + '/uploads/documents/13th Schedule dec 2013.pdf',
        '_blank'
      );
    }

    function _openFormularyDocument() {
      $window.open(
        $rootScope.routePath + '/uploads/documents/UMSC Formulary.pdf',
        '_blank'
      );
    }

    function _openGlobocareUserGuide() {
      $window.open(
        $rootScope.routePath +
          '/uploads/documents/User Manual for Globocare Medical Record Management System.pdf',
        '_blank'
      );
    }

    function _openScheduleOfProcedureBooklet() {
      $window.open(
        $rootScope.routePath +
          '/uploads/documents/Schedule of Procedures_UMSC 2022.pdf',
        '_blank'
      );
    }

    function _advancedSearch() {
      isAdvancedSearch = true;
      vm.dashboardTable.ajax.reload(null, false);
    }

    function _resetAdvancedSearch() {
      vm.fromDatetime = null;
      vm.toDatetime = null;
      isAdvancedSearch = false;
      vm.dashboardTable.ajax.reload(null, false);
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;
      if (vm.dashboardTable.page.info().start === 0) return;
      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;
      if (
        vm.dashboardTable.page.info().end ===
        vm.dashboardTable.page.info().recordsTotal
      )
        return;
      _next();
    }

    function _prev() {
      vm.dashboardTable.page('previous');
      vm.dashboardTable.ajax.reload(null, false);
    }

    function _next() {
      vm.dashboardTable.page('next');
      vm.dashboardTable.ajax.reload(null, false);
    }

    function _destroy() {
      canceller.resolve();
    }

    // Initializations
    _init();
  }
})();

(function() {
	'use strict';

	angular
		.module('app.bill')
		.controller('BillController', BillController);
	
	/** @ngInject */
	function BillController($stateParams, $mdMedia, sharedService, Todo, $rootScope, $scope, $http, $q, accountService, Role, $timeout) {
		var vm = this;

		// Data
		vm.sharedService = sharedService;

		vm.Todo = Todo;
		vm.todo = null;
		vm.patient = null;
		vm.doctor = null;
		vm.episode = null;
		vm.ward = null;
		vm.bed = null;
		vm.files = [];

		vm.mediaXsActionButtons = $mdMedia('gt-xs') ? '' : 'md-mini';

		sharedService.pageIcon = 'icon-cash-usd';
		sharedService.pageName = 'Pending Bill Matters';

		// Methods
		vm.$onInit = init;
		vm.request = request;
		vm.back = back;

		vm.acPatient = acPatient;
		vm.acDoctor = acDoctor;
		vm.acEpisode = acEpisode;
		vm.acWard = acWard;
		vm.acBed = acBed;

		//////////

		function init() {
			resetPristine();

			if (!$stateParams.id) return;

			$http.get($rootScope.routePath + '/todo/get-bill', {
				params: {
					id: $stateParams.id
				}
			})
			.then(function(res) {
				res = res.data;
				if (!res.success) return $q.reject(res.message);

				vm.todo = new Todo(res.data.todo);
				vm.todo.requested_datetime = vm.todo.requested_datetime ? moment(vm.todo.requested_datetime).local() : moment();

				vm.patient = res.data.autocompletes.patient;
				vm.doctor = res.data.autocompletes.doctor;
				vm.episode = res.data.autocompletes.episode;
				vm.ward = res.data.autocompletes.ward;
				vm.bed = res.data.autocompletes.bed;
			})
			.catch(function(err) {
				if (err.message) sharedService.showToast(err.message);
				else sharedService.showToast('Request timed out.');
			});
		}
		
		function request() {
			vm.todo.created_for = vm.doctor.code;
			vm.todo.created_for_role = Role.NAME.DOCTOR;
			var bill = {
				patient_mrn: vm.patient.patient_no,
				patient_name: vm.patient.patient_name,
				episode_no: vm.episode.episode_no,
				ward_code: vm.ward.code,
				bed_no: vm.bed.bed_no
			};

			if (vm.todo.id === 0) {
				var formData = new FormData();
				if (vm.files.length) {
					for (var i = 0; i < vm.files.length; ++i) {
						formData.append('files', vm.files[i].lfFile);
					}
				}
				formData.append('todo', JSON.stringify(vm.todo));
				formData.append('bill', JSON.stringify(bill));

				$http.post($rootScope.routePath + '/todo/saveBill', formData, {
					transformRequest: angular.identity,
					headers: { 'Content-Type': undefined },
				})
				.then(function(res) {
					res = res.data;
					if (res.success) {
						vm.todo.id = res.data.id;
						resetPristine();
						
						vm.lfApi.removeAll();
					}
					sharedService.showToast(res.message);
				})
				.catch(function(err) {
					if (err.message) sharedService.showToast(err.message);
					else sharedService.showToast('Request timed out.');
				});
			} else {
				$http.post($rootScope.routePath + '/todo/update-bill', {
					todo: vm.todo,
					bill: bill
				})
				.then(function(res) {
					res = res.data;
					if (res.success) resetPristine();
					sharedService.showToast(res.message);
				})
				.catch(function(err) {
					if (err.message) sharedService.showToast(err.message);
					else sharedService.showToast('Request timed out.');
				});
			}
		}

		function back() {
			sharedService.back('app.bill');
		}
		
		function resetPristine() {
			vm.patient = null;
			vm.doctor = null;
			vm.episode = null;
			vm.ward = null;
			vm.bed = null;
			vm.todo = new Todo({
				type: Todo.TYPE.BILLING,
				requested_datetime: moment(),
				created_by: accountService.user.username,
				created_by_role: accountService.user.getFirstRole()
			});

			$timeout(function() {
				var controlNames = Object.keys($scope.billForm).filter(function(key) {
					return key.indexOf('$') !== 0;
				})
				.forEach(function(name) {
					$scope.billForm[name].$setViewValue(undefined);
				});

				$scope.billForm.$setPristine();
				$scope.billForm.$setUntouched();
			});
		}

		function acPatient() {
			return $http.get($rootScope.routePath + '/autocomplete/patient', {
				params: {
					q: vm.searchPatient
				}
			})
			.then(function(res) {
				res = res.data;
				if (res.success) return res.data;
				return [];
			})
			.catch(function(err) {
			});
		}

		function acDoctor() {
			return $http.get($rootScope.routePath + '/autocomplete/doctor2', {
				params: {
					q: vm.searchDoctor
				}
			})
			.then(function(res) {
				res = res.data;
				if (res.success) return res.data;
				return [];
			})
			.catch(function(err) {
			});
		}

		function acEpisode() {
			return $http.get($rootScope.routePath + '/autocomplete/episode', {
				params: {
					q: vm.searchEpisode
				}
			})
			.then(function(res) {
				res = res.data;
				if (res.success) return res.data;
				return [];
			})
			.catch(function(err) {
			});
		}

		function acWard() {
			return $http.get($rootScope.routePath + '/autocomplete/ward', {
				params: {
					q: vm.searchWard
				}
			})
			.then(function(res) {
				res = res.data;
				if (res.success) return res.data;
				return [];
			})
			.catch(function(err) {
			});
		}

		function acBed() {
			return $http.get($rootScope.routePath + '/autocomplete/bed', {
				params: {
					q: vm.searchBed
				}
			})
			.then(function(res) {
				res = res.data;
				if (res.success) return res.data;
				return [];
			})
			.catch(function(err) {
			});
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('app.announcement')
    .controller('AnnouncementController', AnnouncementController);

  /** @ngInject */
  function AnnouncementController(
    $scope,
    $rootScope,
    $http,
    $q,
    $state,
    $stateParams,
    $mdDialog,
    $mdMedia,
    sharedService,
    DtRendererService
  ) {
    var vm = this;

    // Hooks
    vm.$onInit = _init;
    $scope.$on('$destroy', _destroy);

    // Local data
    var announcements = [];
    var canceller = $q.defer();
    var isMediaGtSm = $mdMedia('gt-sm');

    // Exposed data
    vm.loading = false;
    vm.sharedService = sharedService;

    vm.announcementTable;

    // Exposed methods
    vm.search = _search;

    vm.edit = _edit;
    vm.delete = _delete;

    vm.swipeLeft = _swipeLeft;
    vm.swipeRight = _swipeRight;
    vm.prev = _prev;
    vm.next = _next;

    // Method definitions
    function _init() {
      sharedService.pageIcon = 'icon-volume';
      sharedService.pageName = 'Announcement';

      // Copy search term for display only
      vm.searchTerm = $stateParams.searchTerm;

      _initDatatable();
    }

    function _initDatatable() {
      vm.announcementTable = $('#announcement-dt').DataTable({
        dom: 'rt<"bottom"<"left"<"length"l>><"right"<"dt-info"i>>>',
        processing: true,
        serverSide: true,
        pagingType: 'simple',
        pageLength: $stateParams.pageLength,
        displayStart: $stateParams.page * $stateParams.pageLength,
        search: {
          search: $stateParams.searchTerm // Initial search term actually here
        },
        order: [[0, 'asc']],
        language: DtRendererService.languageDefaults,
        ajax: function (data, callback, settings) {
          vm.loading = true;
          $rootScope.loadingProgress = true;

          $http
            .post($rootScope.routePath + '/announcement/getByPage', data, {
              timeout: canceller.promise
            })
            .then(function (res) {
              res = res.data;

              if (res.success) {
                announcements = res.data.announcements;
                callback({
                  recordsTotal: res.data.recordsTotal,
                  recordsFiltered: res.data.recordsTotal,
                  data: res.data.announcements
                });
              } else {
                sharedService.showToast(res.message);
                callback({
                  recordsTotal: 0,
                  recordsFiltered: 0,
                  data: []
                });
              }
            })
            .finally(function () {
              vm.loading = false;
              $rootScope.loadingProgress = false;
            });
        },
        responsive: {
          details: {
            renderer: DtRendererService.responsiveRenderer($scope)
          }
        },
        headerCallback: DtRendererService.headerRenderer($scope),
        createdRow: DtRendererService.rowRenderer($scope),
        scrollY: 'auto',
        columns: [
          {
            data: 'id',
            title: 'No',
            width: '40px',
            render: function (data, type, row, meta) {
              return meta.row + 1;
            }
          },
          {
            data: 'name',
            title: 'Name'
          },
          {
            data: 'message',
            title: 'Message'
          },
          {
            data: 'start_datetime',
            title: 'Start Datetime',
            render: function (data, type, row, meta) {
              return moment.utc(data).local().format('DD/MM/YYYY hh:mm a');
            }
          },
          {
            data: 'end_datetime',
            title: 'End Datetime',
            render: function (data, type, row, meta) {
              if (!data) {
                return 'Ongoing';
              }

              return moment.utc(data).local().format('DD/MM/YYYY hh:mm a');
            }
          },
          {
            data: 'is_active',
            title: 'Is Active',
            render: function (data, type, row, meta) {
              return data
                ? '<md-icon md-font-icon="icon-check" class="s18 green-500-fg"></md-icon>'
                : '<md-icon md-font-icon="icon-close" class="s18 red-500-fg"></md-icon>';
            }
          },
          {
            data: null,
            title: 'Actions',
            sortable: false,
            render: function (data, type, row, meta) {
              var template =
                '<md-button class="md-icon-button" ng-click="vm.edit(' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-pencil" class="s18 green-500-fg"></md-icon>' +
                '<md-tooltip>Edit</md-tooltip>' +
                '</md-button>' +
                '<md-button class="md-icon-button" ng-click="vm.delete(' +
                meta.row +
                ')">' +
                '<md-icon md-font-icon="icon-trash" class="s18 red-500-fg"></md-icon>' +
                '<md-tooltip>Delete</md-tooltip>' +
                '</md-button>';

              return template;
            }
          }
        ]
      });
    }

    function _search() {
      vm.announcementTable.search(vm.searchTerm).draw();
    }

    function _edit(index) {
      var announcement = announcements[index];
      $state.go('app.announcement.edit', {
        id: announcement ? announcement.id : null,
        searchTerm: vm.searchTerm,
        page: vm.announcementTable.page.info().page,
        pageLength: vm.announcementTable.page.info().length
      });
    }

    function _delete(index) {
      var announcement = announcements[index];
      var confirm = $mdDialog
        .confirm()
        .title('Delete Confirmation')
        .textContent(
          'Are you sure you want to delete this announcement "' +
            announcement.name +
            '"? This action is irreversible!'
        )
        .ok('DELETE')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        return $http
          .post($rootScope.routePath + '/announcement/deleteById', {
            announcementId: announcement.id
          })
          .then(function (res) {
            res = res.data;

            sharedService.showToast(res.message);

            vm.announcementTable.ajax.reload(null, false);
          })
          .catch(function (err) {
            if (err.message) {
              sharedService.showToast(err.message);
            } else {
              sharedService.showToast('Request timed out.');
            }
          });
      });
    }

    // Only swipe on small to medium screens,
    // prevent click, drag and copy data conflict on bigger screens
    function _swipeLeft() {
      if (isMediaGtSm) return;
      if (vm.timeslotTable.page.info().start === 0) return;
      _prev();
    }

    function _swipeRight() {
      if (isMediaGtSm) return;
      if (
        vm.timeslotTable.page.info().end ===
        vm.timeslotTable.page.info().recordsTotal
      )
        return;
      _next();
    }

    function _prev() {
      vm.timeslotTable.page('previous');
      vm.timeslotTable.ajax.reload(null, false);
    }

    function _next() {
      vm.timeslotTable.page('next');
      vm.timeslotTable.ajax.reload(null, false);
    }

    function _destroy() {
      canceller.resolve();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.appointment')
    .controller('AppointmentController', AppointmentController);

  /** @ngInject */
  function AppointmentController(
    $rootScope,
    $scope,
    sharedService,
    $state,
    $http,
    $q,
    $mdDialog,
    $document,
    $mdMedia,
    Appointment
  ) {
    var vm = this;

    // Local data
    var viewDataRequest;
    var canceller = $q.defer();

    // Data
    vm.sharedService = sharedService;

    vm.events = [[]];

    vm.calendarUiConfig = {
      calendar: {
        eventLimit: true,
        header: false,
        handleWindowResize: true,
        aspectRatio: 1,
        dayNames: [
          'Sunday',
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday'
        ],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        viewRender: viewRender,
        columnFormat: {
          month: 'ddd',
          week: 'ddd',
          day: 'ddd M'
        },
        eventClick: showAppointmentDetailDialog,
        dayClick: dayClick,
        timezone: 'local',
        slotDuration: '00:20:00'
      }
    };

    vm.mediaXsAddButton = $mdMedia('gt-xs') ? '' : 'md-mini';

    sharedService.pageIcon = 'icon-calendar';
    sharedService.pageName = 'Appointments';

    vm.appts = [];

    $rootScope.loadingProgress = true;

    // Methods
    vm.edit = edit;
    vm.next = next;
    vm.prev = prev;
    vm.acAppointment = acAppointment;
    vm.showList = showList;
    vm.hideList = hideList;
    vm.showPopup = showPopup;

    //////////

    function next() {
      canceller.resolve();
      canceller = $q.defer();
      vm.calendar.next();
    }

    function prev() {
      canceller.resolve();
      canceller = $q.defer();
      vm.calendar.prev();
    }

    function acAppointment() {
      return $http
        .get($rootScope.routePath + '/autocomplete/appointment', {
          params: {
            q: vm.searchAppointment
          }
        })
        .then(function (res) {
          res = res.data;
          if (res.success) {
            for (var i = 0; i < res.data.length; ++i) {
              res.data[i] = new Appointment(res.data[i]);
              if (res.data[i].patient_no) {
                res.data[i].subtitle = ' (' + res.data[i].patient_no + ')';
              } else {
                res.data[i].subtitle = ' (NEW)';
              }
            }
            return res.data;
          }
          return [];
        })
        .catch(function (err) {});
    }

    function showAppointmentDetailDialog(calEvent, jsEvent, view) {
      $mdDialog.show({
        controller: 'AppointmentDetailDialogController',
        controllerAs: 'vm',
        templateUrl:
          'app/main/appointment/dialogs/appointment-detail/appointment-detail-dialog.html',
        parent: angular.element($document.body),
        targetEvent: jsEvent,
        clickOutsideToClose: true,
        locals: {
          appointmentId: calEvent.id
        }
      });
    }

    function showList() {
      vm.showListView = vm.appointment !== null;
      vm.appts = [];

      if (vm.showListView) {
        $rootScope.loadingProgress = true;

        $http
          .get($rootScope.routePath + '/appointment/get-by-patient-name', {
            params: {
              patientName: vm.appointment.patient_name
            }
          })
          .then(function (res) {
            res = res.data;

            if (res.success) {
              for (var i = 0; i < res.data.length; ++i) {
                res.data[i] = new Appointment(res.data[i]);
              }

              vm.appts = res.data;
            } else {
              sharedService.showToast(res.message);
            }
          })
          .catch(function (err) {
            if (err.message) sharedService.showToast(err.message);
            else sharedService.showToast('Request timed out.');
          })
          .finally(function () {
            $rootScope.loadingProgress = false;
          });
      }
    }

    function hideList() {
      vm.showListView = false;
    }

    function showPopup(id) {
      $mdDialog.show({
        controller: 'AppointmentDetailDialogController',
        controllerAs: 'vm',
        templateUrl:
          'app/main/appointment/dialogs/appointment-detail/appointment-detail-dialog.html',
        parent: angular.element($document.body),
        clickOutsideToClose: true,
        locals: {
          appointmentId: id
        }
      });
    }

    function edit() {
      if (vm.calendarView.name === 'month') {
        $state.go('app.todo.edit', {
          selectedDatetime: null,
          selectedDatetimePrecision: 'month'
        });
      } else if (vm.calendarView.name === 'agendaWeek') {
        $state.go('app.todo.edit', {
          selectedDatetime: null,
          selectedDatetimePrecision: 'week'
        });
      } else if (vm.calendarView.name === 'agendaDay') {
        $state.go('app.todo.edit', {
          selectedDatetime: vm.calendar.getDate(),
          selectedDatetimePrecision: 'day'
        });
      }
    }

    function viewRender(view) {
      vm.calendarView = view;
      vm.calendar = vm.calendarView.calendar;
      vm.currentMonthShort = vm.calendar.getDate().format('MMM');

      $rootScope.loadingProgress = true;

      // Clear previous events
      vm.events.length = 0;

      $http
        .get($rootScope.routePath + '/appointment/get-between-dates', {
          params: {
            from: view.intervalStart.local().toISOString(),
            to: view.intervalEnd.local().subtract(1, 'seconds').toISOString()
          },
          timeout: canceller.promise
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            switch (view.name) {
              case 'month': {
                // Get selected month's offset
                var cellOffset = view.intervalStart.local().isoWeekday() % 7;

                // Create empty object
                var eventCountPerDay = {};

                res.data.appointments.forEach(function (appointment) {
                  var s = moment(appointment.datetime);

                  // Add to count
                  var cellIndex = s.date() + cellOffset - 1;
                  eventCountPerDay[cellIndex] = eventCountPerDay[cellIndex]
                    ? ++eventCountPerDay[cellIndex]
                    : 1;
                });

                // Loop through all dates and modify render
                for (var key in eventCountPerDay) {
                  var $dayEl = $(view.dayGrid.dayEls[key]);
                  var html =
                    '<span class="count">' + eventCountPerDay[key] + '</span>';
                  $dayEl.html(html);
                }

                // Loop public holidays and color dates
                for (var i = 0; i < res.data.publicHolidays.length; ++i) {
                  var ph = res.data.publicHolidays[i];
                  var date = moment(ph.datetime).format('YYYY-MM-DD');
                  var $el = angular.element(
                    'td.fc-day[data-date="' + date + '"]'
                  );
                  $el.addClass('grey-300-bg');
                }

                // Loop blocked days and color dates
                for (var i = 0; i < res.data.blockedDays.length; ++i) {
                  var bd = res.data.blockedDays[i];
                  var date = moment(bd.blocked_datetime).format('YYYY-MM-DD');
                  var $el = angular.element(
                    'td.fc-day[data-date="' + date + '"]'
                  );
                  $el.addClass('pink-100-bg');
                }
                break;
              }
              case 'agendaWeek': {
                var events = [];

                res.data.appointments.forEach(function (appointment) {
                  var s = moment(appointment.datetime);
                  var e = s.clone().add(15, 'minutes');

                  var obj = {
                    id: appointment.id,
                    title: appointment.patient_name,
                    start: s,
                    end: e
                  };

                  // Material design colors 600 hue + 300 hue for light
                  if (appointment.type_desc.indexOf('OVERBOOKING') >= 0) {
                    obj.color = '#E53935';
                    obj.textColor = '#000';
                  } else if (appointment.type_desc.indexOf('TRAVELLING') >= 0) {
                    obj.color = '#FB8C00';
                    obj.textColor = '#000';
                  } else if (
                    appointment.type_desc.indexOf('DISCHARGE FROM WARD') >= 0
                  ) {
                    obj.color = '#CE93D8';
                    obj.textColor = '#000';
                  } else if (appointment.type_desc === 'NEW') {
                    obj.color = '#43A047';
                  }

                  events.push(obj);
                });

                vm.events.push(events);

                break;
              }
              case 'agendaDay': {
                var events = [];

                res.data.appointments.forEach(function (appointment) {
                  var s = moment(appointment.datetime);
                  var e = s.clone().add(15, 'minutes');

                  var obj = {
                    id: appointment.id,
                    title: appointment.patient_name,
                    start: s,
                    end: e
                  };

                  // Material design colors 600 hue + 300 hue for light
                  if (appointment.type_desc.indexOf('OVERBOOKING') >= 0) {
                    obj.color = '#E53935';
                    obj.textColor = '#000';
                  } else if (appointment.type_desc.indexOf('TRAVELLING') >= 0) {
                    obj.color = '#FB8C00';
                    obj.textColor = '#000';
                  } else if (
                    appointment.type_desc.indexOf('DISCHARGE FROM WARD') >= 0
                  ) {
                    obj.color = '#CE93D8';
                    obj.textColor = '#000';
                  } else if (appointment.type_desc === 'NEW') {
                    obj.color = '#43A047';
                  }

                  events.push(obj);
                });

                // Round down every 20 minutes slot and color the slot

                for (var i = 0; i < res.data.blockedSlots.length; ++i) {
                  var bs = res.data.blockedSlots[i];
                  var bsdt = moment(bs.blocked_datetime);
                  var rem = bsdt.minute() % 20;
                  var bsdt = bsdt.subtract(rem, 'minutes');
                  var ss =
                    bsdt.format('mm') === '00'
                      ? bsdt.format('ha')
                      : bsdt.format('h:mma');
                  var $el = angular
                    .element('td.fc-axis.fc-time span:contains("' + ss + '")')
                    .parent()
                    .parent();
                  $el.addClass('pink-100-bg');
                }

                vm.events.push(events);

                break;
              }
            }
          }

          sharedService.showToast(res.message);
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        })
        .finally(function () {
          $rootScope.loadingProgress = false;
        });
    }

    function dayClick(date, jsEvent, view) {
      switch (view.name) {
        case 'month':
        case 'agendaWeek': {
          // Fix: MUST change date first before change view
          // Otherwise it will render twice!!
          view.calendar.gotoDate(date);
          view.calendar.changeView('agendaDay');
          break;
        }
      }
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function() {
	'use strict';

	angular
		.module('app.directives.mdChips', []);
})();
(function() {
	'use strict';

	angular
		.module('app.directives.mdChips')
		.directive('minItems', minItems)
		.directive('maxItems', maxItems)
		.decorator('mdChipsDirective', chipsDecorator);
	
	/** @ngInject */
	function chipsDecorator($delegate, $controller) {
		var directive = $delegate[0];

		var controllerName = directive.controller;

		/** @ngInject */
		directive.controller = function($scope, $attrs, $mdConstant, $log, $element, $timeout, $mdUtil) {
			var controller = $controller(controllerName, {
				$scope: $scope,
				$attrs: $attrs,
				$mdConstant: $mdConstant,
				$log: $log,
				$element: $element,
				$timeout: $timeout,
				$mdUtil: $mdUtil
			});

			controller.validateModel = function() {
				controller.ngModelCtrl.$validate();
			};

			return controller;
		};

		return $delegate;
	}

	function minItems() {
		return {
			require: 'ngModel',
			restrict: 'A',
			link: function(scope, element, attr, ctrl) {
				var minItems = 0;

				attr.$observe('minItems', function(value) {
					minItems = parseInt(value, 10) || 0;
					ctrl.$validate();
				});

				ctrl.$validators['min-items'] = function(modelValue, viewValue) {
					return viewValue.length >= minItems;
				};
			}
		};
	}

	function maxItems() {
		return {
			require: 'ngModel',
			restrict: 'A',
			link: function(scope, element, attr, ctrl) {
				var maxItems = -1;

				attr.$observe('maxItems', function(value) {
					var intVal = parseInt(value, 10);

					maxItems = isFinite(intVal) ? intVal : -1;
					ctrl.$validate();
				});

				ctrl.$validators['max-items'] = function(modelValue, viewValue) {
					return maxItems < 0 || viewValue.length <= maxItems;
				};
			}
		};
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function() {
	'use strict';

	angular
		.module('app.services', []);
})();
(function () {
  'use strict';

  angular.module('app.services').service('unsavedChangesService', Service);

  /** @ngInject */
  function Service($rootScope, $location, $state, $mdDialog, bridgeService) {
    var service = this;
    var removeLocationChangeStartListener = null;
    var removeStateChangeStartListener = null;

    var hasUnsavedChanges = false;
    var message = null;

    service.registerUnsavedChangesHandler = _registerUnsavedChangesHandler;
    service.setUnsavedChanges = _setUnsavedChanges;
    service.hasUnsavedChanges = _hasUnsavedChanges;
    service.setMessage = _setMessage;

    function _init() {
      $rootScope.$on('$destroy', function () {
        if (removeLocationChangeStartListener) {
          removeLocationChangeStartListener();
        }
        if (removeStateChangeStartListener) {
          removeStateChangeStartListener();
        }
      });
    }

    function _registerUnsavedChangesHandler() {
      removeLocationChangeStartListener = $rootScope.$on(
        '$locationChangeStart',
        function (event, newUrl, oldUrl) {
          var next = _extractPath(newUrl);

          if (!hasUnsavedChanges) {
            if (bridgeService.isUrlPathBridged(next)) {
              event.preventDefault();

              bridgeService.bridgeToV2();
              return;
            }

            return;
          }

          event.preventDefault();

          _showConfirmDialog()
            .then(function () {
              if (bridgeService.isUrlPathBridged(next)) {
                bridgeService.bridgeToV2();
                return;
              }

              _resetState();

              $location.url(next);
            })
            .catch(function () {
              $rootScope.loadingProgress = false;
            });
        }
      );

      removeStateChangeStartListener = $rootScope.$on(
        '$stateChangeStart',
        function (event, toState, toParams, fromState, fromParams) {
          if (!hasUnsavedChanges) {
            if (bridgeService.isStateNameBridged(toState.name)) {
              event.preventDefault();

              bridgeService.bridgeToV2();
              return;
            }

            return;
          }

          event.preventDefault();

          _showConfirmDialog()
            .then(function () {
              if (bridgeService.isStateNameBridged(toState.name)) {
                bridgeService.bridgeToV2();
                return;
              }

              _resetState();

              $state.go(toState.name, toParams);
            })
            .catch(function () {
              $rootScope.loadingProgress = false;
            });
        }
      );
    }

    function _showConfirmDialog() {
      var confirm = $mdDialog
        .confirm()
        .title('Unsaved Changes')
        .textContent(
          message ||
            'You have unsaved changes. Are you sure you want to leave without saving?'
        )
        .ok('Yes, Leave')
        .cancel('No, Stay');

      return $mdDialog.show(confirm);
    }

    function _extractPath(newUrl) {
      var link = angular.element('<a>')[0];
      link.href = newUrl;

      var full = link.pathname + link.search + link.hash;

      return full.replace(/^\/#/, '');
    }

    function _setUnsavedChanges(value) {
      hasUnsavedChanges = value;
    }

    function _hasUnsavedChanges() {
      return hasUnsavedChanges;
    }

    function _setMessage(msg) {
      message = msg;
    }

    function _resetState() {
      hasUnsavedChanges = false;
      message = null;
    }

    _init();
  }
})();

(function () {
  'use strict';

  angular.module('app.services').service('sharedService', sharedService);

  /** @ngInject */
  function sharedService($rootScope, $state, $timeout, $compile, $mdToast) {
    var service = this;

    // Data
    service.pageIcon = 'icon-pages';
    service.pageName = '';

    service.prevState;

    // Methods
    service.showToast = showToast;
    service.dtCreatedRow = dtCreatedRow;
    service.dtResponsiveDisplay = dtResponsiveDisplay;
    service.back = back;
    service.error = error;

    //////////

    function showToast(msg) {
      $mdToast.show(
        $mdToast.simple().textContent(msg).position('top right').hideDelay(3000)
      );
    }

    function dtCreatedRow(scope) {
      return function (row, data, dataIndex) {
        var $row = angular.element(row);
        var attr = $row.attr('compiled');
        if (typeof attr === typeof undefined || attr === false) {
          $row.attr('compiled', 'true');
          $timeout(function () {
            $compile($row.contents())(scope);
          });
        }
      };
    }

    function dtResponsiveDisplay(scope) {
      return function (jsEvent, datatable, row, isShown, update) {
        if (isShown) {
          var child = angular.element(row.node()).next();
          var attr = child.attr('compiled');
          if (typeof attr === typeof undefined || attr === false) {
            child.attr('compiled', 'true');
            $timeout(function () {
              $compile(child)(scope);
            });
          }
        }
      };
    }

    function back(stateName, params) {
      if (service.prevState) {
        $timeout(function () {
          $state.go(service.prevState, params);
        });
      } else {
        $timeout(function () {
          $state.go(stateName, params);
        });
      }
    }

    function error(message) {
      var err = new Error(message);
      err.name = 'BugzError';
      return err;
    }

    $rootScope.$on(
      '$stateChangeSuccess',
      function (jsEvent, toState, toParams, fromState, fromParams) {
        service.prevState = fromState;
      }
    );
  }
})();

(function() {
	'use strict';

	angular
		.module('app.services')
		.factory('hReqInterceptor', hReqInterceptorService);
	
	/** @ngInject */
	function hReqInterceptorService($cookies, $injector, User) {
		var hReqInterceptor = {
			request: request
		};

		return hReqInterceptor;

		function request(config) {
			var $state = $injector.get('$state');

			var user = $cookies.getObject('user');
			user = user ? new User(user) : null;
			config.headers['Authorization'] = user ? user.token : '';
			config.headers['Bugz-Id'] = user ? user.id : ''; // Non-standard
			config.headers['Bugz-Credentials'] = user ? user.username : ''; // Non-standard
			if (user && user.roles.length === 1) {
				config.headers['Bugz-Role'] = user.roles[0].name; // Non-standard
			}
			config.headers['X-Requested-With'] = $state.current.moduleName;
			return config;
		}
	}
})();
(function () {
  'use strict';

  angular
    .module('app.services')
    .service('DtRendererService', DtRendererService);

  /** @ngInject */
  function DtRendererService($compile) {
    // Local data

    // Exposed data
    this.languageDefaults = {
      info: '_START_ - _END_ / _TOTAL_',
      infoEmpty: '0 - 0 / 0',
      infoFiltered: '(_MAX_)',
      paginate: {
        next: '<md-icon md-font-icon="icon-chevron-right" class="md-default-theme md-font material-icons icon-chevron-right" role="img" aria-label="icon-chevron-right"></md-icon>',
        previous: '<md-icon md-font-icon="icon-chevron-left" class="md-default-theme md-font material-icons icon-chevron-left" role="img" aria-label="icon-chevron-left"></md-icon>',
      },
    };

    // Exposed methods
    this.headerRenderer = _headerRenderer;
    this.rowRenderer = _rowRenderer;
    this.responsiveRenderer = _responsiveRenderer;

    // Method definitions
    function _headerRenderer($scope) {
      var once = false;

      return function (thead, data, start, end, display) {
        if (once) return;
        // Apply fuse specific theme to display sorting icons in ::after
        angular.element(thead).children().each(function (index, element) {
          angular.element(element).contents().wrapAll('<div class="table-header"></div>').wrapAll('<span class="column-title"></span>');
        });
        $compile(angular.element(thead).contents())($scope);
        once = true;
      };
    }

    function _rowRenderer($scope) {
      return function (row, data, dataIndex) {
        $compile(angular.element(row).contents())($scope);
      };
    }

    function _responsiveRenderer($scope) {
      return function (api, rowIdx, columns) {
        var data = $.map(columns, function (col) {
          return col.hidden ?
            '<li data-dtr-index="' + col.columnIndex + '" data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' +
            '<span class="dtr-title">' +
            col.title +
            '</span>' +
            '<span class="dtr-data">' +
            col.data +
            '</span>' +
            '</li>' :
            '';
        }).join('');

        return data ?
          $('<ul data-dtr-index="' + rowIdx + '"/>').append($compile(data)($scope)) :
          false;
      };
    }

    // Initializations
  }
})();
(function () {
  'use strict';

  angular.module('app.services').service('bridgeService', Service);

  /** @ngInject */
  function Service($window, $timeout, $location, $cookies, $rootScope) {
    var service = this;

    service.isUrlPathBridged = _isUrlPathBridged;
    service.isStateNameBridged = _isStateNameBridged;
    service.bridgeToV2 = _bridgeToV2;
    service.getV2Host = _getV2Host;

    function _isRoleBridged() {
      // [2025-07-21 @ Dino] All todo states for nurse manager and call center staff redirect to v2
      var user = $cookies.getObject('user');
      var roleNames = user.roles.map(function (role) {
        return role.name;
      });
      var isTodoDisabled =
        roleNames.includes('NurseManager') ||
        roleNames.includes('CallCenterStaff');

      // [2025-07-21 @ Dino] Unless there is also a flag for no_redirect to do testing
      var noRedirect = $cookies.getObject('no_redirect');

      return isTodoDisabled && !noRedirect;
    }

    function _isUrlPathBridged(urlPath) {
      if (urlPath.startsWith('/todo')) {
        return _isRoleBridged();
      }

      if (
        urlPath.startsWith('/charge-category-setup') ||
        urlPath.startsWith('/charge-code-override-amount') ||
        urlPath.startsWith('/insurance-qna') ||
        urlPath.startsWith('/doctor-prescription') ||
        urlPath.startsWith('/pharmacy-prescription')
      ) {
        return true;
      }

      return false;
    }

    function _isStateNameBridged(toStateName) {
      if (!toStateName.startsWith('app.todo')) {
        return false;
      }

      return _isRoleBridged();
    }

    // Base URL of the new dr-portal-nestjs-api ("v2") — same host mapping
    // used both to open the bridged v2 app and to call v2-only APIs (e.g.
    // the feature popup) directly from this (v1) app.
    function _getV2Host() {
      var protocol = $location.protocol();
      var host = $location.host();

      return host === 'localhost'
        ? protocol + '://' + host + ':30040'
        : protocol +
            '://api.' +
            host
              .split('.')
              .map(function (part, index) {
                if (index === 0) {
                  return part + '2';
                }
                return part;
              })
              .join('.');
    }

    function _bridgeToV2() {
      $timeout(function () {
        $rootScope.loadingProgress = false;
      });

      var user = $cookies.getObject('user');
      var url = _getV2Host() + '/bridge/getAccessCode?authorization=' + user.token;
      $window.open(url, '_blank');
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.services').service('accountService', accountService);

  /** @ngInject */
  function accountService(
    $rootScope,
    $cookies,
    sharedService,
    $http,
    User,
    $q,
    $state,
    msNavigationService,
    $timeout,
    $mdDialog,
    $document,
    bridgeService
  ) {
    var service = this;

    // Data
    this.isRemembered;
    this.shouldRemember;
    this.resetPhrase = '';
    this.user;

    this.canView = false;
    this.canCreate = false;
    this.canModify = false;
    this.canDelete = false;

    this.toState = null;

    // Methods
    this.login = login;
    this.loginOtp = loginOtp;
    this.logout = logout;
    this.loadSidenav = loadSidenav;
    this.getPermissionByModule = getPermissionByModule;
    this.checkFeaturePopup = checkFeaturePopup;

    this.resetPassword = resetPassword;
    this.updatePassword = updatePassword;

    init();

    //////////

    function init() {
      loadUser();
      loadRememberState();
    }

    function loadUser() {
      var user = $cookies.getObject('user');
      service.user = user
        ? new User(user)
        : new User({
            profile_name: 'Specialist Joe'
          });
    }

    function loadRememberState() {
      var isRemembered = $cookies.getObject('is_remembered');
      service.isRemembered = isRemembered || false;
      service.shouldRemember = isRemembered ? isRemembered : true;
    }

    //////////

    function _getCurrentActiveAnnouncement() {
      $http
        .get($rootScope.routePath + '/announcement/getCurrentActive')
        .then(function (res) {
          res = res.data;

          if (!res.success) return $q.reject(res.message);

          $rootScope.globalAnnouncement = res.data.announcement;
        })
        .catch(function (err) {});
    }

    // Fetches the active feature popup once per login (not on every
    // navigation like the announcement banner above) and shows it.
    function checkFeaturePopup() {
      if ($rootScope.hasCheckedFeaturePopup) return;
      $rootScope.hasCheckedFeaturePopup = true;

      $http
        .get(bridgeService.getV2Host() + '/featurePopup/getCurrentActive')
        .then(function (res) {
          res = res.data;

          if (!res.success) return;

          // Defensive: a popup can end up with no displayable content (e.g.
          // its images were all removed after it was made active, without
          // deactivating it). Rather than showing an empty dialog, just skip
          // it — same as if there were no active popup at all.
          var featurePopup = res.data.featurePopup;
          var images = res.data.images || [];
          var hasContent =
            (featurePopup.displayType === 'video' && !!featurePopup.videoUrl) ||
            (featurePopup.displayType === 'images' && images.length > 0);

          if (!hasContent) return;

          $mdDialog.show({
            controller: 'FeaturePopupDialogController',
            controllerAs: 'vm',
            templateUrl:
              'app/main/feature-popup/dialogs/feature-popup-dialog.html',
            parent: angular.element($document.body),
            clickOutsideToClose: true,
            locals: {
              featurePopup: res.data.featurePopup,
              images: res.data.images
            }
          });
        })
        .catch(function (err) {});
    }

    function login() {
      return $http
        .post($rootScope.routePath + '/account/login2', {
          // return $http
          //   .post($rootScope.routePath + '/account/login-bypass', {
          username: service.user.username,
          password: service.user.password,
          isRemembered: service.isRemembered
        })
        .then(function (res) {
          res = res.data;

          if (res.data) {
            var expires = moment().add(7, 'days').toDate();

            // Store user
            $cookies.putObject('user', res.data, {
              expires: expires
            });
            service.user = new User(res.data);

            // Should remember, so remember now
            service.isRemembered = service.shouldRemember;
            $cookies.putObject('is_remembered', service.isRemembered, {
              expires: expires
            });
          }

          sharedService.showToast(res.message);

          return res;
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');

          // Fix for undefined data
          return {
            success: false
          };
        });
    }

    function loginOtp() {
      return $http
        .post($rootScope.routePath + '/account/loginOtp2', {
          phrase: service.resetPhrase
        })
        .then(function (res) {
          res = res.data;

          if (res.success) {
            var expires = moment().add(7, 'days').toDate();

            // Store user
            $cookies.putObject('user', res.data, {
              expires: expires
            });
            service.user = new User(res.data);

            // Should remember, so remember now
            service.isRemembered = service.shouldRemember;
            $cookies.putObject('is_remembered', service.isRemembered, {
              expires: expires
            });
          }

          sharedService.showToast(res.message);
          service.resetPhrase = '';
          return res;
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function logout() {
      // Backend logout
      return $http
        .post($rootScope.routePath + '/account/logout')
        .catch(function (err) {})
        .then(function () {
          $rootScope.$broadcast('userLoggedOut');
          $rootScope.hasCheckedFeaturePopup = false;
          angular.element('#header').slideToggle();

          var expires = moment().add(7, 'days').toDate();

          // If has backup then means is impersonate, restore it
          var userBak = $cookies.getObject('user_bak');

          if (userBak !== undefined) {
            $cookies.putObject('user', userBak, {
              expires: expires
            });
            $cookies.remove('user_bak');
            sharedService.showToast('Logout impersonation.');
            return;
          }

          // Remove cookies
          $cookies.remove('user');
          $cookies.remove('is_remembered');

          // Re-init
          init();
        });
    }

    function resetPassword() {
      return $http
        .post($rootScope.routePath + '/account/reset-password', {
          username: service.user.username,
          email: service.user.email
        })
        .then(function (res) {
          res = res.data;
          sharedService.showToast(res.message);

          return res;
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function updatePassword() {
      return $http
        .post($rootScope.routePath + '/account/update-password', {
          phrase: service.resetPhrase,
          username: service.user.username,
          password: service.user.password
        })
        .then(function (res) {
          res = res.data;
          sharedService.showToast(res.message);
          service.resetPhrase = '';
          return res;
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function loadSidenav() {
      return $http
        .get($rootScope.routePath + '/account/get-viewable-modules')
        .then(function (res) {
          res = res.data;

          if (res.success) {
            msNavigationService.clearNavigation();

            res.data.forEach(function (m) {
              switch (m.name) {
                case 'Appointment': {
                  msNavigationService.saveItem('appointment', {
                    title: 'Appointments',
                    icon: 'icon-calendar',
                    state: 'app.appointment',
                    order: m.display_order
                  });
                  break;
                }
                case 'Bill': {
                  msNavigationService.saveItem('bill', {
                    title: 'Bill',
                    icon: 'icon-cash-usd',
                    state: 'app.bill',
                    order: m.display_order
                  });
                  break;
                }
                case 'Insurance Q&A': {
                  msNavigationService.saveItem('insuranceQna', {
                    title: 'Insurance Q&A',
                    icon: 'icon-help-circle',
                    state: 'app.insuranceQna',
                    order: m.display_order
                  });
                  break;
                }
                case "Doctor's Prescription": {
                  msNavigationService.saveItem('doctorPrescription', {
                    title: 'Prescription',
                    icon: 'icon-pill',
                    state: 'app.doctorPrescription',
                    order: m.display_order
                  });
                  break;
                }
                case "Pharmacy's Prescription": {
                  msNavigationService.saveItem('pharmacyPrescription', {
                    title: 'Prescription',
                    icon: 'icon-pill',
                    state: 'app.pharmacyPrescription',
                    order: m.display_order
                  });
                  break;
                }
                case 'Dashboard': {
                  msNavigationService.saveItem('dashboard', {
                    title: 'Dashboard',
                    icon: 'icon-tile-four',
                    state: 'app.dashboard',
                    order: m.display_order
                  });
                  break;
                }
                case 'Operation Theater': {
                  msNavigationService.saveItem('operationTheater', {
                    title: 'Operation Theaters',
                    icon: 'icon-bone',
                    state: 'app.operationTheater',
                    order: m.display_order
                  });
                  break;
                }
                case 'Seven Days Discharge': {
                  msNavigationService.saveItem('sevenDaysDischarge', {
                    title: 'Seven Days Discharge',
                    icon: 'icon-run',
                    state: 'app.sevenDaysDischarge',
                    order: m.display_order
                  });
                  break;
                }
                case 'E-Discharge List (Consultant View)': {
                  msNavigationService.saveItem('eDischargeConsultant', {
                    title: 'E-Discharge',
                    icon: 'icon-logout',
                    state: 'app.eDischargeConsultant',
                    order: m.display_order
                  });
                  break;
                }
                case 'E-Discharge List (Staff View)': {
                  msNavigationService.saveItem('eDischargeStaff', {
                    title: 'E-Discharge',
                    icon: 'icon-logout',
                    state: 'app.eDischargeStaff',
                    order: m.display_order
                  });
                  break;
                }
                case 'To Do': {
                  msNavigationService.saveItem('todo', {
                    title: 'To Do',
                    icon: 'icon-checkbox-marked',
                    state: 'app.todo',
                    order: m.display_order
                  });
                  break;
                }
                case 'Permission': {
                  msNavigationService.saveItem('User.permission', {
                    title: 'Permissions',
                    icon: 'icon-account-key',
                    state: 'app.permission',
                    order: m.display_order
                  });
                  break;
                }
                case 'Role': {
                  msNavigationService.saveItem('User.role', {
                    title: 'Roles',
                    icon: 'icon-account-check',
                    state: 'app.role',
                    order: m.display_order
                  });
                  break;
                }
                case 'User': {
                  msNavigationService.saveItem('User.user', {
                    title: 'Users',
                    icon: 'icon-account',
                    state: 'app.user',
                    order: m.display_order
                  });
                  break;
                }
                case 'Module': {
                  msNavigationService.saveItem('module', {
                    title: 'Modules',
                    icon: 'icon-view-module',
                    state: 'app.module',
                    order: m.display_order
                  });
                  break;
                }
                case 'Statistics': {
                  msNavigationService.saveItem('statistics', {
                    title: 'Statistics',
                    icon: 'icon-poll',
                    state: 'app.statistics',
                    order: m.display_order
                  });
                  break;
                }
                case 'SMS': {
                  msNavigationService.saveItem('SMS.sms', {
                    title: 'Daily Appointment Blast List',
                    icon: 'icon-comment',
                    state: 'app.sms',
                    order: m.display_order
                  });
                  break;
                }
                case 'SMS Response': {
                  msNavigationService.saveItem('SMS.smsResponse', {
                    title: 'SMS Response',
                    icon: 'icon-comment',
                    state: 'app.smsResponse',
                    order: m.display_order
                  });
                  break;
                }
                case 'Settings': {
                  msNavigationService.saveItem('Settings.Settings', {
                    title: 'Settings',
                    icon: 'icon-cog',
                    state: 'app.settings',
                    order: m.display_order
                  });
                  break;
                }
                case 'Announcement': {
                  msNavigationService.saveItem('Settings.announcement', {
                    title: 'Announcement',
                    icon: 'icon-volume',
                    state: 'app.announcement',
                    order: m.display_order
                  });
                  break;
                }
                case 'Surgical Procedure': {
                  msNavigationService.saveItem('Settings.surgicalProcedure', {
                    title: 'Surgical Procedure',
                    icon: 'icon-content-cut',
                    state: 'app.surgicalProcedure',
                    order: m.display_order
                  });
                  break;
                }
                case 'Roster': {
                  msNavigationService.saveItem('Roster.roster', {
                    title: 'Roster',
                    icon: 'icon-calendar-clock',
                    state: 'app.roster',
                    order: m.display_order
                  });
                  msNavigationService.saveItem('Roster.rosterList', {
                    title: 'Roster List',
                    icon: 'icon-calendar-clock',
                    state: 'app.rosterList',
                    order: m.display_order
                  });
                  break;
                }
                case 'Shift': {
                  msNavigationService.saveItem('Roster.shift', {
                    title: 'Shift',
                    icon: 'icon-calendar-text',
                    state: 'app.shift',
                    order: m.display_order
                  });
                  break;
                }
                case 'Timeslot': {
                  msNavigationService.saveItem('Roster.timeslot', {
                    title: 'Timeslot',
                    icon: 'icon-clock',
                    state: 'app.timeslot',
                    order: m.display_order
                  });
                  break;
                }
                case 'Specialty': {
                  msNavigationService.saveItem('Roster.specialty', {
                    title: 'Specialty',
                    icon: 'icon-tie',
                    state: 'app.specialty',
                    order: m.display_order
                  });
                  break;
                }
                case 'Income': {
                  // if (
                  //   service.user.username === 'MKKWAN' ||
                  //   service.user.username === 'VAIRAVANN' ||
                  //   service.user.username === 'SANJIVM' ||
                  //   service.user.username === 'IDANH' ||
                  //   service.user.username === 'SKLIM' ||
                  //   service.user.username === 'TAONG' ||
                  //   service.user.username === 'SITIZAWIAH' ||
                  //   service.user.username === 'YAZID' ||
                  //   service.user.username === 'AMERSIDDIQ' ||
                  //   service.user.username === 'RAMESHSINGH' ||
                  //   service.user.username === 'VICKY'
                  // ) {
                  msNavigationService.saveItem('Income', {
                    title: 'Income',
                    icon: 'icon-cash-usd',
                    state: 'app.income',
                    order: m.display_order
                  });
                  // }
                  break;
                }
                case 'Charge Category Setup': {
                  msNavigationService.saveItem('Settings.chargeCategorySetup', {
                    title: 'Charge Category Setup',
                    icon: 'icon-cash-multiple',
                    state: 'app.chargeCategorySetup',
                    order: m.display_order
                  });
                  break;
                }
                case 'Charge Code Override Amount': {
                  msNavigationService.saveItem(
                    'Settings.chargeCodeOverrideAmount',
                    {
                      title: 'Charge Code Override Amount',
                      icon: 'icon-cash',
                      state: 'app.chargeCodeOverrideAmount',
                      order: m.display_order
                    }
                  );
                  break;
                }
              }
            });
          }
        })
        .catch(function (err) {
          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function getPermissionByModule() {
      return $http
        .get($rootScope.routePath + '/account/get-permission-by-module')
        .then(function (res) {
          res = res.data;
          if (res.success) {
            $rootScope.$broadcast('permissionGet', {
              canView: res.data.can_view,
              canCreate: res.data.can_create,
              canModify: res.data.can_modify,
              canDelete: res.data.can_delete
            });

            service.canView = res.data.can_view;
            service.canCreate = res.data.can_create;
            service.canModify = res.data.can_modify;
            service.canDelete = res.data.can_delete;

            if (!service.canView) {
              logout();
              $state.go('app.login');
            }
          } else {
            logout();
            $state.go('app.login');
          }
        })
        .catch(function (err) {
          $rootScope.$broadcast('permissionGet', {
            canView: false,
            canCreate: false,
            canModify: false,
            canDelete: false
          });

          if (err.message) sharedService.showToast(err.message);
          else sharedService.showToast('Request timed out.');
        });
    }

    function _getCurrentActiveAnnouncement() {
      $http
        .get($rootScope.routePath + '/announcement/getCurrentActive')
        .then(function (res) {
          res = res.data;

          if (!res.success) return $q.reject(res.message);

          $rootScope.globalAnnouncement = res.data.announcement;
        })
        .catch(function (err) {});
    }

    $rootScope.$on('$viewContentLoading', function (jsEvent, viewConfig) {
      loadSidenav();
      if (!service.toState) {
        getPermissionByModule();
        _getCurrentActiveAnnouncement();
      } else {
        if (
          service.toState.moduleName !== 'Login' &&
          service.toState.moduleName !== 'Forgot Password'
        ) {
          getPermissionByModule();
          _getCurrentActiveAnnouncement();
        }
      }
    });

    $rootScope.$on(
      '$stateChangeSuccess',
      function (jsEvent, toState, toParams, fromState, fromParams) {
        service.toState = toState;
      }
    );
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config()
    {
    }
})();

(function () {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('ToolbarController', ToolbarController);

  /** @ngInject */
  function ToolbarController(
    $rootScope,
    $q,
    $state,
    $timeout,
    $mdSidenav,
    $translate,
    $mdToast,
    msNavigationService,
    accountService,
    sharedService,
    $window
  ) {
    var vm = this;

    // Data
    vm.accountService = accountService;
    vm.sharedService = sharedService;

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.logout = logout;
    vm.openScheduleDocument = _openScheduleDocument;
    vm.openFormularyDocument = _openFormularyDocument;
    vm.openGlobocareUserGuide = _openGlobocareUserGuide;
    vm.openScheduleOfProcedureBooklet = _openScheduleOfProcedureBooklet;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

    //////////

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Logout Function
     */
    function logout() {
      // Do logout here..
      accountService.logout().then(function () {
        $state.go('app.login');
      });
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }

    /**
     * Toggle msNavigation folded
     */
    function toggleMsNavigationFolded() {
      msNavigationService.toggleFolded();
    }

    function _openScheduleDocument() {
      $window.open(
        $rootScope.routePath + '/uploads/documents/13th Schedule dec 2013.pdf',
        '_blank'
      );
    }

    function _openFormularyDocument() {
      $window.open(
        $rootScope.routePath + '/uploads/documents/UMSC Formulary.pdf',
        '_blank'
      );
    }

    function _openGlobocareUserGuide() {
      $window.open(
        $rootScope.routePath +
          '/uploads/documents/User Manual for Globocare Medical Record Management System.pdf',
        '_blank'
      );
    }

    function _openScheduleOfProcedureBooklet() {
      $window.open(
        $rootScope.routePath +
          '/uploads/documents/Schedule of Procedures_UMSC 2022.pdf',
        '_blank'
      );
    }
  }
})();

(function () {
  'use strict';

  /**
   * Main module of the Fuse
   */
  angular.module('fuse', [
    // Common 3rd Party Dependencies
    'textAngular',
    'xeditable',
    'moment-picker',
    'lfNgMdFileInput',
    'minicolors',

    // Core
    'app.core',

    // Services
    'app.services',

    // Directives
    'app.directives',

    // Models
    'app.models',

    // Navigation
    'app.navigation',

    // Toolbar
    'app.toolbar',

    // UMSC
    'app.login',
    'app.forgotPassword',
    'app.dashboard',
    'app.user',
    'app.role',
    'app.permission',
    'app.module',
    'app.appointment',
    'app.operationTheater',
    'app.sevenDaysDischarge',
    'app.bill',
    'app.todo',
    'app.statistics',
    'app.sms',
    'app.smsResponse',
    'app.settings',
    'app.roster',
    'app.rosterList',
    'app.shift',
    'app.timeslot',
    'app.specialty',
    'app.income',
    'app.announcement',
    'app.featurePopup',
    'app.surgicalProcedure',
    'app.eDischargeStaff',
    'app.eDischargeConsultant',
    'app.chargeCategorySetup',
    'app.chargeCodeOverrideAmount',
    'app.insuranceQna',
    'app.doctorPrescription',
    'app.pharmacyPrescription'
  ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function() {
	'use strict';

	angular
		.module('app.models', []);
})();
(function() {
	'use strict';

	angular
		.module('app.models')
		.service('User', model);
	
	/** @ngInject */
	function model() {
		function User(values) {
			this.id = 0;
			this.username = '';
			this.password = '';
			this.email = '';
			this.token = '';
			this.token_expiry_datetime = null;
			this.profile_name = '';
			this.is_suspended = '';
			this.reset_phrase = '';
			this.phrase_expiry_datetime = null;
			this.is_phrase_verified = false;

			// Special case for Personal Assistants
			this.doctorUsername = '';

			// Relations
			this.roles = [];

			values = values || {};

			if (typeof values !== 'object') {
				throw new TypeError('Expected User values to be an object!');
			}

			for (var key in values) {
				if (this.hasOwnProperty(key)) {
					this[key] = values[key];
				}
			}
		}

		User.prototype.hasRole = hasRole;
		User.prototype.getFlatRoleNames = getFlatRoleNames;
		User.prototype.isSuspendedString = isSuspendedString;
		User.prototype.getFirstRole = getFirstRole;

		//////////

		function hasRole(roleName) {
			for (var i = 0; i < this.roles.length; ++i) {
				var role = this.roles[i];
				if (role.name.toUpperCase() === roleName.toUpperCase()) {
					return true;
				}
			}
			return false;
		}

		function getFlatRoleNames() {
			var roleNames = '';
			for (var i = 0; i < this.roles.length; ++i) {
				if (i > 0) {
					roleNames += ', ';
				}
				roleNames += this.roles[i].description;
			}
			return roleNames;
		}

		function isSuspendedString() {
			return this.is_suspended ? 'YES' : 'NO';
		}

		function getFirstRole() {
			return this.roles.length >= 1 ? this.roles[0].name : '';
		}

		return User;
	}
})();
(function() {
	'use strict';

	angular
		.module('app.models')
		.service('Todo', model);
	
	/** @ngInject */
	function model() {
		function Todo(values) {
			this.id = 0;
			this.type = '';
			this.subtype = '';
			this.requested_datetime = null;
			this.remarks = '';
			this.status = Todo.STATUS.REQUESTED;
			this.created_datetime = moment();
			this.created_by = '';
			this.created_by_role = '';
			this.created_for = '';
			this.created_for_role = '';
			this.ref_id = 0;

			// Additional field for secondary personnel (e.g. Personal Asssitant)
			this.created_by_2 = '';
			this.created_by_role_2 = '';

			// Additional field for closing thread
			this.closed_by = '';
			this.closed_by_role = '';
			this.closed_datetime = null;

			// Additional field for secondary recipient (e.g. Nurse Manager)
			this.created_for_2 = '';
			this.created_for_role_2 = '';

			// Additional field for biller attachment
			this.attachment = null;
			this.attachment_name = null;

			values = values || {};

			if (typeof values !== 'object') {
				throw new TypeError('Expected Todo values to be an object!');
			}

			for (var key in values) {
				if (this.hasOwnProperty(key)) {
					this[key] = values[key];
				}
			}
		}

		// Type
		Todo.TYPE = {
			APPOINTMENT: 'APPOINTMENT',
			BILLING: 'BILLING',
			MEMO: 'MEMO',
			OT_BOOKING: 'OT BOOKING'
		};

		// Subtypes
		Todo.SUBTYPE = {
			RESCHEDULE: 'RESCHEDULE',
			CANCEL: 'CANCEL',
			CANCEL_CLINIC: 'CANCEL CLINIC'
		};

		// Status
		Todo.STATUS = {
			REQUESTED: 'REQUESTED',
			PENDING: 'PENDING',
			COMPLETED: 'COMPLETED',

			// Nurse Manager
			APPROVED: 'APPROVED',
			REJECTED: 'REJECTED'
		};

		// Methods
		Todo.prototype.getRequestedDatetime = getRequestedDatetime;
		Todo.prototype.getCreatedDatetime = getCreatedDatetime;
		Todo.prototype.getClosedDatetime = getClosedDatetime;

		//////////

		function getRequestedDatetime() {
			return moment(this.requested_datetime).local();
		}

		function getCreatedDatetime() {
			return moment(this.created_datetime).local();
		}

		function getClosedDatetime() {
			return moment(this.closed_datetime).local();
		}

		return Todo;
	}
})();
(function() {
	'use strict';

	angular
		.module('app.models')
		.service('SevenDaysDischarge', model);
	
	function model() {
		function SevenDaysDischarge(values) {
			this.id = 0;
			this.ext_id = 0;
			this.episode_no = '';
			this.created_datetime = null;
			this.last_modified_datetime = null;
			this.admission_datetime = null;
			this.discharge_datetime = null;
			this.txn_desc = '';
			this.txn_amount = 0.00;
			this.dr_code = '';
			this.billinggrp_code = '';

			values = values || {};

			if (typeof values !== 'object') {
				throw new TypeError('Expected User values to be an object!');
			}

			for (var key in values) {
				if (this.hasOwnProperty(key)) {
					this[key] = values[key];
				}
			}
		}

		// Methods
		SevenDaysDischarge.prototype.getAdmissionDatetime = getAdmissionDatetime;
		SevenDaysDischarge.prototype.getDischargeDatetime = getDischargeDatetime;

		//////////

		function getAdmissionDatetime() {
			return moment(this.admission_datetime).local();
		}

		function getDischargeDatetime() {
			return moment(this.discharge_datetime).local();
		}

		return SevenDaysDischarge;
	}
})();
(function() {
	'use strict';

	angular
		.module('app.models')
		.service('Role', model);
	
	function model() {
		function Role(values) {
			this.id = 0;
			this.name = '';
			this.description = '';

			values = values || {};

			if (typeof values !== 'object') {
				throw new TypeError('Expected User values to be an object!');
			}

			for (var key in values) {
				if (this.hasOwnProperty(key)) {
					this[key] = values[key];
				}
			}
		}

		Role.NAME = {
			ROOT: 'Root',
			ADMIN: 'Admin',
			CALL_CENTER_STAFF: 'CallCenterStaff',
			PRE_ADMISSION_STAFF: 'PreAdmissionStaff',
			BILLER: 'Biller',
			DOCTOR: 'Doctor',
			NURSE_MANAGER: 'NurseManager',
			PERSONAL_ASSISTANT: 'PersonalAssistant'
		};

		return Role;
	}
})();
(function() {
	'use strict';

	angular
		.module('app.models')
		.service('Permission', model);
	
	function model() {
		function Permission(values) {
			this.id = 0;
			this.role_id = 0;
			this.module_id = 0;
			this.module_name = '';
			this.can_view = false;
			this.can_create = false;
			this.can_modify = false;
			this.can_delete = false;

			values = values || {};

			if (typeof values !== 'object') {
				throw new TypeError('Expected User values to be an object!');
			}

			for (var key in values) {
				if (this.hasOwnProperty(key)) {
					this[key] = values[key];
				}
			}
		}

		return Permission;
	}
})();
(function() {
	'use strict';

	angular
		.module('app.models')
		.service('OperationTheater', model);
	
	function model() {
		function OperationTheater(values) {
			this.id = 0;
			this.ext_id = 0;
			this.created_datetime = null;
			this.last_modified_datetime = null;
			this.patient_name = '';
			this.patient_no = '';
			this.patient_gender = '';
			this.patient_bd = null;
			this.diagnosis = '';
			this.procedures = '';
			this.surgeon = '';
			this.surgeon_code = '';
			this.anesthesiologist = '';
			this.surgery_type = '';
			this.anesthesia_tech = '';
			this.location = '';
			this.scrub_nurse = '';
			this.anes_scrub_nurse = '';
			this.circulate_nurse = '';
			this.pro_remarks = '';
			this.booking_datetime = null;
			this.room_code = '';
			this.or_status = '';
			this.status_description = '';
			this.room_desc = '';
			this.operation_datetime = null;

			values = values || {};

			if (typeof values !== 'object') {
				throw new TypeError('Expected User values to be an object!');
			}

			for (var key in values) {
				if (this.hasOwnProperty(key)) {
					this[key] = values[key];
				}
			}
		}

		// Methods
		OperationTheater.prototype.getMrnNameHtmlString = getMrnNameHtmlString;
		OperationTheater.prototype.getGenderAgeString = getGenderAgeString;
		OperationTheater.prototype.getOperationDatetime = getOperationDatetime;
		OperationTheater.prototype.getBookingDatetime = getBookingDatetime;

		//////////

		function getMrnNameHtmlString() {
			return this.patient_no + '<br>' + this.patient_name;
		}

		function getGenderAgeString() {
			return this.patient_gender + '/' + getAgeString(this.patient_bd);
		}

		function getOperationDatetime() {
			return moment(this.operation_datetime).local();
		}

		function getBookingDatetime() {
			return moment(this.booking_datetime).local();
		}

		function getAgeString(dateString) {
			if (dateString == null || dateString == undefined) return null;
			var today = moment();
			var birthDate = moment.utc(dateString);
			var age = moment.duration(today.diff(birthDate));
			return age.asYears() === 0 ? Math.ceil(age.asMonths()) + ' MTHS' : Math.ceil(age.asYears()) + ' YRS';
		}

		return OperationTheater;
	}
})();
(function() {
	'use strict';

	angular
		.module('app.models')
		.service('Module', model);
	
	function model() {
		function Module(values) {
			this.id = 0;
			this.name = '';
			this.is_active = false;
			this.display_order = 0;

			values = values || {};

			if (typeof values !== 'object') {
				throw new TypeError('Expected User values to be an object!');
			}

			for (var key in values) {
				if (this.hasOwnProperty(key)) {
					this[key] = values[key];
				}
			}
		}

		return Module;
	}
})();
(function() {
	'use strict';

	angular
		.module('app.models')
		.service('Appointment', model);
	
	/** @ngInject */
	function model() {
		function Appointment(values) {
			this.id = 0;
			this.ext_id = 0;
			this.datetime = null;
			this.status_id = 0;
			this.status_code = '';
			this.status_desc = '';
			this.type_code = '';
			this.type_desc = '';
			this.urgent_ind = '';
			this.created_datetime = null;
			this.last_modified_datetime = null;
			this.patient_no = '';
			this.patient_name = '';
			this.dr_code = '';
			this.dr_desc = '';
			this.dr_specialty_code = '';
			this.dr_specialty_desc = '';

			values = values || {};

			if (typeof values !== 'object') {
				throw new TypeError('Expected Appointment values to be an object!');
			}

			for (var key in values) {
				if (this.hasOwnProperty(key)) {
					this[key] = values[key];
				}
			}
		}

		// Status
		Appointment.STATUS = {
			MOVED: 'MOVED',
			CANCELLED: 'CANCELLED',
			FUTURE: 'FUTURE'
		};

		// Methods
		Appointment.prototype.getDatetime = getDatetime;
		Appointment.prototype.setDatetime = setDatetime;
		Appointment.prototype.getCreatedDatetime = getCreatedDatetime;
		Appointment.prototype.setCreatedDatetime = setCreatedDatetime;
		Appointment.prototype.getLastModifiedDatetime = getLastModifiedDatetime;
		Appointment.prototype.setLastModifiedDatetime = setLastModifiedDatetime;
		Appointment.prototype.isUrgent = isUrgent;
		Appointment.prototype.isUrgentString = isUrgentString;

		function isUrgent() {
			return this.urgent_ind === 'Y';
		}

		function isUrgentString() {
			return this.urgent_ind === 'Y' ? 'YES' : 'NO';
		}

		function getDatetime() {
			return moment(this.datetime).local();
		}

		function setDatetime(datetime) {
			this.datetime = datetime.toISOString();
		}

		function getCreatedDatetime() {
			return moment(this.created_datetime).local();
		}

		function setCreatedDatetime(created_datetime) {
			this.created_datetime = created_datetime.toISOString();
		}

		function getLastModifiedDatetime() {
			return moment(this.last_modified_datetime).local();
		}

		function setLastModifiedDatetime(last_modified_datetime) {
			this.last_modified_datetime = last_modified_datetime.toISOString();
		}

		return Appointment;
	}
})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function () {
  'use strict';

  angular.module('fuse').run(runBlock);

  /** @ngInject */
  function runBlock(
    $rootScope,
    $timeout,
    $state,
    $location,
    $cookies,
    editableThemes,
    unsavedChangesService
  ) {
    var protocol = $location.protocol();
    var host = $location.host();

    $rootScope.routePath =
      host === 'localhost'
        ? protocol + '://' + host + ':38808/api'
        : 'https://' + host + '/api';

    $rootScope.buildVersion = '20260904.03.4171c27';
    $rootScope.disclaimerText =
      'Requests will be handled by our staffs within 2-3 business days.';

    // 3rd Party Dependencies
    editableThemes.default.submitTpl =
      '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
    editableThemes.default.cancelTpl =
      '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';

    unsavedChangesService.registerUnsavedChangesHandler();

    // Immediately refresh the token time (if any)
    var expires = moment().add(7, 'days').toDate();

    var isRemembered = $cookies.getObject('is_remembered');
    if (isRemembered !== undefined) {
      $cookies.putObject('is_remembered', isRemembered, {
        expires: expires
      });
    }

    var user = $cookies.getObject('user');
    if (user !== undefined) {
      $cookies.putObject('user', user, {
        expires: expires
      });
    }

    var userBak = $cookies.getObject('user_bak');
    if (userBak !== undefined) {
      $cookies.putObject('user_bak', userBak, {
        expires: expires
      });
    }

    // Activate loading indicator
    var stateChangeStartEvent = $rootScope.$on(
      '$stateChangeStart',
      function () {
        $rootScope.loadingProgress = true;
      }
    );

    // De-activate loading indicator
    var stateChangeSuccessEvent = $rootScope.$on(
      '$stateChangeSuccess',
      function () {
        $timeout(function () {
          $rootScope.loadingProgress = false;
        });
      }
    );

    // Store state in the root scope for easy access
    $rootScope.state = $state;

    // Cleanup
    $rootScope.$on('$destroy', function () {
      stateChangeStartEvent();
      stateChangeSuccessEvent();
    });
  }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(false);

        $urlRouterProvider.otherwise('/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    }
                }
            });
    }

})();
(function () {
  'use strict';

  angular.module('fuse').controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(fuseTheming, $rootScope, $cookies) {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;
    vm.isLoggedIn = !!$cookies.getObject('user');

    //////////

    $rootScope.$on('userLoggedIn', function () {
      vm.isLoggedIn = true;
    });

    $rootScope.$on('userLoggedOut', function () {
      vm.isLoggedIn = false;
    });

    vm.closeAnnouncement = function () {
      angular.element('#header').slideToggle('fast');
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider, $provide, $mdAriaProvider, $httpProvider, $cookiesProvider)
    {
        // Put your common app configurations here

        // Inject hReqInterceptor
        $httpProvider.interceptors.push('hReqInterceptor');

        // Retain cookies please!
        // $cookiesProvider.defaults.path = '/';

        // Disable ARIA warnings
        $mdAriaProvider.disableWarnings();

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        /**
         * Here you can find all the definitions that the Demo Project requires
         *
         * If you wish to use this method, you can create your API definitions
         * in a similar way.
         */

        /*
         api.dashboard = {
         project  : $resource(api.baseUrl + 'dashboard/project/data.json'),
         server   : $resource(api.baseUrl + 'dashboard/server/data.json'),
         analytics: $resource(api.baseUrl + 'dashboard/analytics/data.json')
         };

         api.cards = $resource(api.baseUrl + 'cards/cards.json');

         api.fileManager = {
         documents: $resource(api.baseUrl + 'file-manager/documents.json')
         };

         api.ganttChart = {
         tasks: $resource(api.baseUrl + 'gantt-chart/tasks.json'),
         timespans : $resource(api.baseUrl + 'gantt-chart/timespans.json')
         };

         api.icons = $resource('assets/icons/selection.json');

         api.invoice = $resource(api.baseUrl + 'invoice/invoice.json');

         api.mail = {
         inbox: $resource(api.baseUrl + 'mail/inbox.json')
         };

         api.profile = {
         timeline    : $resource(api.baseUrl + 'profile/timeline.json'),
         about       : $resource(api.baseUrl + 'profile/about.json'),
         photosVideos: $resource(api.baseUrl + 'profile/photos-videos.json')
         };

         api.quickPanel = {
         activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
         contacts  : $resource(api.baseUrl + 'quick-panel/contacts.json'),
         events    : $resource(api.baseUrl + 'quick-panel/events.json'),
         notes     : $resource(api.baseUrl + 'quick-panel/notes.json')
         };

         api.search = {
         classic : $resource(api.baseUrl + 'search/classic.json'),
         mails   : $resource(api.baseUrl + 'search/mails.json'),
         users   : $resource(api.baseUrl + 'search/users.json'),
         contacts: $resource(api.baseUrl + 'search/contacts.json')
         };

         api.scrumboard = {
         boardList: $resource(api.baseUrl + 'scrumboard/boardList.json'),
         board    : $resource(api.baseUrl + 'scrumboard/boards/:id.json')
         };

         api.tables = {
         employees   : $resource(api.baseUrl + 'tables/employees.json'),
         employees100: $resource(api.baseUrl + 'tables/employees100.json')
         };

         api.timeline = {
         page1: $resource(api.baseUrl + 'timeline/page-1.json'),
         page2: $resource(api.baseUrl + 'timeline/page-2.json'),
         page3: $resource(api.baseUrl + 'timeline/page-3.json')
         };

         api.todo = {
         tasks: $resource(api.baseUrl + 'todo/tasks.json'),
         tags : $resource(api.baseUrl + 'todo/tags.json')
         };
         */

        return api;
    }

})();
(function () {
  'use strict';

  angular.module('app.pharmacyPrescription', []).config(config);

  /** @ngInject */
  function config($stateProvider, msApiProvider) {
    $stateProvider
      // Main
      .state('app.pharmacyPrescription', {
        url: '/pharmacy-prescription',
        moduleName: "Pharmacy's Prescription"
      });
  }
})();

(function () {
  'use strict';

  angular.module('app.insuranceQna', []).config(config);

  /** @ngInject */
  function config($stateProvider, msApiProvider) {
    $stateProvider
      // Main
      .state('app.insuranceQna', {
        url: '/insurance-qna',
        moduleName: 'Insurance Q&A'
      });
  }
})();

(function () {
  'use strict';

  angular.module('app.chargeCategorySetup', []).config(config);

  /** @ngInject */
  function config($stateProvider, msApiProvider) {
    $stateProvider
      // Main
      .state('app.chargeCategorySetup', {
        url: '/charge-category-setup',
        moduleName: 'Charge Category Setup'
      });
  }
})();

(function () {
  'use strict';

  angular.module('app.chargeCodeOverrideAmount', []).config(config);

  /** @ngInject */
  function config($stateProvider, msApiProvider) {
    $stateProvider
      // Main
      .state('app.chargeCodeOverrideAmount', {
        url: '/charge-code-override-amount',
        moduleName: 'Charge Code Override Amount'
      });
  }
})();

(function () {
  'use strict';

  angular.module('app.doctorPrescription', []).config(config);

  /** @ngInject */
  function config($stateProvider, msApiProvider) {
    $stateProvider
      // Main
      .state('app.doctorPrescription', {
        url: '/doctor-prescription',
        moduleName: "Doctor's Prescription"
      });
  }
})();

(function() {
	'use strict';

	angular
		.module('app.directives', [
			'app.directives.mdChips'
		]);
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/announcement/announcement.html","<div id=\"announcement\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon>\n<span class=\"white-fg h2\" ng-bind=\"vm.sharedService.pageName\"></span></div><div class=\"toolbar white-bg\"><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"sep\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex=\"100\" class=\"search\" md-no-float><input type=\"search\" \nplaceholder=\"Search\" ng-model=\"vm.searchTerm\" ng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.search()\">\n</md-input-container></div><div class=\"nav-buttons\" layout=\"row\" layout-align=\"space-around center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.announcementTable.page.info().start === 0\">\n<md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.announcementTable.page.info().end === vm.announcementTable.page.info().recordsTotal\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div></div><div \nclass=\"content\" layout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table \nid=\"announcement-dt\" class=\"dataTable row-border hover\"></table><div class=\"loading\" ng-show=\"vm.loading\">\n<md-progress-circular md-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div><md-button \nclass=\"md-fab md-fab-bottom-right md-warn md-mini\" ng-click=\"vm.edit()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"top\">Add Announcement</md-tooltip></md-button></div>");
$templateCache.put("app/main/appointment/appointment.html","<div id=\"appointment\" class=\"page-layout carded fullwidth\"><div id=\"appt-main\" ng-hide=\"vm.showListView\" \nlayout=\"column\"><div class=\"header\" ng-class=\"vm.currentMonthShort\"><div class=\"header-content\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\"></md-icon>\n</span><span class=\"logo-text\">{{ vm.sharedService.pageName }}</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.today()\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip>Today</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\"><md-icon md-font-icon=\"icon-view-module\"></md-icon>\n<md-tooltip>Month</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" hide-xs><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip>\nWeek</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\"><md-icon \nmd-font-icon=\"icon-view-day\"></md-icon><md-tooltip>Day</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.showSearchbar = !vm.showSearchbar\"><md-icon \nmd-font-icon=\"{{ vm.showSearchbar ? \'icon-close\' : \'icon-magnify\' }}\"></md-icon><md-tooltip>Show Searchbar</md-tooltip>\n</md-button></div></div><div class=\"header-bottom-wrapper\" layout=\"row\" layout-align=\"space-between\"><div \nclass=\"header-bottom\" ng-class=\"{\'hide-on-search\': vm.showSearchbar}\" layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-icon-button arrow\" ng-click=\"vm.prev()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n<md-tooltip>Previous</md-tooltip></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.next()\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next\n</md-tooltip></md-button></div><div class=\"header-bottom-searchbar\" ng-class=\"{\'show-on-search\': vm.showSearchbar}\" \nlayout=\"row\" layout-align=\"space-between center\"><md-autocomplete md-no-float class=\"md-block\" flex \nplaceholder=\"Patient\" md-delay=\"200\" md-item-text=\"appointment.patient_name\" md-selected-item=\"vm.appointment\" \nmd-selected-item-change=\"vm.showList()\" md-search-text=\"vm.searchAppointment\" \nmd-items=\"appointment in vm.acAppointment()\" md-input-name=\"patient\" md-menu-class=\"mdit-custom\" \nmd-menu-container-class=\"mdit-custom-container\" md-require-match required><md-item-template><span class=\"mdit-title\">\n{{ appointment.patient_name }}</span> <span class=\"mdit-group\"><span class=\"mdit-subtitle\" \nng-class=\"{\'is-new\': !appointment.patient_no }\">{{ appointment.subtitle }}</span> <span class=\"mdit-sub\">\n{{ appointment.getDatetime().format(\'DD/MM/YYYY hh:mm a\') }}</span></span></md-item-template><md-not-found>\nNo matches found.</md-not-found></md-autocomplete></div></div></div></div><md-content class=\"content\" ms-scroll \nmd-swipe-left=\"vm.next()\" md-swipe-right=\"vm.prev()\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" \nng-model=\"vm.events\" calendar=\"main\"></div></md-content><md-button \nclass=\"add-todo-button md-fab md-fab-bottom-right md-warn\" ng-class=\"vm.mediaXsAddButton\" ng-click=\"vm.edit()\"><md-icon\n md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Request for Changes</md-tooltip></md-button></div>\n<div id=\"appt-listview\" ng-show=\"vm.showListView\"><div class=\"top-bg md-accent-bg\"><div class=\"lv-header\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\" hide-xs></md-icon>\n<span class=\"white-fg h2\" hide-xs flex>{{ vm.sharedService.pageName }}</span><md-button class=\"btn-ra\" \nng-click=\"vm.hideList()\" hide-xs><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip>Back</md-tooltip><span>\nBACK</span></md-button><md-button class=\"btn-ra md-icon-button\" ng-click=\"vm.hideList()\" hide-gt-xs><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip>Back</md-tooltip></md-button></div></div><div class=\"center\" \nms-scroll><div class=\"nra-container\" ng-repeat=\"appt in vm.appts track by appt.id\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"nra-left\" layout=\"column\" layout-align=\"center center\"><span \nng-bind=\"::$index + 1\"></span></div><div class=\"nra-center\" flex layout=\"column\" layout-align=\"start stretch\"><div \nclass=\"nra-title\"><span ng-bind=\"::appt.patient_name\"></span></div><div class=\"nra-content\"><span \nng-bind=\"::appt.patient_no\"></span></div><div class=\"nra-time\" layout=\"row\" layout-align=\"space-between center\"><span \nng-bind=\"::appt.status_desc\" flex></span> <span ng-bind=\"::appt.getDatetime().format(\'DD/MM/YYYY hh:mm a\')\"></span>\n</div></div><div class=\"nra-right\"><md-button class=\"md-icon-button\" ng-click=\"vm.showPopup(appt.id)\"><md-icon \nmd-font-icon=\"icon-window-maximize\"></md-icon><md-tooltip>Show Popup</md-tooltip></md-button></div></div></div></div>\n</div>");
$templateCache.put("app/main/bill/bill.html","<div id=\"bill\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs><md-icon \nmd-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\">\n{{ vm.sharedService.pageName }}</span></div><div class=\"content-card\"><md-content class=\"content\" ms-scroll><form \nname=\"billForm\" ng-submit=\"vm.request()\" novalidate><div layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\">\n<md-autocomplete class=\"md-block\" flex-gt-xs=\"33\" md-floating-label=\"Patient\" md-delay=\"200\" \nmd-item-text=\"patient.patient_name\" md-selected-item=\"vm.patient\" md-search-text=\"vm.searchPatient\" \nmd-items=\"patient in vm.acPatient()\" md-input-name=\"patient\" md-require-match required><md-item-template><span \nmd-highlight-text=\"vm.searchPatient\">{{ patient.patient_no }} :: {{ patient.patient_name }}</span></md-item-template>\n<md-not-found>No matches found.</md-not-found><div ng-messages=\"billForm.patient.$error\" \nng-show=\"billForm.patient.$dirty\"><div ng-message=\"required\">Patient is required</div><div \nng-message=\"md-require-match\">Please select a valid patient.</div></div></md-autocomplete><md-autocomplete \nclass=\"md-block\" flex-gt-xs=\"33\" md-floating-label=\"For Doctor\" md-delay=\"200\" md-item-text=\"doctor.name\" \nmd-selected-item=\"vm.doctor\" md-search-text=\"vm.searchDoctor\" md-items=\"doctor in vm.acDoctor()\" \nmd-input-name=\"doctor\" md-require-match required><md-item-template><span md-highlight-text=\"vm.searchDoctor\">\n{{ doctor.code }} :: {{ doctor.name }}</span></md-item-template><md-not-found>No matches found.</md-not-found><div \nng-messages=\"billForm.doctor.$error\" ng-show=\"billForm.doctor.$dirty\"><div ng-message=\"required\">Doctor is required\n</div><div ng-message=\"md-require-match\">Please select a valid doctor.</div></div></md-autocomplete></div><div \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><md-autocomplete class=\"md-block\" flex-gt-xs=\"33\" \nmd-floating-label=\"Episode\" md-delay=\"200\" md-item-text=\"episode.episode_no\" md-selected-item=\"vm.episode\" \nmd-search-text=\"vm.searchEpisode\" md-items=\"episode in vm.acEpisode()\" md-input-name=\"episode\" md-require-match \nrequired><md-item-template><span md-highlight-text=\"vm.searchEpisode\">{{ episode.episode_no }}</span>\n</md-item-template><md-not-found>No matches found.</md-not-found><div ng-messages=\"billForm.episode.$error\" \nng-show=\"billForm.episode.$dirty\"><div ng-message=\"required\">Episode is required</div><div \nng-message=\"md-require-match\">Please select a valid episode.</div></div></md-autocomplete><md-autocomplete \nclass=\"md-block\" flex-gt-xs=\"33\" md-floating-label=\"Ward\" md-delay=\"200\" md-item-text=\"ward.description\" \nmd-selected-item=\"vm.ward\" md-search-text=\"vm.searchWard\" md-items=\"ward in vm.acWard()\" md-input-name=\"ward\" \nmd-require-match required><md-item-template><span md-highlight-text=\"vm.searchWard\">\n{{ ward.code }} :: {{ ward.description }}</span></md-item-template><md-not-found>No matches found.</md-not-found><div \nng-messages=\"billForm.ward.$error\" ng-show=\"billForm.ward.$dirty\"><div ng-message=\"required\">Ward is required</div><div\n ng-message=\"md-require-match\">Please select a valid ward.</div></div></md-autocomplete><md-autocomplete \nclass=\"md-block\" flex-gt-xs=\"33\" md-floating-label=\"Bed\" md-delay=\"200\" md-item-text=\"bed.bed_no\" \nmd-selected-item=\"vm.bed\" md-search-text=\"vm.searchBed\" md-items=\"bed in vm.acBed()\" md-input-name=\"bed\" \nmd-require-match required><md-item-template><span md-highlight-text=\"vm.searchBed\">{{ bed.bed_no }}</span>\n</md-item-template><md-not-found>No matches found.</md-not-found><div ng-messages=\"billForm.bed.$error\" \nng-show=\"billForm.bed.$dirty\"><div ng-message=\"required\">Bed is required</div><div ng-message=\"md-require-match\">\nPlease select a valid bed.</div></div></md-autocomplete></div><div layout=\"row\" layout-align=\"start center\">\n<md-input-container flex=\"100\" class=\"md-block\"><label>Remarks</label><input name=\"remarks\" ng-model=\"vm.todo.remarks\" \nrequired><div ng-messages=\"billForm.remarks.$error\" ng-show=\"billForm.remarks.$dirty\"><div ng-message=\"required\">\nRemarks is required</div></div></md-input-container></div><div layout=\"row\" layout-align=\"start center\">\n<lf-ng-md-file-input lf-files=\"vm.files\" lf-api=\"vm.lfApi\" flex=\"100\" multiple=\"multiple\" preview progress>\n</lf-ng-md-file-input></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-fab md-warn\" \nng-class=\"vm.mediaXsActionButtons\" ng-show=\"vm.sharedService.prevState\" ng-click=\"vm.back()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"top\">Back</md-tooltip></md-button><md-button \ntype=\"submit\" class=\"md-fab md-accent\" ng-class=\"vm.mediaXsActionButtons\" \nng-disabled=\"billForm.$invalid || billForm.$pristine\"><md-icon md-font-icon=\"icon-check\"></md-icon><md-tooltip \nmd-direction=\"top\">Place Request</md-tooltip></md-button></div></form></md-content></div></div></div>");
$templateCache.put("app/main/dashboard/dashboard2.html","<div id=\"dashboard\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs>\n<md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\">\n{{ vm.sharedService.pageName }}</span> <span class=\"expanded-only\"></span><md-button class=\"md-raised\" \nng-click=\"vm.openScheduleOfProcedureBooklet()\"><span>Schedule of Procedure Booklet</span></md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.openGlobocareUserGuide()\"><span>Globocare User Guide</span></md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.openFormularyDocument()\"><span>UMSC Formulary</span></md-button><md-button \nclass=\"md-raised\" ng-click=\"vm.openScheduleDocument()\"><span>13th Schedule Dec 2013</span></md-button></div><div \nclass=\"toolbar white-bg\"><div flex layout=\"row\" layout-align=\"end stretch\" class=\"sep\" id=\"imp\"><div \nng-repeat=\"status in vm.readStatuses\"><md-button class=\"custom-font-icon md-raised\" \nng-class=\"{\'md-accent\': status.selected }\" ng-click=\"vm.selectReadStatus(status)\"><span ng-bind=\"::status.text\" \nclass=\"text\"></span> <span class=\"{{ ::status.class }}\" ng-class=\"{\'white-600-fg-i\': status.selected }\"></span><div \nclass=\"badge\" ng-bind=\"::vm.badgesCount[status.text]\" ng-if=\"vm.badgesCount[status.text] > 0\"></div><md-tooltip \nng-bind=\"::status.tooltip\"></md-tooltip></md-button></div></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"sep\"><div flex layout=\"row\" layout-align=\"start center\"><md-button class=\"custom-font-icon md-raised\" \nng-class=\"{\'md-accent\': vm.selectedTypeAndBox === vm.typeAndBoxes[0]}\" ng-click=\"vm.selectTypeAndBox(0)\"><span \nclass=\"text\">Billing In</span><md-icon md-font-icon=\"icon-billing-in\"></md-icon><md-tooltip>Billing In</md-tooltip>\n</md-button><md-button class=\"custom-font-icon md-raised\" \nng-class=\"{\'md-accent\': vm.selectedTypeAndBox === vm.typeAndBoxes[1]}\" ng-click=\"vm.selectTypeAndBox(1)\"><span \nclass=\"text\">Billing Out</span><md-icon md-font-icon=\"icon-billing-out\"></md-icon><md-tooltip>Billing Out</md-tooltip>\n</md-button><md-button class=\"custom-font-icon md-raised\" \nng-class=\"{\'md-accent\': vm.selectedTypeAndBox === vm.typeAndBoxes[2]}\" ng-click=\"vm.selectTypeAndBox(2)\"><span \nclass=\"text\">Others In</span><md-icon md-font-icon=\"icon-others-in path1\"></md-icon><md-tooltip>Others In</md-tooltip>\n</md-button><md-button class=\"custom-font-icon md-raised\" \nng-class=\"{\'md-accent\': vm.selectedTypeAndBox === vm.typeAndBoxes[3]}\" ng-click=\"vm.selectTypeAndBox(3)\"><span \nclass=\"text\">Others Out</span><md-icon md-font-icon=\"icon-others-out\"></md-icon><md-tooltip>Others Out</md-tooltip>\n</md-button></div><div class=\"nav-buttons\" layout=\"row\" layout-align=\"space-around center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.showAdvancedSearch = !vm.showAdvancedSearch\"><md-icon \nmd-font-icon=\"{{ vm.showAdvancedSearch ? \'icon-magnify-minus\' : \'icon-magnify-plus\' }}\"></md-icon><md-tooltip>\nAdvanced Search</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.prev()\" \nng-disabled=\"vm.loading || vm.dashboardTable.page.info().start === 0\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.dashboardTable.page.info().end === vm.dashboardTable.page.info().recordsTotal\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div></div><div \nng-show=\"vm.showAdvancedSearch\" class=\"advanced-search-bar white-bg\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"asb-body\" flex layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block fix-from-date\">\n<label>From Date</label><input moment-picker ng-model=\"vm.fromDatetime\" format=\"DD/MM/YYYY\" readonly=\"readonly\">\n</md-input-container><md-input-container class=\"md-block fix-to-date\"><label>To Date</label><input moment-picker \nposition=\"bottom right\" ng-model=\"vm.toDatetime\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></md-input-container></div>\n<div class=\"asb-actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.advancedSearch()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><md-tooltip>Search</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.resetAdvancedSearch()\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Reset</md-tooltip>\n</md-button></div></div><div class=\"content\" layout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" \nmd-swipe-right=\"vm.swipeRight()\"><table id=\"dashboard-dt\" class=\"dataTable row-border hover\"></table><div \nclass=\"loading\" ng-show=\"vm.loading\"><md-progress-circular md-diameter=\"100\" class=\"md-accent\"></md-progress-circular>\n</div></div></div></div>");
$templateCache.put("app/main/e-discharge-staff/e-discharge-staff.html","<div id=\"e-discharge-staff\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon>\n<span class=\"white-fg h2\" ng-bind=\"vm.sharedService.pageName\"></span></div><div class=\"toolbar white-bg\"><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"sep\"><div flex layout=\"row\" layout-align=\"start center\">\n<md-button ng-repeat=\"filter in vm.statusFilters\" class=\"custom-font-icon md-raised\" \nng-class=\"{\'md-accent\': vm.statusFilter === filter}\" ng-click=\"vm.onStatusFilter(filter)\"><span class=\"text\" \nng-bind=\"::filter.display\"></span><md-icon md-font-icon=\"{{ ::filter.icon }}\"></md-icon><md-tooltip \nng-bind=\"::filter.tooltip\"></md-tooltip><div class=\"badge\" ng-show=\"filter.badge.show && filter.badge.count\" \nng-bind=\"filter.badge.count\"></div></md-button></div></div><div layout=\"row\" layout-align=\"end center\" class=\"sep\">\n<md-input-container flex class=\"search\" md-no-float><input type=\"search\" placeholder=\"Search\" ng-model=\"vm.searchTerm\" \nng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.search()\"></md-input-container><div class=\"nav-buttons\" \nlayout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-icon-button\" ng-click=\"vm.prev()\" \nng-disabled=\"vm.loading || vm.dataSourceTable.page.info().start === 0\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.dataSourceTable.page.info().end === vm.dataSourceTable.page.info().recordsTotal\"><md-icon\n md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div></div><div \nng-show=\"vm.showAdvancedSearch\" class=\"advanced-search-bar white-bg\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"asb-body\" flex layout=\"row\" layout-align=\"start center\"><md-input-container flex class=\"search\" \nmd-no-float><input type=\"search\" placeholder=\"Search\" ng-model=\"vm.searchTerm\" ng-model-options=\"{ debounce: 200 }\" \nng-change=\"vm.search()\"></md-input-container></div><div class=\"asb-actions\"></div></div><div class=\"content\" \nlayout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table id=\"e-discharge-staff-dt\" \nclass=\"dataTable row-border hover\"></table><div class=\"loading\" ng-show=\"vm.loading\"><md-progress-circular \nmd-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/e-discharge-consultant/e-discharge-consultant.html","<div id=\"e-discharge-consultant\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon>\n<span class=\"white-fg h2\" ng-bind=\"vm.sharedService.pageName\"></span></div><div class=\"toolbar white-bg\"><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"sep\"><div flex layout=\"row\" layout-align=\"start center\">\n<md-button ng-repeat=\"filter in vm.statusFilters\" class=\"custom-font-icon md-raised\" \nng-class=\"{\'md-accent\': vm.statusFilter === filter}\" ng-click=\"vm.onStatusFilter(filter)\"><span class=\"text\" \nng-bind=\"::filter.display\"></span><md-icon md-font-icon=\"{{ ::filter.icon }}\"></md-icon><md-tooltip \nng-bind=\"::filter.tooltip\"></md-tooltip><div class=\"badge\" ng-show=\"filter.badge.show && filter.badge.count\" \nng-bind=\"filter.badge.count\"></div></md-button></div></div><div layout=\"row\" layout-align=\"end center\" class=\"sep\">\n<md-input-container flex class=\"search\" md-no-float><input type=\"search\" placeholder=\"Search\" ng-model=\"vm.searchTerm\" \nng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.search()\"></md-input-container><div class=\"nav-buttons\" \nlayout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-icon-button\" ng-click=\"vm.prev()\" \nng-disabled=\"vm.loading || vm.dataSourceTable.page.info().start === 0\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.dataSourceTable.page.info().end === vm.dataSourceTable.page.info().recordsTotal\"><md-icon\n md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div></div><div \nng-show=\"vm.showAdvancedSearch\" class=\"advanced-search-bar white-bg\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"asb-body\" flex layout=\"row\" layout-align=\"start center\"><md-input-container flex class=\"search\" \nmd-no-float><input type=\"search\" placeholder=\"Search\" ng-model=\"vm.searchTerm\" ng-model-options=\"{ debounce: 200 }\" \nng-change=\"vm.search()\"></md-input-container></div><div class=\"asb-actions\"></div></div><div class=\"content\" \nlayout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table \nid=\"e-discharge-consultant-dt\" class=\"dataTable row-border hover\"></table><div class=\"loading\" ng-show=\"vm.loading\">\n<md-progress-circular md-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/income/income.html","<div id=\"income\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs>\n<md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\" \nng-bind=\"vm.sharedService.pageName\"></span></div><div class=\"toolbar white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"sep\"><div flex layout=\"row\" layout-align=\"space-between center\">\n<md-input-container flex class=\"search\" md-no-float \nng-show=\"vm.viewName === \'month\' || vm.viewName === \'cn_dn_year_month\'\"><input type=\"search\" placeholder=\"Search\" \nng-model=\"vm.searchTerm\" ng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.search()\"></md-input-container><div flex \nng-show=\"vm.viewName === \'cn_dn_episode\'\"></div><md-input-container class=\"search\" \nstyle=\"display: flex; align-items: center\" ng-show=\"vm.viewName === \'year\'\"><span>Income for:</span><md-select \nng-model=\"vm.yearFilter\" ng-change=\"vm.view(\'year\', 0)\" style=\"margin-left: 20px\"><md-option \nng-repeat=\"year in vm.yearFilters\" ng-value=\"year\" ng-bind=\"::year\"></md-option></md-select></md-input-container><div \nng-show=\"vm.viewName === \'year\'\" flex layout=\"row\" layout-align=\"space-between center\" style=\"font-weight: bold\"><div>\n<span>Consultant Name:</span> <span ng-bind=\"::vm.consultantName\"></span></div><div>MONTHLY INCOME STATEMENT</div>\n</div><div ng-show=\"vm.viewName === \'month\'\" flex layout=\"row\" layout-align=\"space-between center\" \nstyle=\"font-weight: bold\"><div><span>Consultant Name:</span> <span ng-bind=\"::vm.consultantName\"></span></div><div>\nMONTHLY STATEMENT BY DETAIL LIST</div></div><div \nng-show=\"vm.viewName === \'cn_dn_year_month\' || vm.viewName === \'cn_dn_episode\'\" flex layout=\"row\" \nlayout-align=\"space-between center\" style=\"font-weight: bold\"><div><span>Consultant Name:</span> <span \nng-bind=\"::vm.consultantName\"></span></div><div>CREDIT NOTE/DEBIT NOTE</div></div></div><div class=\"nav-buttons\" \nlayout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-icon-button\" ng-click=\"vm.back(\'year\')\" \nng-show=\"vm.viewName === \'month\'\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"top\">Back\n</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.back(\'month\')\" \nng-show=\"vm.viewName === \'detail\'\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"top\">\nBack</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.back(\'year\')\" \nng-show=\"vm.viewName === \'category\'\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"top\">\nBack</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.back(\'month\')\" \nng-show=\"vm.viewName === \'todo\'\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"top\">Back\n</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.back(\'year\')\" \nng-show=\"vm.viewName === \'cn_dn_year_month\'\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip \nmd-direction=\"top\">Back</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.back(\'month\')\" \nng-show=\"vm.viewName === \'cn_dn_episode\'\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip \nmd-direction=\"top\">Back</md-tooltip></md-button><div layout=\"row\" layout-align=\"space-around center\" \nng-show=\"vm.viewName === \'year\'\"><md-button class=\"md-icon-button\" ng-click=\"vm.exportGetIncomes()\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><md-tooltip md-direction=\"top\">Export</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.incomeYearTable.page.info().start === 0\">\n<md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.incomeYearTable.page.info().end === vm.incomeYearTable.page.info().recordsTotal\"><md-icon\n md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div><div layout=\"row\" \nlayout-align=\"space-around center\" ng-show=\"vm.viewName === \'month\'\"><md-button class=\"md-icon-button\" \nng-click=\"vm.exportGetIncomesByEpisodeNo()\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip \nmd-direction=\"top\">Export</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.prev()\" \nng-disabled=\"vm.loading || vm.incomeMonthTable.page.info().start === 0\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.incomeMonthTable.page.info().end === vm.incomeMonthTable.page.info().recordsTotal\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div><div layout=\"row\" \nlayout-align=\"space-around center\" ng-show=\"vm.viewName === \'detail\'\"><md-button class=\"md-icon-button\" \nng-click=\"vm.exportGetIncomeDetails()\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip md-direction=\"top\">\nExport</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.prev()\" \nng-disabled=\"vm.loading || vm.incomeDetailTable.page.info().start === 0\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.incomeDetailTable.page.info().end === vm.incomeDetailTable.page.info().recordsTotal\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div><div layout=\"row\" \nlayout-align=\"space-around center\" ng-show=\"vm.viewName === \'category\'\"><md-button class=\"md-icon-button\" \nng-click=\"vm.exportGetIncomesByCategory()\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip \nmd-direction=\"top\">Export</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.prev()\" \nng-disabled=\"vm.loading || vm.incomeCategoryTable.page.info().start === 0\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.incomeCategoryTable.page.info().end === vm.incomeCategoryTable.page.info().recordsTotal\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div><div layout=\"row\" \nlayout-align=\"space-around center\" ng-show=\"vm.viewName === \'cn_dn_year_month\'\"><md-button class=\"md-icon-button\" \nng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.incomeCnDnYearMonthTable.page.info().start === 0\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.incomeCnDnYearMonthTable.page.info().end === vm.incomeCnDnYearMonthTable.page.info().recordsTotal\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div><div layout=\"row\" \nlayout-align=\"space-around center\" ng-show=\"vm.viewName === \'cn_dn_episode\'\"><md-button class=\"md-icon-button\" \nng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.incomeCnDnEpisodeTable.page.info().start === 0\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.incomeCnDnEpisodeTable.page.info().end === vm.incomeCnDnEpisodeTable.page.info().recordsTotal\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div></div></div>\n<div class=\"content\" layout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table \nid=\"income-year-dt\" class=\"dataTable row-border hover\" ng-show=\"vm.viewName === \'year\'\" width=\"100%\"></table><div \nng-show=\"vm.viewName === \'month\' || vm.viewName === \'category\'\" style=\"background-color: white; padding: 10px 20px\">\n<div style=\"font-size: 16px\"><span style=\"font-weight: bold\">Year:</span> <span ng-bind=\"vm.yearFilter\"></span></div>\n<div style=\"font-size: 16px\"><span style=\"font-weight: bold\">Month:</span> <span ng-bind=\"vm.selectedRecord.month\">\n</span></div><div style=\"font-size: 16px\"><span style=\"font-weight: bold\">Total Bill Size:</span> <span \nng-bind=\"vm.totalBillSize\"></span></div><div style=\"font-size: 16px\"><span style=\"font-weight: bold\">\nTotal Gross Income:</span> <span ng-bind=\"vm.totalGrossIncome\"></span></div></div><table id=\"income-month-dt\" \nclass=\"dataTable row-border hover\" ng-show=\"vm.viewName === \'month\'\"></table><div ng-show=\"vm.viewName === \'detail\'\" \nstyle=\"background-color: white; padding: 10px 20px\"><div style=\"font-size: 16px\"><span style=\"font-weight: bold\">\nEpisode No:</span> <span ng-bind=\"vm.incomeDetail.episode_no\"></span></div><div style=\"font-size: 16px\"><span \nstyle=\"font-weight: bold\">Admission Datetime:</span> <span ng-bind=\"vm.incomeDetail.admission_datetime_display\"></span>\n</div><div style=\"font-size: 16px\"><span style=\"font-weight: bold\">Discharge Datetime:</span> <span \nng-bind=\"vm.incomeDetail.discharge_datetime_display\"></span></div><div style=\"font-size: 16px\"><span \nstyle=\"font-weight: bold\">Total Income:</span> <span ng-bind=\"vm.incomeDetail.eporg_dr_amt\"></span></div><div \nstyle=\"font-size: 16px\"><span style=\"font-weight: bold\">Bill Size:</span> <span ng-bind=\"vm.incomeDetail.bill_size\">\n</span></div><div style=\"font-size: 16px\"><span style=\"font-weight: bold\">Patient Type:</span> <span \nng-bind=\"vm.incomeDetail.patient_type_desc\"></span></div></div><div ng-show=\"vm.viewName === \'todo\'\" \nstyle=\"background-color: white; padding: 10px 20px\"><div style=\"font-size: 16px\"><span style=\"font-weight: bold\">\nEpisode No:</span> <span ng-bind=\"vm.selectedRecord.episode_no\"></span></div><div style=\"font-size: 16px\"><span \nstyle=\"font-weight: bold\">Admission Datetime:</span> <span ng-bind=\"vm.selectedRecord.admission_datetime_display\">\n</span></div><div style=\"font-size: 16px\"><span style=\"font-weight: bold\">Discharge Datetime:</span> <span \nng-bind=\"vm.selectedRecord.discharge_datetime_display\"></span></div><div style=\"font-size: 16px\"><span \nstyle=\"font-weight: bold\">Total Income:</span> <span ng-bind=\"vm.selectedRecord.dr_amt\"></span></div><div \nstyle=\"font-size: 16px\"><span style=\"font-weight: bold\">Bill Size:</span> <span ng-bind=\"vm.selectedRecord.bill_size\">\n</span></div><div style=\"font-size: 16px\"><span style=\"font-weight: bold\">Patient Type:</span> <span \nng-bind=\"vm.selectedRecord.patient_type_desc\"></span></div><div style=\"font-size: 14px; margin-top: 10px\"><div \nstyle=\"font-size: 16px;\n              font-weight: bold;\n              border-bottom: 2px solid black\">Biller Remarks\n</div><div ng-repeat=\"todo in vm.billerRemarks\" layout=\"row\" layout-align=\"space-between center\" \nstyle=\"padding-left: 10px; border-bottom: 1px solid grey\"><span ng-bind=\"$index + 1\" style=\"margin-right: 10px\"></span>\n <span flex ng-bind=\"todo.remarks\"></span><div layout=\"row\" layout-align=\"space-between center\"><span \nng-bind=\"todo.status\" style=\"font-weight: bold\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.showDialog(todo.ref_id)\"><md-icon md-font-icon=\"icon-more\" class=\"grey-500-fg\"></md-icon><md-tooltip>Reply\n</md-tooltip></md-button></div></div></div></div><table id=\"income-detail-dt\" class=\"dataTable row-border hover\" \nng-show=\"vm.viewName === \'detail\'\"></table><table id=\"income-category-dt\" class=\"dataTable row-border hover\" \nng-show=\"vm.viewName === \'category\'\"></table><div ng-show=\"vm.viewName === \'cn_dn_year_month\'\" \nstyle=\"background-color: white; padding: 10px 20px\"><div style=\"font-size: 16px\"><span>Year:</span> <span \nng-bind=\"vm.yearFilter\"></span></div><div style=\"font-size: 16px\"><span>Month:</span> <span \nng-bind=\"vm.selectedRecord.month\"></span></div><div style=\"font-size: 16px\"><span style=\"font-weight: bold\">\nTotal Bill Size:</span> <span ng-bind=\"vm.totalBillSize\"></span></div><div style=\"font-size: 16px\"><span \nstyle=\"font-weight: bold\">Total Gross Income:</span> <span ng-bind=\"vm.totalGrossIncome\"></span></div></div><table \nid=\"income-cn-dn-year-month-dt\" class=\"dataTable row-border hover\" ng-show=\"vm.viewName === \'cn_dn_year_month\'\">\n</table><div ng-show=\"vm.viewName === \'cn_dn_episode\'\" style=\"background-color: white; padding: 10px 20px\"><div \nstyle=\"font-size: 16px\"><span>Year:</span> <span ng-bind=\"vm.yearFilter\"></span></div><div style=\"font-size: 16px\">\n<span>Month:</span> <span ng-bind=\"vm.selectedRecord.month\"></span></div><div style=\"font-size: 16px\"><span \nstyle=\"font-weight: bold\">Total Bill Size:</span> <span ng-bind=\"vm.totalBillSize\"></span></div><div \nstyle=\"font-size: 16px\"><span style=\"font-weight: bold\">Total Gross Income:</span> <span ng-bind=\"vm.totalGrossIncome\">\n</span></div></div><table id=\"income-cn-dn-episode-dt\" class=\"dataTable row-border hover\" \nng-show=\"vm.viewName === \'cn_dn_episode\'\"></table><div class=\"loading\" ng-show=\"vm.loading\"><md-progress-circular \nmd-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"></div><div class=\"title\">Recover your password</div><form name=\"forgotPasswordForm\" \nng-submit=\"vm.reset()\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"username\" \nng-model=\"vm.accountService.user.username\" placeholder=\"Username\" required><div \nng-messages=\"forgotPasswordForm.username.$error\"><div ng-message=\"required\">Username is required</div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.accountService.user.email\" placeholder=\"Email address\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" multiple=\"multiple\"><div ng-message=\"required\">Email field is required\n</div><div ng-message=\"pattern\">Email must be of valid format</div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\">\nRESET PASSWORD</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" \nui-sref=\"app.login\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"></div><div \nclass=\"title\">Log in to your account</div><form name=\"loginForm\" ng-submit=\"vm.login()\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input type=\"text\" name=\"username\" ng-model=\"vm.accountService.user.username\" \nplaceholder=\"Username\" ng-required=\"!vm.accountService.isRemembered\"><div ng-messages=\"loginForm.username.$error\"><div \nng-message=\"required\"><span>Username is required</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.accountService.user.password\" \nplaceholder=\"Password\" ng-required=\"!vm.accountService.isRemembered\"><div ng-messages=\"loginForm.password.$error\"><div \nng-message=\"required\"><span>Password is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"vm.accountService.shouldRemember\"><span>Remember Me</span></md-checkbox><a \nui-sref=\"app.forgotPassword\" class=\"forgot-password md-accent-color\">Forgot Password?</a></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" ng-disabled=\"loginForm.$invalid\">LOG IN</md-button></form>\n</div></div></div>");
$templateCache.put("app/main/module/module.html","<div id=\"module\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs>\n<md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\">\n{{ vm.sharedService.pageName }}</span></div><div class=\"toolbar white-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex=\"60\" flex-gt-sm=\"85\" class=\"search\" md-no-float><input \ntype=\"search\" placeholder=\"Search\" ng-model=\"vm.searchTerm\" ng-model-options=\"{ debounce: 200 }\" \nng-change=\"vm.search()\"></md-input-container><div flex=\"40\" flex-gt-sm=\"15\" class=\"nav-buttons\" layout=\"row\" \nlayout-align=\"space-around center\"><md-button ng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.offset === 0\"><md-icon\n md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nng-click=\"vm.next()\" ng-disabled=\"vm.loading || vm.offset + vm.recordsPerPage >= vm.recordsTotal\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div><div class=\"content\" \nlayout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dt\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"></table><div class=\"loading\" ng-show=\"vm.loading\"><md-progress-circular md-diameter=\"100\" \nclass=\"md-accent\"></md-progress-circular></div></div><div class=\"footer white-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"paging\" layout=\"row\" layout-align=\"space-between center\"><span>Show\n</span><md-input-container><md-select ng-model=\"vm.recordsPerPage\" ng-change=\"vm.pagingChanged()\" \nng-disabled=\"vm.loading\"><md-option ng-value=\"l\" ng-repeat=\"l in vm.lengthMenu\">{{ ::l }}</md-option></md-select>\n</md-input-container><span hide-xs>records</span></div><div class=\"records\">\n{{ vm.offsetFrom }} - {{ vm.pageRecords }} / {{ vm.recordsTotal }}</div></div></div></div>");
$templateCache.put("app/main/operation-theater/operation-theater.html","<div id=\"operation-theater\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon>\n<span class=\"white-fg h2\">{{ vm.sharedService.pageName }}</span></div><div class=\"toolbar white-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex=\"60\" flex-gt-sm=\"85\" class=\"search\" md-no-float><input \ntype=\"search\" placeholder=\"Search\" ng-model=\"vm.searchTerm\" ng-model-options=\"{ debounce: 200 }\" \nng-change=\"vm.search()\"></md-input-container><div flex=\"40\" flex-gt-sm=\"15\" class=\"nav-buttons\" layout=\"row\" \nlayout-align=\"space-around center\"><md-button ng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.offset === 0\"><md-icon\n md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nng-click=\"vm.next()\" ng-disabled=\"vm.loading || vm.offset + vm.recordsPerPage >= vm.recordsTotal\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div><div class=\"content\" \nlayout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dt\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"></table><div class=\"loading\" ng-show=\"vm.loading\"><md-progress-circular md-diameter=\"100\" \nclass=\"md-accent\"></md-progress-circular></div></div><div class=\"footer white-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"paging\" layout=\"row\" layout-align=\"space-between center\"><span>Show\n</span><md-input-container><md-select ng-model=\"vm.recordsPerPage\" ng-change=\"vm.pagingChanged()\" \nng-disabled=\"vm.loading\"><md-option ng-value=\"l\" ng-repeat=\"l in vm.lengthMenu\">{{ ::l }}</md-option></md-select>\n</md-input-container><span hide-xs>records</span></div><div class=\"records\">\n{{ vm.offsetFrom }} - {{ vm.pageRecords }} / {{ vm.recordsTotal }}</div></div></div><md-fab-speed-dial \nmd-direction=\"up\" class=\"md-scale md-fab-bottom-right\"><md-fab-trigger><md-button class=\"md-fab md-warn\" \nng-class=\"vm.mediaXsAddButton\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></md-fab-trigger>\n<md-fab-actions><md-button class=\"md-fab md-raised md-mini\" ng-click=\"vm.simple()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon><md-tooltip md-direction=\"left\">Simple Memo</md-tooltip></md-button><md-button \nclass=\"md-fab md-raised md-mini\" ng-click=\"vm.edit()\"><md-icon md-font-icon=\"icon-file\"></md-icon><md-tooltip \nmd-direction=\"left\">Complex Request</md-tooltip></md-button></md-fab-actions></md-fab-speed-dial></div>");
$templateCache.put("app/main/role/role.html","<div id=\"role\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs><md-icon \nmd-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\">\n{{ vm.sharedService.pageName }}</span></div><div class=\"toolbar white-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex=\"60\" flex-gt-sm=\"85\" class=\"search\" md-no-float><input \ntype=\"search\" placeholder=\"Search\" ng-model=\"vm.searchTerm\" ng-model-options=\"{ debounce: 200 }\" \nng-change=\"vm.search()\"></md-input-container><div flex=\"40\" flex-gt-sm=\"15\" class=\"nav-buttons\" layout=\"row\" \nlayout-align=\"space-around center\"><md-button ng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.offset === 0\"><md-icon\n md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nng-click=\"vm.next()\" ng-disabled=\"vm.loading || vm.offset + vm.recordsPerPage >= vm.recordsTotal\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div><div class=\"content\" \nlayout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dt\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"></table><div class=\"loading\" ng-show=\"vm.loading\"><md-progress-circular md-diameter=\"100\" \nclass=\"md-accent\"></md-progress-circular></div></div><div class=\"footer white-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"paging\" layout=\"row\" layout-align=\"space-between center\"><span>Show\n</span><md-input-container><md-select ng-model=\"vm.recordsPerPage\" ng-change=\"vm.pagingChanged()\" \nng-disabled=\"vm.loading\"><md-option ng-value=\"l\" ng-repeat=\"l in vm.lengthMenu\">{{ ::l }}</md-option></md-select>\n</md-input-container><span hide-xs>records</span></div><div class=\"records\">\n{{ vm.offsetFrom }} - {{ vm.pageRecords }} / {{ vm.recordsTotal }}</div></div></div><md-button \nclass=\"md-fab md-fab-bottom-right md-warn\" ng-class=\"vm.mediaXsAddButton\" ng-click=\"vm.edit()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Add Role</md-tooltip></md-button></div>");
$templateCache.put("app/main/roster/roster.html","<div id=\"roster\" class=\"page-layout carded fullwidth\"><div id=\"roster-main\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.currentMonthShort\"><div class=\"header-content\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span\n class=\"logo-icon\"><md-icon md-font-icon=\"{{ vm.pageIcon }}\"></md-icon></span><span class=\"logo-text\" \nng-bind=\"::vm.pageName\"></span></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.goToToday()\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip>\nToday</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.changeCalendarView(\'month\')\"><md-icon \nmd-font-icon=\"icon-view-module\"></md-icon><md-tooltip>Month</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.changeCalendarView(\'agendaWeek\')\" hide-xs><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip>\nWeek</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.changeCalendarView(\'agendaDay\')\"><md-icon \nmd-font-icon=\"icon-view-day\"></md-icon><md-tooltip>Day</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.showSearchbar = !vm.showSearchbar\"><md-icon \nmd-font-icon=\"{{ vm.showSearchbar ? \'icon-close\' : \'icon-magnify\' }}\"></md-icon><md-tooltip>Show Searchbar</md-tooltip>\n</md-button></div></div><div class=\"header-bottom-wrapper\" layout=\"row\" layout-align=\"space-between\"><div \nclass=\"header-bottom\" ng-class=\"{\'hide-on-search\': vm.showSearchbar}\" layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-icon-button arrow\" ng-click=\"vm.prev()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n<md-tooltip>Previous</md-tooltip></md-button><div class=\"title\" ng-bind=\"vm.calendarTitle\"></div><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.next()\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next\n</md-tooltip></md-button></div><div class=\"header-bottom-searchbar\" ng-class=\"{\'show-on-search\': vm.showSearchbar}\" \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container md-no-float flex=\"100\" class=\"md-block\"><md-select\n ng-change=\"vm.filterSpecialty()\" ng-model=\"vm.specialty\" ng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option \nng-value=\"null\">No filter</md-option><md-option ng-value=\"specialty\" ng-repeat=\"specialty in vm.specialties\" \nng-bind=\"::specialty.name\"></md-option></md-select></md-input-container></div></div></div></div><md-content \nclass=\"content\" ms-scroll md-swipe-left=\"vm.next()\" md-swipe-right=\"vm.prev()\"><div id=\"calendarView\" \nui-calendar=\"vm.uiCalendarConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></md-content><md-button \nclass=\"add-todo-button md-fab md-fab-bottom-right md-warn md-mini\" ng-click=\"vm.edit()\" ng-show=\"vm.canCreate\"><md-icon\n md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Assign Roster</md-tooltip></md-button></div></div>");
$templateCache.put("app/main/roster-list/roster-list.html","<div id=\"roster-list\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs>\n<md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\" \nng-bind=\"vm.sharedService.pageName\"></span></div><div class=\"toolbar white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"sep\"><div flex layout=\"row\" layout-align=\"space-between center\">\n<md-input-container md-no-float flex class=\"md-block\"><md-select ng-change=\"vm.reloadData()\" ng-model=\"vm.specialty\" \nng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option ng-value=\"null\">No filter</md-option><md-option \nng-value=\"specialty\" ng-repeat=\"specialty in vm.specialties\" ng-bind=\"::specialty.name\"></md-option></md-select>\n</md-input-container></div><div class=\"nav-buttons\" layout=\"row\" layout-align=\"space-around center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.rosterTable.page.info().start === 0\"><md-icon\n md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.rosterTable.page.info().end === vm.rosterTable.page.info().recordsTotal\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div></div><div \nclass=\"advanced-search-bar white-bg\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"asb-body\"><md-input-container md-no-float class=\"md-block\"><md-select \nng-change=\"vm.reloadData()\" ng-model=\"vm.view\" ng-model-options=\"{ trackBy: \'$value\' }\"><md-option ng-value=\"view\" \nng-repeat=\"view in vm.views\" ng-bind=\"::view\"></md-option></md-select></md-input-container><md-input-container \nmd-no-float class=\"md-block mp-w80\" ng-show=\"vm.getShow(\'Month\')\"><input placeholder=\"Select Month\" moment-picker \nng-model=\"vm.fromDate\" ng-change=\"vm.reloadData()\" format=\"MM/YYYY\" readonly=\"readonly\"></md-input-container>\n<md-input-container md-no-float class=\"md-block mp-w80\" ng-show=\"vm.getShow(\'Week\')\"><input placeholder=\"Select Week\" \nmoment-picker ng-model=\"vm.fromDate\" ng-change=\"vm.reloadData()\" format=\"DD/MM/YYYY\" readonly=\"readonly\">\n</md-input-container><md-button class=\"md-icon-button\" ng-click=\"vm.print()\"><md-icon md-font-icon=\"icon-printer\">\n</md-icon><md-tooltip>Print</md-tooltip></md-button></div></div><div class=\"content\" layout=\"column\" flex \nmd-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table id=\"roster-dt\" \nclass=\"dataTable row-border hover\"></table><div class=\"loading\" ng-show=\"vm.loading\"><md-progress-circular \nmd-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div><md-button \nclass=\"md-fab md-fab-bottom-right md-warn md-mini\" ng-click=\"vm.edit()\" ng-show=\"vm.canCreate\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Assign Roster</md-tooltip></md-button></div>");
$templateCache.put("app/main/settings/settings.html","<div id=\"settings\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs>\n<md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\">\n{{ vm.sharedService.pageName }}</span></div><div class=\"toolbar white-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex layout=\"row\" layout-align=\"space-between center\"><md-input-container \nflex=\"100\" class=\"search\" md-no-float><input type=\"search\" placeholder=\"Search\" ng-model=\"vm.searchTerm\" \nng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.search()\"></md-input-container></div><div class=\"nav-buttons\" \nlayout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-icon-button\" ng-click=\"vm.prev()\" \nng-disabled=\"vm.loading || vm.settingsTable.page.info().start === 0\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.settingsTable.page.info().end === vm.settingsTable.page.info().recordsTotal\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div><div class=\"content\" \nlayout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table id=\"settings-dt\" \nclass=\"dataTable row-border hover\"></table><div class=\"loading\" ng-show=\"vm.loading\"><md-progress-circular \nmd-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/shift/shift.html","<div id=\"shift\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs><md-icon \nmd-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\" \nng-bind=\"vm.sharedService.pageName\"></span></div><div class=\"toolbar white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"sep\"><div flex layout=\"row\" layout-align=\"space-between center\">\n<md-input-container flex=\"100\" class=\"search\" md-no-float><input type=\"search\" placeholder=\"Search\" \nng-model=\"vm.searchTerm\" ng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.search()\"></md-input-container></div><div \nclass=\"nav-buttons\" layout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.shiftTable.page.info().start === 0\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.shiftTable.page.info().end === vm.shiftTable.page.info().recordsTotal\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div></div><div \nclass=\"content\" layout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table \nid=\"shift-dt\" class=\"dataTable row-border hover\"></table><div class=\"loading\" ng-show=\"vm.loading\">\n<md-progress-circular md-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div><md-button \nclass=\"md-fab md-fab-bottom-right md-warn md-mini\" ng-click=\"vm.edit()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"top\">Add Shift</md-tooltip></md-button></div>");
$templateCache.put("app/main/seven-days-discharge/seven-days-discharge.html","<div id=\"seven-days-discharge\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon>\n<span class=\"white-fg h2\">{{ vm.sharedService.pageName }}</span></div><div class=\"toolbar white-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex=\"60\" flex-gt-sm=\"85\" class=\"search\" md-no-float><input \ntype=\"search\" placeholder=\"Search\" ng-model=\"vm.searchTerm\" ng-model-options=\"{ debounce: 200 }\" \nng-change=\"vm.search()\"></md-input-container><div flex=\"40\" flex-gt-sm=\"15\" class=\"nav-buttons\" layout=\"row\" \nlayout-align=\"space-around center\"><md-button ng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.offset === 0\"><md-icon\n md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nng-click=\"vm.next()\" ng-disabled=\"vm.loading || vm.offset + vm.recordsPerPage >= vm.recordsTotal\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div><div class=\"content\" \nlayout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dt\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"></table><div class=\"loading\" ng-show=\"vm.loading\"><md-progress-circular md-diameter=\"100\" \nclass=\"md-accent\"></md-progress-circular></div></div><div class=\"footer white-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"paging\" layout=\"row\" layout-align=\"space-between center\"><span>Show\n</span><md-input-container><md-select ng-model=\"vm.recordsPerPage\" ng-change=\"vm.pagingChanged()\" \nng-disabled=\"vm.loading\"><md-option ng-value=\"l\" ng-repeat=\"l in vm.lengthMenu\">{{ ::l }}</md-option></md-select>\n</md-input-container><span hide-xs>records</span></div><div class=\"records\">\n{{ vm.offsetFrom }} - {{ vm.pageRecords }} / {{ vm.recordsTotal }}</div></div></div></div>");
$templateCache.put("app/main/seven-days-discharge/seven-days-discharge2.html","<div id=\"discharge\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs>\n<md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\" \nng-bind=\"vm.sharedService.pageName\"></span></div><div class=\"toolbar white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"sep\"><div flex layout=\"row\" layout-align=\"space-between center\">\n<md-input-container flex=\"100\" class=\"search\" md-no-float><input type=\"search\" placeholder=\"Search\" \nng-model=\"vm.searchTerm\" ng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.search()\"></md-input-container></div><div \nclass=\"nav-buttons\" layout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.dischargesTable.page.info().start === 0\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.dischargesTable.page.info().end === vm.dischargesTable.page.info().recordsTotal\"><md-icon\n md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div></div><div \nclass=\"content\" layout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table \nid=\"discharge-dt\" class=\"dataTable row-border hover\"></table><div class=\"loading\" ng-show=\"vm.loading\">\n<md-progress-circular md-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/permission/permission.html","<div id=\"permission\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs>\n<md-icon md-font-icon=\"icon-account-key\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\">\n{{ vm.sharedService.pageName }}</span></div><div class=\"toolbar white-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><md-select flex=\"60\" flex-gt-sm=\"85\" class=\"search\" ng-model=\"vm.role\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" ng-change=\"vm.roleChanged()\"><md-option ng-value=\"role\" \nng-repeat=\"role in vm.roles\">{{ role.description }}</md-option></md-select><div flex=\"40\" flex-gt-sm=\"15\" \nclass=\"nav-buttons\" layout=\"row\" layout-align=\"space-around center\"><md-button ng-click=\"vm.prev()\" \nng-disabled=\"vm.loading || vm.offset === 0\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous\n</md-tooltip></md-button><md-button ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.offset + vm.recordsPerPage >= vm.recordsTotal\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div><div \nclass=\"secondary-toolbar white-bg\" layout=\"row\" layout-align=\"space-between center\"><md-checkbox flex \nng-model=\"vm.all_view\" ng-change=\"vm.allView()\">View</md-checkbox><md-checkbox flex ng-model=\"vm.all_create\" \nng-change=\"vm.allCreate()\">Create</md-checkbox><md-checkbox flex ng-model=\"vm.all_modify\" ng-change=\"vm.allModify()\">\nModify</md-checkbox><md-checkbox flex ng-model=\"vm.all_delete\" ng-change=\"vm.allDelete()\">Delete</md-checkbox></div>\n<div class=\"content\" layout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dt\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"></table><div class=\"loading\" ng-show=\"vm.loading\"><md-progress-circular md-diameter=\"100\" \nclass=\"md-accent\"></md-progress-circular></div></div><div class=\"footer white-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"paging\" layout=\"row\" layout-align=\"space-between center\"><span>Show\n</span><md-input-container><md-select ng-model=\"vm.recordsPerPage\" ng-change=\"vm.pagingChanged()\" \nng-disabled=\"vm.loading\"><md-option ng-value=\"l\" ng-repeat=\"l in vm.lengthMenu\">{{ ::l }}</md-option></md-select>\n</md-input-container><span hide-xs>records</span></div><div class=\"records\">\n{{ vm.offsetFrom }} - {{ vm.pageRecords }} / {{ vm.recordsTotal }}</div></div></div></div>");
$templateCache.put("app/main/permission/permission2.html","<div id=\"permission\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs>\n<md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\" \nng-bind=\"vm.sharedService.pageName\"></span></div><div class=\"toolbar white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"sep\"><div flex layout=\"row\" layout-align=\"space-between center\"><md-select \nflex class=\"search\" ng-model=\"vm.role\" ng-model-options=\"{ trackBy: \'$value.id\' }\" ng-change=\"vm.roleChanged()\">\n<md-option ng-value=\"role\" ng-repeat=\"role in vm.roles\">{{ role.description }}</md-option></md-select></div><div \nclass=\"nav-buttons\" layout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.permissionTable.page.info().start === 0\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.permissionTable.page.info().end === vm.permissionTable.page.info().recordsTotal\"><md-icon\n md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div></div><div \nclass=\"content\" layout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table \nid=\"permission-dt\" class=\"dataTable row-border hover\"></table><div class=\"loading\" ng-show=\"vm.loading\">\n<md-progress-circular md-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/sms/sms2.html","<div id=\"sms\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs><md-icon \nmd-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\">\n{{ vm.sharedService.pageName }}</span><div class=\"thdr-actions\"><md-button class=\"md-raised\" \nng-click=\"vm.showExportExcelDialog()\">Export Excel</md-button></div></div><div class=\"sms-sent-status\"><div \nclass=\"white-fg\">Total sent: <span ng-bind=\"vm.smsSentSuccessCount + vm.smsSentFailedCount\"></span></div><div \nclass=\"white-fg\">Success: <span ng-bind=\"vm.smsSentSuccessCount\"></span></div><div class=\"white-fg\">Failed: <span \nng-bind=\"vm.smsSentFailedCount\"></span></div></div><div class=\"toolbar white-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex layout=\"row\" layout-align=\"space-between center\"><md-input-container \nflex=\"100\" class=\"search\" md-no-float><input type=\"search\" placeholder=\"Search\" ng-model=\"vm.searchTerm\" \nng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.search()\"></md-input-container><md-button \nng-click=\"vm.showAdvancedSearch = !vm.showAdvancedSearch\" class=\"md-icon-button advanced-search-button\"><md-icon \nmd-font-icon=\"{{ vm.showAdvancedSearch ? \'icon-magnify-minus\' : \'icon-magnify-plus\' }}\"></md-icon><md-tooltip>\nAdvanced Search</md-tooltip></md-button></div><div class=\"nav-buttons\" layout=\"row\" layout-align=\"space-around center\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.prev()\" \nng-disabled=\"vm.loading || vm.apptBlastTable.page.info().start === 0\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.apptBlastTable.page.info().end === vm.apptBlastTable.page.info().recordsTotal\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div><div \nng-show=\"vm.showAdvancedSearch\" class=\"advanced-search-bar white-bg\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"asb-body\" flex layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"md-block asb-days-prior-select\"><label>Appointment at?</label><md-select ng-model=\"vm.daysPrior\"><md-option \nvalue=\"Infinity\">Show All</md-option><md-option value=\"1\">Tomorrow</md-option><md-option value=\"2\">Day after tomorrow\n</md-option><md-option value=\"3\">After 3 days</md-option><md-option value=\"4\">After 4 days</md-option><md-option \nvalue=\"5\">After 5 days</md-option><md-option value=\"6\">After 6 days</md-option><md-option value=\"7\">After 1 week\n</md-option></md-select></md-input-container></div><div class=\"asb-actions\"><md-button class=\"md-icon-button\" \nng-click=\"vm.advancedSearch()\"><md-icon md-font-icon=\"icon-filter\"></md-icon><md-tooltip>Filter</md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.resetAdvancedSearch()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon><md-tooltip>Reset</md-tooltip></md-button></div></div><div class=\"content\" layout=\"column\" flex \nmd-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table id=\"appt-blast-dt\" \nclass=\"dataTable row-border hover\"></table><div class=\"loading\" ng-show=\"vm.loading\"><md-progress-circular \nmd-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div><md-button \nclass=\"md-fab md-fab-bottom-right md-warn\" ng-class=\"vm.mediaXsAddButton\" ng-click=\"vm.send()\"><md-icon \nmd-font-icon=\"icon-send\"></md-icon><md-tooltip md-direction=\"top\">Send SMS</md-tooltip></md-button></div>");
$templateCache.put("app/main/sms-response/sms-response.html","<div id=\"sms-response\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon>\n<span class=\"white-fg h2\">{{ vm.sharedService.pageName }}</span></div><div class=\"toolbar white-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex layout=\"row\" layout-align=\"space-between center\"><md-input-container \nflex=\"100\" class=\"search\" md-no-float><input type=\"search\" placeholder=\"Search\" ng-model=\"vm.searchTerm\" \nng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.search()\"></md-input-container><md-button \nng-click=\"vm.showAdvancedSearch = !vm.showAdvancedSearch\" class=\"md-icon-button advanced-search-button\"><md-icon \nmd-font-icon=\"{{ vm.showAdvancedSearch ? \'icon-magnify-minus\' : \'icon-magnify-plus\' }}\"></md-icon><md-tooltip>\nAdvanced Search</md-tooltip></md-button></div><div class=\"nav-buttons\" layout=\"row\" layout-align=\"space-around center\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.prev()\" \nng-disabled=\"vm.loading || vm.smsResponseTable.page.info().start === 0\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.smsResponseTable.page.info().end === vm.smsResponseTable.page.info().recordsTotal\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div><div \nng-show=\"vm.showAdvancedSearch\" class=\"advanced-search-bar white-bg\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"asb-body\" flex layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block fix-from-date\">\n<label>From Date</label><input moment-picker ng-model=\"vm.fromDatetime\" format=\"DD/MM/YYYY\" readonly=\"readonly\">\n</md-input-container><md-input-container class=\"md-block fix-to-date\"><label>To Date</label><input moment-picker \nposition=\"bottom right\" ng-model=\"vm.toDatetime\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></md-input-container></div>\n<div class=\"asb-actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.advancedSearch()\"><md-icon \nmd-font-icon=\"icon-filter\"></md-icon><md-tooltip>Filter</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.resetAdvancedSearch()\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Reset</md-tooltip>\n</md-button></div></div><div class=\"content\" layout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" \nmd-swipe-right=\"vm.swipeRight()\"><table id=\"sms-response-dt\" class=\"dataTable row-border hover\"></table><div \nclass=\"loading\" ng-show=\"vm.loading\"><md-progress-circular md-diameter=\"100\" class=\"md-accent\"></md-progress-circular>\n</div></div></div></div>");
$templateCache.put("app/main/specialty/specialty.html","<div id=\"specialty\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs>\n<md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\" \nng-bind=\"vm.sharedService.pageName\"></span></div><div class=\"toolbar white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"sep\"><div flex layout=\"row\" layout-align=\"space-between center\">\n<md-input-container flex=\"100\" class=\"search\" md-no-float><input type=\"search\" placeholder=\"Search\" \nng-model=\"vm.searchTerm\" ng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.search()\"></md-input-container></div><div \nclass=\"nav-buttons\" layout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.specialtyTable.page.info().start === 0\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.specialtyTable.page.info().end === vm.specialtyTable.page.info().recordsTotal\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div></div><div \nclass=\"content\" layout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table \nid=\"specialty-dt\" class=\"dataTable row-border hover\"></table><div class=\"loading\" ng-show=\"vm.loading\">\n<md-progress-circular md-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div><md-button \nclass=\"md-fab md-fab-bottom-right md-warn md-mini\" ng-click=\"vm.edit()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"top\">Add Specialty</md-tooltip></md-button></div>");
$templateCache.put("app/main/surgical-procedure/surgical-procedure.html","<div id=\"surgical-procedure\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon>\n<span class=\"white-fg h2\" ng-bind=\"vm.sharedService.pageName\"></span></div><div class=\"toolbar white-bg\"><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"sep\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex=\"100\" class=\"search\" md-no-float><input type=\"search\" \nplaceholder=\"Search\" ng-model=\"vm.searchTerm\" ng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.search()\">\n</md-input-container></div><div class=\"nav-buttons\" layout=\"row\" layout-align=\"space-around center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.dataSourceTable.page.info().start === 0\">\n<md-icon md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.dataSourceTable.page.info().end === vm.dataSourceTable.page.info().recordsTotal\"><md-icon\n md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div></div><div \nclass=\"content\" layout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table \nid=\"surgical-procedure-dt\" class=\"dataTable row-border hover\"></table><div class=\"loading\" ng-show=\"vm.loading\">\n<md-progress-circular md-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div></div>");
$templateCache.put("app/main/timeslot/timeslot.html","<div id=\"timeslot\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs>\n<md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\" \nng-bind=\"vm.sharedService.pageName\"></span></div><div class=\"toolbar white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"sep\"><div flex layout=\"row\" layout-align=\"space-between center\">\n<md-input-container flex=\"100\" class=\"search\" md-no-float><input type=\"search\" placeholder=\"Search\" \nng-model=\"vm.searchTerm\" ng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.search()\"></md-input-container></div><div \nclass=\"nav-buttons\" layout=\"row\" layout-align=\"space-around center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.timeslotTable.page.info().start === 0\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.timeslotTable.page.info().end === vm.timeslotTable.page.info().recordsTotal\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div></div><div \nclass=\"content\" layout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table \nid=\"timeslot-dt\" class=\"dataTable row-border hover\"></table><div class=\"loading\" ng-show=\"vm.loading\">\n<md-progress-circular md-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div></div><md-button \nclass=\"md-fab md-fab-bottom-right md-warn md-mini\" ng-click=\"vm.edit()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n<md-tooltip md-direction=\"top\">Add Timeslot</md-tooltip></md-button></div>");
$templateCache.put("app/main/todo/todo2.html","<div id=\"todo\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs><md-icon \nmd-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\">\n{{ vm.sharedService.pageName }}</span><div class=\"thdr-actions\"><md-button class=\"md-raised\" \nng-click=\"vm.exportExcel()\">Export Excel</md-button></div></div><div class=\"toolbar white-bg\"><div flex layout=\"row\" \nlayout-align=\"end stretch\" class=\"sep\" id=\"imp\"><md-button ng-repeat=\"status in vm.readStatuses\" \nclass=\"custom-font-icon md-raised\" ng-class=\"{\'md-accent\': status.selected }\" ng-click=\"vm.selectReadStatus(status)\">\n<span ng-bind=\"::status.text\" class=\"text\"></span> <span class=\"{{ ::status.class }}\" \nng-class=\"{\'white-600-fg-i\': status.selected }\"></span><div class=\"badge\" ng-bind=\"::vm.badgesCount[status.text]\" \nng-if=\"vm.badgesCount[status.text] > 0\"></div><md-tooltip ng-bind=\"::status.tooltip\"></md-tooltip></md-button></div>\n<div layout=\"row\" layout-align=\"space-between center\" class=\"sep\"><div flex layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex=\"100\" class=\"search\" md-no-float><input type=\"search\" \nplaceholder=\"Search\" ng-model=\"vm.searchTerm\" ng-model-options=\"{ debounce: 200 }\" ng-change=\"vm.search()\">\n</md-input-container><md-button ng-click=\"vm.showAdvancedSearch = !vm.showAdvancedSearch\" \nclass=\"md-icon-button advanced-search-button\"><md-icon \nmd-font-icon=\"{{ vm.showAdvancedSearch ? \'icon-magnify-minus\' : \'icon-magnify-plus\' }}\"></md-icon><md-tooltip>\nAdvanced Search</md-tooltip></md-button></div><div class=\"nav-buttons\" layout=\"row\" layout-align=\"space-around center\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.prev()\" \nng-disabled=\"vm.loading || vm.todoTable.page.info().start === 0\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n<md-tooltip>Previous</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.next()\" \nng-disabled=\"vm.loading || vm.todoTable.page.info().end === vm.todoTable.page.info().recordsTotal\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div></div><div \nng-show=\"vm.showAdvancedSearch\" class=\"advanced-search-bar white-bg\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"asb-body\" flex layout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block fix-from-date\">\n<label>From Date</label><input moment-picker ng-model=\"vm.fromDatetime\" format=\"DD/MM/YYYY\" readonly=\"readonly\">\n</md-input-container><md-input-container class=\"md-block fix-to-date\"><label>To Date</label><input moment-picker \nposition=\"bottom right\" ng-model=\"vm.toDatetime\" format=\"DD/MM/YYYY\" readonly=\"readonly\"></md-input-container></div>\n<div class=\"asb-actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.advancedSearch()\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><md-tooltip>Search</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.resetAdvancedSearch()\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Reset</md-tooltip>\n</md-button></div></div><div class=\"content\" layout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" \nmd-swipe-right=\"vm.swipeRight()\"><table id=\"todo-dt\" class=\"dataTable row-border hover\"></table><div class=\"loading\" \nng-show=\"vm.loading\"><md-progress-circular md-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div>\n</div><md-button class=\"md-fab md-fab-bottom-right md-warn\" ng-class=\"vm.mediaXsAddButton\" ng-click=\"vm.edit()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Add To-Do</md-tooltip></md-button></div>");
$templateCache.put("app/main/user/user.html","<div id=\"user\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs><md-icon \nmd-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\">\n{{ vm.sharedService.pageName }}</span></div><div class=\"toolbar white-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex=\"60\" flex-gt-sm=\"85\" class=\"search\" md-no-float><input \ntype=\"search\" placeholder=\"Search\" ng-model=\"vm.searchTerm\" ng-model-options=\"{ debounce: 200 }\" \nng-change=\"vm.search()\"></md-input-container><div flex=\"40\" flex-gt-sm=\"15\" class=\"nav-buttons\" layout=\"row\" \nlayout-align=\"space-around center\"><md-button ng-click=\"vm.prev()\" ng-disabled=\"vm.loading || vm.offset === 0\"><md-icon\n md-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip>Previous</md-tooltip></md-button><md-button \nng-click=\"vm.next()\" ng-disabled=\"vm.loading || vm.offset + vm.recordsPerPage >= vm.recordsTotal\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div><div class=\"content\" \nlayout=\"column\" flex md-swipe-left=\"vm.swipeLeft()\" md-swipe-right=\"vm.swipeRight()\"><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dt\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"></table><div class=\"loading\" ng-show=\"vm.loading\"><md-progress-circular md-diameter=\"100\" \nclass=\"md-accent\"></md-progress-circular></div></div><div class=\"footer white-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"paging\" layout=\"row\" layout-align=\"space-between center\"><span>Show\n</span><md-input-container><md-select ng-model=\"vm.recordsPerPage\" ng-change=\"vm.pagingChanged()\" \nng-disabled=\"vm.loading\"><md-option ng-value=\"l\" ng-repeat=\"l in vm.lengthMenu\">{{ ::l }}</md-option></md-select>\n</md-input-container><span hide-xs>records</span></div><div class=\"records\">\n{{ vm.offsetFrom }} - {{ vm.pageRecords }} / {{ vm.recordsTotal }}</div></div></div></div>");
$templateCache.put("app/main/statistics/statistics.html","<div id=\"statistics\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\" ms-scroll><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon>\n<span class=\"white-fg h2\">{{ vm.sharedService.pageName }}</span></div><div class=\"widget-group\" layout=\"row\" \nlayout-wrap><ms-widget flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-10 red-50-bg\" \nalign=\"center\"><div class=\"h4 secondary-text pb-10 black-500-fg\">Total Active Users</div><md-divider></md-divider><div \nclass=\"md-display-3 red-700-fg\"><span ng-bind=\"vm.stats.totalActiveUsers\"></span></div></ms-widget-front></ms-widget>\n<ms-widget flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-10 purple-50-bg\" align=\"center\"><div \nclass=\"h4 secondary-text pb-10 black-500-fg\">Total Active Doctors (Excluding PA)</div><md-divider></md-divider><div \nclass=\"md-display-3 purple-700-fg\"><span ng-bind=\"vm.stats.totalActiveDoctors\"></span></div></ms-widget-front>\n</ms-widget><ms-widget flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-10 blue-50-bg\" \nalign=\"center\"><div class=\"h4 secondary-text pb-10 black-500-fg\">Total Todos/Posts</div><md-divider></md-divider><div \nclass=\"md-display-3 blue-700-fg\"><span ng-bind=\"vm.stats.totalTodos\"></span></div></ms-widget-front></ms-widget>\n<ms-widget flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-10 green-50-bg\" align=\"center\"><div \nclass=\"h4 secondary-text pb-10 black-500-fg\">Total Users who Posted Todos</div><md-divider></md-divider><div \nclass=\"md-display-3 green-700-fg\"><span ng-bind=\"vm.stats.totalPostedTodoUsers\"></span></div></ms-widget-front>\n</ms-widget><ms-widget flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-10 yellow-50-bg\" \nalign=\"center\"><div class=\"h4 secondary-text pb-10 black-500-fg\">Total Doctors who Posted Todos</div><md-divider>\n</md-divider><div class=\"md-display-3 yellow-700-fg\"><span ng-bind=\"vm.stats.totalPostedTodoDoctors\"></span></div>\n</ms-widget-front></ms-widget><ms-widget flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-10 grey-50-bg\" align=\"center\"><div class=\"h4 secondary-text pb-10 black-500-fg\">Average Daily Logins</div>\n<md-divider></md-divider><div class=\"md-display-3 grey-700-fg\"><span ng-bind=\"vm.stats.dailyAverageLogins\"></span>\n</div></ms-widget-front></ms-widget><div flex=\"100\" class=\"login-graph-container\"><svg class=\"login-graph\"></svg></div>\n<div flex=\"100\" class=\"dino-table-container\"><div class=\"dino-table-toolbar\"><md-input-container md-no-float flex>\n<input type=\"text\" placeholder=\"Search User\" ng-model=\"vm.searchTerm\" ng-change=\"vm.searchTermChanged()\">\n</md-input-container><div class=\"dino-table-action-group\"><md-button class=\"md-icon-button md-raised\" \nng-disabled=\"vm.pageOffset === 0\" ng-click=\"vm.prevPage()\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n<md-tooltip>Previous</md-tooltip></md-button><md-button class=\"md-icon-button md-raised\" \nng-disabled=\"vm.pageOffset >= vm.accessList().length / vm.pageSize - 1\" ng-click=\"vm.nextPage()\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip>Next</md-tooltip></md-button></div></div><div \nclass=\"dino-table-header\"><div flex=\"70\">User</div><div flex=\"30\">Access Count/<br>Number of Logins</div></div><div \nclass=\"dino-table-body\" \nng-repeat=\"item in vm.stats.accessList | filter: vm.searchTerm | startFrom: vm.pageOffset * vm.pageSize | limitTo: vm.pageSize \">\n<div flex=\"70\"><span ng-bind=\"::item.username\"></span></div><div flex=\"30\"><span ng-bind=\"::item.totalLogins\"></span>\n</div></div><div class=\"dino-table-footer\"><div flex=\"70\"><md-select ng-model=\"vm.pageSize\" \nng-change=\"vm.pageSizeChanged()\" placeholder=\"Show\"><md-option value=\"1\">1</md-option><md-option value=\"10\">10\n</md-option><md-option value=\"25\">25</md-option><md-option value=\"50\">50</md-option><md-option value=\"100\">100\n</md-option></md-select></div><div flex=\"30\"><span ng-bind=\"vm.itemIndex\"></span> - <span ng-bind=\"vm.itemToIndex\">\n</span> / <span ng-bind=\"vm.filteredLength || 0\"></span></div></div></div><div flex=\"100\" class=\"stats-bottom-spacer\">\n</div></div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdMenu.open($event)\"><ms-color-picker-button><md-button\n aria-label=\"Row Color\" md-menu-origin ng-click=\"$mdMenu.open($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"></span> <span class=\"logo-text\">\nUMSC Dr Portal</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/announcement/edit/announcement-edit.html","<div id=\"announcement-edit\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon>\n<span class=\"white-fg h2\" ng-bind=\"vm.sharedService.pageName\"></span><div flex></div><md-button \nclass=\"md-fab md-warn md-mini\" ng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip \nmd-direction=\"top\">Back</md-tooltip></md-button><md-button class=\"md-fab md-accent md-mini\" ng-click=\"vm.save()\" \nng-disabled=\"announcementEditForm.$invalid || announcementEditForm.$pristine\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip md-direction=\"top\">Save</md-tooltip></md-button></div><div \nclass=\"content-card\"><md-content class=\"content\" ms-scroll><form name=\"announcementEditForm\" novalidate><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"md-block\" flex><label>Name</label><input \nname=\"name\" ng-model=\"vm.announcement.name\" required maxlength=\"256\" md-maxlength=\"256\"><div \nng-messages=\"announcementEditForm.name.$error\"><div ng-message=\"required\">Name is required</div><div \nng-message=\"md-maxlength\">Name cannot be longer than 256 characters.</div></div></md-input-container><div class=\"ml-8\">\n<md-checkbox ng-model=\"vm.announcement.is_active\">Is Active</md-checkbox></div></div><md-input-container \nclass=\"md-block\"><label>Message</label><textarea name=\"message\" ng-model=\"vm.announcement.message\" rows=\"3\" required>\n</textarea><div ng-messages=\"announcementEditForm.message.$error\"><div ng-message=\"required\">Message is required</div>\n</div></md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex-gt-xs=\"45\"><label>Start Datetime\n</label><input name=\"startDatetime\" moment-picker ng-model=\"vm.announcement.start_datetime\" format=\"DD-MM-YYYY HH:mm\" \nreadonly=\"readonly\" required><div ng-messages=\"announcementEditForm.startDatetime.$error\"><div ng-message=\"required\">\nStart datetime is required</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"45\"><label>\nEnd Datetime</label><input name=\"endDatetime\" moment-picker ng-model=\"vm.announcement.end_datetime\" \nformat=\"DD-MM-YYYY HH:mm\" readonly=\"readonly\"></md-input-container></div></form></md-content></div></div></div>");
$templateCache.put("app/main/appointment/edit/appointment-edit.html","<div id=\"appointment-edit\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon>\n<span class=\"white-fg h2\">{{ vm.sharedService.pageName }}</span></div><div class=\"content-card\"><md-content \nclass=\"content\" ms-scroll><form name=\"appointmentEditForm\" ng-submit=\"vm.request()\" novalidate><div layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><md-input-container class=\"md-block md-input-has-value\" flex-gt-xs=\"45\"><label>\nPatient Name</label><span>{{ vm.appointment.patient_name }}</span></md-input-container><md-input-container \nclass=\"md-block md-input-has-value\" flex-gt-xs=\"45\"><label>Patient MRN</label><span>{{ vm.appointment.patient_no }}\n</span></md-input-container></div><div layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><md-input-container \nclass=\"md-block md-input-has-value\" flex-gt-xs=\"45\"><label>Status</label><span>{{ vm.appointment.status_desc }}</span>\n</md-input-container><md-input-container class=\"md-block md-input-has-value\" flex-gt-xs=\"45\"><label>Type</label><span>\n{{ vm.appointment.type_desc }}</span></md-input-container><md-input-container class=\"md-block md-input-has-value\" \nflex-gt-xs=\"10\"><label>Is Urgent?</label><span>{{ vm.appointment.isUrgentString() }}</span></md-input-container></div>\n<div layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><md-input-container class=\"md-block md-input-has-value\" \nflex-gt-xs=\"45\"><label>Fixed Datetime</label><span>{{ vm.appointment.getDatetime().format(\'DD/MM/YYYY hh:mm a\') }}\n</span></md-input-container></div><div layout-gt-xs=\"row\" layout-align-gt-xs=\"start start\"><md-input-container \nclass=\"md-block md-input-has-value\" flex-gt-xs=\"45\"><label>Action</label><md-radio-group ng-model=\"vm.todo.subtype\" \nclass=\"md-block\" layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><md-radio-button \nng-value=\"vm.Todo.SUBTYPE.RESCHEDULE\">Reschedule</md-radio-button><md-radio-button ng-value=\"vm.Todo.SUBTYPE.CANCEL\">\nCancel</md-radio-button></md-radio-group></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"45\" \nng-show=\"vm.todo.subtype === vm.Todo.SUBTYPE.RESCHEDULE\"><label>Move to Datetime</label><input moment-picker \nng-model=\"vm.todo.requested_datetime\" format=\"DD/MM/YYYY hh:mm a\" min-date=\"vm.minDate\" readonly=\"readonly\">\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container flex=\"100\" \nclass=\"md-block\"><label>Remarks</label><input name=\"remarks\" ng-model=\"vm.todo.remarks\" required><div \nng-messages=\"appointmentEditForm.remarks.$error\"><div ng-message=\"required\">Remarks is required</div></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-fab md-warn\" \nng-class=\"vm.mediaXsActionButtons\" ng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip \nmd-direction=\"top\">Back</md-tooltip></md-button><md-button type=\"submit\" class=\"md-fab md-accent\" \nng-class=\"vm.mediaXsActionButtons\" ng-disabled=\"appointmentEditForm.$invalid || appointmentEditForm.$pristine\"><md-icon\n md-font-icon=\"icon-check\"></md-icon><md-tooltip md-direction=\"top\">Place Request</md-tooltip></md-button></div></form>\n</md-content></div></div></div>");
$templateCache.put("app/main/e-discharge-staff/view/e-discharge-staff-view.html","<div id=\"e-discharge-staff-view\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\" hide-xs></md-icon>\n<span class=\"white-fg h2\" ng-bind=\"vm.sharedService.pageName\" hide-xs></span><div flex></div><md-button \nclass=\"md-fab md-warn md-mini\" ng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip \nmd-direction=\"top\">Back</md-tooltip></md-button><md-button class=\"md-fab md-accent md-mini\" ng-click=\"vm.complete()\" \nng-if=\"vm.dataSource.status === \'Approved\'\"><md-icon md-font-icon=\"icon-package-variant-closed\"></md-icon><md-tooltip \nmd-direction=\"top\">Mark As Complete</md-tooltip></md-button></div><div class=\"content-card\"><md-content \nclass=\"content\"><form name=\"editForm\" novalidate><table class=\"uneditable\"><tr><th>MRN</th><td \nng-bind=\"::vm.dataSource.patient_mrn\"></td></tr><tr><th>Patient Name</th><td ng-bind=\"::vm.dataSource.patient_name\">\n</td></tr><tr><th>Admission Datetime</th><td><span \nng-bind=\"::vm.dataSource.admission_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></span> <span \nng-if=\"!vm.dataSource.admission_datetime\">-</span></td></tr><tr><th>Discharged Datetime</th><td><span \nng-bind=\"::vm.dataSource.discharged_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></span> <span \nng-if=\"!vm.dataSource.discharged_datetime\">-</span></td></tr><tr><th>Status</th><td ng-bind=\"vm.dataSource.status\">\n</td></tr></table><div class=\"vnp-doctor\" ng-repeat=\"doctor in vm.dataSource.e_discharge_doctor\"><div \nng-bind=\"::doctor.doctor_name\" ng-class=\"{\'green-100-bg\': doctor.is_primary }\"></div><div class=\"vnp-approved\" \nng-if=\"::doctor.approved_datetime\"><span>Last Approved</span> <span \nng-bind=\"::doctor.approved_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></span></div><div layout=\"column\"><div \nclass=\"vnp-header\">Visit</div><div class=\"no-data\" \nng-if=\"!doctor.e_discharge_visit || !doctor.e_discharge_visit.length\">No data</div><div class=\"vnp-data\" \nng-if=\"doctor.e_discharge_visit && doctor.e_discharge_visit.length\"><div><div>Date / Time</div><div>Visit Type</div>\n<div>Fee</div><div>Remark</div></div><div ng-repeat=\"item in doctor.e_discharge_visit\" \nng-class=\"{\'brown-50-bg\': !item.is_approved}\"><div><div>Date / Time</div><div ng-class=\"{amended: item.is_amended}\" \nng-bind=\"::item.visit_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></div></div><div><div>Visit Type</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.visit_type\"></div></div><div><div>Fee</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.amount\"></div></div><div><div>Remark</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.remark\"></div></div></div></div></div><div layout=\"column\"><div \nclass=\"vnp-header\">Procedure</div><div class=\"no-data\" \nng-if=\"!doctor.e_discharge_procedure || !doctor.e_discharge_procedure.length\">No data</div><div class=\"vnp-data\" \nng-if=\"doctor.e_discharge_procedure && doctor.e_discharge_procedure.length\"><div><div>Procedure Code (MMA Code)</div>\n<div>Procedure Name</div><div>Fee</div><div>Consultant</div></div><div \nng-repeat=\"item in doctor.e_discharge_procedure\" ng-class=\"{\'brown-50-bg\': !item.is_approved}\"><div><div>\nProcedure Code (MMA Code)</div><div ng-class=\"{amended: item.is_amended}\"><div ng-bind=\"::item.procedure_code\"></div>\n<div ng-if=\"item.procedure_mma_code\">({{::item.procedure_mma_code}})</div></div></div><div><div>Procedure Name</div>\n<div ng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.procedure_name\"></div></div><div><div>Fee</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.amount\"></div></div><div><div>Anaesthetist</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.doctor_name\"></div></div></div></div></div><div \nclass=\"vnp-questions\" \nng-show=\"doctor.e_discharge_question[doctor.e_discharge_question.length - 1].uses_implants !== undefined\"><div>\nDoes the procedure use implants?</div><md-radio-group class=\"vnp-implants\" \nng-class=\"{\'red-100-bg\': doctor.e_discharge_question[doctor.e_discharge_question.length - 1].uses_implants}\" \nng-model=\"doctor.e_discharge_question[doctor.e_discharge_question.length - 1].uses_implants\" ng-disabled=\"true\" \ntabindex=\"-1\"><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button ng-value=\"false\">No\n</md-radio-button></md-radio-group><div class=\"vnp-questions-bar\"><md-button class=\"md-raised\" \nng-class=\"{\'md-accent\': doctor.showQuestionHistory}\" ng-click=\"vm.showQuestionHistory(doctor)\">View History<md-icon \nng-if=\"!doctor.showQuestionHistory\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-if=\"doctor.showQuestionHistory\" md-font-icon=\"icon-chevron-up\"></md-icon></md-button></div><div \nng-show=\"doctor.showQuestionHistory\"><div class=\"no-data\" ng-if=\"!vm.hasQuestionHistory(doctor)\">No data</div><div \nclass=\"vnp-data\" ng-if=\"vm.hasQuestionHistory(doctor)\"><div><div>Uses Implants</div></div><div \nng-repeat=\"item in doctor.e_discharge_question\" ng-class=\"{\'brown-50-bg\': !item.is_approved}\"><div><div>Uses Implants\n</div><div ng-class=\"{amended: item.is_amended}\" ng-bind=\"item.uses_implants ? \'Yes\' : \'No\'\"></div></div></div></div>\n</div></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/e-discharge-staff/edit/e-discharge-staff-edit.html","<div id=\"e-discharge-staff-edit\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\" hide-xs></md-icon>\n<span class=\"white-fg h2\" ng-bind=\"vm.sharedService.pageName\" hide-xs></span><div flex></div><md-button \nclass=\"md-fab md-warn md-mini\" ng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip \nmd-direction=\"top\">Back</md-tooltip></md-button><md-button class=\"md-fab md-accent md-mini orange-500-bg\" \nng-click=\"vm.addDoctor()\" ng-if=\"vm.dataSource.status !== \'Approved\'\"><md-icon md-font-icon=\"icon-tie\"></md-icon>\n<md-tooltip md-direction=\"top\">Add Doctor</md-tooltip></md-button><md-button class=\"md-fab md-accent md-mini\" \nng-click=\"vm.requestDischarge()\" ng-if=\"vm.isPendingApproval()\"><md-icon md-font-icon=\"icon-logout\"></md-icon>\n<md-tooltip md-direction=\"top\">Request Discharge</md-tooltip></md-button><md-button class=\"md-fab md-accent md-mini\" \nng-click=\"vm.complete()\" ng-if=\"vm.dataSource.status === \'Approved\'\"><md-icon \nmd-font-icon=\"icon-package-variant-closed\"></md-icon><md-tooltip md-direction=\"top\">Mark As Complete</md-tooltip>\n</md-button></div><div class=\"content-card\"><md-content class=\"content\"><form name=\"editForm\" novalidate><table \nclass=\"uneditable\"><tr><th>MRN</th><td ng-bind=\"::vm.dataSource.patient_mrn\"></td></tr><tr><th>Patient Name</th><td \nng-bind=\"::vm.dataSource.patient_name\"></td></tr><tr><th>Admission Datetime</th><td><span \nng-bind=\"::vm.dataSource.admission_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></span> <span \nng-if=\"!vm.dataSource.admission_datetime\">-</span></td></tr><tr><th>Discharged Datetime</th><td><span \nng-bind=\"::vm.dataSource.discharged_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></span> <span \nng-if=\"!vm.dataSource.discharged_datetime\">-</span></td></tr><tr><th>Status</th><td ng-bind=\"vm.dataSource.status\">\n</td></tr></table><md-input-container class=\"md-block\"><label>Doctor</label><md-select ng-model=\"vm.selectedDoctor\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" ng-change=\"vm.selectedDoctorChanged()\" \nng-class=\"{\'green-100-bg\': vm.selectedDoctor.is_primary }\"><md-option ng-if=\"!vm.selectedDoctor\" ng-value=\"null\" \nng-bind=\"::vm.defaultNoSelectionText\" disabled=\"disabled\"></md-option><md-option ng-value=\"item\" \nng-repeat=\"item in vm.dataSource.e_discharge_doctor\" ng-bind=\"::item.doctor_name\" \nng-class=\"{\'green-100-bg\': item.is_primary }\"></md-option></md-select></md-input-container><div class=\"vnp-approved\" \nng-if=\"vm.selectedDoctor.approved_datetime\"><span>Last Approved</span> <span \nng-bind=\"vm.selectedDoctor.approved_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></span></div><div ng-if=\"vm.selectedDoctor\">\n<div layout=\"column\"><div class=\"vnp-header\">Visit</div><div class=\"no-data\" \nng-if=\"!vm.selectedDoctor.e_discharge_visit || !vm.selectedDoctor.e_discharge_visit.length\">No data</div><div \nclass=\"vnp-data\" ng-if=\"vm.selectedDoctor.e_discharge_visit && vm.selectedDoctor.e_discharge_visit.length\"><div><div>\nDate / Time</div><div>Visit Type</div><div>Fee</div><div>Remark</div><div>Action</div></div><div \nng-repeat=\"item in vm.selectedDoctor.e_discharge_visit\" ng-class=\"{\'brown-50-bg\': !item.is_approved}\"><div><div>\nDate / Time</div><div ng-class=\"{amended: item.is_amended}\" \nng-bind=\"::item.visit_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></div></div><div><div>Visit Type</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.visit_type\"></div></div><div><div>Fee</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.amount\"></div></div><div><div>Remark</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.remark\"></div></div><div><div>Action</div><div \nng-show=\"!vm.selectedDoctor.requires_reapproval\"><md-button class=\"md-icon-button\" \nng-if=\"!vm.selectedDoctor.is_approved\" ng-click=\"vm.editVisit(item)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s18 green-500-fg\"></md-icon><md-tooltip>Edit</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-if=\"!vm.selectedDoctor.is_approved\" ng-click=\"vm.deleteVisit(item)\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"s18 red-500-fg\"></md-icon><md-tooltip>Delete</md-tooltip></md-button></div><div \nng-show=\"vm.selectedDoctor.requires_reapproval\"><md-button class=\"md-icon-button\" ng-if=\"!item.is_amended\" \nng-click=\"vm.amendVisit(item)\"><md-icon md-font-icon=\"icon-eraser\" class=\"s18 orange-500-fg\"></md-icon><md-tooltip>\nAmend</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-if=\"!item.is_amended\" \nng-click=\"vm.cancelVisit(item)\"><md-icon md-font-icon=\"icon-cancel\" class=\"s18 red-500-fg\"></md-icon><md-tooltip>Cancel\n</md-tooltip></md-button></div></div></div></div><div ng-show=\"!vm.selectedDoctor.requires_reapproval\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-fab md-mini\" ng-if=\"!vm.selectedDoctor.is_approved\" \nng-click=\"vm.editVisit()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Add</md-tooltip>\n</md-button></div><div ng-show=\"vm.selectedDoctor.requires_reapproval\" layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-fab md-mini orange-500-bg\" ng-click=\"vm.amendVisit()\"><md-icon md-font-icon=\"icon-playlist-plus\">\n</md-icon><md-tooltip md-direction=\"top\">Append</md-tooltip></md-button></div></div><div layout=\"column\"><div \nclass=\"vnp-header\">Procedure</div><div class=\"no-data\" \nng-if=\"!vm.selectedDoctor.e_discharge_procedure || !vm.selectedDoctor.e_discharge_procedure.length\">No data</div><div \nclass=\"vnp-data\" ng-if=\"vm.selectedDoctor.e_discharge_procedure && vm.selectedDoctor.e_discharge_procedure.length\">\n<div><div>Procedure Code (MMA Code)</div><div>Procedure Name</div><div>Fee</div><div>Consultant</div><div>Action</div>\n</div><div ng-repeat=\"item in vm.selectedDoctor.e_discharge_procedure\" ng-class=\"{\'brown-50-bg\': !item.is_approved}\">\n<div><div>Procedure Code (MMA Code)</div><div ng-class=\"{amended: item.is_amended}\"><div \nng-bind=\"::item.procedure_code\"></div><div ng-if=\"item.procedure_mma_code\">({{::item.procedure_mma_code}})</div></div>\n</div><div><div>Procedure Name</div><div ng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.procedure_name\"></div>\n</div><div><div>Fee</div><div ng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.amount\"></div></div><div><div>\nAnaesthetist</div><div ng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.doctor_name\"></div></div><div><div>Action\n</div><div ng-show=\"!vm.selectedDoctor.requires_reapproval\"><md-button class=\"md-icon-button\" \nng-if=\"!vm.selectedDoctor.is_approved\" ng-click=\"vm.editProcedure(item)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s18 green-500-fg\"></md-icon><md-tooltip>Edit</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-if=\"!vm.selectedDoctor.is_approved\" ng-click=\"vm.deleteProcedure(item)\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"s18 red-500-fg\"></md-icon><md-tooltip>Delete</md-tooltip></md-button></div><div \nng-show=\"vm.selectedDoctor.requires_reapproval\"><md-button class=\"md-icon-button\" ng-if=\"!item.is_amended\" \nng-click=\"vm.amendProcedure(item)\"><md-icon md-font-icon=\"icon-eraser\" class=\"s18 orange-500-fg\"></md-icon><md-tooltip>\nAmend</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-if=\"!item.is_amended\" \nng-click=\"vm.cancelProcedure(item)\"><md-icon md-font-icon=\"icon-cancel\" class=\"s18 red-500-fg\"></md-icon><md-tooltip>\nCancel</md-tooltip></md-button></div></div></div></div><div ng-show=\"!vm.selectedDoctor.requires_reapproval\" \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-fab md-mini\" ng-if=\"!vm.selectedDoctor.is_approved\" \nng-click=\"vm.editProcedure()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Add\n</md-tooltip></md-button></div><div ng-show=\"vm.selectedDoctor.requires_reapproval\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-fab md-mini orange-500-bg\" ng-click=\"vm.amendProcedure()\"><md-icon \nmd-font-icon=\"icon-playlist-plus\"></md-icon><md-tooltip md-direction=\"top\">Append</md-tooltip></md-button></div></div>\n<div class=\"vnp-questions\"><div class=\"vnp-unsaved\" ng-show=\"vm.hasUnsavedChanges()\">\nYou have unsaved changes. Save to apply your changes.</div><div>Does the procedure use implants?</div><md-radio-group \nclass=\"vnp-implants\" \nng-model=\"vm.selectedDoctor.e_discharge_question[vm.selectedDoctor.e_discharge_question.length - 1].uses_implants\" \nng-change=\"vm.catchAttention()\"><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button \nng-value=\"false\">No</md-radio-button></md-radio-group><div class=\"vnp-questions-bar\" \nng-show=\"!vm.selectedDoctor.requires_reapproval\"><md-button class=\"md-raised\" \nng-class=\"{\'md-accent\': vm.selectedDoctor.showQuestionHistory}\" ng-click=\"vm.showQuestionHistory(vm.selectedDoctor)\" \nng-if=\"vm.hasPastQuestionHistory(vm.selectedDoctor)\">View History<md-icon \nng-if=\"!vm.selectedDoctor.showQuestionHistory\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-if=\"vm.selectedDoctor.showQuestionHistory\" md-font-icon=\"icon-chevron-up\"></md-icon></md-button><div \nclass=\"vnp-spacer\"></div><md-button class=\"button-save-questions md-fab md-mini\" \nng-if=\"!vm.selectedDoctor.is_approved\" ng-click=\"vm.editQuestion(item)\" ng-disabled=\"vm.saveQuestionDisabled()\">\n<md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip md-direction=\"top\">Save Edit</md-tooltip></md-button>\n</div><div class=\"vnp-questions-bar\" ng-show=\"vm.selectedDoctor.requires_reapproval\"><md-button class=\"md-raised\" \nng-class=\"{\'md-accent\': vm.selectedDoctor.showQuestionHistory}\" ng-click=\"vm.showQuestionHistory(vm.selectedDoctor)\" \nng-if=\"vm.hasPastQuestionHistory(vm.selectedDoctor)\">View History<md-icon \nng-if=\"!vm.selectedDoctor.showQuestionHistory\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-if=\"vm.selectedDoctor.showQuestionHistory\" md-font-icon=\"icon-chevron-up\"></md-icon></md-button><div \nclass=\"vnp-spacer\"></div><md-button class=\"button-save-questions md-fab md-mini orange-500-bg-override\" \nng-click=\"vm.amendQuestion()\" ng-disabled=\"vm.saveQuestionDisabled()\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon><md-tooltip md-direction=\"top\">Save Amendment</md-tooltip></md-button></div><div \nng-show=\"vm.selectedDoctor.showQuestionHistory\"><div class=\"no-data\" ng-if=\"!vm.hasQuestionHistory(vm.selectedDoctor)\">\nNo data</div><div class=\"vnp-data\" ng-if=\"vm.hasQuestionHistory(vm.selectedDoctor)\"><div><div>Uses Implants</div></div>\n<div ng-repeat=\"item in vm.selectedDoctor.e_discharge_question\" ng-class=\"{\'brown-50-bg\': !item.is_approved}\"><div>\n<div>Uses Implants</div><div ng-class=\"{amended: item.is_amended}\" ng-bind=\"item.uses_implants ? \'Yes\' : \'No\'\"></div>\n</div></div></div></div></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/feature-popup/dialogs/feature-popup-dialog.html","<md-dialog id=\"feature-popup-dialog\" aria-label=\"{{ vm.featurePopup.name }}\" \nng-style=\"{ width: vm.popupWidth + \'px\' }\"><md-dialog-content ng-cloak><div class=\"dialog-header\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button close-button\" ng-click=\"vm.close()\"><span \nclass=\"glyph-close\" aria-hidden=\"true\">&times;</span><md-tooltip md-direction=\"bottom\">Close</md-tooltip></md-button>\n</div><div class=\"slide-viewport\" ng-style=\"{ height: vm.popupHeight + \'px\' }\" ng-if=\"vm.slides.length\"><iframe \nng-repeat=\"slide in vm.slides track by $index\" ng-if=\"slide.type === \'video\'\" ng-src=\"{{ slide.trustedUrl }}\" \nng-class=\"{ active: $index === vm.currentSlideIndex }\" allow=\"autoplay; encrypted-media\" allowfullscreen></iframe><img \nng-repeat=\"slide in vm.slides track by $index\" ng-if=\"slide.type === \'image\'\" ng-src=\"{{ slide.url }}\" \nng-class=\"{ active: $index === vm.currentSlideIndex }\"></div><div class=\"carousel-controls\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"vm.slides.length > 1\"><md-button class=\"md-icon-button\" \nng-click=\"vm.prev()\"><span class=\"glyph-chevron\" aria-hidden=\"true\">&#8249;</span><md-tooltip md-direction=\"top\">\nPrevious</md-tooltip></md-button><div class=\"carousel-dots\"><span ng-repeat=\"slide in vm.slides track by $index\" \nng-class=\"{ active: $index === vm.currentSlideIndex }\"></span></div><md-button class=\"md-icon-button\" \nng-click=\"vm.next()\"><span class=\"glyph-chevron\" aria-hidden=\"true\">&#8250;</span><md-tooltip md-direction=\"top\">Next\n</md-tooltip></md-button></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/e-discharge-consultant/edit/e-discharge-consultant-edit.html","<div id=\"e-discharge-consultant-edit\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\" hide-xs></md-icon>\n<span class=\"white-fg h2\" ng-bind=\"vm.sharedService.pageName\" hide-xs></span><div flex></div><md-button \nclass=\"md-fab md-warn md-mini\" ng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip \nmd-direction=\"top\">Back</md-tooltip></md-button></div><div class=\"content-card\"><md-content class=\"content\"><form \nname=\"editForm\" novalidate><table class=\"uneditable\"><tr><th>MRN</th><td ng-bind=\"::vm.dataSource.patient_mrn\"></td>\n</tr><tr><th>Patient Name</th><td ng-bind=\"::vm.dataSource.patient_name\"></td></tr><tr><th>Admission Datetime</th><td>\n<span ng-bind=\"::vm.dataSource.admission_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></span> <span \nng-if=\"!vm.dataSource.admission_datetime\">-</span></td></tr><tr><th>Discharged Datetime</th><td><span \nng-bind=\"::vm.dataSource.discharged_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></span> <span \nng-if=\"!vm.dataSource.discharged_datetime\">-</span></td></tr><tr><th>Status</th><td ng-bind=\"::vm.dataSource.status\">\n</td></tr><tr><th>Doctor</th><td ng-bind=\"::vm.selectedDoctor.doctor_name\" \nng-class=\"{\'green-100-bg\': vm.selectedDoctor.is_primary }\"></td></tr></table><div class=\"vnp-approved\" \nng-if=\"vm.selectedDoctor.approved_datetime\"><span>Last Approved</span> <span \nng-bind=\"vm.selectedDoctor.approved_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></span></div><div ng-if=\"vm.selectedDoctor\">\n<div layout=\"column\"><div class=\"vnp-header\">Visit</div><div class=\"no-data\" \nng-if=\"!vm.selectedDoctor.e_discharge_visit || !vm.selectedDoctor.e_discharge_visit.length\">No data</div><div \nclass=\"vnp-data\" ng-if=\"vm.selectedDoctor.e_discharge_visit && vm.selectedDoctor.e_discharge_visit.length\"><div><div>\nDate / Time</div><div>Visit Type</div><div>Fee</div><div>Remark</div><div>Action</div></div><div \nng-repeat=\"item in vm.selectedDoctor.e_discharge_visit\" ng-class=\"{\'brown-50-bg\': !item.is_approved}\"><div><div>\nDate / Time</div><div ng-class=\"{amended: item.is_amended}\" \nng-bind=\"::item.visit_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></div></div><div><div>Visit Type</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.visit_type\"></div></div><div><div>Fee</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.amount\"></div></div><div><div>Remark</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.remark\"></div></div><div><div>Action</div><div \nng-show=\"!vm.selectedDoctor.requires_reapproval\"><md-button class=\"md-icon-button\" \nng-if=\"!vm.selectedDoctor.is_approved\" ng-click=\"vm.editVisit(item)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s18 green-500-fg\"></md-icon><md-tooltip>Edit</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-if=\"!vm.selectedDoctor.is_approved\" ng-click=\"vm.deleteVisit(item)\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"s18 red-500-fg\"></md-icon><md-tooltip>Delete</md-tooltip></md-button></div><div \nng-show=\"vm.selectedDoctor.requires_reapproval\"><md-button class=\"md-icon-button\" ng-if=\"!item.is_amended\" \nng-click=\"vm.amendVisit(item)\"><md-icon md-font-icon=\"icon-eraser\" class=\"s18 orange-500-fg\"></md-icon><md-tooltip>\nAmend</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-if=\"!item.is_amended\" \nng-click=\"vm.cancelVisit(item)\"><md-icon md-font-icon=\"icon-cancel\" class=\"s18 red-500-fg\"></md-icon><md-tooltip>Cancel\n</md-tooltip></md-button></div></div></div></div><div ng-show=\"!vm.selectedDoctor.requires_reapproval\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-fab md-mini\" ng-if=\"!vm.selectedDoctor.is_approved\" \nng-click=\"vm.editVisit()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Add</md-tooltip>\n</md-button></div><div ng-show=\"vm.selectedDoctor.requires_reapproval\" layout=\"row\" layout-align=\"end center\">\n<md-button class=\"md-fab md-mini orange-500-bg\" ng-click=\"vm.amendVisit()\"><md-icon md-font-icon=\"icon-playlist-plus\">\n</md-icon><md-tooltip md-direction=\"top\">Append</md-tooltip></md-button></div></div><div layout=\"column\"><div \nclass=\"vnp-header\">Procedure</div><div class=\"no-data\" \nng-if=\"!vm.selectedDoctor.e_discharge_procedure || !vm.selectedDoctor.e_discharge_procedure.length\">No data</div><div \nclass=\"vnp-data\" ng-if=\"vm.selectedDoctor.e_discharge_procedure && vm.selectedDoctor.e_discharge_procedure.length\">\n<div><div>Procedure Code (MMA Code)</div><div>Procedure Name</div><div>Fee</div><div>Consultant</div><div>Action</div>\n</div><div ng-repeat=\"item in vm.selectedDoctor.e_discharge_procedure\" ng-class=\"{\'brown-50-bg\': !item.is_approved}\">\n<div><div>Procedure Code (MMA Code)</div><div ng-class=\"{amended: item.is_amended}\"><div \nng-bind=\"::item.procedure_code\"></div><div ng-if=\"item.procedure_mma_code\">({{::item.procedure_mma_code}})</div></div>\n</div><div><div>Procedure Name</div><div ng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.procedure_name\"></div>\n</div><div><div>Fee</div><div ng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.amount\"></div></div><div><div>\nAnaesthetist</div><div ng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.doctor_name\"></div></div><div><div>Action\n</div><div ng-show=\"!vm.selectedDoctor.requires_reapproval\"><md-button class=\"md-icon-button\" \nng-if=\"!vm.selectedDoctor.is_approved\" ng-click=\"vm.editProcedure(item)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s18 green-500-fg\"></md-icon><md-tooltip>Edit</md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-if=\"!vm.selectedDoctor.is_approved\" ng-click=\"vm.deleteProcedure(item)\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"s18 red-500-fg\"></md-icon><md-tooltip>Delete</md-tooltip></md-button></div><div \nng-show=\"vm.selectedDoctor.requires_reapproval\"><md-button class=\"md-icon-button\" ng-if=\"!item.is_amended\" \nng-click=\"vm.amendProcedure(item)\"><md-icon md-font-icon=\"icon-eraser\" class=\"s18 orange-500-fg\"></md-icon><md-tooltip>\nAmend</md-tooltip></md-button><md-button class=\"md-icon-button\" ng-if=\"!item.is_amended\" \nng-click=\"vm.cancelProcedure(item)\"><md-icon md-font-icon=\"icon-cancel\" class=\"s18 red-500-fg\"></md-icon><md-tooltip>\nCancel</md-tooltip></md-button></div></div></div></div><div ng-show=\"!vm.selectedDoctor.requires_reapproval\" \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-fab md-mini\" ng-if=\"!vm.selectedDoctor.is_approved\" \nng-click=\"vm.editProcedure()\"><md-icon md-font-icon=\"icon-plus\"></md-icon><md-tooltip md-direction=\"top\">Add\n</md-tooltip></md-button></div><div ng-show=\"vm.selectedDoctor.requires_reapproval\" layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-fab md-mini orange-500-bg\" ng-click=\"vm.amendProcedure()\"><md-icon \nmd-font-icon=\"icon-playlist-plus\"></md-icon><md-tooltip md-direction=\"top\">Append</md-tooltip></md-button></div></div>\n<div class=\"vnp-questions\"><div class=\"vnp-unsaved\" ng-show=\"vm.hasUnsavedChanges()\">\nYou have unsaved changes. Save to apply your changes.</div><div>Does the procedure use implants?</div><md-radio-group \nclass=\"vnp-implants\" \nng-model=\"vm.selectedDoctor.e_discharge_question[vm.selectedDoctor.e_discharge_question.length - 1].uses_implants\" \nng-change=\"vm.catchAttention()\"><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button \nng-value=\"false\">No</md-radio-button></md-radio-group><div class=\"vnp-questions-bar\" \nng-show=\"!vm.selectedDoctor.requires_reapproval\"><md-button class=\"md-raised\" \nng-class=\"{\'md-accent\': vm.selectedDoctor.showQuestionHistory}\" ng-click=\"vm.showQuestionHistory(vm.selectedDoctor)\" \nng-if=\"vm.hasPastQuestionHistory(vm.selectedDoctor)\">View History<md-icon \nng-if=\"!vm.selectedDoctor.showQuestionHistory\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-if=\"vm.selectedDoctor.showQuestionHistory\" md-font-icon=\"icon-chevron-up\"></md-icon></md-button><div \nclass=\"vnp-spacer\"></div><md-button class=\"button-save-questions md-fab md-mini\" \nng-if=\"!vm.selectedDoctor.is_approved\" ng-click=\"vm.editQuestion(item)\" ng-disabled=\"vm.saveQuestionDisabled()\">\n<md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip md-direction=\"top\">Save Edit</md-tooltip></md-button>\n</div><div class=\"vnp-questions-bar\" ng-show=\"vm.selectedDoctor.requires_reapproval\"><md-button class=\"md-raised\" \nng-class=\"{\'md-accent\': vm.selectedDoctor.showQuestionHistory}\" ng-click=\"vm.showQuestionHistory(vm.selectedDoctor)\" \nng-if=\"vm.hasPastQuestionHistory(vm.selectedDoctor)\">View History<md-icon \nng-if=\"!vm.selectedDoctor.showQuestionHistory\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-if=\"vm.selectedDoctor.showQuestionHistory\" md-font-icon=\"icon-chevron-up\"></md-icon></md-button><div \nclass=\"vnp-spacer\"></div><md-button class=\"button-save-questions md-fab md-mini orange-500-bg-override\" \nng-click=\"vm.amendQuestion()\" ng-disabled=\"vm.saveQuestionDisabled()\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon><md-tooltip md-direction=\"top\">Save Amendment</md-tooltip></md-button></div><div \nng-show=\"vm.selectedDoctor.showQuestionHistory\"><div class=\"no-data\" ng-if=\"!vm.hasQuestionHistory(vm.selectedDoctor)\">\nNo data</div><div class=\"vnp-data\" ng-if=\"vm.hasQuestionHistory(vm.selectedDoctor)\"><div><div>Uses Implants</div></div>\n<div ng-repeat=\"item in vm.selectedDoctor.e_discharge_question\" ng-class=\"{\'brown-50-bg\': !item.is_approved}\"><div>\n<div>Uses Implants</div><div ng-class=\"{amended: item.is_amended}\" ng-bind=\"item.uses_implants ? \'Yes\' : \'No\'\"></div>\n</div></div></div></div></div></div><div class=\"confirm-section\" ng-if=\"vm.dataSource.status === \'Pending Approval\'\">\n<div layout=\"row\" layout-align=\"end center\"><md-checkbox class=\"no-margin md-primary\" ng-model=\"vm.isDataAccurate\">\n</md-checkbox><md-button class=\"md-accent md-raised\" ng-disabled=\"!vm.isDataAccurate\" ng-click=\"vm.approve()\"><span \nng-show=\"!vm.selectedDoctor.requires_reapproval\">Approve </span><span ng-show=\"vm.selectedDoctor.requires_reapproval\">\nReapprove</span></md-button></div><div class=\"confirm-disclaimer\">\n*By ticking the checkbox, you agree that all the above data entered are accurate, including the fee.</div></div></form>\n</md-content></div></div></div>");
$templateCache.put("app/main/e-discharge-consultant/view/e-discharge-consultant-view.html","<div id=\"e-discharge-consultant-view\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\" hide-xs></md-icon>\n<span class=\"white-fg h2\" ng-bind=\"vm.sharedService.pageName\" hide-xs></span><div flex></div><md-button \nclass=\"md-fab md-warn md-mini\" ng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip \nmd-direction=\"top\">Back</md-tooltip></md-button></div><div class=\"content-card\"><md-content class=\"content\"><form \nname=\"editForm\" novalidate><table class=\"uneditable\"><tr><th>MRN</th><td ng-bind=\"::vm.dataSource.patient_mrn\"></td>\n</tr><tr><th>Patient Name</th><td ng-bind=\"::vm.dataSource.patient_name\"></td></tr><tr><th>Admission Datetime</th><td>\n<span ng-bind=\"::vm.dataSource.admission_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></span> <span \nng-if=\"!vm.dataSource.admission_datetime\">-</span></td></tr><tr><th>Discharged Datetime</th><td><span \nng-bind=\"::vm.dataSource.discharged_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></span> <span \nng-if=\"!vm.dataSource.discharged_datetime\">-</span></td></tr><tr><th>Status</th><td ng-bind=\"vm.dataSource.status\">\n</td></tr></table><div class=\"vnp-doctor\" ng-repeat=\"doctor in vm.dataSource.e_discharge_doctor\"><div \nng-bind=\"::doctor.doctor_name\" ng-class=\"{\'green-100-bg\': doctor.is_primary }\"></div><div class=\"vnp-approved\" \nng-if=\"::doctor.approved_datetime\"><span>Last Approved</span> <span \nng-bind=\"::doctor.approved_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></span></div><div layout=\"column\"><div \nclass=\"vnp-header\">Visit</div><div class=\"no-data\" \nng-if=\"!doctor.e_discharge_visit || !doctor.e_discharge_visit.length\">No data</div><div class=\"vnp-data\" \nng-if=\"doctor.e_discharge_visit && doctor.e_discharge_visit.length\"><div><div>Date / Time</div><div>Visit Type</div>\n<div>Fee</div><div>Remark</div></div><div ng-repeat=\"item in doctor.e_discharge_visit\" \nng-class=\"{\'brown-50-bg\': !item.is_approved}\"><div><div>Date / Time</div><div ng-class=\"{amended: item.is_amended}\" \nng-bind=\"::item.visit_datetime | date: \'dd/MM/yyyy hh:mm a\'\"></div></div><div><div>Visit Type</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.visit_type\"></div></div><div><div>Fee</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.amount\"></div></div><div><div>Remark</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.remark\"></div></div></div></div></div><div layout=\"column\"><div \nclass=\"vnp-header\">Procedure</div><div class=\"no-data\" \nng-if=\"!doctor.e_discharge_procedure || !doctor.e_discharge_procedure.length\">No data</div><div class=\"vnp-data\" \nng-if=\"doctor.e_discharge_procedure && doctor.e_discharge_procedure.length\"><div><div>Procedure Code (MMA Code)</div>\n<div>Procedure Name</div><div>Fee</div><div>Consultant</div></div><div \nng-repeat=\"item in doctor.e_discharge_procedure\" ng-class=\"{\'brown-50-bg\': !item.is_approved}\"><div><div>\nProcedure Code (MMA Code)</div><div ng-class=\"{amended: item.is_amended}\"><div ng-bind=\"::item.procedure_code\"></div>\n<div ng-if=\"item.procedure_mma_code\">({{::item.procedure_mma_code}})</div></div></div><div><div>Procedure Name</div>\n<div ng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.procedure_name\"></div></div><div><div>Fee</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.amount\"></div></div><div><div>Anaesthetist</div><div \nng-class=\"{amended: item.is_amended}\" ng-bind=\"::item.doctor_name\"></div></div></div></div></div><div \nclass=\"vnp-questions\" \nng-show=\"doctor.e_discharge_question[doctor.e_discharge_question.length - 1].uses_implants !== undefined\"><div>\nDoes the procedure use implants?</div><md-radio-group class=\"vnp-implants\" \nng-class=\"{\'red-100-bg\': doctor.e_discharge_question[doctor.e_discharge_question.length - 1].uses_implants}\" \nng-model=\"doctor.e_discharge_question[doctor.e_discharge_question.length - 1].uses_implants\" ng-disabled=\"true\" \ntabindex=\"-1\"><md-radio-button ng-value=\"true\">Yes</md-radio-button><md-radio-button ng-value=\"false\">No\n</md-radio-button></md-radio-group><div class=\"vnp-questions-bar\"><md-button class=\"md-raised\" \nng-class=\"{\'md-accent\': doctor.showQuestionHistory}\" ng-click=\"vm.showQuestionHistory(doctor)\">View History<md-icon \nng-if=\"!doctor.showQuestionHistory\" md-font-icon=\"icon-chevron-down\"></md-icon><md-icon \nng-if=\"doctor.showQuestionHistory\" md-font-icon=\"icon-chevron-up\"></md-icon></md-button></div><div \nng-show=\"doctor.showQuestionHistory\"><div class=\"no-data\" ng-if=\"!vm.hasQuestionHistory(doctor)\">No data</div><div \nclass=\"vnp-data\" ng-if=\"vm.hasQuestionHistory(doctor)\"><div><div>Uses Implants</div></div><div \nng-repeat=\"item in doctor.e_discharge_question\" ng-class=\"{\'brown-50-bg\': !item.is_approved}\"><div><div>Uses Implants\n</div><div ng-class=\"{amended: item.is_amended}\" ng-bind=\"item.uses_implants ? \'Yes\' : \'No\'\"></div></div></div></div>\n</div></div></div></form></md-content></div></div></div>");
$templateCache.put("app/main/forgot-password/edit/forgot-password-edit.html","<div id=\"forgot-password-edit\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div \nid=\"forgot-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" \nclass=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"></div><div class=\"title\">Reset your password</div><form \nname=\"forgotPasswordEditForm\" ng-submit=\"vm.reset()\" novalidate><md-input-container class=\"md-block\" md-no-float><input\n type=\"password\" name=\"password\" ng-model=\"vm.accountService.user.password\" placeholder=\"New Password\" \nng-change=\"vm.resetErrors()\" required><div ng-messages=\"forgotPasswordEditForm.password.$error\"><div \nng-message=\"required\">Password is required</div><div ng-message=\"passwords-not-match\">Passwords does not match</div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"confirmPassword\" ng-model=\"vm.confirmPassword\" placeholder=\"Confirm Password\" ng-change=\"vm.resetErrors()\" \nrequired><div ng-messages=\"forgotPasswordEditForm.confirmPassword.$error\" multiple=\"multiple\"><div \nng-message=\"required\">Confirm password is required</div><div ng-message=\"passwords-not-match\">Passwords does not match\n</div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \nng-disabled=\"forgotPasswordEditForm.$invalid\">RESET PASSWORD</md-button></form><div class=\"login\" layout=\"row\" \nlayout-align=\"center center\"><a class=\"link\" ui-sref=\"app.login\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/login/otp/login-otp.html","<div id=\"login-otp\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"></div><div \nclass=\"title\">Type in your OTP number</div><form name=\"loginOtpForm\" ng-submit=\"vm.login()\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"otp\" \nng-model=\"vm.accountService.resetPhrase\" placeholder=\"OTP number\" required><div ng-messages=\"loginOtpForm.otp.$error\">\n<div ng-message=\"required\"><span>OTP number is required</span></div></div></md-input-container><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" ng-disabled=\"loginOtpForm.$invalid\">LOG IN</md-button></form>\n</div></div></div>");
$templateCache.put("app/main/operation-theater/edit/operation-theater-edit.html","<div id=\"operation-theater-edit\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><md-icon md-font-icon=\"icon-pencil\" class=\"white-fg\"></md-icon><span \nclass=\"white-fg h2\">{{ vm.sharedService.pageName }}</span></div><div class=\"content-card\"><md-content class=\"content\" \nms-scroll><form name=\"operationTheaterEditForm\" ng-submit=\"vm.request()\" novalidate><div layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"start center\"><md-autocomplete class=\"md-block\" flex-gt-xs=\"50\" md-floating-label=\"Patient\" \nmd-delay=\"200\" md-item-text=\"patient.patient_name\" md-selected-item=\"vm.patient\" md-search-text=\"vm.searchPatient\" \nmd-items=\"patient in vm.acPatient()\" md-input-name=\"patient\" md-require-match required><md-item-template><span \nmd-highlight-text=\"vm.searchPatient\">{{ patient.patient_no }} :: {{ patient.patient_name }}</span></md-item-template>\n<md-not-found>No matches found.</md-not-found><div ng-messages=\"operationTheaterEditForm.patient.$error\"><div \nng-message=\"required\">Patient is required</div><div ng-message=\"md-require-match\">Please select a valid patient.</div>\n</div></md-autocomplete><md-input-container class=\"md-block\" flex-gt-xs=\"50\"><label>Book for Datetime</label><input \nmoment-picker ng-model=\"vm.todo.requested_datetime\" format=\"DD/MM/YYYY hh:mm a\" min-date=\"vm.minDate\" \nreadonly=\"readonly\"></md-input-container></div><div layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\">\n<md-autocomplete class=\"md-block\" flex-gt-xs=\"50\" md-floating-label=\"OT Room\" md-delay=\"200\" md-item-text=\"room.code\" \nmd-selected-item=\"vm.room\" md-search-text=\"vm.searchRoom\" md-items=\"room in vm.acRoom()\" md-input-name=\"room\" \nmd-require-match><md-item-template><span md-highlight-text=\"vm.searchRoom\">{{ room.code }} :: {{ room.description }}\n</span></md-item-template><md-not-found>No matches found.</md-not-found><div \nng-messages=\"operationTheaterEditForm.room.$error\"><div ng-message=\"md-require-match\">Please select a valid room.</div>\n</div></md-autocomplete><div class=\"chips-autocomplete-wrapper\" flex-gt-xs=\"50\"><md-chips class=\"md-block\" \nflex-gt-sm=\"50\" ng-model=\"vm.procedures\" md-transform-chip=\"vm.transformChip($chip)\" md-autocomplete-snap \nmd-require-match min-items=\"1\" name=\"procedures\"><md-autocomplete placeholder=\"Procedures\" \nmd-item-text=\"procedure.code\" md-selected-item=\"vm.procedure\" md-search-text=\"vm.searchProcedure\" \nmd-items=\"procedure in vm.acProcedure()\" md-input-name=\"procedure\"><md-item-template><span \nmd-highlight-text=\"vm.searchProcedure\">{{ procedure.code }} :: {{ procedure.description }}</span></md-item-template>\n</md-autocomplete><md-chip-template><span><strong>{{ $chip.code }}</strong> <em>{{ $chip.description }}</em></span>\n</md-chip-template></md-chips><div ng-messages=\"operationTheaterEditForm.procedures.$error\" \nng-if=\"operationTheaterEditForm.procedure.$touched || operationTheaterEditForm.$submitted\" class=\"errors\"><div \nng-message=\"min-items\">At least one procedure is required.</div></div></div></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"100\" class=\"md-block\"><label>Remarks</label><input \nname=\"remarks\" ng-model=\"vm.todo.remarks\" required><div ng-messages=\"operationTheaterEditForm.remarks.$error\"><div \nng-message=\"required\">Remarks is required</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-fab md-warn\" ng-class=\"vm.mediaXsActionButtons\" ng-click=\"vm.back()\">\n<md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"top\">Back</md-tooltip></md-button>\n<md-button type=\"submit\" class=\"md-fab md-accent\" ng-class=\"vm.mediaXsActionButtons\" \nng-disabled=\"operationTheaterEditForm.$invalid || operationTheaterEditForm.$pristine\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip md-direction=\"top\">Place Request</md-tooltip></md-button></div></form>\n</md-content></div></div></div>");
$templateCache.put("app/main/role/edit/role-edit.html","<div id=\"role-edit\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs>\n<md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\">\n{{ vm.sharedService.pageName }}</span></div><div class=\"content-card\"><md-content class=\"content\" ms-scroll><form \nname=\"roleEditForm\" ng-submit=\"vm.request()\" novalidate><div layout=\"row\" layout-align-gt-xs=\"start center\">\n<md-input-container class=\"md-block md-input-has-value\" flex=\"100\" ng-hide=\"vm.role.id === 0\"><label>Role Name</label>\n<span>{{ vm.role.name }}</span></md-input-container><md-input-container class=\"md-block md-input-has-value\" flex=\"100\" \nng-show=\"vm.role.id === 0\"><label>Role Name</label><input name=\"name\" ng-model=\"vm.role.name\" \nng-required=\"vm.role.id === 0\"><div ng-messages=\"roleEditForm.name.$error\"><div ng-message=\"required\">\nRole name is required.</div></div></md-input-container></div><div layout=\"row\" layout-align=\"start center\">\n<md-input-container flex=\"100\" class=\"md-block\"><label>Description</label><input name=\"description\" \nng-model=\"vm.role.description\"></md-input-container></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-fab md-warn\" ng-class=\"vm.mediaXsActionButtons\" ng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon><md-tooltip md-direction=\"top\">Back</md-tooltip></md-button><md-button type=\"submit\" \nclass=\"md-fab md-accent\" ng-class=\"vm.mediaXsActionButtons\" \nng-disabled=\"roleEditForm.$invalid || roleEditForm.$pristine\"><md-icon md-font-icon=\"icon-check\"></md-icon><md-tooltip \nmd-direction=\"top\" ng-bind=\"vm.role.id === 0 ? \'Create\' : \'Update\'\"></md-tooltip></md-button></div></form></md-content>\n</div></div></div>");
$templateCache.put("app/main/roster/edit/roster-edit.html","<div id=\"roster-edit\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs>\n<md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\" \nng-bind=\"vm.sharedService.pageName\"></span><div flex></div><md-button class=\"md-fab md-warn md-mini\" \nng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"top\">Back</md-tooltip>\n</md-button><md-button class=\"md-fab md-accent md-mini\" ng-click=\"vm.save()\" \nng-disabled=\"rosterEditForm.$invalid || rosterEditForm.$pristine\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n<md-tooltip md-direction=\"top\">Save</md-tooltip></md-button></div><div class=\"content-card\"><md-content \nclass=\"content\" ms-scroll><form name=\"rosterEditForm\" novalidate><md-autocomplete class=\"md-block\" \nmd-floating-label=\"On Duty User\" md-delay=\"200\" md-item-text=\"user.profile_name\" md-selected-item=\"vm.user\" \nmd-search-text=\"vm.searchUser\" md-items=\"user in vm.autocompleteUser()\" md-input-name=\"user\" md-require-match required>\n<md-item-template><span md-highlight-text=\"vm.searchUser\">{{ user.username }} :: {{ user.profile_name }}</span>\n</md-item-template><md-not-found>No matches found.</md-not-found><div ng-messages=\"rosterEditForm.user.$error\" \nng-show=\"rosterEditForm.user.$dirty\"><div ng-message=\"required\">On duty user is required</div><div \nng-message=\"md-require-match\">Please select a valid user.</div></div></md-autocomplete><md-input-container \nclass=\"md-block\"><label>Tag</label><md-select ng-model=\"vm.roster.tag\" ng-model-options=\"{ trackBy: \'$value\' }\">\n<md-option ng-value=\"null\" ng-bind=\"::vm.defaultNoSelectionText\"></md-option><md-option ng-value=\"tag\" \nng-repeat=\"tag in vm.tags\" ng-bind=\"::tag\"></md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\"><label>Apply From Date</label><input name=\"applyFromDate\" moment-picker ng-model=\"vm.applyFromDate\" \nformat=\"DD/MM/YYYY\" min-date=\"vm.minDate\" readonly=\"readonly\" required><div \nng-messages=\"rosterEditForm.applyFromDate.$error\"><div ng-message=\"required\">Apply from date is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Apply To Date</label><input name=\"applyToDate\" \nmoment-picker ng-model=\"vm.applyToDate\" format=\"DD/MM/YYYY\" min-date=\"vm.minDate\" readonly=\"readonly\" required><div \nng-messages=\"rosterEditForm.applyToDate.$error\"><div ng-message=\"required\">Apply to date is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Apply Shift</label><md-select name=\"shift\" \nng-model=\"vm.shift\" ng-model-options=\"{ trackBy: \'$value.id\' }\" required><md-option ng-value=\"shift\" \nng-repeat=\"shift in vm.shifts\"><span ng-bind=\"::shift.name\"></span></md-option></md-select><div \nng-messages=\"rosterEditForm.shift.$error\"><div ng-message=\"required\">Shift is required</div></div></md-input-container>\n</form></md-content></div></div></div>");
$templateCache.put("app/main/shift/edit/shift-edit.html","<div id=\"shift-edit\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs>\n<md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\" \nng-bind=\"vm.sharedService.pageName\"></span><div flex></div><md-button class=\"md-fab md-warn md-mini\" \nng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"top\">Back</md-tooltip>\n</md-button><md-button class=\"md-fab md-accent md-mini\" ng-click=\"vm.save()\" \nng-disabled=\"shiftEditForm.$invalid || shiftEditForm.$pristine\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n<md-tooltip md-direction=\"top\">Save</md-tooltip></md-button></div><div class=\"content-card\"><md-content \nclass=\"content\" ms-scroll><form name=\"shiftEditForm\" novalidate><md-input-container class=\"md-block\"><label>Name\n</label><input name=\"name\" ng-model=\"vm.shift.name\" required><div ng-messages=\"shiftEditForm.name.$error\"><div \nng-message=\"required\">Name is required</div></div></md-input-container><md-input-container class=\"md-block\"><label>\nMonday</label><md-select ng-model=\"vm.shift.mondaySlot\" ng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option \nng-value=\"null\" ng-bind=\"::vm.defaultNoSelectionText\"></md-option><md-option ng-value=\"timeslot\" \nng-repeat=\"timeslot in vm.timeslots\" ng-bind=\"::timeslot.name\"></md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label>Tuesday</label><md-select ng-model=\"vm.shift.tuesdaySlot\" \nng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option ng-value=\"null\" ng-bind=\"::vm.defaultNoSelectionText\">\n</md-option><md-option ng-value=\"timeslot\" ng-repeat=\"timeslot in vm.timeslots\" ng-bind=\"::timeslot.name\"></md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>Wednesday</label><md-select \nng-model=\"vm.shift.wednesdaySlot\" ng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option ng-value=\"null\" \nng-bind=\"::vm.defaultNoSelectionText\"></md-option><md-option ng-value=\"timeslot\" ng-repeat=\"timeslot in vm.timeslots\" \nng-bind=\"::timeslot.name\"></md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>\nThursday</label><md-select ng-model=\"vm.shift.thursdaySlot\" ng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option \nng-value=\"null\" ng-bind=\"::vm.defaultNoSelectionText\"></md-option><md-option ng-value=\"timeslot\" \nng-repeat=\"timeslot in vm.timeslots\" ng-bind=\"::timeslot.name\"></md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label>Friday</label><md-select ng-model=\"vm.shift.fridaySlot\" \nng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option ng-value=\"null\" ng-bind=\"::vm.defaultNoSelectionText\">\n</md-option><md-option ng-value=\"timeslot\" ng-repeat=\"timeslot in vm.timeslots\" ng-bind=\"::timeslot.name\"></md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\"><label>Saturday</label><md-select \nng-model=\"vm.shift.saturdaySlot\" ng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option ng-value=\"null\" \nng-bind=\"::vm.defaultNoSelectionText\"></md-option><md-option ng-value=\"timeslot\" ng-repeat=\"timeslot in vm.timeslots\" \nng-bind=\"::timeslot.name\"></md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label>\nSunday</label><md-select ng-model=\"vm.shift.sundaySlot\" ng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option \nng-value=\"null\" ng-bind=\"::vm.defaultNoSelectionText\"></md-option><md-option ng-value=\"timeslot\" \nng-repeat=\"timeslot in vm.timeslots\" ng-bind=\"::timeslot.name\"></md-option></md-select></md-input-container></form>\n</md-content></div></div></div>");
$templateCache.put("app/main/seven-days-discharge/edit/discharge-edit.html","<div id=\"discharge-edit\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon>\n<span class=\"white-fg h2\" ng-bind=\"vm.sharedService.pageName\"></span><div flex></div><md-button \nclass=\"md-fab md-warn md-mini\" ng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip \nmd-direction=\"top\">Back</md-tooltip></md-button><md-button class=\"md-fab md-accent md-mini\" ng-click=\"vm.save()\" \nng-disabled=\"dischargeEditForm.$invalid || dischargeEditForm.$pristine\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon><md-tooltip md-direction=\"top\">Save</md-tooltip></md-button><md-button class=\"md-fab md-accent md-mini\" \nng-click=\"vm.submit()\" ng-disabled=\"vm.submitDisabled()\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip \nmd-direction=\"top\">Submit and Download Form</md-tooltip></md-button></div><div class=\"content-card\"><md-content \nclass=\"content\" ms-scroll><form name=\"dischargeEditForm\" novalidate><md-input-container class=\"md-block\"><label>\nDate of Admission</label><input name=\"admissionDate\" moment-picker ng-model=\"vm.dischargeForm.admission_date\" \nformat=\"DD/MM/YYYY\" readonly=\"readonly\" required><div ng-messages=\"dischargeEditForm.admissionDate.$error\"><div \nng-message=\"required\">Date of admission is required</div></div></md-input-container><md-input-container \nclass=\"md-block\"><label>Date of Discharge</label><input name=\"dischargeDate\" moment-picker \nng-model=\"vm.dischargeForm.discharge_date\" format=\"DD/MM/YYYY\" readonly=\"readonly\" required><div \nng-messages=\"dischargeEditForm.dischargeDate.$error\"><div ng-message=\"required\">Date of discharge is required</div>\n</div></md-input-container><md-input-container class=\"md-block\"><label>Primary Physician</label><input \nname=\"primaryPhysician\" ng-model=\"vm.dischargeForm.primary_physician\" required><div \nng-messages=\"dischargeEditForm.primaryPhysician.$error\"><div ng-message=\"required\">Primary physician is required</div>\n</div></md-input-container><md-input-container class=\"md-block\"><label>Admitting Diagnosis &amp; Reason For Admission\n</label><textarea name=\"diagAndReason\" ng-model=\"vm.dischargeForm.diag_and_reason\" required rows=\"3\"></textarea><div \nng-messages=\"dischargeEditForm.diagAndReason.$error\"><div ng-message=\"required\">\nAdmitting diagnosis &amp; reason for admission is required</div></div></md-input-container><md-input-container \nclass=\"md-block\"><label>Medical And Surgical History</label><textarea name=\"medHistory\" \nng-model=\"vm.dischargeForm.med_history\" required rows=\"3\"></textarea><div \nng-messages=\"dischargeEditForm.medHistory.$error\"><div ng-message=\"required\">Medical and surgical history is required\n</div></div></md-input-container><md-input-container class=\"md-block\"><label>Investigation</label><textarea \nname=\"investigation\" ng-model=\"vm.dischargeForm.investigation\" required rows=\"3\"></textarea><div \nng-messages=\"dischargeEditForm.investigation.$error\"><div ng-message=\"required\">Investigation is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Procedure/Surgery</label><textarea name=\"procedure\" \nng-model=\"vm.dischargeForm.procedure\" required rows=\"3\"></textarea><div \nng-messages=\"dischargeEditForm.procedure.$error\"><div ng-message=\"required\">Procedure/Surgery is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Progress During Admission</label><textarea \nname=\"progress\" ng-model=\"vm.dischargeForm.progress\" required rows=\"3\"></textarea><div \nng-messages=\"dischargeEditForm.progress.$error\"><div ng-message=\"required\">Progress during admission is required</div>\n</div></md-input-container><md-input-container class=\"md-block\"><label>Discharge Diagnosis</label><textarea \nname=\"dischargeDiag\" ng-model=\"vm.dischargeForm.discharge_diag\" required rows=\"3\"></textarea><div \nng-messages=\"dischargeEditForm.dischargeDiag.$error\"><div ng-message=\"required\">Discharge diagnosis is required</div>\n</div></md-input-container><md-input-container class=\"md-block\"><label>Allergies</label><textarea name=\"allergies\" \nng-model=\"vm.dischargeForm.allergies\" required rows=\"3\"></textarea><div \nng-messages=\"dischargeEditForm.allergies.$error\"><div ng-message=\"required\">Allergies is required</div></div>\n</md-input-container><md-input-container class=\"md-block\"><label>Medication Upon Discharge</label><textarea \nname=\"dischargeMeds\" ng-model=\"vm.dischargeForm.discharge_meds\" required rows=\"3\"></textarea><div \nng-messages=\"dischargeEditForm.dischargeMeds.$error\"><div ng-message=\"required\">Medication upon discharge is required\n</div></div></md-input-container><md-input-container class=\"md-block\"><label>Discharge/Follow-Up Orders</label>\n<textarea name=\"followUpOrders\" ng-model=\"vm.dischargeForm.follow_up_orders\" required rows=\"3\"></textarea><div \nng-messages=\"dischargeEditForm.followUpOrders.$error\"><div ng-message=\"required\">Discharge/Follow-up orders is required\n</div></div></md-input-container><div layout=\"row\"><md-input-container class=\"md-block\" flex><label>\nMedical Leave Start Date</label><input name=\"medLeaveStartDate\" moment-picker \nng-model=\"vm.dischargeForm.med_leave_start_date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"><div \nng-messages=\"dischargeEditForm.medLeaveStartDate.$error\"><div ng-message=\"required\">\nMedical leave start date is required</div></div></md-input-container><md-button class=\"md-fab md-warn md-mini\" \nng-click=\"vm.dischargeForm.med_leave_start_date = null\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon><md-tooltip\n md-direction=\"top\">Clear Date</md-tooltip></md-button></div><div layout=\"row\"><md-input-container class=\"md-block\" \nflex><label>Medical Leave End Date</label><input name=\"medLeaveEndDate\" moment-picker \nng-model=\"vm.dischargeForm.med_leave_end_date\" format=\"DD/MM/YYYY\" readonly=\"readonly\"><div \nng-messages=\"dischargeEditForm.medLeaveEndDate.$error\"><div ng-message=\"required\">Medical leave end date is required\n</div></div></md-input-container><md-button class=\"md-fab md-warn md-mini\" \nng-click=\"vm.dischargeForm.med_leave_end_date = null\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon><md-tooltip \nmd-direction=\"top\">Clear Date</md-tooltip></md-button></div></form></md-content></div></div></div>");
$templateCache.put("app/main/specialty/edit/specialty-edit.html","<div id=\"specialty-edit\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon>\n<span class=\"white-fg h2\" ng-bind=\"vm.sharedService.pageName\"></span><div flex></div><md-button \nclass=\"md-fab md-warn md-mini\" ng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip \nmd-direction=\"top\">Back</md-tooltip></md-button><md-button class=\"md-fab md-accent md-mini\" ng-click=\"vm.save()\" \nng-disabled=\"specialtyEditForm.$invalid || specialtyEditForm.$pristine\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon><md-tooltip md-direction=\"top\">Save</md-tooltip></md-button></div><div class=\"content-card\"><md-content \nclass=\"content\" ms-scroll><form name=\"specialtyEditForm\" novalidate><md-input-container class=\"md-block\"><label>Name\n</label><input name=\"name\" ng-model=\"vm.specialty.name\" required><div ng-messages=\"specialtyEditForm.name.$error\"><div \nng-message=\"required\">Name is required</div></div></md-input-container><md-input-container class=\"md-block\"><label>\nColor</label><input minicolors=\"vm.colorSettings\" ng-model=\"vm.specialty.color\"></md-input-container></form>\n</md-content></div></div></div>");
$templateCache.put("app/main/surgical-procedure/edit/surgical-procedure-edit.html","<div id=\"surgical-procedure-edit\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon>\n<span class=\"white-fg h2\" ng-bind=\"vm.sharedService.pageName\"></span><div flex></div><md-button \nclass=\"md-fab md-warn md-mini\" ng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip \nmd-direction=\"top\">Back</md-tooltip></md-button><md-button class=\"md-fab md-accent md-mini\" ng-click=\"vm.save()\" \nng-disabled=\"editForm.$invalid || editForm.$pristine\"><md-icon md-font-icon=\"icon-content-save\"></md-icon><md-tooltip \nmd-direction=\"top\">Save</md-tooltip></md-button></div><div class=\"content-card\"><md-content class=\"content\" ms-scroll>\n<div class=\"proc-uneditable\"><div class=\"proc-title\">Procedure Code</div><div class=\"proc-val\" \nng-bind=\"::vm.dataSource.transaction_code\"></div></div><div class=\"proc-uneditable\"><div class=\"proc-title\">\nProcedure Description</div><div class=\"proc-val\" ng-bind=\"::vm.dataSource.transaction_code_description\"></div></div>\n<form name=\"editForm\" novalidate><md-input-container class=\"md-block\"><label>MMA Code</label><input name=\"mmaCode\" \nng-model=\"vm.dataSource.procedure_detail.mma_code\"><div ng-messages=\"editForm.mmaCode.$error\"><div \nng-message=\"required\">MMA code is required</div></div></md-input-container></form></md-content></div></div></div>");
$templateCache.put("app/main/timeslot/edit/timeslot-edit.html","<div id=\"timeslot-edit\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" \nlayout-align=\"start center\" hide-xs><md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon>\n<span class=\"white-fg h2\" ng-bind=\"vm.sharedService.pageName\"></span><div flex></div><md-button \nclass=\"md-fab md-warn md-mini\" ng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip \nmd-direction=\"top\">Back</md-tooltip></md-button><md-button class=\"md-fab md-accent md-mini\" ng-click=\"vm.save()\" \nng-disabled=\"timeslotEditForm.$invalid || timeslotEditForm.$pristine\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon><md-tooltip md-direction=\"top\">Save</md-tooltip></md-button></div><div class=\"content-card\"><md-content \nclass=\"content\" ms-scroll><form name=\"timeslotEditForm\" novalidate><md-input-container class=\"md-block\"><label>Name\n</label><input name=\"name\" ng-model=\"vm.timeslot.name\" required><div ng-messages=\"timeslotEditForm.name.$error\"><div \nng-message=\"required\">Name is required</div></div></md-input-container><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-xs=\"45\"><label>Start Time</label><input name=\"startTime\" moment-picker \nng-model=\"vm.timeslot.start_time\" ng-change=\"vm.startTimeChanged()\" format=\"HH:mm\" readonly=\"readonly\" required><div \nng-messages=\"timeslotEditForm.startTime.$error\"><div ng-message=\"required\">Start time is required</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"45\"><label>End Time</label><input name=\"endTime\" \nmoment-picker ng-model=\"vm.timeslot.end_time\" format=\"HH:mm\" readonly=\"readonly\" required><div \nng-messages=\"timeslotEditForm.endTime.$error\"><div ng-message=\"required\">End time is required</div></div>\n</md-input-container></div></form></md-content></div></div></div>");
$templateCache.put("app/main/todo/edit/memo-edit2.html","<div id=\"memo-edit\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs>\n<md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\">\n{{ vm.sharedService.pageName }}</span></div><div class=\"content-card\"><md-content class=\"content\" ms-scroll><form \nname=\"memoEditForm\" ng-submit=\"vm.request()\" novalidate><div layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\">\n<md-input-container class=\"md-block md-input-has-value\" flex-gt-xs=\"50\"><label>Type</label><span>{{ vm.todo.type }}\n</span></md-input-container><md-input-container class=\"md-block md-input-has-value\" flex-gt-xs=\"50\" \nng-show=\"vm.todo.subtype\"><label>Process</label><span>{{ vm.todo.subtype }}</span></md-input-container></div>\n<md-input-container class=\"md-block md-input-has-value\" flex-gt-xs=\"50\"><label>Status</label><span>{{ vm.todo.status }}\n</span></md-input-container><div ng-if=\"vm.apptInfo\"><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block md-input-has-value\" flex-gt-xs=\"50\"><label>Patient Name</label><span \nng-bind=\"::vm.apptInfo.patientName\"></span></md-input-container><md-input-container \nclass=\"md-block md-input-has-value\" flex-gt-xs=\"50\"><label>Patient Number</label><span \nng-bind=\"::vm.apptInfo.patientNo\"></span></md-input-container><md-input-container class=\"md-block md-input-has-value\" \nflex-gt-xs=\"50\"><label>Status</label><span ng-bind=\"::vm.apptInfo.statusDesc\"></span></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block md-input-has-value\" flex-gt-xs=\"50\"><label>Type</label><span \nng-bind=\"::vm.apptInfo.typeDesc\"></span></md-input-container><md-input-container class=\"md-block md-input-has-value\" \nflex-gt-xs=\"50\"><label>Is Urgent?</label><span ng-bind=\"::vm.apptInfo.urgentInd\"></span></md-input-container>\n<md-input-container class=\"md-block md-input-has-value\" flex-gt-xs=\"50\"><label>Date & Time</label><span \nng-bind=\"::vm.apptInfo.datetime.local().format(\'DD-MM-YYYY hh:mm a\')\"></span></md-input-container></div></div>\n<md-radio-group layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" ng-model=\"vm.todo.subtype\" \nng-change=\"vm.subtypeChanged()\" ng-show=\"vm.isDoctorOrPa()\"><md-radio-button flex-gt-xs=\"33\" \nvalue=\"NEW/RESCHEDULE SLOT\">New/Reschedule Slot</md-radio-button><md-radio-button flex-gt-xs=\"33\" \nvalue=\"CANCEL/BLOCK CLINIC\">Cancel/Block Clinic</md-radio-button><md-radio-button flex-gt-xs=\"33\" value=\"OTHERS\">Others\n</md-radio-button></md-radio-group><md-select class=\"md-block\" ng-model=\"vm.role\" \nng-model-options=\"{ trackBy: \'$value.id\' }\" \nng-disabled=\"vm.todo.subtype === \'NEW/RESCHEDULE SLOT\' || vm.todo.subtype === \'CANCEL/BLOCK CLINIC\'\"><md-option \nng-value=\"role\" ng-repeat=\"role in vm.roles\">{{ role.description }}</md-option></md-select><md-input-container \nclass=\"md-block\" flex-gt-xs=\"45\" ng-show=\"vm.needStartDate()\"><label>Start Date (Required)</label><input moment-picker \nng-model=\"vm.startDate\" ng-change=\"vm.startDateChanged()\" format=\"DD/MM/YYYY\" min-date=\"vm.minDate\" \nreadonly=\"readonly\" ng-required=\"vm.needStartDate()\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-xs=\"45\" ng-show=\"vm.needStartTime()\"><label>Start Time (Required)</label><input moment-picker \nng-model=\"vm.startTime\" ng-change=\"vm.startTimeChanged()\" format=\"HH:mm\" readonly=\"readonly\" \nng-required=\"vm.needStartTime()\"></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"45\" \nng-show=\"vm.needEndDate()\"><label>End Date (Required)</label><input moment-picker ng-model=\"vm.endDate\" \nformat=\"DD/MM/YYYY\" min-date=\"vm.minDate\" readonly=\"readonly\" ng-required=\"vm.needEndDate()\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-xs=\"45\" ng-show=\"vm.needEndTime()\"><label>End Time (Required)</label>\n<input moment-picker ng-model=\"vm.endTime\" format=\"HH:mm\" readonly=\"readonly\" ng-required=\"vm.needEndTime()\">\n</md-input-container><md-autocomplete class=\"md-block\" md-floating-label=\"For Doctor\" md-delay=\"200\" \nmd-item-text=\"doctor.name\" md-selected-item=\"vm.doctor\" md-search-text=\"vm.searchDoctor\" \nmd-items=\"doctor in vm.acDoctor()\" md-input-name=\"doctor\" md-require-match ng-show=\"vm.role.name === \'Doctor\'\" \nng-required=\"vm.role.name === \'Doctor\'\"><md-item-template><span md-highlight-text=\"vm.searchDoctor\">\n{{ doctor.code }} :: {{ doctor.name }}</span></md-item-template><md-not-found>No matches found.</md-not-found><div \nng-messages=\"memoEditForm.doctor.$error\"><div ng-message=\"required\">Doctor is required</div><div \nng-message=\"md-require-match\">Please select a valid doctor.</div></div></md-autocomplete><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"100\" class=\"md-block\"><label>Remarks</label><input \nname=\"remarks\" ng-model=\"vm.todo.remarks\" required><div ng-messages=\"memoEditForm.remarks.$error\"><div \nng-message=\"required\">Remarks is required</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><lf-ng-md-file-input lf-files=\"vm.files\" lf-api=\"vm.lfApi\" flex=\"100\" multiple=\"multiple\" \npreview progress></lf-ng-md-file-input></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-fab md-warn\" ng-class=\"vm.mediaXsActionButtons\" ng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\">\n</md-icon><md-tooltip md-direction=\"top\">Back</md-tooltip></md-button><md-button type=\"submit\" \nclass=\"md-fab md-accent\" ng-class=\"vm.mediaXsActionButtons\" \nng-disabled=\"memoEditForm.$invalid || memoEditForm.$pristine\"><md-icon md-font-icon=\"icon-check\"></md-icon><md-tooltip \nmd-direction=\"top\">Place Request</md-tooltip></md-button></div></form></md-content></div></div></div>");
$templateCache.put("app/main/todo/thread/thread2.html","<div id=\"thread\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><md-icon \nhide-xs md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><div class=\"white-fg h2\" \nlayout=\"row\" layout-align=\"start center\"><span hide-xs>{{ vm.sharedService.pageName }}</span><div \nng-bind-html=\"vm.displayThreadStatus()\"></div></div><div class=\"white-fg back-icon\"><md-button ng-click=\"vm.back()\" \nhide-xs><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"top\">Back</md-tooltip><span>BACK\n</span></md-button><md-button class=\"md-icon-button\" hide-gt-xs ng-click=\"vm.back()\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"top\">Back</md-tooltip></md-button></div></div><div \nclass=\"content\" layout=\"column\" flex><md-button type=\"button\" class=\"md-fab md-warn md-mini super-tiny\" \nng-show=\"vm.notAtBottom\" ng-click=\"vm.scrollToBottom()\"><md-icon md-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip\n md-direction=\"top\">Scroll to Bottom</md-tooltip></md-button><md-content id=\"thread-scroll-anchor\" class=\"content\"><div\n class=\"thread-container\" ms-scroll><div class=\"chat-bubble-container\" ng-class=\"{self: memo.isSelf}\" \nng-repeat=\"memo in vm.memos track by memo.id\"><div class=\"chat-bubble\" ng-class=\"{show: !!memo, self: memo.isSelf}\">\n<div md-ink-ripple=\"#808080\" class=\"chevron-down\" ng-click=\"vm.showReadStatuses($event, memo)\"><md-icon \nmd-font-icon=\"icon-chevron-down\"></md-icon><md-tooltip md-direction=\"top\">Message info</md-tooltip></div><div \nclass=\"chat-bubble-header\" ng-if=\"memo.subtype === \'NEW/RESCHEDULE SLOT\' || memo.subtype === \'CANCEL/BLOCK CLINIC\'\">\n<span ng-bind=\"::memo.subtype\" ng-if=\"$index === 0\"></span><div ng-bind=\"::memo.requested_datetime\" \nng-if=\"$index === 0\"></div><div ng-if=\"memo.status === vm.Todo.STATUS.APPROVED\"><span class=\"green-500-fg\" \nng-bind=\"memo.status\"></span></div><div ng-if=\"memo.status === vm.Todo.STATUS.REJECTED\"><span class=\"red-500-fg\" \nng-bind=\"memo.status\"></span></div></div><div class=\"chat-remarks\" ng-class=\"{\'chat-no-remarks\': !memo.remarks}\"><span \nng-bind-html=\"::memo.remarks\"></span> <span ng-if=\"!memo.remarks\">(No remarks)</span></div><br><div \nclass=\"chat-attachments\" ng-show=\"memo.attachments.length > 0\"><span class=\"chat-attachments-header\">Attachments</span>\n <a ng-repeat=\"attachment in memo.attachments\" href=\"javascript:void(0)\" \nng-click=\"vm.downloadAttachment($parent.$index, $index)\" ng-bind=\"attachment.original_file_name\"></a></div><div \nclass=\"chat-bubble-date\"><div ng-bind-html=\"vm.displaySenders(memo)\"></div></div><div class=\"chat-bubble-action\" \nng-if=\"vm.hasRole(\'NurseManager\') && $index === 0\"><md-button class=\"md-icon-button md-raised md-accent\" \nng-click=\"vm.alterThreadState(\'APPROVED\', memo)\" ng-disabled=\"vm.memos[0].status !== \'PENDING\'\"><md-icon \nmd-font-icon=\"icon-check\"></md-icon><md-tooltip>Approve</md-tooltip></md-button><md-button \nclass=\"md-icon-button md-raised md-warn\" ng-click=\"vm.alterThreadState(\'REJECTED\', memo)\" \nng-disabled=\"!vm.memo.remarks || vm.memos[0].status !== \'PENDING\'\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n<md-tooltip>Reject</md-tooltip></md-button></div></div></div></div></md-content><div class=\"loading\" \nng-show=\"vm.loading\"><md-progress-circular md-diameter=\"100\" class=\"md-accent\"></md-progress-circular></div></div><form\n class=\"footer white-bg\" layout=\"column\" layout-align=\"start start\" ng-submit=\"vm.saveMemoToThread()\"><div \nclass=\"footer-input\" layout=\"row\" layout-align=\"space-between center\" flex><md-input-container \nclass=\"md-block message-input\" flex ng-if=\"!vm.hasRole(\'NurseManager\') && !vm.hasRole(\'CallCenterStaff\')\"><input \nng-disabled=\"vm.memos[0].status === \'COMPLETED\'\" ng-model=\"vm.memo.remarks\" placeholder=\"Type in remarks...\">\n</md-input-container><md-input-container class=\"md-block message-input\" flex \nng-if=\"vm.hasRole(\'CallCenterStaff\') && vm.memos[0].subtype === \'NEW/RESCHEDULE SLOT\'\"><input \nng-disabled=\"vm.memos[0].status === \'PENDING\' || vm.memos[0].status === \'COMPLETED\'\" ng-model=\"vm.memo.remarks\" \nplaceholder=\"Type in remarks...\"></md-input-container><md-input-container class=\"md-block message-input\" flex \nng-if=\"vm.hasRole(\'CallCenterStaff\') && vm.memos[0].subtype !== \'NEW/RESCHEDULE SLOT\'\"><input \nng-disabled=\"vm.memos[0].status === \'COMPLETED\'\" ng-model=\"vm.memo.remarks\" placeholder=\"Type in remarks...\">\n</md-input-container><md-input-container class=\"md-block message-input\" flex ng-if=\"vm.hasRole(\'NurseManager\')\"><input \nng-disabled=\"vm.memos[0].status === \'COMPLETED\'\" ng-model=\"vm.memo.remarks\" placeholder=\"Type in remarks...\">\n</md-input-container><div class=\"footer-buttons\" layout=\"row\" layout-align=\"end center\"><md-button type=\"submit\" \nclass=\"md-fab md-accent md-mini\" ng-disabled=\"!vm.memo.remarks || vm.memos[0].status === \'COMPLETED\'\" \nng-class=\"vm.mediaXsSendButton\"><md-icon md-font-icon=\"icon-send\"></md-icon><md-tooltip md-direction=\"top\">Send\n</md-tooltip></md-button><md-button type=\"button\" class=\"md-fab md-warn md-mini\" \nng-if=\"!vm.hasRole(\'NurseManager\') || vm.memos[0].status === \'REJECTED\'\" ng-class=\"vm.mediaXsCompleteButton\" \nng-disabled=\"!vm.memo.remarks || vm.memos[0].status === \'COMPLETED\'\" ng-click=\"vm.closeThread()\"><md-icon \nmd-font-icon=\"icon-minus-circle\"></md-icon><md-tooltip md-direction=\"top\">Close Thread</md-tooltip></md-button></div>\n</div><div class=\"footer-file\" flex><div layout=\"row\" layout-align=\"start center\" \nng-if=\"vm.hasRole(\'CallCenterStaff\') && vm.memos[0].subtype === \'NEW/RESCHEDULE SLOT\'\"><lf-ng-md-file-input \nlf-files=\"vm.files\" lf-api=\"vm.lfApi\" flex=\"100\" multiple=\"multiple\" progress \nng-disabled=\"vm.memos[0].status === \'PENDING\' || vm.memos[0].status === \'COMPLETED\'\"></lf-ng-md-file-input></div><div \nlayout=\"row\" layout-align=\"start center\" \nng-if=\"vm.hasRole(\'CallCenterStaff\') && vm.memos[0].subtype !== \'NEW/RESCHEDULE SLOT\'\"><lf-ng-md-file-input \nlf-files=\"vm.files\" lf-api=\"vm.lfApi\" flex=\"100\" multiple=\"multiple\" progress \nng-disabled=\"vm.memos[0].status === \'COMPLETED\'\"></lf-ng-md-file-input></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"!vm.hasRole(\'CallCenterStaff\')\"><lf-ng-md-file-input lf-files=\"vm.files\" \nlf-api=\"vm.lfApi\" flex=\"100\" multiple=\"multiple\" progress ng-disabled=\"vm.memos[0].status === \'COMPLETED\'\">\n</lf-ng-md-file-input></div></div></form></div></div>");
$templateCache.put("app/main/user/edit/user-edit.html","<div id=\"user-edit\" class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\" hide-xs>\n<md-icon md-font-icon=\"{{ vm.sharedService.pageIcon }}\" class=\"white-fg\"></md-icon><span class=\"white-fg h2\">\n{{ vm.sharedService.pageName }}</span></div><div class=\"content-card\"><md-content class=\"content\" ms-scroll><form \nname=\"userEditForm\" ng-submit=\"vm.request()\" novalidate><div layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\">\n<md-input-container class=\"md-block md-input-has-value\" flex-gt-xs=\"50\"><label>Profile Name</label><span>\n{{ vm.user.profile_name }}</span></md-input-container><md-input-container class=\"md-block md-input-has-value\" \nflex-gt-xs=\"50\" ng-show=\"vm.user.email\"><label>Email</label><span>{{ vm.user.email }}</span></md-input-container></div>\n<div layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><md-input-container class=\"md-block md-input-has-value\" \nflex-gt-xs=\"50\"><label>Is Suspended</label><span>{{ vm.user.isSuspendedString() }}</span></md-input-container>\n<md-input-container class=\"md-block md-input-has-value\" flex-gt-xs=\"50\"><label>Email</label><input name=\"email\" \nng-model=\"vm.user.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"userEditForm.email.$error\"><div \nng-message=\"required\">Email is required</div><div ng-message=\"pattern\">Email must be of valid format</div></div>\n</md-input-container></div><div layout-gt-xs=\"row\" layout-align-gt-xs=\"start center\"><md-input-container \nclass=\"md-block\" flex-gt-xs=\"50\"><label>Password</label><input name=\"password\" ng-model=\"vm.user.password\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"50\"><label>Phone Number</label><input \nname=\"phoneNumber\" ng-model=\"vm.phoneNumber\" required><div ng-messages=\"userEditForm.phoneNumber.$error\"><div \nng-message=\"required\">Phone number is required</div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"100\" class=\"md-block\"><label>Assign to Role</label><md-select \nng-model=\"vm.role\" ng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option ng-value=\"role\" ng-repeat=\"role in vm.roles\">\n{{ role.description }}</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\">\n<md-input-container flex=\"100\" class=\"md-block\"><label>Specialty</label><md-select ng-model=\"vm.specialty\" \nng-model-options=\"{ trackBy: \'$value.id\' }\"><md-option ng-value=\"null\">No specialty/Not relevant</md-option><md-option \nng-value=\"specialty\" ng-repeat=\"specialty in vm.specialties\" ng-bind=\"::specialty.name\"></md-option></md-select>\n</md-input-container></div><md-input-container class=\"md-block\"><label>\nRoster Email(s), comma separated, ignore if not relevant</label><textarea name=\"rosterEmails\" \nng-model=\"vm.rosterEmails\" rows=\"3\"></textarea></md-input-container><md-autocomplete class=\"md-block\" flex-gt-xs=\"50\" \nmd-floating-label=\"Associated Doctor\" md-delay=\"200\" md-item-text=\"doctor.name\" md-selected-item=\"vm.doctor\" \nmd-search-text=\"vm.searchDoctor\" md-items=\"doctor in vm.acDoctor()\" md-input-name=\"doctor\" md-require-match \nng-show=\"vm.role.name === vm.Role.NAME.PERSONAL_ASSISTANT\" \nng-required=\"vm.role.name === vm.Role.NAME.PERSONAL_ASSISTANT\"><md-item-template><span \nmd-highlight-text=\"vm.searchDoctor\">{{ doctor.code }} :: {{ doctor.name }}</span></md-item-template><md-not-found>\nNo matches found.</md-not-found><div ng-messages=\"userEditForm.doctor.$error\"><div ng-message=\"required\">\nDoctor is required</div><div ng-message=\"md-require-match\">Please select a valid doctor.</div></div></md-autocomplete>\n<div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-fab md-warn\" ng-class=\"vm.mediaXsActionButtons\" \nng-click=\"vm.back()\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon><md-tooltip md-direction=\"top\">Back</md-tooltip>\n</md-button><md-button type=\"submit\" class=\"md-fab md-accent\" ng-class=\"vm.mediaXsActionButtons\" \nng-disabled=\"userEditForm.$invalid || userEditForm.$pristine\"><md-icon md-font-icon=\"icon-check\"></md-icon><md-tooltip \nmd-direction=\"top\">Update</md-tooltip></md-button></div></form></md-content></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon \nng-class=\"vm.sharedService.pageIcon\"></md-icon></span><span class=\"logo-text\">{{ vm.sharedService.pageName }}</span>\n</div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>{{ vm.accountService.user.profile_name }}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" hide-gt-sm><md-icon \nmd-font-icon=\"vm.userStatus.icon\" class=\"icon\"></md-icon><span class=\"username\">\n{{ vm.accountService.user.profile_name }}</span></md-menu-item><md-menu-divider hide-gt-sm></md-menu-divider>\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-document\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.openScheduleOfProcedureBooklet()\">Schedule of Procedure Booklet</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-file-document\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.openGlobocareUserGuide()\">Globocare User Guide</md-button></md-menu-item><md-menu-item class=\"md-indent\">\n<md-icon md-font-icon=\"icon-file-document\" class=\"icon\"></md-icon><md-button ng-click=\"vm.openFormularyDocument()\">\nUMSC Formulary</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-document\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.openScheduleDocument()\">13th Schedule Dec 2013</md-button>\n</md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li><li \nclass=\"ms-navigation-node\"><div class=\"ms-navigation-item\" layout=\"row\"><a class=\"ms-navigation-button\" \nonclick=\"window.open(\'https\\:\\/\\/docs.google.com/forms/d/e/1FAIpQLSdaksCWzzrWKawbI_YriV3XPg0JDKdRsaoNmYLHhuDc0Hzc8A/viewform?fbzx=5584003201834805145\', \'newwindow\', \'width=\' + screen.availWidth + \',height=\' + screen.availHeight); return false\" \nui-sref-active=\"active md-accent-bg\"><i class=\"icon s16 icon-document\"></i> <span class=\"title\" flex>Incident Report\n</span></a></div></li></ul><script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/appointment/dialogs/appointment-detail/appointment-detail-dialog.html","<md-dialog id=\"appointment-detail-dialog\"><md-dialog-content ng-cloak><div class=\"page-layout simple fullwidth\"><div \nclass=\"simple-table-container\"><div class=\"table-title\">Appointment</div><table class=\"simple\" ms-responsive-table><tr>\n<th>Patient Name</th><td>{{ vm.appointment.patient_name }}</td></tr><tr><th>Patient MRN</th><td>\n{{ vm.appointment.patient_no }}</td></tr><tr><th>Status</th><td>{{ vm.appointment.status_desc }}</td></tr><tr><th>Type\n</th><td>{{ vm.appointment.type_desc }}</td></tr><tr><th>Is Urgent?</th><td>{{ vm.appointment.isUrgentString() }}</td>\n</tr><tr><th>Datetime</th><td>{{ vm.appointment.getDatetime().format(\'DD/MM/YYYY hh:mm a\') }}</td></tr></table></div>\n</div><form name=\"appointmentDetailDialogForm\" layout=\"row\" ng-if=\"!vm.loading && vm.showCompleteButton\">\n<md-input-container flex=\"100\" class=\"md-block\"><label>Remarks</label><input name=\"remarks\" ng-model=\"vm.memo.remarks\" \nrequired><div ng-messages=\"appointmentDetailDialogForm.remarks.$error\"><div ng-message=\"required\">Remarks is required\n</div></div></md-input-container></form></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.edit()\" \nclass=\"md-fab md-warn\" ng-class=\"vm.mediaXsActionButtons\" ng-if=\"!vm.loading && vm.showRequestButton\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Request for Changes</md-tooltip></md-button><md-button \nng-click=\"vm.complete()\" class=\"md-fab md-warn\" ng-class=\"vm.mediaXsActionButtons\" \nng-if=\"!vm.loading && vm.showCompleteButton\" ng-disabled=\"!vm.memo.remarks\"><md-icon md-font-icon=\"icon-check\">\n</md-icon><md-tooltip>Complete</md-tooltip></md-button><md-button ng-click=\"vm.close()\" class=\"md-fab md-accent\" \nng-class=\"vm.mediaXsActionButtons\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Close</md-tooltip>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/bill/dialogs/bill-detail/bill-detail-dialog.html","<md-dialog id=\"bill-detail-dialog\"><md-dialog-content ng-cloak><div class=\"page-layout simple fullwidth\"><div \nclass=\"simple-table-container\"><div class=\"table-title\">Bill</div><table class=\"simple\" ms-responsive-table><tr><th>\nPatient MRN</th><td>{{ vm.bill.patient_mrn }}</td></tr><tr><th>Patient Name</th><td>{{ vm.bill.patient_name }}</td>\n</tr><tr><th>Episode No</th><td>{{ vm.bill.episode_no }}</td></tr><tr><th>Ward Code</th><td>{{ vm.bill.ward_code }}\n</td></tr><tr><th>Bed No</th><td>{{ vm.bill.bed_no }}</td></tr><tr ng-show=\"vm.todoAttachments.length > 0\"><th>\nAttachments</th><td><div ng-repeat=\"attachment in vm.todoAttachments\"><a href=\"javascript:void(0)\" \nng-click=\"vm.downloadAttachment(attachment)\" ng-bind=\"attachment.original_file_name\"></a></div></td></tr><tr><th>\nBiller Remarks</th><td ng-bind=\"::vm.todo.remarks\"></td></tr><tr ng-show=\"vm.todos.length > 0\"><th>Doctor Remarks</th>\n<td ng-bind=\"::vm.todos[0].remarks\"></td></tr></table></div></div><form name=\"billDetailDialogForm\" layout=\"row\" \nng-if=\"!vm.loading && vm.showCompleteButton\"><md-input-container flex=\"100\" class=\"md-block\"><label>Fee and or Remarks\n</label><input name=\"remarks\" ng-model=\"vm.memo.remarks\" required><div \nng-messages=\"billDetailDialogForm.remarks.$error\"><div ng-message=\"required\">Fee is required</div></div>\n</md-input-container></form></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.edit()\" \nclass=\"md-fab md-warn\" ng-class=\"vm.mediaXsActionButtons\" ng-if=\"!vm.loading && vm.showRequestButton\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Edit</md-tooltip></md-button><md-button ng-click=\"vm.complete()\" \nclass=\"md-fab md-warn\" ng-class=\"vm.mediaXsActionButtons\" ng-if=\"!vm.loading && vm.showCompleteButton\" \nng-disabled=\"!vm.memo.remarks\"><md-icon md-font-icon=\"icon-check\"></md-icon><md-tooltip>Complete</md-tooltip>\n</md-button><md-button ng-click=\"vm.close()\" class=\"md-fab md-accent\" ng-class=\"vm.mediaXsActionButtons\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon><md-tooltip>Close</md-tooltip></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/e-discharge-staff/dialogs/e-discharge-staff-add-doctor/e-discharge-staff-add-doctor-dialog.html","<md-dialog id=\"e-discharge-staff-add-doctor-dialog\"><md-dialog-content flex ng-cloak><div \nclass=\"page-layout simple fullwidth\"><div class=\"simple-table-container\"><div class=\"table-title\">Add Doctor</div>\n</div></div><form name=\"$root.dialogForm\" layout=\"column\" ng-if=\"!vm.loading\"><md-autocomplete md-no-float \nclass=\"md-block\" flex placeholder=\"Doctor\" md-delay=\"200\" md-item-text=\"item.name\" md-selected-item=\"vm.doctor\" \nmd-search-text=\"vm.searchDoctor\" md-items=\"item in vm.acDoctor()\" md-input-name=\"doctor\" md-menu-class=\"mdit-custom\" \nmd-menu-container-class=\"mdit-custom-container\" md-require-match required><md-item-template><div class=\"mdit-title\">\n<span ng-bind=\"item.code\"></span></div><span class=\"mdit-group\"><span class=\"mdit-subtitle\" ng-bind=\"item.name\"></span>\n</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></form></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"vm.save()\" class=\"md-fab md-mini\" \nng-disabled=\"vm.loading || $root.dialogForm.$invalid || $root.dialogForm.$pristine\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Save</md-tooltip></md-button><md-button ng-click=\"vm.close()\" \nclass=\"md-fab md-mini md-warn\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Close</md-tooltip></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/e-discharge-staff/dialogs/e-discharge-staff-amend-procedure/e-discharge-staff-amend-procedure-dialog.html","<md-dialog id=\"e-discharge-staff-amend-procedure-dialog\"><md-dialog-content flex ng-cloak><div \nclass=\"page-layout simple fullwidth\"><div class=\"simple-table-container\"><div class=\"table-title\">Amend Procedure</div>\n</div></div><form name=\"$root.dialogForm\" layout=\"column\" ng-if=\"!vm.loading\"><md-autocomplete md-no-float \nclass=\"md-block\" flex placeholder=\"Procedure\" md-delay=\"200\" md-item-text=\"item.transaction_code_description\" \nmd-selected-item=\"vm.procedure\" md-search-text=\"vm.searchProcedure\" md-items=\"item in vm.acProcedure()\" \nmd-input-name=\"procedure\" md-menu-class=\"mdit-custom\" md-menu-container-class=\"mdit-custom-container\" md-require-match \nrequired><md-item-template><div class=\"mdit-title\"><span ng-bind=\"item.transaction_code\"></span> <span \nng-if=\"item.procedure_detail.mma_code\">({{ item.procedure_detail.mma_code }})</span></div><span class=\"mdit-group\">\n<span class=\"mdit-subtitle\" ng-bind=\"item.transaction_code_description\"></span></span></md-item-template><md-not-found>\nNo matches found.</md-not-found></md-autocomplete><md-input-container flex class=\"md-block\"><label>Fee</label><input \nng-disabled=\"!vm.procedure\" type=\"number\" name=\"amount\" ng-model=\"vm.dataSource.amount\" required><div \nng-messages=\"$root.dialogForm.amount.$error\"><div ng-message=\"required\">Fee is required</div><div ng-message=\"min\">\nFee cannot be less than {{ vm.procedure && vm.procedure.min_price_range }}</div><div ng-message=\"max\">\nFee cannot be more than {{ vm.procedure && vm.procedure.max_price_range }}</div></div></md-input-container><md-checkbox\n ng-model=\"vm.dataSource.is_anaesthetic\" ng-change=\"vm.setConsultant(null)\">Anaesthetic</md-checkbox><md-autocomplete \nng-if=\"vm.dataSource.is_anaesthetic\" md-no-float class=\"md-block\" flex placeholder=\"Consultant\" md-delay=\"200\" \nmd-item-text=\"item.name\" md-selected-item=\"vm.consultant\" md-search-text=\"vm.searchConsultant\" \nmd-items=\"item in vm.acConsultant()\" md-input-name=\"consultant\" md-menu-class=\"mdit-custom\" \nmd-menu-container-class=\"mdit-custom-container\" md-require-match required><md-item-template><div class=\"mdit-title\">\n<span ng-bind=\"item.code\"></span></div><span class=\"mdit-group\"><span class=\"mdit-subtitle\" ng-bind=\"item.name\"></span>\n</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></form></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"vm.save()\" class=\"md-fab md-mini\" \nng-disabled=\"vm.loading || $root.dialogForm.$invalid || $root.dialogForm.$pristine\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Save</md-tooltip></md-button><md-button ng-click=\"vm.close()\" \nclass=\"md-fab md-mini md-warn\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Close</md-tooltip></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/e-discharge-staff/dialogs/e-discharge-staff-amend-visit/e-discharge-staff-amend-visit-dialog.html","<md-dialog id=\"e-discharge-staff-amend-visit-dialog\"><md-dialog-content flex ng-cloak><div \nclass=\"page-layout simple fullwidth\"><div class=\"simple-table-container\"><div class=\"table-title\">Amend Visit</div>\n</div></div><form name=\"$root.dialogForm\" layout=\"column\" ng-if=\"!vm.loading\"><md-input-container flex \nclass=\"md-block\"><label>Date / Time</label><input name=\"visitDatetime\" moment-picker \nng-model=\"vm.dataSource.visit_datetime\" format=\"DD/MM/YYYY HH:mm\" readonly=\"readonly\" required><div \nng-messages=\"$root.dialogForm.visitDatetime.$error\"><div ng-message=\"required\">Date / time is required</div></div>\n</md-input-container><div flex layout=\"row\" layout-align=\"space-between center\"><md-input-container flex \nclass=\"md-block\"><label>Visit Type</label><input name=\"visitType\" ng-model=\"vm.dataSource.visit_type\" required><div \nng-messages=\"$root.dialogForm.visitType.$error\"><div ng-message=\"required\">Visit type is required</div></div>\n</md-input-container><md-button class=\"am-pm\" ng-click=\"vm.setVisitType(\'AM\')\">AM</md-button><div>/</div><md-button \nclass=\"am-pm\" ng-click=\"vm.setVisitType(\'PM\')\">PM</md-button></div><md-input-container flex class=\"md-block\"><label>Fee\n</label><input type=\"number\" name=\"amount\" ng-model=\"vm.dataSource.amount\" required><div \nng-messages=\"$root.dialogForm.amount.$error\"><div ng-message=\"required\">Fee is required</div></div>\n</md-input-container><md-input-container flex class=\"md-block\"><label>Remark</label><input name=\"remark\" \nng-model=\"vm.dataSource.remark\" required><div ng-messages=\"$root.dialogForm.remark.$error\"><div ng-message=\"required\">\nRemark is required</div></div></md-input-container></form></md-dialog-content><md-dialog-actions><md-button \nng-click=\"vm.save()\" class=\"md-fab md-mini\" \nng-disabled=\"vm.loading || $root.dialogForm.$invalid || $root.dialogForm.$pristine\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Save</md-tooltip></md-button><md-button ng-click=\"vm.close()\" \nclass=\"md-fab md-mini md-warn\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Close</md-tooltip></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/e-discharge-staff/dialogs/e-discharge-staff-procedure/e-discharge-staff-procedure-dialog.html","<md-dialog id=\"e-discharge-staff-procedure-dialog\"><md-dialog-content flex ng-cloak><div \nclass=\"page-layout simple fullwidth\"><div class=\"simple-table-container\"><div class=\"table-title\">Procedure</div></div>\n</div><form name=\"$root.dialogForm\" layout=\"column\" ng-if=\"!vm.loading\"><md-autocomplete md-no-float class=\"md-block\" \nflex placeholder=\"Procedure\" md-delay=\"200\" md-item-text=\"item.transaction_code_description\" \nmd-selected-item=\"vm.procedure\" md-search-text=\"vm.searchProcedure\" md-items=\"item in vm.acProcedure()\" \nmd-input-name=\"procedure\" md-menu-class=\"mdit-custom\" md-menu-container-class=\"mdit-custom-container\" md-require-match \nrequired><md-item-template><div class=\"mdit-title\"><span ng-bind=\"item.transaction_code\"></span> <span \nng-if=\"item.procedure_detail.mma_code\">({{ item.procedure_detail.mma_code }})</span></div><span class=\"mdit-group\">\n<span class=\"mdit-subtitle\" ng-bind=\"item.transaction_code_description\"></span></span></md-item-template><md-not-found>\nNo matches found.</md-not-found></md-autocomplete><md-input-container flex class=\"md-block\"><label>Fee</label><input \nng-disabled=\"!vm.procedure\" type=\"number\" name=\"amount\" ng-model=\"vm.dataSource.amount\" required><div \nng-messages=\"$root.dialogForm.amount.$error\"><div ng-message=\"required\">Fee is required</div><div ng-message=\"min\">\nFee cannot be less than {{ vm.procedure && vm.procedure.min_price_range }}</div><div ng-message=\"max\">\nFee cannot be more than {{ vm.procedure && vm.procedure.max_price_range }}</div></div></md-input-container><md-checkbox\n ng-model=\"vm.dataSource.is_anaesthetic\" ng-change=\"vm.setConsultant(null)\">Anaesthetic</md-checkbox><md-autocomplete \nng-if=\"vm.dataSource.is_anaesthetic\" md-no-float class=\"md-block\" flex placeholder=\"Consultant\" md-delay=\"200\" \nmd-item-text=\"item.name\" md-selected-item=\"vm.consultant\" md-search-text=\"vm.searchConsultant\" \nmd-items=\"item in vm.acConsultant()\" md-input-name=\"consultant\" md-menu-class=\"mdit-custom\" \nmd-menu-container-class=\"mdit-custom-container\" md-require-match required><md-item-template><div class=\"mdit-title\">\n<span ng-bind=\"item.code\"></span></div><span class=\"mdit-group\"><span class=\"mdit-subtitle\" ng-bind=\"item.name\"></span>\n</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></form></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"vm.save()\" class=\"md-fab md-mini\" \nng-disabled=\"vm.loading || $root.dialogForm.$invalid || $root.dialogForm.$pristine\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Save</md-tooltip></md-button><md-button ng-click=\"vm.close()\" \nclass=\"md-fab md-mini md-warn\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Close</md-tooltip></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/e-discharge-staff/dialogs/e-discharge-staff-visit/e-discharge-staff-visit-dialog.html","<md-dialog id=\"e-discharge-staff-visit-dialog\"><md-dialog-content flex ng-cloak><div \nclass=\"page-layout simple fullwidth\"><div class=\"simple-table-container\"><div class=\"table-title\">Visit</div></div>\n</div><form name=\"$root.dialogForm\" layout=\"column\" ng-if=\"!vm.loading\"><md-input-container flex class=\"md-block\">\n<label>Date / Time</label><input name=\"visitDatetime\" moment-picker ng-model=\"vm.dataSource.visit_datetime\" \nformat=\"DD/MM/YYYY HH:mm\" readonly=\"readonly\" required><div ng-messages=\"$root.dialogForm.visitDatetime.$error\"><div \nng-message=\"required\">Date / time is required</div></div></md-input-container><div flex layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex class=\"md-block\"><label>Visit Type</label><input \nname=\"visitType\" ng-model=\"vm.dataSource.visit_type\" required><div ng-messages=\"$root.dialogForm.visitType.$error\"><div\n ng-message=\"required\">Visit type is required</div></div></md-input-container><md-button class=\"am-pm\" \nng-click=\"vm.setVisitType(\'AM\')\">AM</md-button><div>/</div><md-button class=\"am-pm\" ng-click=\"vm.setVisitType(\'PM\')\">PM\n</md-button></div><md-input-container flex class=\"md-block\"><label>Fee</label><input type=\"number\" name=\"amount\" \nng-model=\"vm.dataSource.amount\" required><div ng-messages=\"$root.dialogForm.amount.$error\"><div ng-message=\"required\">\nFee is required</div></div></md-input-container><md-input-container flex class=\"md-block\"><label>Remark</label><input \nname=\"remark\" ng-model=\"vm.dataSource.remark\" required><div ng-messages=\"$root.dialogForm.remark.$error\"><div \nng-message=\"required\">Remark is required</div></div></md-input-container></form></md-dialog-content><md-dialog-actions>\n<md-button ng-click=\"vm.save()\" class=\"md-fab md-mini\" \nng-disabled=\"vm.loading || $root.dialogForm.$invalid || $root.dialogForm.$pristine\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Save</md-tooltip></md-button><md-button ng-click=\"vm.close()\" \nclass=\"md-fab md-mini md-warn\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Close</md-tooltip></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/e-discharge-consultant/dialogs/e-discharge-consultant-amend-visit/e-discharge-consultant-amend-visit-dialog.html","<md-dialog id=\"e-discharge-consultant-amend-visit-dialog\"><md-dialog-content flex ng-cloak><div \nclass=\"page-layout simple fullwidth\"><div class=\"simple-table-container\"><div class=\"table-title\">Amend Visit</div>\n</div></div><form name=\"$root.dialogForm\" layout=\"column\" ng-if=\"!vm.loading\"><md-input-container flex \nclass=\"md-block\"><label>Date / Time</label><input name=\"visitDatetime\" moment-picker \nng-model=\"vm.dataSource.visit_datetime\" format=\"DD/MM/YYYY HH:mm\" readonly=\"readonly\" required><div \nng-messages=\"$root.dialogForm.visitDatetime.$error\"><div ng-message=\"required\">Date / time is required</div></div>\n</md-input-container><div flex layout=\"row\" layout-align=\"space-between center\"><md-input-container flex \nclass=\"md-block\"><label>Visit Type</label><input name=\"visitType\" ng-model=\"vm.dataSource.visit_type\" required><div \nng-messages=\"$root.dialogForm.visitType.$error\"><div ng-message=\"required\">Visit type is required</div></div>\n</md-input-container><md-button class=\"am-pm\" ng-click=\"vm.setVisitType(\'AM\')\">AM</md-button><div>/</div><md-button \nclass=\"am-pm\" ng-click=\"vm.setVisitType(\'PM\')\">PM</md-button></div><md-input-container flex class=\"md-block\"><label>Fee\n</label><input type=\"number\" name=\"amount\" ng-model=\"vm.dataSource.amount\" required><div \nng-messages=\"$root.dialogForm.amount.$error\"><div ng-message=\"required\">Fee is required</div></div>\n</md-input-container><md-input-container flex class=\"md-block\"><label>Remark</label><input name=\"remark\" \nng-model=\"vm.dataSource.remark\" required><div ng-messages=\"$root.dialogForm.remark.$error\"><div ng-message=\"required\">\nRemark is required</div></div></md-input-container></form></md-dialog-content><md-dialog-actions><md-button \nng-click=\"vm.save()\" class=\"md-fab md-mini\" \nng-disabled=\"vm.loading || $root.dialogForm.$invalid || $root.dialogForm.$pristine\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Save</md-tooltip></md-button><md-button ng-click=\"vm.close()\" \nclass=\"md-fab md-mini md-warn\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Close</md-tooltip></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/e-discharge-consultant/dialogs/e-discharge-consultant-procedure/e-discharge-consultant-procedure-dialog.html","<md-dialog id=\"e-discharge-consultant-procedure-dialog\"><md-dialog-content flex ng-cloak><div \nclass=\"page-layout simple fullwidth\"><div class=\"simple-table-container\"><div class=\"table-title\">Procedure</div></div>\n</div><form name=\"$root.dialogForm\" layout=\"column\" ng-if=\"!vm.loading\"><md-autocomplete md-no-float class=\"md-block\" \nflex placeholder=\"Procedure\" md-delay=\"200\" md-item-text=\"item.transaction_code_description\" \nmd-selected-item=\"vm.procedure\" md-search-text=\"vm.searchProcedure\" md-items=\"item in vm.acProcedure()\" \nmd-input-name=\"procedure\" md-menu-class=\"mdit-custom\" md-menu-container-class=\"mdit-custom-container\" md-require-match \nrequired><md-item-template><div class=\"mdit-title\"><span ng-bind=\"item.transaction_code\"></span> <span \nng-if=\"item.procedure_detail.mma_code\">({{ item.procedure_detail.mma_code }})</span></div><span class=\"mdit-group\">\n<span class=\"mdit-subtitle\" ng-bind=\"item.transaction_code_description\"></span></span></md-item-template><md-not-found>\nNo matches found.</md-not-found></md-autocomplete><md-input-container flex class=\"md-block\"><label>Fee</label><input \nng-disabled=\"!vm.procedure\" type=\"number\" name=\"amount\" ng-model=\"vm.dataSource.amount\" required><div \nng-messages=\"$root.dialogForm.amount.$error\"><div ng-message=\"required\">Fee is required</div><div ng-message=\"min\">\nFee cannot be less than {{ vm.procedure && vm.procedure.min_price_range }}</div><div ng-message=\"max\">\nFee cannot be more than {{ vm.procedure && vm.procedure.max_price_range }}</div></div></md-input-container><md-checkbox\n ng-model=\"vm.dataSource.is_anaesthetic\" ng-change=\"vm.setConsultant(null)\">Anaesthetic</md-checkbox><md-autocomplete \nng-if=\"vm.dataSource.is_anaesthetic\" md-no-float class=\"md-block\" flex placeholder=\"Consultant\" md-delay=\"200\" \nmd-item-text=\"item.name\" md-selected-item=\"vm.consultant\" md-search-text=\"vm.searchConsultant\" \nmd-items=\"item in vm.acConsultant()\" md-input-name=\"consultant\" md-menu-class=\"mdit-custom\" \nmd-menu-container-class=\"mdit-custom-container\" md-require-match required><md-item-template><div class=\"mdit-title\">\n<span ng-bind=\"item.code\"></span></div><span class=\"mdit-group\"><span class=\"mdit-subtitle\" ng-bind=\"item.name\"></span>\n</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></form></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"vm.save()\" class=\"md-fab md-mini\" \nng-disabled=\"vm.loading || $root.dialogForm.$invalid || $root.dialogForm.$pristine\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Save</md-tooltip></md-button><md-button ng-click=\"vm.close()\" \nclass=\"md-fab md-mini md-warn\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Close</md-tooltip></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/e-discharge-consultant/dialogs/e-discharge-consultant-amend-procedure/e-discharge-consultant-amend-procedure-dialog.html","<md-dialog id=\"e-discharge-consultant-amend-procedure-dialog\"><md-dialog-content flex ng-cloak><div \nclass=\"page-layout simple fullwidth\"><div class=\"simple-table-container\"><div class=\"table-title\">Amend Procedure</div>\n</div></div><form name=\"$root.dialogForm\" layout=\"column\" ng-if=\"!vm.loading\"><md-autocomplete md-no-float \nclass=\"md-block\" flex placeholder=\"Procedure\" md-delay=\"200\" md-item-text=\"item.transaction_code_description\" \nmd-selected-item=\"vm.procedure\" md-search-text=\"vm.searchProcedure\" md-items=\"item in vm.acProcedure()\" \nmd-input-name=\"procedure\" md-menu-class=\"mdit-custom\" md-menu-container-class=\"mdit-custom-container\" md-require-match \nrequired><md-item-template><div class=\"mdit-title\"><span ng-bind=\"item.transaction_code\"></span> <span \nng-if=\"item.procedure_detail.mma_code\">({{ item.procedure_detail.mma_code }})</span></div><span class=\"mdit-group\">\n<span class=\"mdit-subtitle\" ng-bind=\"item.transaction_code_description\"></span></span></md-item-template><md-not-found>\nNo matches found.</md-not-found></md-autocomplete><md-input-container flex class=\"md-block\"><label>Fee</label><input \nng-disabled=\"!vm.procedure\" type=\"number\" name=\"amount\" ng-model=\"vm.dataSource.amount\" required><div \nng-messages=\"$root.dialogForm.amount.$error\"><div ng-message=\"required\">Fee is required</div><div ng-message=\"min\">\nFee cannot be less than {{ vm.procedure && vm.procedure.min_price_range }}</div><div ng-message=\"max\">\nFee cannot be more than {{ vm.procedure && vm.procedure.max_price_range }}</div></div></md-input-container><md-checkbox\n ng-model=\"vm.dataSource.is_anaesthetic\" ng-change=\"vm.setConsultant(null)\">Anaesthetic</md-checkbox><md-autocomplete \nng-if=\"vm.dataSource.is_anaesthetic\" md-no-float class=\"md-block\" flex placeholder=\"Consultant\" md-delay=\"200\" \nmd-item-text=\"item.name\" md-selected-item=\"vm.consultant\" md-search-text=\"vm.searchConsultant\" \nmd-items=\"item in vm.acConsultant()\" md-input-name=\"consultant\" md-menu-class=\"mdit-custom\" \nmd-menu-container-class=\"mdit-custom-container\" md-require-match required><md-item-template><div class=\"mdit-title\">\n<span ng-bind=\"item.code\"></span></div><span class=\"mdit-group\"><span class=\"mdit-subtitle\" ng-bind=\"item.name\"></span>\n</span></md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></form></md-dialog-content>\n<md-dialog-actions><md-button ng-click=\"vm.save()\" class=\"md-fab md-mini\" \nng-disabled=\"vm.loading || $root.dialogForm.$invalid || $root.dialogForm.$pristine\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Save</md-tooltip></md-button><md-button ng-click=\"vm.close()\" \nclass=\"md-fab md-mini md-warn\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Close</md-tooltip></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/e-discharge-consultant/dialogs/e-discharge-consultant-visit/e-discharge-consultant-visit-dialog.html","<md-dialog id=\"e-discharge-consultant-visit-dialog\"><md-dialog-content flex ng-cloak><div \nclass=\"page-layout simple fullwidth\"><div class=\"simple-table-container\"><div class=\"table-title\">Visit</div></div>\n</div><form name=\"$root.dialogForm\" layout=\"column\" ng-if=\"!vm.loading\"><md-input-container flex class=\"md-block\">\n<label>Date / Time</label><input name=\"visitDatetime\" moment-picker ng-model=\"vm.dataSource.visit_datetime\" \nformat=\"DD/MM/YYYY HH:mm\" readonly=\"readonly\" required><div ng-messages=\"$root.dialogForm.visitDatetime.$error\"><div \nng-message=\"required\">Date / time is required</div></div></md-input-container><div flex layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container flex class=\"md-block\"><label>Visit Type</label><input \nname=\"visitType\" ng-model=\"vm.dataSource.visit_type\" required><div ng-messages=\"$root.dialogForm.visitType.$error\"><div\n ng-message=\"required\">Visit type is required</div></div></md-input-container><md-button class=\"am-pm\" \nng-click=\"vm.setVisitType(\'AM\')\">AM</md-button><div>/</div><md-button class=\"am-pm\" ng-click=\"vm.setVisitType(\'PM\')\">PM\n</md-button></div><md-input-container flex class=\"md-block\"><label>Fee</label><input type=\"number\" name=\"amount\" \nng-model=\"vm.dataSource.amount\" required><div ng-messages=\"$root.dialogForm.amount.$error\"><div ng-message=\"required\">\nFee is required</div></div></md-input-container><md-input-container flex class=\"md-block\"><label>Remark</label><input \nname=\"remark\" ng-model=\"vm.dataSource.remark\" required><div ng-messages=\"$root.dialogForm.remark.$error\"><div \nng-message=\"required\">Remark is required</div></div></md-input-container></form></md-dialog-content><md-dialog-actions>\n<md-button ng-click=\"vm.save()\" class=\"md-fab md-mini\" \nng-disabled=\"vm.loading || $root.dialogForm.$invalid || $root.dialogForm.$pristine\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Save</md-tooltip></md-button><md-button ng-click=\"vm.close()\" \nclass=\"md-fab md-mini md-warn\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Close</md-tooltip></md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/operation-theater/dialogs/operation-theater-detail/operation-theater-detail-dialog.html","<md-dialog id=\"operation-theater-detail-dialog\"><md-dialog-content ng-cloak><div class=\"page-layout simple fullwidth\">\n<div class=\"simple-table-container\"><div class=\"table-title\">OT Booking</div><table class=\"simple\" ms-responsive-table>\n<tr><th>Patient MRN</th><td>{{ vm.booking.patient_no }}</td></tr><tr ng-if=\"vm.booking.location\"><th>OT Room</th><td>\n{{ vm.booking.location }}</td></tr><tr><th>Procedures</th><td>{{ vm.booking.procedures }}</td></tr><tr><th>Doctor</th>\n<td>{{ vm.booking.dr_desc }}</td></tr><tr><th>Datetime</th><td>\n{{ vm.todo.getRequestedDatetime().format(\'DD/MM/YYYY hh:mm a\') }}</td></tr></table></div></div><form \nname=\"operationTheaterDetailDialogForm\" layout=\"row\" ng-if=\"!vm.loading && vm.showCompleteButton\"><md-input-container \nflex=\"100\" class=\"md-block\"><label>Remarks</label><input name=\"remarks\" ng-model=\"vm.memo.remarks\" required><div \nng-messages=\"operationTheaterDetailDialogForm.remarks.$error\"><div ng-message=\"required\">Remarks is required</div>\n</div></md-input-container></form></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.edit()\" \nclass=\"md-fab md-warn\" ng-class=\"vm.mediaXsActionButtons\" ng-if=\"!vm.loading && vm.showRequestButton\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Request for Changes</md-tooltip></md-button><md-button \nng-click=\"vm.complete()\" class=\"md-fab md-warn\" ng-class=\"vm.mediaXsActionButtons\" \nng-if=\"!vm.loading && vm.showCompleteButton\" ng-disabled=\"!vm.memo.remarks\"><md-icon md-font-icon=\"icon-check\">\n</md-icon><md-tooltip>Complete</md-tooltip></md-button><md-button ng-click=\"vm.close()\" class=\"md-fab md-accent\" \nng-class=\"vm.mediaXsActionButtons\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Close</md-tooltip>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/roster/dialogs/roster-detail/roster-detail-dialog.html","<md-dialog id=\"roster-detail-dialog\"><md-dialog-content ng-cloak><div class=\"page-layout simple fullwidth\"><div \nclass=\"simple-table-container\"><div class=\"table-title\">Roster</div><table class=\"simple\" ms-responsive-table><tr><th>\nOn Duty User</th><td><span ng-bind=\"::vm.roster.username\"></span> :: <span ng-bind=\"::vm.roster.profile_name\"></span>\n</td></tr><tr><th>Tag</th><td ng-bind=\"::vm.roster.tag || \'No tag\'\"></td></tr><tr><th>Phone Number</th><td \nng-bind=\"::vm.roster.phone_number\"></td></tr><tr><th>Email</th><td ng-bind=\"::vm.roster.roster_emails\"></td></tr><tr>\n<th>Start Date & Time</th><td ng-bind=\"::vm.roster.start_datetime_display\"></td></tr><tr><th>End Date & Time</th><td \nng-bind=\"::vm.roster.end_datetime_display\"></td></tr></table></div></div><form name=\"rosterDetailDialogForm\" \nng-show=\"vm.canModify && vm.isEditing\"><md-input-container class=\"md-block\"><label>New Start Date & Time</label><input \nname=\"startDatetime\" moment-picker ng-model=\"vm.startDatetime\" format=\"DD/MM/YYYY HH:mm\" readonly=\"readonly\" required>\n<div ng-messages=\"rosterDetailDialogForm.startDatetime.$error\"><div ng-message=\"required\">Start date & time is required\n</div></div></md-input-container><md-input-container class=\"md-block\"><label>New End Date & Time</label><input \nname=\"endDatetime\" moment-picker ng-model=\"vm.endDatetime\" format=\"DD/MM/YYYY HH:mm\" readonly=\"readonly\" required><div \nng-messages=\"rosterDetailDialogForm.endDatetime.$error\"><div ng-message=\"required\">End date & time is required</div>\n</div></md-input-container></form></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.delete()\" \nclass=\"md-fab md-primary md-mini\" ng-show=\"vm.canDelete && vm.isEditing\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n<md-tooltip>Delete</md-tooltip></md-button><md-button ng-click=\"vm.edit()\" class=\"md-fab md-primary md-mini\" \nng-show=\"vm.canModify && vm.isEditing\" ng-disabled=\"rosterDetailDialogForm.$invalid\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon><md-tooltip>Save</md-tooltip></md-button><md-button \nng-click=\"vm.isEditing = !vm.isEditing\" class=\"md-fab md-warn md-mini\" ng-show=\"vm.canModify || vm.canDelete\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><md-tooltip>Edit</md-tooltip></md-button><md-button ng-click=\"vm.close()\" \nclass=\"md-fab md-accent md-mini\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Close</md-tooltip>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/sms/dialogs/sms-export-excel/sms-export-excel-dialog.html","<md-dialog id=\"sms-export-excel-dialog\"><form ng-cloak><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h3>\nSelect Date Range</h3></div></md-toolbar><md-dialog-content><md-input-container class=\"md-block fix-from-date\"><label>\nFrom Date</label><input moment-picker ng-model=\"vm.fromDate\" format=\"DD/MM/YYYY\" ng-change=\"vm.limitDateRange()\" \nreadonly=\"readonly\"></md-input-container><md-input-container class=\"md-block fix-to-date\"><label>To Date</label><input \nmoment-picker position=\"bottom right\" ng-model=\"vm.toDate\" format=\"DD/MM/YYYY\" ng-change=\"vm.limitDateRange()\" \nreadonly=\"readonly\"></md-input-container></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.exportExcel()\" \nclass=\"md-fab md-warn\" ng-class=\"vm.mediaXsActionButtons\"><md-icon md-font-icon=\"icon-download\"></md-icon><md-tooltip>\nExport Excel</md-tooltip></md-button><md-button ng-click=\"vm.close()\" class=\"md-fab md-accent\" \nng-class=\"vm.mediaXsActionButtons\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Close</md-tooltip>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/todo/dialogs/thread-read-status/thread-read-status-dialog.html","<md-dialog id=\"thread-read-status-dialog\"><md-dialog-content ng-cloak><div class=\"page-layout simple fullwidth\"><div \nclass=\"simple-table-container\"><div class=\"table-title\">Read Status</div><div class=\"bold\">Read</div><div \nng-repeat=\"read in vm.read\"><span ng-bind=\"vm.displayName(read)\"></span></div><div class=\"spacer\"></div><div \nclass=\"bold\">Unread</div><div ng-repeat=\"unread in vm.unread\"><span ng-bind=\"vm.displayName(unread)\"></span></div>\n</div></div></md-dialog-content><md-dialog-actions><md-button ng-click=\"vm.close()\" class=\"md-fab md-accent\" \nng-class=\"vm.mediaXsActionButtons\"><md-icon md-font-icon=\"icon-close\"></md-icon><md-tooltip>Close</md-tooltip>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);